const L0 = [
  // Visibility-only: visible Back Office where shown, hidden elsewhere.
  "useType",
  "engineBrand",
  "engineModel",
  "width",
  "height",
  // Responsibility-varying: always visible; Back Office/Inspector and required both vary.
  "length",
  "axles",
  "wheels",
  "wheelsSizeAxle1",
  "wheelsSizeAxle2",
  "wheelsSizeAxle3",
  "inspectionExpiryDate",
  "cylinders",
  // Inspector or hidden.
  "hasDepotService"
], Wy = [
  "cocDocument",
  "registrationDocument",
  "registrationDocumentPartTwo",
  "maintenanceCard",
  "technicalSheet",
  "inspectionAndMileageCheck"
], yo = { visibility: "hidden" }, E = { visibility: "visible", responsibility: "BackOffice", required: !0 }, Wo = { visibility: "visible", responsibility: "BackOffice", required: !1 }, ko = { visibility: "visible", responsibility: "Inspector", required: !0 }, Bo = { visibility: "visible", responsibility: "Inspector", required: !1 }, Bi = {
  useType: { default: yo, overrides: { IT: E } },
  engineBrand: {
    default: yo,
    overrides: {
      IT: E,
      ES: E,
      PT: E,
      BE: E,
      AT: E,
      NL: E
    }
  },
  engineModel: { default: yo, overrides: { IT: E, ES: E, AT: E } },
  width: {
    default: yo,
    overrides: { IT: E, ES: E, DE: E, AT: E, LU: E }
  },
  height: {
    default: yo,
    overrides: { IT: E, ES: E, DE: E, AT: E, LU: E }
  },
  length: {
    default: ko,
    overrides: {
      IT: E,
      ES: E,
      BE: E,
      DE: E,
      AT: E,
      CZ: E,
      NL: E,
      LU: E,
      PT: Bo
    }
  },
  axles: {
    default: ko,
    overrides: {
      IT: E,
      ES: E,
      DE: E,
      AT: E,
      LU: E,
      PT: Bo
    }
  },
  wheels: {
    default: ko,
    overrides: {
      IT: E,
      ES: E,
      DE: E,
      AT: E,
      LU: E,
      PT: Bo
    }
  },
  wheelsSizeAxle1: {
    default: Bo,
    overrides: { IT: E, ES: E, DE: E, AT: E, LU: E }
  },
  wheelsSizeAxle2: {
    default: Bo,
    overrides: { IT: E, ES: E, DE: E, AT: E, LU: Wo }
  },
  wheelsSizeAxle3: {
    default: Bo,
    overrides: { IT: E, ES: E, DE: E, AT: E, LU: Wo }
  },
  inspectionExpiryDate: { default: E, overrides: { PT: ko, DE: ko } },
  cylinders: { default: Bo, overrides: { ES: E } },
  // Deliberately NOT aligned to PT-703 (BSD-4329): the sheet's "Depot Service" (code 60) is an attribute the
  // inspector observes, whereas this column is a commercial flag, set when the seller accepts the depot terms
  // (BusAsset.depotTermsAcceptedAt). Same name, different thing — do not sync this row from the sheet.
  hasDepotService: { default: yo, overrides: { IT: Bo } }
}, ki = {
  cocDocument: { default: Wo, overrides: { BE: E, NL: E } },
  registrationDocument: { default: E, overrides: { DE: ko, AT: ko, CZ: ko } },
  registrationDocumentPartTwo: { default: yo, overrides: { DE: E, AT: E, CZ: E } },
  maintenanceCard: { default: Wo },
  technicalSheet: { default: yo, overrides: { ES: E } },
  inspectionAndMileageCheck: { default: yo, overrides: { IT: Wo, ES: Wo, PL: Wo } }
};
function gn(o, t) {
  const { default: r, overrides: a } = o;
  if (t != null && a !== void 0) {
    const u = a[t];
    if (u !== void 0) return u;
  }
  return r;
}
function Vy(o, t) {
  return gn(Bi[o], t).visibility === "hidden";
}
function P0(o, t) {
  const r = gn(Bi[o], t);
  return r.visibility === "visible" && r.required;
}
function Jy(o, t) {
  const r = gn(Bi[o], t);
  return r.visibility === "visible" ? r.responsibility : void 0;
}
function jy(o) {
  return L0.filter((t) => P0(t, o));
}
function Yy(o, t) {
  return gn(ki[o], t).visibility === "hidden";
}
function Xy(o, t) {
  const r = gn(ki[o], t);
  return r.visibility === "visible" && r.required;
}
function Qy(o, t) {
  const r = gn(ki[o], t);
  return r.visibility === "visible" ? r.responsibility : void 0;
}
function I(o, t, r) {
  function a(b, T) {
    if (b._zod || Object.defineProperty(b, "_zod", {
      value: {
        def: T,
        constr: p,
        traits: /* @__PURE__ */ new Set()
      },
      enumerable: !1
    }), b._zod.traits.has(o))
      return;
    b._zod.traits.add(o), t(b, T);
    const v = p.prototype, w = Object.keys(v);
    for (let z = 0; z < w.length; z++) {
      const B = w[z];
      B in b || (b[B] = v[B].bind(b));
    }
  }
  const u = r?.Parent ?? Object;
  class f extends u {
  }
  Object.defineProperty(f, "name", { value: o });
  function p(b) {
    var T;
    const v = r?.Parent ? new f() : this;
    a(v, b), (T = v._zod).deferred ?? (T.deferred = []);
    for (const w of v._zod.deferred)
      w();
    return v;
  }
  return Object.defineProperty(p, "init", { value: a }), Object.defineProperty(p, Symbol.hasInstance, {
    value: (b) => r?.Parent && b instanceof r.Parent ? !0 : b?._zod?.traits?.has(o)
  }), Object.defineProperty(p, "name", { value: o }), p;
}
class _n extends Error {
  constructor() {
    super("Encountered Promise during synchronous parse. Use .parseAsync() instead.");
  }
}
class ju extends Error {
  constructor(t) {
    super(`Encountered unidirectional transform during encode: ${t}`), this.name = "ZodEncodeError";
  }
}
const Yu = {};
function Vo(o) {
  return Yu;
}
function Xu(o) {
  const t = Object.values(o).filter((a) => typeof a == "number");
  return Object.entries(o).filter(([a, u]) => t.indexOf(+a) === -1).map(([a, u]) => u);
}
function Ni(o, t) {
  return typeof t == "bigint" ? t.toString() : t;
}
function Di(o) {
  return {
    get value() {
      {
        const t = o();
        return Object.defineProperty(this, "value", { value: t }), t;
      }
    }
  };
}
function Li(o) {
  return o == null;
}
function Pi(o) {
  const t = o.startsWith("^") ? 1 : 0, r = o.endsWith("$") ? o.length - 1 : o.length;
  return o.slice(t, r);
}
function R0(o, t) {
  const r = (o.toString().split(".")[1] || "").length, a = t.toString();
  let u = (a.split(".")[1] || "").length;
  if (u === 0 && /\d?e-\d?/.test(a)) {
    const T = a.match(/\d?e-(\d?)/);
    T?.[1] && (u = Number.parseInt(T[1]));
  }
  const f = r > u ? r : u, p = Number.parseInt(o.toFixed(f).replace(".", "")), b = Number.parseInt(t.toFixed(f).replace(".", ""));
  return p % b / 10 ** f;
}
const xu = /* @__PURE__ */ Symbol("evaluating");
function j(o, t, r) {
  let a;
  Object.defineProperty(o, t, {
    get() {
      if (a !== xu)
        return a === void 0 && (a = xu, a = r()), a;
    },
    set(u) {
      Object.defineProperty(o, t, {
        value: u
        // configurable: true,
      });
    },
    configurable: !0
  });
}
function jo(o, t, r) {
  Object.defineProperty(o, t, {
    value: r,
    writable: !0,
    enumerable: !0,
    configurable: !0
  });
}
function Do(...o) {
  const t = {};
  for (const r of o) {
    const a = Object.getOwnPropertyDescriptors(r);
    Object.assign(t, a);
  }
  return Object.defineProperties({}, t);
}
function vu(o) {
  return JSON.stringify(o);
}
function O0(o) {
  return o.toLowerCase().trim().replace(/[^\w\s-]/g, "").replace(/[\s_-]+/g, "-").replace(/^-+|-+$/g, "");
}
const Qu = "captureStackTrace" in Error ? Error.captureStackTrace : (...o) => {
};
function Ht(o) {
  return typeof o == "object" && o !== null && !Array.isArray(o);
}
const z0 = Di(() => {
  if (typeof navigator < "u" && navigator?.userAgent?.includes("Cloudflare"))
    return !1;
  try {
    const o = Function;
    return new o(""), !0;
  } catch {
    return !1;
  }
});
function Vn(o) {
  if (Ht(o) === !1)
    return !1;
  const t = o.constructor;
  if (t === void 0 || typeof t != "function")
    return !0;
  const r = t.prototype;
  return !(Ht(r) === !1 || Object.prototype.hasOwnProperty.call(r, "isPrototypeOf") === !1);
}
function el(o) {
  return Vn(o) ? { ...o } : Array.isArray(o) ? [...o] : o;
}
const G0 = /* @__PURE__ */ new Set(["string", "number", "symbol"]);
function bn(o) {
  return o.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function Lo(o, t, r) {
  const a = new o._zod.constr(t ?? o._zod.def);
  return (!t || r?.parent) && (a._zod.parent = o), a;
}
function k(o) {
  const t = o;
  if (!t)
    return {};
  if (typeof t == "string")
    return { error: () => t };
  if (t?.message !== void 0) {
    if (t?.error !== void 0)
      throw new Error("Cannot specify both `message` and `error` params");
    t.error = t.message;
  }
  return delete t.message, typeof t.error == "string" ? { ...t, error: () => t.error } : t;
}
function Z0(o) {
  return Object.keys(o).filter((t) => o[t]._zod.optin === "optional" && o[t]._zod.optout === "optional");
}
const U0 = {
  safeint: [Number.MIN_SAFE_INTEGER, Number.MAX_SAFE_INTEGER],
  int32: [-2147483648, 2147483647],
  uint32: [0, 4294967295],
  float32: [-34028234663852886e22, 34028234663852886e22],
  float64: [-Number.MAX_VALUE, Number.MAX_VALUE]
};
function $0(o, t) {
  const r = o._zod.def, a = r.checks;
  if (a && a.length > 0)
    throw new Error(".pick() cannot be used on object schemas containing refinements");
  const f = Do(o._zod.def, {
    get shape() {
      const p = {};
      for (const b in t) {
        if (!(b in r.shape))
          throw new Error(`Unrecognized key: "${b}"`);
        t[b] && (p[b] = r.shape[b]);
      }
      return jo(this, "shape", p), p;
    },
    checks: []
  });
  return Lo(o, f);
}
function K0(o, t) {
  const r = o._zod.def, a = r.checks;
  if (a && a.length > 0)
    throw new Error(".omit() cannot be used on object schemas containing refinements");
  const f = Do(o._zod.def, {
    get shape() {
      const p = { ...o._zod.def.shape };
      for (const b in t) {
        if (!(b in r.shape))
          throw new Error(`Unrecognized key: "${b}"`);
        t[b] && delete p[b];
      }
      return jo(this, "shape", p), p;
    },
    checks: []
  });
  return Lo(o, f);
}
function q0(o, t) {
  if (!Vn(t))
    throw new Error("Invalid input to extend: expected a plain object");
  const r = o._zod.def.checks;
  if (r && r.length > 0) {
    const f = o._zod.def.shape;
    for (const p in t)
      if (Object.getOwnPropertyDescriptor(f, p) !== void 0)
        throw new Error("Cannot overwrite keys on object schemas containing refinements. Use `.safeExtend()` instead.");
  }
  const u = Do(o._zod.def, {
    get shape() {
      const f = { ...o._zod.def.shape, ...t };
      return jo(this, "shape", f), f;
    }
  });
  return Lo(o, u);
}
function H0(o, t) {
  if (!Vn(t))
    throw new Error("Invalid input to safeExtend: expected a plain object");
  const r = Do(o._zod.def, {
    get shape() {
      const a = { ...o._zod.def.shape, ...t };
      return jo(this, "shape", a), a;
    }
  });
  return Lo(o, r);
}
function W0(o, t) {
  const r = Do(o._zod.def, {
    get shape() {
      const a = { ...o._zod.def.shape, ...t._zod.def.shape };
      return jo(this, "shape", a), a;
    },
    get catchall() {
      return t._zod.def.catchall;
    },
    checks: []
    // delete existing checks
  });
  return Lo(o, r);
}
function V0(o, t, r) {
  const u = t._zod.def.checks;
  if (u && u.length > 0)
    throw new Error(".partial() cannot be used on object schemas containing refinements");
  const p = Do(t._zod.def, {
    get shape() {
      const b = t._zod.def.shape, T = { ...b };
      if (r)
        for (const v in r) {
          if (!(v in b))
            throw new Error(`Unrecognized key: "${v}"`);
          r[v] && (T[v] = o ? new o({
            type: "optional",
            innerType: b[v]
          }) : b[v]);
        }
      else
        for (const v in b)
          T[v] = o ? new o({
            type: "optional",
            innerType: b[v]
          }) : b[v];
      return jo(this, "shape", T), T;
    },
    checks: []
  });
  return Lo(t, p);
}
function J0(o, t, r) {
  const a = Do(t._zod.def, {
    get shape() {
      const u = t._zod.def.shape, f = { ...u };
      if (r)
        for (const p in r) {
          if (!(p in f))
            throw new Error(`Unrecognized key: "${p}"`);
          r[p] && (f[p] = new o({
            type: "nonoptional",
            innerType: u[p]
          }));
        }
      else
        for (const p in u)
          f[p] = new o({
            type: "nonoptional",
            innerType: u[p]
          });
      return jo(this, "shape", f), f;
    }
  });
  return Lo(t, a);
}
function hn(o, t = 0) {
  if (o.aborted === !0)
    return !0;
  for (let r = t; r < o.issues.length; r++)
    if (o.issues[r]?.continue !== !0)
      return !0;
  return !1;
}
function ol(o, t) {
  return t.map((r) => {
    var a;
    return (a = r).path ?? (a.path = []), r.path.unshift(o), r;
  });
}
function $t(o) {
  return typeof o == "string" ? o : o?.message;
}
function Jo(o, t, r) {
  const a = { ...o, path: o.path ?? [] };
  if (!o.message) {
    const u = $t(o.inst?._zod.def?.error?.(o)) ?? $t(t?.error?.(o)) ?? $t(r.customError?.(o)) ?? $t(r.localeError?.(o)) ?? "Invalid input";
    a.message = u;
  }
  return delete a.inst, delete a.continue, t?.reportInput || delete a.input, a;
}
function Ri(o) {
  return Array.isArray(o) ? "array" : typeof o == "string" ? "string" : "unknown";
}
function Jn(...o) {
  const [t, r, a] = o;
  return typeof t == "string" ? {
    message: t,
    code: "custom",
    input: r,
    inst: a
  } : { ...t };
}
const nl = (o, t) => {
  o.name = "$ZodError", Object.defineProperty(o, "_zod", {
    value: o._zod,
    enumerable: !1
  }), Object.defineProperty(o, "issues", {
    value: t,
    enumerable: !1
  }), o.message = JSON.stringify(t, Ni, 2), Object.defineProperty(o, "toString", {
    value: () => o.message,
    enumerable: !1
  });
}, tl = I("$ZodError", nl), rl = I("$ZodError", nl, { Parent: Error });
function j0(o, t = (r) => r.message) {
  const r = {}, a = [];
  for (const u of o.issues)
    u.path.length > 0 ? (r[u.path[0]] = r[u.path[0]] || [], r[u.path[0]].push(t(u))) : a.push(t(u));
  return { formErrors: a, fieldErrors: r };
}
function Y0(o, t = (r) => r.message) {
  const r = { _errors: [] }, a = (u) => {
    for (const f of u.issues)
      if (f.code === "invalid_union" && f.errors.length)
        f.errors.map((p) => a({ issues: p }));
      else if (f.code === "invalid_key")
        a({ issues: f.issues });
      else if (f.code === "invalid_element")
        a({ issues: f.issues });
      else if (f.path.length === 0)
        r._errors.push(t(f));
      else {
        let p = r, b = 0;
        for (; b < f.path.length; ) {
          const T = f.path[b];
          b === f.path.length - 1 ? (p[T] = p[T] || { _errors: [] }, p[T]._errors.push(t(f))) : p[T] = p[T] || { _errors: [] }, p = p[T], b++;
        }
      }
  };
  return a(o), r;
}
const Oi = (o) => (t, r, a, u) => {
  const f = a ? Object.assign(a, { async: !1 }) : { async: !1 }, p = t._zod.run({ value: r, issues: [] }, f);
  if (p instanceof Promise)
    throw new _n();
  if (p.issues.length) {
    const b = new (u?.Err ?? o)(p.issues.map((T) => Jo(T, f, Vo())));
    throw Qu(b, u?.callee), b;
  }
  return p.value;
}, zi = (o) => async (t, r, a, u) => {
  const f = a ? Object.assign(a, { async: !0 }) : { async: !0 };
  let p = t._zod.run({ value: r, issues: [] }, f);
  if (p instanceof Promise && (p = await p), p.issues.length) {
    const b = new (u?.Err ?? o)(p.issues.map((T) => Jo(T, f, Vo())));
    throw Qu(b, u?.callee), b;
  }
  return p.value;
}, Xt = (o) => (t, r, a) => {
  const u = a ? { ...a, async: !1 } : { async: !1 }, f = t._zod.run({ value: r, issues: [] }, u);
  if (f instanceof Promise)
    throw new _n();
  return f.issues.length ? {
    success: !1,
    error: new (o ?? tl)(f.issues.map((p) => Jo(p, u, Vo())))
  } : { success: !0, data: f.value };
}, X0 = /* @__PURE__ */ Xt(rl), Qt = (o) => async (t, r, a) => {
  const u = a ? Object.assign(a, { async: !0 }) : { async: !0 };
  let f = t._zod.run({ value: r, issues: [] }, u);
  return f instanceof Promise && (f = await f), f.issues.length ? {
    success: !1,
    error: new o(f.issues.map((p) => Jo(p, u, Vo())))
  } : { success: !0, data: f.value };
}, Q0 = /* @__PURE__ */ Qt(rl), eb = (o) => (t, r, a) => {
  const u = a ? Object.assign(a, { direction: "backward" }) : { direction: "backward" };
  return Oi(o)(t, r, u);
}, ob = (o) => (t, r, a) => Oi(o)(t, r, a), nb = (o) => async (t, r, a) => {
  const u = a ? Object.assign(a, { direction: "backward" }) : { direction: "backward" };
  return zi(o)(t, r, u);
}, tb = (o) => async (t, r, a) => zi(o)(t, r, a), rb = (o) => (t, r, a) => {
  const u = a ? Object.assign(a, { direction: "backward" }) : { direction: "backward" };
  return Xt(o)(t, r, u);
}, ib = (o) => (t, r, a) => Xt(o)(t, r, a), ab = (o) => async (t, r, a) => {
  const u = a ? Object.assign(a, { direction: "backward" }) : { direction: "backward" };
  return Qt(o)(t, r, u);
}, sb = (o) => async (t, r, a) => Qt(o)(t, r, a), ub = /^[cC][^\s-]{8,}$/, lb = /^[0-9a-z]+$/, cb = /^[0-9A-HJKMNP-TV-Za-hjkmnp-tv-z]{26}$/, db = /^[0-9a-vA-V]{20}$/, pb = /^[A-Za-z0-9]{27}$/, fb = /^[a-zA-Z0-9_-]{21}$/, hb = /^P(?:(\d+W)|(?!.*W)(?=\d|T\d)(\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+([.,]\d+)?S)?)?)$/, mb = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/, Nu = (o) => o ? new RegExp(`^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-${o}[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})$`) : /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/, _b = /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/, bb = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
function Ab() {
  return new RegExp(bb, "u");
}
const gb = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, yb = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))$/, Tb = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/([0-9]|[1-2][0-9]|3[0-2])$/, Mb = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, Ib = /^$|^(?:[0-9a-zA-Z+/]{4})*(?:(?:[0-9a-zA-Z+/]{2}==)|(?:[0-9a-zA-Z+/]{3}=))?$/, il = /^[A-Za-z0-9_-]*$/, Sb = /^\+[1-9]\d{6,14}$/, al = "(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))", xb = /* @__PURE__ */ new RegExp(`^${al}$`);
function sl(o) {
  const t = "(?:[01]\\d|2[0-3]):[0-5]\\d";
  return typeof o.precision == "number" ? o.precision === -1 ? `${t}` : o.precision === 0 ? `${t}:[0-5]\\d` : `${t}:[0-5]\\d\\.\\d{${o.precision}}` : `${t}(?::[0-5]\\d(?:\\.\\d+)?)?`;
}
function vb(o) {
  return new RegExp(`^${sl(o)}$`);
}
function Nb(o) {
  const t = sl({ precision: o.precision }), r = ["Z"];
  o.local && r.push(""), o.offset && r.push("([+-](?:[01]\\d|2[0-3]):[0-5]\\d)");
  const a = `${t}(?:${r.join("|")})`;
  return new RegExp(`^${al}T(?:${a})$`);
}
const Fb = (o) => {
  const t = o ? `[\\s\\S]{${o?.minimum ?? 0},${o?.maximum ?? ""}}` : "[\\s\\S]*";
  return new RegExp(`^${t}$`);
}, wb = /^-?\d+$/, Cb = /^-?\d+(?:\.\d+)?$/, Eb = /^[^A-Z]*$/, Bb = /^[^a-z]*$/, Ce = /* @__PURE__ */ I("$ZodCheck", (o, t) => {
  var r;
  o._zod ?? (o._zod = {}), o._zod.def = t, (r = o._zod).onattach ?? (r.onattach = []);
}), ul = {
  number: "number",
  bigint: "bigint",
  object: "date"
}, ll = /* @__PURE__ */ I("$ZodCheckLessThan", (o, t) => {
  Ce.init(o, t);
  const r = ul[typeof t.value];
  o._zod.onattach.push((a) => {
    const u = a._zod.bag, f = (t.inclusive ? u.maximum : u.exclusiveMaximum) ?? Number.POSITIVE_INFINITY;
    t.value < f && (t.inclusive ? u.maximum = t.value : u.exclusiveMaximum = t.value);
  }), o._zod.check = (a) => {
    (t.inclusive ? a.value <= t.value : a.value < t.value) || a.issues.push({
      origin: r,
      code: "too_big",
      maximum: typeof t.value == "object" ? t.value.getTime() : t.value,
      input: a.value,
      inclusive: t.inclusive,
      inst: o,
      continue: !t.abort
    });
  };
}), cl = /* @__PURE__ */ I("$ZodCheckGreaterThan", (o, t) => {
  Ce.init(o, t);
  const r = ul[typeof t.value];
  o._zod.onattach.push((a) => {
    const u = a._zod.bag, f = (t.inclusive ? u.minimum : u.exclusiveMinimum) ?? Number.NEGATIVE_INFINITY;
    t.value > f && (t.inclusive ? u.minimum = t.value : u.exclusiveMinimum = t.value);
  }), o._zod.check = (a) => {
    (t.inclusive ? a.value >= t.value : a.value > t.value) || a.issues.push({
      origin: r,
      code: "too_small",
      minimum: typeof t.value == "object" ? t.value.getTime() : t.value,
      input: a.value,
      inclusive: t.inclusive,
      inst: o,
      continue: !t.abort
    });
  };
}), kb = /* @__PURE__ */ I("$ZodCheckMultipleOf", (o, t) => {
  Ce.init(o, t), o._zod.onattach.push((r) => {
    var a;
    (a = r._zod.bag).multipleOf ?? (a.multipleOf = t.value);
  }), o._zod.check = (r) => {
    if (typeof r.value != typeof t.value)
      throw new Error("Cannot mix number and bigint in multiple_of check.");
    (typeof r.value == "bigint" ? r.value % t.value === BigInt(0) : R0(r.value, t.value) === 0) || r.issues.push({
      origin: typeof r.value,
      code: "not_multiple_of",
      divisor: t.value,
      input: r.value,
      inst: o,
      continue: !t.abort
    });
  };
}), Db = /* @__PURE__ */ I("$ZodCheckNumberFormat", (o, t) => {
  Ce.init(o, t), t.format = t.format || "float64";
  const r = t.format?.includes("int"), a = r ? "int" : "number", [u, f] = U0[t.format];
  o._zod.onattach.push((p) => {
    const b = p._zod.bag;
    b.format = t.format, b.minimum = u, b.maximum = f, r && (b.pattern = wb);
  }), o._zod.check = (p) => {
    const b = p.value;
    if (r) {
      if (!Number.isInteger(b)) {
        p.issues.push({
          expected: a,
          format: t.format,
          code: "invalid_type",
          continue: !1,
          input: b,
          inst: o
        });
        return;
      }
      if (!Number.isSafeInteger(b)) {
        b > 0 ? p.issues.push({
          input: b,
          code: "too_big",
          maximum: Number.MAX_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: o,
          origin: a,
          inclusive: !0,
          continue: !t.abort
        }) : p.issues.push({
          input: b,
          code: "too_small",
          minimum: Number.MIN_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: o,
          origin: a,
          inclusive: !0,
          continue: !t.abort
        });
        return;
      }
    }
    b < u && p.issues.push({
      origin: "number",
      input: b,
      code: "too_small",
      minimum: u,
      inclusive: !0,
      inst: o,
      continue: !t.abort
    }), b > f && p.issues.push({
      origin: "number",
      input: b,
      code: "too_big",
      maximum: f,
      inclusive: !0,
      inst: o,
      continue: !t.abort
    });
  };
}), Lb = /* @__PURE__ */ I("$ZodCheckMaxLength", (o, t) => {
  var r;
  Ce.init(o, t), (r = o._zod.def).when ?? (r.when = (a) => {
    const u = a.value;
    return !Li(u) && u.length !== void 0;
  }), o._zod.onattach.push((a) => {
    const u = a._zod.bag.maximum ?? Number.POSITIVE_INFINITY;
    t.maximum < u && (a._zod.bag.maximum = t.maximum);
  }), o._zod.check = (a) => {
    const u = a.value;
    if (u.length <= t.maximum)
      return;
    const p = Ri(u);
    a.issues.push({
      origin: p,
      code: "too_big",
      maximum: t.maximum,
      inclusive: !0,
      input: u,
      inst: o,
      continue: !t.abort
    });
  };
}), Pb = /* @__PURE__ */ I("$ZodCheckMinLength", (o, t) => {
  var r;
  Ce.init(o, t), (r = o._zod.def).when ?? (r.when = (a) => {
    const u = a.value;
    return !Li(u) && u.length !== void 0;
  }), o._zod.onattach.push((a) => {
    const u = a._zod.bag.minimum ?? Number.NEGATIVE_INFINITY;
    t.minimum > u && (a._zod.bag.minimum = t.minimum);
  }), o._zod.check = (a) => {
    const u = a.value;
    if (u.length >= t.minimum)
      return;
    const p = Ri(u);
    a.issues.push({
      origin: p,
      code: "too_small",
      minimum: t.minimum,
      inclusive: !0,
      input: u,
      inst: o,
      continue: !t.abort
    });
  };
}), Rb = /* @__PURE__ */ I("$ZodCheckLengthEquals", (o, t) => {
  var r;
  Ce.init(o, t), (r = o._zod.def).when ?? (r.when = (a) => {
    const u = a.value;
    return !Li(u) && u.length !== void 0;
  }), o._zod.onattach.push((a) => {
    const u = a._zod.bag;
    u.minimum = t.length, u.maximum = t.length, u.length = t.length;
  }), o._zod.check = (a) => {
    const u = a.value, f = u.length;
    if (f === t.length)
      return;
    const p = Ri(u), b = f > t.length;
    a.issues.push({
      origin: p,
      ...b ? { code: "too_big", maximum: t.length } : { code: "too_small", minimum: t.length },
      inclusive: !0,
      exact: !0,
      input: a.value,
      inst: o,
      continue: !t.abort
    });
  };
}), er = /* @__PURE__ */ I("$ZodCheckStringFormat", (o, t) => {
  var r, a;
  Ce.init(o, t), o._zod.onattach.push((u) => {
    const f = u._zod.bag;
    f.format = t.format, t.pattern && (f.patterns ?? (f.patterns = /* @__PURE__ */ new Set()), f.patterns.add(t.pattern));
  }), t.pattern ? (r = o._zod).check ?? (r.check = (u) => {
    t.pattern.lastIndex = 0, !t.pattern.test(u.value) && u.issues.push({
      origin: "string",
      code: "invalid_format",
      format: t.format,
      input: u.value,
      ...t.pattern ? { pattern: t.pattern.toString() } : {},
      inst: o,
      continue: !t.abort
    });
  }) : (a = o._zod).check ?? (a.check = () => {
  });
}), Ob = /* @__PURE__ */ I("$ZodCheckRegex", (o, t) => {
  er.init(o, t), o._zod.check = (r) => {
    t.pattern.lastIndex = 0, !t.pattern.test(r.value) && r.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "regex",
      input: r.value,
      pattern: t.pattern.toString(),
      inst: o,
      continue: !t.abort
    });
  };
}), zb = /* @__PURE__ */ I("$ZodCheckLowerCase", (o, t) => {
  t.pattern ?? (t.pattern = Eb), er.init(o, t);
}), Gb = /* @__PURE__ */ I("$ZodCheckUpperCase", (o, t) => {
  t.pattern ?? (t.pattern = Bb), er.init(o, t);
}), Zb = /* @__PURE__ */ I("$ZodCheckIncludes", (o, t) => {
  Ce.init(o, t);
  const r = bn(t.includes), a = new RegExp(typeof t.position == "number" ? `^.{${t.position}}${r}` : r);
  t.pattern = a, o._zod.onattach.push((u) => {
    const f = u._zod.bag;
    f.patterns ?? (f.patterns = /* @__PURE__ */ new Set()), f.patterns.add(a);
  }), o._zod.check = (u) => {
    u.value.includes(t.includes, t.position) || u.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "includes",
      includes: t.includes,
      input: u.value,
      inst: o,
      continue: !t.abort
    });
  };
}), Ub = /* @__PURE__ */ I("$ZodCheckStartsWith", (o, t) => {
  Ce.init(o, t);
  const r = new RegExp(`^${bn(t.prefix)}.*`);
  t.pattern ?? (t.pattern = r), o._zod.onattach.push((a) => {
    const u = a._zod.bag;
    u.patterns ?? (u.patterns = /* @__PURE__ */ new Set()), u.patterns.add(r);
  }), o._zod.check = (a) => {
    a.value.startsWith(t.prefix) || a.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "starts_with",
      prefix: t.prefix,
      input: a.value,
      inst: o,
      continue: !t.abort
    });
  };
}), $b = /* @__PURE__ */ I("$ZodCheckEndsWith", (o, t) => {
  Ce.init(o, t);
  const r = new RegExp(`.*${bn(t.suffix)}$`);
  t.pattern ?? (t.pattern = r), o._zod.onattach.push((a) => {
    const u = a._zod.bag;
    u.patterns ?? (u.patterns = /* @__PURE__ */ new Set()), u.patterns.add(r);
  }), o._zod.check = (a) => {
    a.value.endsWith(t.suffix) || a.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "ends_with",
      suffix: t.suffix,
      input: a.value,
      inst: o,
      continue: !t.abort
    });
  };
}), Kb = /* @__PURE__ */ I("$ZodCheckOverwrite", (o, t) => {
  Ce.init(o, t), o._zod.check = (r) => {
    r.value = t.tx(r.value);
  };
});
class qb {
  constructor(t = []) {
    this.content = [], this.indent = 0, this && (this.args = t);
  }
  indented(t) {
    this.indent += 1, t(this), this.indent -= 1;
  }
  write(t) {
    if (typeof t == "function") {
      t(this, { execution: "sync" }), t(this, { execution: "async" });
      return;
    }
    const a = t.split(`
`).filter((p) => p), u = Math.min(...a.map((p) => p.length - p.trimStart().length)), f = a.map((p) => p.slice(u)).map((p) => " ".repeat(this.indent * 2) + p);
    for (const p of f)
      this.content.push(p);
  }
  compile() {
    const t = Function, r = this?.args, u = [...(this?.content ?? [""]).map((f) => `  ${f}`)];
    return new t(...r, u.join(`
`));
  }
}
const Hb = {
  major: 4,
  minor: 3,
  patch: 6
}, ce = /* @__PURE__ */ I("$ZodType", (o, t) => {
  var r;
  o ?? (o = {}), o._zod.def = t, o._zod.bag = o._zod.bag || {}, o._zod.version = Hb;
  const a = [...o._zod.def.checks ?? []];
  o._zod.traits.has("$ZodCheck") && a.unshift(o);
  for (const u of a)
    for (const f of u._zod.onattach)
      f(o);
  if (a.length === 0)
    (r = o._zod).deferred ?? (r.deferred = []), o._zod.deferred?.push(() => {
      o._zod.run = o._zod.parse;
    });
  else {
    const u = (p, b, T) => {
      let v = hn(p), w;
      for (const z of b) {
        if (z._zod.def.when) {
          if (!z._zod.def.when(p))
            continue;
        } else if (v)
          continue;
        const B = p.issues.length, R = z._zod.check(p);
        if (R instanceof Promise && T?.async === !1)
          throw new _n();
        if (w || R instanceof Promise)
          w = (w ?? Promise.resolve()).then(async () => {
            await R, p.issues.length !== B && (v || (v = hn(p, B)));
          });
        else {
          if (p.issues.length === B)
            continue;
          v || (v = hn(p, B));
        }
      }
      return w ? w.then(() => p) : p;
    }, f = (p, b, T) => {
      if (hn(p))
        return p.aborted = !0, p;
      const v = u(b, a, T);
      if (v instanceof Promise) {
        if (T.async === !1)
          throw new _n();
        return v.then((w) => o._zod.parse(w, T));
      }
      return o._zod.parse(v, T);
    };
    o._zod.run = (p, b) => {
      if (b.skipChecks)
        return o._zod.parse(p, b);
      if (b.direction === "backward") {
        const v = o._zod.parse({ value: p.value, issues: [] }, { ...b, skipChecks: !0 });
        return v instanceof Promise ? v.then((w) => f(w, p, b)) : f(v, p, b);
      }
      const T = o._zod.parse(p, b);
      if (T instanceof Promise) {
        if (b.async === !1)
          throw new _n();
        return T.then((v) => u(v, a, b));
      }
      return u(T, a, b);
    };
  }
  j(o, "~standard", () => ({
    validate: (u) => {
      try {
        const f = X0(o, u);
        return f.success ? { value: f.data } : { issues: f.error?.issues };
      } catch {
        return Q0(o, u).then((p) => p.success ? { value: p.data } : { issues: p.error?.issues });
      }
    },
    vendor: "zod",
    version: 1
  }));
}), Gi = /* @__PURE__ */ I("$ZodString", (o, t) => {
  ce.init(o, t), o._zod.pattern = [...o?._zod.bag?.patterns ?? []].pop() ?? Fb(o._zod.bag), o._zod.parse = (r, a) => {
    if (t.coerce)
      try {
        r.value = String(r.value);
      } catch {
      }
    return typeof r.value == "string" || r.issues.push({
      expected: "string",
      code: "invalid_type",
      input: r.value,
      inst: o
    }), r;
  };
}), te = /* @__PURE__ */ I("$ZodStringFormat", (o, t) => {
  er.init(o, t), Gi.init(o, t);
}), Wb = /* @__PURE__ */ I("$ZodGUID", (o, t) => {
  t.pattern ?? (t.pattern = mb), te.init(o, t);
}), Vb = /* @__PURE__ */ I("$ZodUUID", (o, t) => {
  if (t.version) {
    const a = {
      v1: 1,
      v2: 2,
      v3: 3,
      v4: 4,
      v5: 5,
      v6: 6,
      v7: 7,
      v8: 8
    }[t.version];
    if (a === void 0)
      throw new Error(`Invalid UUID version: "${t.version}"`);
    t.pattern ?? (t.pattern = Nu(a));
  } else
    t.pattern ?? (t.pattern = Nu());
  te.init(o, t);
}), Jb = /* @__PURE__ */ I("$ZodEmail", (o, t) => {
  t.pattern ?? (t.pattern = _b), te.init(o, t);
}), jb = /* @__PURE__ */ I("$ZodURL", (o, t) => {
  te.init(o, t), o._zod.check = (r) => {
    try {
      const a = r.value.trim(), u = new URL(a);
      t.hostname && (t.hostname.lastIndex = 0, t.hostname.test(u.hostname) || r.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid hostname",
        pattern: t.hostname.source,
        input: r.value,
        inst: o,
        continue: !t.abort
      })), t.protocol && (t.protocol.lastIndex = 0, t.protocol.test(u.protocol.endsWith(":") ? u.protocol.slice(0, -1) : u.protocol) || r.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid protocol",
        pattern: t.protocol.source,
        input: r.value,
        inst: o,
        continue: !t.abort
      })), t.normalize ? r.value = u.href : r.value = a;
      return;
    } catch {
      r.issues.push({
        code: "invalid_format",
        format: "url",
        input: r.value,
        inst: o,
        continue: !t.abort
      });
    }
  };
}), Yb = /* @__PURE__ */ I("$ZodEmoji", (o, t) => {
  t.pattern ?? (t.pattern = Ab()), te.init(o, t);
}), Xb = /* @__PURE__ */ I("$ZodNanoID", (o, t) => {
  t.pattern ?? (t.pattern = fb), te.init(o, t);
}), Qb = /* @__PURE__ */ I("$ZodCUID", (o, t) => {
  t.pattern ?? (t.pattern = ub), te.init(o, t);
}), eA = /* @__PURE__ */ I("$ZodCUID2", (o, t) => {
  t.pattern ?? (t.pattern = lb), te.init(o, t);
}), oA = /* @__PURE__ */ I("$ZodULID", (o, t) => {
  t.pattern ?? (t.pattern = cb), te.init(o, t);
}), nA = /* @__PURE__ */ I("$ZodXID", (o, t) => {
  t.pattern ?? (t.pattern = db), te.init(o, t);
}), tA = /* @__PURE__ */ I("$ZodKSUID", (o, t) => {
  t.pattern ?? (t.pattern = pb), te.init(o, t);
}), rA = /* @__PURE__ */ I("$ZodISODateTime", (o, t) => {
  t.pattern ?? (t.pattern = Nb(t)), te.init(o, t);
}), iA = /* @__PURE__ */ I("$ZodISODate", (o, t) => {
  t.pattern ?? (t.pattern = xb), te.init(o, t);
}), aA = /* @__PURE__ */ I("$ZodISOTime", (o, t) => {
  t.pattern ?? (t.pattern = vb(t)), te.init(o, t);
}), sA = /* @__PURE__ */ I("$ZodISODuration", (o, t) => {
  t.pattern ?? (t.pattern = hb), te.init(o, t);
}), uA = /* @__PURE__ */ I("$ZodIPv4", (o, t) => {
  t.pattern ?? (t.pattern = gb), te.init(o, t), o._zod.bag.format = "ipv4";
}), lA = /* @__PURE__ */ I("$ZodIPv6", (o, t) => {
  t.pattern ?? (t.pattern = yb), te.init(o, t), o._zod.bag.format = "ipv6", o._zod.check = (r) => {
    try {
      new URL(`http://[${r.value}]`);
    } catch {
      r.issues.push({
        code: "invalid_format",
        format: "ipv6",
        input: r.value,
        inst: o,
        continue: !t.abort
      });
    }
  };
}), cA = /* @__PURE__ */ I("$ZodCIDRv4", (o, t) => {
  t.pattern ?? (t.pattern = Tb), te.init(o, t);
}), dA = /* @__PURE__ */ I("$ZodCIDRv6", (o, t) => {
  t.pattern ?? (t.pattern = Mb), te.init(o, t), o._zod.check = (r) => {
    const a = r.value.split("/");
    try {
      if (a.length !== 2)
        throw new Error();
      const [u, f] = a;
      if (!f)
        throw new Error();
      const p = Number(f);
      if (`${p}` !== f)
        throw new Error();
      if (p < 0 || p > 128)
        throw new Error();
      new URL(`http://[${u}]`);
    } catch {
      r.issues.push({
        code: "invalid_format",
        format: "cidrv6",
        input: r.value,
        inst: o,
        continue: !t.abort
      });
    }
  };
});
function dl(o) {
  if (o === "")
    return !0;
  if (o.length % 4 !== 0)
    return !1;
  try {
    return atob(o), !0;
  } catch {
    return !1;
  }
}
const pA = /* @__PURE__ */ I("$ZodBase64", (o, t) => {
  t.pattern ?? (t.pattern = Ib), te.init(o, t), o._zod.bag.contentEncoding = "base64", o._zod.check = (r) => {
    dl(r.value) || r.issues.push({
      code: "invalid_format",
      format: "base64",
      input: r.value,
      inst: o,
      continue: !t.abort
    });
  };
});
function fA(o) {
  if (!il.test(o))
    return !1;
  const t = o.replace(/[-_]/g, (a) => a === "-" ? "+" : "/"), r = t.padEnd(Math.ceil(t.length / 4) * 4, "=");
  return dl(r);
}
const hA = /* @__PURE__ */ I("$ZodBase64URL", (o, t) => {
  t.pattern ?? (t.pattern = il), te.init(o, t), o._zod.bag.contentEncoding = "base64url", o._zod.check = (r) => {
    fA(r.value) || r.issues.push({
      code: "invalid_format",
      format: "base64url",
      input: r.value,
      inst: o,
      continue: !t.abort
    });
  };
}), mA = /* @__PURE__ */ I("$ZodE164", (o, t) => {
  t.pattern ?? (t.pattern = Sb), te.init(o, t);
});
function _A(o, t = null) {
  try {
    const r = o.split(".");
    if (r.length !== 3)
      return !1;
    const [a] = r;
    if (!a)
      return !1;
    const u = JSON.parse(atob(a));
    return !("typ" in u && u?.typ !== "JWT" || !u.alg || t && (!("alg" in u) || u.alg !== t));
  } catch {
    return !1;
  }
}
const bA = /* @__PURE__ */ I("$ZodJWT", (o, t) => {
  te.init(o, t), o._zod.check = (r) => {
    _A(r.value, t.alg) || r.issues.push({
      code: "invalid_format",
      format: "jwt",
      input: r.value,
      inst: o,
      continue: !t.abort
    });
  };
}), pl = /* @__PURE__ */ I("$ZodNumber", (o, t) => {
  ce.init(o, t), o._zod.pattern = o._zod.bag.pattern ?? Cb, o._zod.parse = (r, a) => {
    if (t.coerce)
      try {
        r.value = Number(r.value);
      } catch {
      }
    const u = r.value;
    if (typeof u == "number" && !Number.isNaN(u) && Number.isFinite(u))
      return r;
    const f = typeof u == "number" ? Number.isNaN(u) ? "NaN" : Number.isFinite(u) ? void 0 : "Infinity" : void 0;
    return r.issues.push({
      expected: "number",
      code: "invalid_type",
      input: u,
      inst: o,
      ...f ? { received: f } : {}
    }), r;
  };
}), AA = /* @__PURE__ */ I("$ZodNumberFormat", (o, t) => {
  Db.init(o, t), pl.init(o, t);
}), gA = /* @__PURE__ */ I("$ZodUnknown", (o, t) => {
  ce.init(o, t), o._zod.parse = (r) => r;
}), yA = /* @__PURE__ */ I("$ZodNever", (o, t) => {
  ce.init(o, t), o._zod.parse = (r, a) => (r.issues.push({
    expected: "never",
    code: "invalid_type",
    input: r.value,
    inst: o
  }), r);
});
function Fu(o, t, r) {
  o.issues.length && t.issues.push(...ol(r, o.issues)), t.value[r] = o.value;
}
const TA = /* @__PURE__ */ I("$ZodArray", (o, t) => {
  ce.init(o, t), o._zod.parse = (r, a) => {
    const u = r.value;
    if (!Array.isArray(u))
      return r.issues.push({
        expected: "array",
        code: "invalid_type",
        input: u,
        inst: o
      }), r;
    r.value = Array(u.length);
    const f = [];
    for (let p = 0; p < u.length; p++) {
      const b = u[p], T = t.element._zod.run({
        value: b,
        issues: []
      }, a);
      T instanceof Promise ? f.push(T.then((v) => Fu(v, r, p))) : Fu(T, r, p);
    }
    return f.length ? Promise.all(f).then(() => r) : r;
  };
});
function Wt(o, t, r, a, u) {
  if (o.issues.length) {
    if (u && !(r in a))
      return;
    t.issues.push(...ol(r, o.issues));
  }
  o.value === void 0 ? r in a && (t.value[r] = void 0) : t.value[r] = o.value;
}
function fl(o) {
  const t = Object.keys(o.shape);
  for (const a of t)
    if (!o.shape?.[a]?._zod?.traits?.has("$ZodType"))
      throw new Error(`Invalid element at key "${a}": expected a Zod schema`);
  const r = Z0(o.shape);
  return {
    ...o,
    keys: t,
    keySet: new Set(t),
    numKeys: t.length,
    optionalKeys: new Set(r)
  };
}
function hl(o, t, r, a, u, f) {
  const p = [], b = u.keySet, T = u.catchall._zod, v = T.def.type, w = T.optout === "optional";
  for (const z in t) {
    if (b.has(z))
      continue;
    if (v === "never") {
      p.push(z);
      continue;
    }
    const B = T.run({ value: t[z], issues: [] }, a);
    B instanceof Promise ? o.push(B.then((R) => Wt(R, r, z, t, w))) : Wt(B, r, z, t, w);
  }
  return p.length && r.issues.push({
    code: "unrecognized_keys",
    keys: p,
    input: t,
    inst: f
  }), o.length ? Promise.all(o).then(() => r) : r;
}
const MA = /* @__PURE__ */ I("$ZodObject", (o, t) => {
  if (ce.init(o, t), !Object.getOwnPropertyDescriptor(t, "shape")?.get) {
    const b = t.shape;
    Object.defineProperty(t, "shape", {
      get: () => {
        const T = { ...b };
        return Object.defineProperty(t, "shape", {
          value: T
        }), T;
      }
    });
  }
  const a = Di(() => fl(t));
  j(o._zod, "propValues", () => {
    const b = t.shape, T = {};
    for (const v in b) {
      const w = b[v]._zod;
      if (w.values) {
        T[v] ?? (T[v] = /* @__PURE__ */ new Set());
        for (const z of w.values)
          T[v].add(z);
      }
    }
    return T;
  });
  const u = Ht, f = t.catchall;
  let p;
  o._zod.parse = (b, T) => {
    p ?? (p = a.value);
    const v = b.value;
    if (!u(v))
      return b.issues.push({
        expected: "object",
        code: "invalid_type",
        input: v,
        inst: o
      }), b;
    b.value = {};
    const w = [], z = p.shape;
    for (const B of p.keys) {
      const R = z[B], ae = R._zod.optout === "optional", ee = R._zod.run({ value: v[B], issues: [] }, T);
      ee instanceof Promise ? w.push(ee.then((uo) => Wt(uo, b, B, v, ae))) : Wt(ee, b, B, v, ae);
    }
    return f ? hl(w, v, b, T, a.value, o) : w.length ? Promise.all(w).then(() => b) : b;
  };
}), IA = /* @__PURE__ */ I("$ZodObjectJIT", (o, t) => {
  MA.init(o, t);
  const r = o._zod.parse, a = Di(() => fl(t)), u = (B) => {
    const R = new qb(["shape", "payload", "ctx"]), ae = a.value, ee = (Be) => {
      const oe = vu(Be);
      return `shape[${oe}]._zod.run({ value: input[${oe}], issues: [] }, ctx)`;
    };
    R.write("const input = payload.value;");
    const uo = /* @__PURE__ */ Object.create(null);
    let Ee = 0;
    for (const Be of ae.keys)
      uo[Be] = `key_${Ee++}`;
    R.write("const newResult = {};");
    for (const Be of ae.keys) {
      const oe = uo[Be], me = vu(Be), Po = B[Be]?._zod?.optout === "optional";
      R.write(`const ${oe} = ${ee(Be)};`), Po ? R.write(`
        if (${oe}.issues.length) {
          if (${me} in input) {
            payload.issues = payload.issues.concat(${oe}.issues.map(iss => ({
              ...iss,
              path: iss.path ? [${me}, ...iss.path] : [${me}]
            })));
          }
        }
        
        if (${oe}.value === undefined) {
          if (${me} in input) {
            newResult[${me}] = undefined;
          }
        } else {
          newResult[${me}] = ${oe}.value;
        }
        
      `) : R.write(`
        if (${oe}.issues.length) {
          payload.issues = payload.issues.concat(${oe}.issues.map(iss => ({
            ...iss,
            path: iss.path ? [${me}, ...iss.path] : [${me}]
          })));
        }
        
        if (${oe}.value === undefined) {
          if (${me} in input) {
            newResult[${me}] = undefined;
          }
        } else {
          newResult[${me}] = ${oe}.value;
        }
        
      `);
    }
    R.write("payload.value = newResult;"), R.write("return payload;");
    const To = R.compile();
    return (Be, oe) => To(B, Be, oe);
  };
  let f;
  const p = Ht, b = !Yu.jitless, v = b && z0.value, w = t.catchall;
  let z;
  o._zod.parse = (B, R) => {
    z ?? (z = a.value);
    const ae = B.value;
    return p(ae) ? b && v && R?.async === !1 && R.jitless !== !0 ? (f || (f = u(t.shape)), B = f(B, R), w ? hl([], ae, B, R, z, o) : B) : r(B, R) : (B.issues.push({
      expected: "object",
      code: "invalid_type",
      input: ae,
      inst: o
    }), B);
  };
});
function wu(o, t, r, a) {
  for (const f of o)
    if (f.issues.length === 0)
      return t.value = f.value, t;
  const u = o.filter((f) => !hn(f));
  return u.length === 1 ? (t.value = u[0].value, u[0]) : (t.issues.push({
    code: "invalid_union",
    input: t.value,
    inst: r,
    errors: o.map((f) => f.issues.map((p) => Jo(p, a, Vo())))
  }), t);
}
const SA = /* @__PURE__ */ I("$ZodUnion", (o, t) => {
  ce.init(o, t), j(o._zod, "optin", () => t.options.some((u) => u._zod.optin === "optional") ? "optional" : void 0), j(o._zod, "optout", () => t.options.some((u) => u._zod.optout === "optional") ? "optional" : void 0), j(o._zod, "values", () => {
    if (t.options.every((u) => u._zod.values))
      return new Set(t.options.flatMap((u) => Array.from(u._zod.values)));
  }), j(o._zod, "pattern", () => {
    if (t.options.every((u) => u._zod.pattern)) {
      const u = t.options.map((f) => f._zod.pattern);
      return new RegExp(`^(${u.map((f) => Pi(f.source)).join("|")})$`);
    }
  });
  const r = t.options.length === 1, a = t.options[0]._zod.run;
  o._zod.parse = (u, f) => {
    if (r)
      return a(u, f);
    let p = !1;
    const b = [];
    for (const T of t.options) {
      const v = T._zod.run({
        value: u.value,
        issues: []
      }, f);
      if (v instanceof Promise)
        b.push(v), p = !0;
      else {
        if (v.issues.length === 0)
          return v;
        b.push(v);
      }
    }
    return p ? Promise.all(b).then((T) => wu(T, u, o, f)) : wu(b, u, o, f);
  };
}), xA = /* @__PURE__ */ I("$ZodIntersection", (o, t) => {
  ce.init(o, t), o._zod.parse = (r, a) => {
    const u = r.value, f = t.left._zod.run({ value: u, issues: [] }, a), p = t.right._zod.run({ value: u, issues: [] }, a);
    return f instanceof Promise || p instanceof Promise ? Promise.all([f, p]).then(([T, v]) => Cu(r, T, v)) : Cu(r, f, p);
  };
});
function Fi(o, t) {
  if (o === t)
    return { valid: !0, data: o };
  if (o instanceof Date && t instanceof Date && +o == +t)
    return { valid: !0, data: o };
  if (Vn(o) && Vn(t)) {
    const r = Object.keys(t), a = Object.keys(o).filter((f) => r.indexOf(f) !== -1), u = { ...o, ...t };
    for (const f of a) {
      const p = Fi(o[f], t[f]);
      if (!p.valid)
        return {
          valid: !1,
          mergeErrorPath: [f, ...p.mergeErrorPath]
        };
      u[f] = p.data;
    }
    return { valid: !0, data: u };
  }
  if (Array.isArray(o) && Array.isArray(t)) {
    if (o.length !== t.length)
      return { valid: !1, mergeErrorPath: [] };
    const r = [];
    for (let a = 0; a < o.length; a++) {
      const u = o[a], f = t[a], p = Fi(u, f);
      if (!p.valid)
        return {
          valid: !1,
          mergeErrorPath: [a, ...p.mergeErrorPath]
        };
      r.push(p.data);
    }
    return { valid: !0, data: r };
  }
  return { valid: !1, mergeErrorPath: [] };
}
function Cu(o, t, r) {
  const a = /* @__PURE__ */ new Map();
  let u;
  for (const b of t.issues)
    if (b.code === "unrecognized_keys") {
      u ?? (u = b);
      for (const T of b.keys)
        a.has(T) || a.set(T, {}), a.get(T).l = !0;
    } else
      o.issues.push(b);
  for (const b of r.issues)
    if (b.code === "unrecognized_keys")
      for (const T of b.keys)
        a.has(T) || a.set(T, {}), a.get(T).r = !0;
    else
      o.issues.push(b);
  const f = [...a].filter(([, b]) => b.l && b.r).map(([b]) => b);
  if (f.length && u && o.issues.push({ ...u, keys: f }), hn(o))
    return o;
  const p = Fi(t.value, r.value);
  if (!p.valid)
    throw new Error(`Unmergable intersection. Error path: ${JSON.stringify(p.mergeErrorPath)}`);
  return o.value = p.data, o;
}
const vA = /* @__PURE__ */ I("$ZodEnum", (o, t) => {
  ce.init(o, t);
  const r = Xu(t.entries), a = new Set(r);
  o._zod.values = a, o._zod.pattern = new RegExp(`^(${r.filter((u) => G0.has(typeof u)).map((u) => typeof u == "string" ? bn(u) : u.toString()).join("|")})$`), o._zod.parse = (u, f) => {
    const p = u.value;
    return a.has(p) || u.issues.push({
      code: "invalid_value",
      values: r,
      input: p,
      inst: o
    }), u;
  };
}), NA = /* @__PURE__ */ I("$ZodLiteral", (o, t) => {
  if (ce.init(o, t), t.values.length === 0)
    throw new Error("Cannot create literal schema with no valid values");
  const r = new Set(t.values);
  o._zod.values = r, o._zod.pattern = new RegExp(`^(${t.values.map((a) => typeof a == "string" ? bn(a) : a ? bn(a.toString()) : String(a)).join("|")})$`), o._zod.parse = (a, u) => {
    const f = a.value;
    return r.has(f) || a.issues.push({
      code: "invalid_value",
      values: t.values,
      input: f,
      inst: o
    }), a;
  };
}), FA = /* @__PURE__ */ I("$ZodTransform", (o, t) => {
  ce.init(o, t), o._zod.parse = (r, a) => {
    if (a.direction === "backward")
      throw new ju(o.constructor.name);
    const u = t.transform(r.value, r);
    if (a.async)
      return (u instanceof Promise ? u : Promise.resolve(u)).then((p) => (r.value = p, r));
    if (u instanceof Promise)
      throw new _n();
    return r.value = u, r;
  };
});
function Eu(o, t) {
  return o.issues.length && t === void 0 ? { issues: [], value: void 0 } : o;
}
const ml = /* @__PURE__ */ I("$ZodOptional", (o, t) => {
  ce.init(o, t), o._zod.optin = "optional", o._zod.optout = "optional", j(o._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, void 0]) : void 0), j(o._zod, "pattern", () => {
    const r = t.innerType._zod.pattern;
    return r ? new RegExp(`^(${Pi(r.source)})?$`) : void 0;
  }), o._zod.parse = (r, a) => {
    if (t.innerType._zod.optin === "optional") {
      const u = t.innerType._zod.run(r, a);
      return u instanceof Promise ? u.then((f) => Eu(f, r.value)) : Eu(u, r.value);
    }
    return r.value === void 0 ? r : t.innerType._zod.run(r, a);
  };
}), wA = /* @__PURE__ */ I("$ZodExactOptional", (o, t) => {
  ml.init(o, t), j(o._zod, "values", () => t.innerType._zod.values), j(o._zod, "pattern", () => t.innerType._zod.pattern), o._zod.parse = (r, a) => t.innerType._zod.run(r, a);
}), CA = /* @__PURE__ */ I("$ZodNullable", (o, t) => {
  ce.init(o, t), j(o._zod, "optin", () => t.innerType._zod.optin), j(o._zod, "optout", () => t.innerType._zod.optout), j(o._zod, "pattern", () => {
    const r = t.innerType._zod.pattern;
    return r ? new RegExp(`^(${Pi(r.source)}|null)$`) : void 0;
  }), j(o._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, null]) : void 0), o._zod.parse = (r, a) => r.value === null ? r : t.innerType._zod.run(r, a);
}), EA = /* @__PURE__ */ I("$ZodDefault", (o, t) => {
  ce.init(o, t), o._zod.optin = "optional", j(o._zod, "values", () => t.innerType._zod.values), o._zod.parse = (r, a) => {
    if (a.direction === "backward")
      return t.innerType._zod.run(r, a);
    if (r.value === void 0)
      return r.value = t.defaultValue, r;
    const u = t.innerType._zod.run(r, a);
    return u instanceof Promise ? u.then((f) => Bu(f, t)) : Bu(u, t);
  };
});
function Bu(o, t) {
  return o.value === void 0 && (o.value = t.defaultValue), o;
}
const BA = /* @__PURE__ */ I("$ZodPrefault", (o, t) => {
  ce.init(o, t), o._zod.optin = "optional", j(o._zod, "values", () => t.innerType._zod.values), o._zod.parse = (r, a) => (a.direction === "backward" || r.value === void 0 && (r.value = t.defaultValue), t.innerType._zod.run(r, a));
}), kA = /* @__PURE__ */ I("$ZodNonOptional", (o, t) => {
  ce.init(o, t), j(o._zod, "values", () => {
    const r = t.innerType._zod.values;
    return r ? new Set([...r].filter((a) => a !== void 0)) : void 0;
  }), o._zod.parse = (r, a) => {
    const u = t.innerType._zod.run(r, a);
    return u instanceof Promise ? u.then((f) => ku(f, o)) : ku(u, o);
  };
});
function ku(o, t) {
  return !o.issues.length && o.value === void 0 && o.issues.push({
    code: "invalid_type",
    expected: "nonoptional",
    input: o.value,
    inst: t
  }), o;
}
const DA = /* @__PURE__ */ I("$ZodCatch", (o, t) => {
  ce.init(o, t), j(o._zod, "optin", () => t.innerType._zod.optin), j(o._zod, "optout", () => t.innerType._zod.optout), j(o._zod, "values", () => t.innerType._zod.values), o._zod.parse = (r, a) => {
    if (a.direction === "backward")
      return t.innerType._zod.run(r, a);
    const u = t.innerType._zod.run(r, a);
    return u instanceof Promise ? u.then((f) => (r.value = f.value, f.issues.length && (r.value = t.catchValue({
      ...r,
      error: {
        issues: f.issues.map((p) => Jo(p, a, Vo()))
      },
      input: r.value
    }), r.issues = []), r)) : (r.value = u.value, u.issues.length && (r.value = t.catchValue({
      ...r,
      error: {
        issues: u.issues.map((f) => Jo(f, a, Vo()))
      },
      input: r.value
    }), r.issues = []), r);
  };
}), LA = /* @__PURE__ */ I("$ZodPipe", (o, t) => {
  ce.init(o, t), j(o._zod, "values", () => t.in._zod.values), j(o._zod, "optin", () => t.in._zod.optin), j(o._zod, "optout", () => t.out._zod.optout), j(o._zod, "propValues", () => t.in._zod.propValues), o._zod.parse = (r, a) => {
    if (a.direction === "backward") {
      const f = t.out._zod.run(r, a);
      return f instanceof Promise ? f.then((p) => Kt(p, t.in, a)) : Kt(f, t.in, a);
    }
    const u = t.in._zod.run(r, a);
    return u instanceof Promise ? u.then((f) => Kt(f, t.out, a)) : Kt(u, t.out, a);
  };
});
function Kt(o, t, r) {
  return o.issues.length ? (o.aborted = !0, o) : t._zod.run({ value: o.value, issues: o.issues }, r);
}
const PA = /* @__PURE__ */ I("$ZodReadonly", (o, t) => {
  ce.init(o, t), j(o._zod, "propValues", () => t.innerType._zod.propValues), j(o._zod, "values", () => t.innerType._zod.values), j(o._zod, "optin", () => t.innerType?._zod?.optin), j(o._zod, "optout", () => t.innerType?._zod?.optout), o._zod.parse = (r, a) => {
    if (a.direction === "backward")
      return t.innerType._zod.run(r, a);
    const u = t.innerType._zod.run(r, a);
    return u instanceof Promise ? u.then(Du) : Du(u);
  };
});
function Du(o) {
  return o.value = Object.freeze(o.value), o;
}
const RA = /* @__PURE__ */ I("$ZodCustom", (o, t) => {
  Ce.init(o, t), ce.init(o, t), o._zod.parse = (r, a) => r, o._zod.check = (r) => {
    const a = r.value, u = t.fn(a);
    if (u instanceof Promise)
      return u.then((f) => Lu(f, r, a, o));
    Lu(u, r, a, o);
  };
});
function Lu(o, t, r, a) {
  if (!o) {
    const u = {
      code: "custom",
      input: r,
      inst: a,
      // incorporates params.error into issue reporting
      path: [...a._zod.def.path ?? []],
      // incorporates params.error into issue reporting
      continue: !a._zod.def.abort
      // params: inst._zod.def.params,
    };
    a._zod.def.params && (u.params = a._zod.def.params), t.issues.push(Jn(u));
  }
}
var Pu;
class OA {
  constructor() {
    this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map();
  }
  add(t, ...r) {
    const a = r[0];
    return this._map.set(t, a), a && typeof a == "object" && "id" in a && this._idmap.set(a.id, t), this;
  }
  clear() {
    return this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map(), this;
  }
  remove(t) {
    const r = this._map.get(t);
    return r && typeof r == "object" && "id" in r && this._idmap.delete(r.id), this._map.delete(t), this;
  }
  get(t) {
    const r = t._zod.parent;
    if (r) {
      const a = { ...this.get(r) ?? {} };
      delete a.id;
      const u = { ...a, ...this._map.get(t) };
      return Object.keys(u).length ? u : void 0;
    }
    return this._map.get(t);
  }
  has(t) {
    return this._map.has(t);
  }
}
function zA() {
  return new OA();
}
(Pu = globalThis).__zod_globalRegistry ?? (Pu.__zod_globalRegistry = zA());
const Kn = globalThis.__zod_globalRegistry;
// @__NO_SIDE_EFFECTS__
function GA(o, t) {
  return new o({
    type: "string",
    ...k(t)
  });
}
// @__NO_SIDE_EFFECTS__
function ZA(o, t) {
  return new o({
    type: "string",
    format: "email",
    check: "string_format",
    abort: !1,
    ...k(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Ru(o, t) {
  return new o({
    type: "string",
    format: "guid",
    check: "string_format",
    abort: !1,
    ...k(t)
  });
}
// @__NO_SIDE_EFFECTS__
function _l(o, t) {
  return new o({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    ...k(t)
  });
}
// @__NO_SIDE_EFFECTS__
function UA(o, t) {
  return new o({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v4",
    ...k(t)
  });
}
// @__NO_SIDE_EFFECTS__
function $A(o, t) {
  return new o({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v6",
    ...k(t)
  });
}
// @__NO_SIDE_EFFECTS__
function KA(o, t) {
  return new o({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v7",
    ...k(t)
  });
}
// @__NO_SIDE_EFFECTS__
function qA(o, t) {
  return new o({
    type: "string",
    format: "url",
    check: "string_format",
    abort: !1,
    ...k(t)
  });
}
// @__NO_SIDE_EFFECTS__
function HA(o, t) {
  return new o({
    type: "string",
    format: "emoji",
    check: "string_format",
    abort: !1,
    ...k(t)
  });
}
// @__NO_SIDE_EFFECTS__
function WA(o, t) {
  return new o({
    type: "string",
    format: "nanoid",
    check: "string_format",
    abort: !1,
    ...k(t)
  });
}
// @__NO_SIDE_EFFECTS__
function VA(o, t) {
  return new o({
    type: "string",
    format: "cuid",
    check: "string_format",
    abort: !1,
    ...k(t)
  });
}
// @__NO_SIDE_EFFECTS__
function JA(o, t) {
  return new o({
    type: "string",
    format: "cuid2",
    check: "string_format",
    abort: !1,
    ...k(t)
  });
}
// @__NO_SIDE_EFFECTS__
function jA(o, t) {
  return new o({
    type: "string",
    format: "ulid",
    check: "string_format",
    abort: !1,
    ...k(t)
  });
}
// @__NO_SIDE_EFFECTS__
function YA(o, t) {
  return new o({
    type: "string",
    format: "xid",
    check: "string_format",
    abort: !1,
    ...k(t)
  });
}
// @__NO_SIDE_EFFECTS__
function XA(o, t) {
  return new o({
    type: "string",
    format: "ksuid",
    check: "string_format",
    abort: !1,
    ...k(t)
  });
}
// @__NO_SIDE_EFFECTS__
function QA(o, t) {
  return new o({
    type: "string",
    format: "ipv4",
    check: "string_format",
    abort: !1,
    ...k(t)
  });
}
// @__NO_SIDE_EFFECTS__
function eg(o, t) {
  return new o({
    type: "string",
    format: "ipv6",
    check: "string_format",
    abort: !1,
    ...k(t)
  });
}
// @__NO_SIDE_EFFECTS__
function og(o, t) {
  return new o({
    type: "string",
    format: "cidrv4",
    check: "string_format",
    abort: !1,
    ...k(t)
  });
}
// @__NO_SIDE_EFFECTS__
function ng(o, t) {
  return new o({
    type: "string",
    format: "cidrv6",
    check: "string_format",
    abort: !1,
    ...k(t)
  });
}
// @__NO_SIDE_EFFECTS__
function tg(o, t) {
  return new o({
    type: "string",
    format: "base64",
    check: "string_format",
    abort: !1,
    ...k(t)
  });
}
// @__NO_SIDE_EFFECTS__
function rg(o, t) {
  return new o({
    type: "string",
    format: "base64url",
    check: "string_format",
    abort: !1,
    ...k(t)
  });
}
// @__NO_SIDE_EFFECTS__
function ig(o, t) {
  return new o({
    type: "string",
    format: "e164",
    check: "string_format",
    abort: !1,
    ...k(t)
  });
}
// @__NO_SIDE_EFFECTS__
function ag(o, t) {
  return new o({
    type: "string",
    format: "jwt",
    check: "string_format",
    abort: !1,
    ...k(t)
  });
}
// @__NO_SIDE_EFFECTS__
function sg(o, t) {
  return new o({
    type: "string",
    format: "datetime",
    check: "string_format",
    offset: !1,
    local: !1,
    precision: null,
    ...k(t)
  });
}
// @__NO_SIDE_EFFECTS__
function ug(o, t) {
  return new o({
    type: "string",
    format: "date",
    check: "string_format",
    ...k(t)
  });
}
// @__NO_SIDE_EFFECTS__
function lg(o, t) {
  return new o({
    type: "string",
    format: "time",
    check: "string_format",
    precision: null,
    ...k(t)
  });
}
// @__NO_SIDE_EFFECTS__
function cg(o, t) {
  return new o({
    type: "string",
    format: "duration",
    check: "string_format",
    ...k(t)
  });
}
// @__NO_SIDE_EFFECTS__
function dg(o, t) {
  return new o({
    type: "number",
    checks: [],
    ...k(t)
  });
}
// @__NO_SIDE_EFFECTS__
function pg(o, t) {
  return new o({
    type: "number",
    check: "number_format",
    abort: !1,
    format: "safeint",
    ...k(t)
  });
}
// @__NO_SIDE_EFFECTS__
function fg(o) {
  return new o({
    type: "unknown"
  });
}
// @__NO_SIDE_EFFECTS__
function hg(o, t) {
  return new o({
    type: "never",
    ...k(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Ou(o, t) {
  return new ll({
    check: "less_than",
    ...k(t),
    value: o,
    inclusive: !1
  });
}
// @__NO_SIDE_EFFECTS__
function xi(o, t) {
  return new ll({
    check: "less_than",
    ...k(t),
    value: o,
    inclusive: !0
  });
}
// @__NO_SIDE_EFFECTS__
function zu(o, t) {
  return new cl({
    check: "greater_than",
    ...k(t),
    value: o,
    inclusive: !1
  });
}
// @__NO_SIDE_EFFECTS__
function vi(o, t) {
  return new cl({
    check: "greater_than",
    ...k(t),
    value: o,
    inclusive: !0
  });
}
// @__NO_SIDE_EFFECTS__
function Gu(o, t) {
  return new kb({
    check: "multiple_of",
    ...k(t),
    value: o
  });
}
// @__NO_SIDE_EFFECTS__
function bl(o, t) {
  return new Lb({
    check: "max_length",
    ...k(t),
    maximum: o
  });
}
// @__NO_SIDE_EFFECTS__
function Vt(o, t) {
  return new Pb({
    check: "min_length",
    ...k(t),
    minimum: o
  });
}
// @__NO_SIDE_EFFECTS__
function Al(o, t) {
  return new Rb({
    check: "length_equals",
    ...k(t),
    length: o
  });
}
// @__NO_SIDE_EFFECTS__
function mg(o, t) {
  return new Ob({
    check: "string_format",
    format: "regex",
    ...k(t),
    pattern: o
  });
}
// @__NO_SIDE_EFFECTS__
function _g(o) {
  return new zb({
    check: "string_format",
    format: "lowercase",
    ...k(o)
  });
}
// @__NO_SIDE_EFFECTS__
function bg(o) {
  return new Gb({
    check: "string_format",
    format: "uppercase",
    ...k(o)
  });
}
// @__NO_SIDE_EFFECTS__
function Ag(o, t) {
  return new Zb({
    check: "string_format",
    format: "includes",
    ...k(t),
    includes: o
  });
}
// @__NO_SIDE_EFFECTS__
function gg(o, t) {
  return new Ub({
    check: "string_format",
    format: "starts_with",
    ...k(t),
    prefix: o
  });
}
// @__NO_SIDE_EFFECTS__
function yg(o, t) {
  return new $b({
    check: "string_format",
    format: "ends_with",
    ...k(t),
    suffix: o
  });
}
// @__NO_SIDE_EFFECTS__
function yn(o) {
  return new Kb({
    check: "overwrite",
    tx: o
  });
}
// @__NO_SIDE_EFFECTS__
function Tg(o) {
  return /* @__PURE__ */ yn((t) => t.normalize(o));
}
// @__NO_SIDE_EFFECTS__
function Mg() {
  return /* @__PURE__ */ yn((o) => o.trim());
}
// @__NO_SIDE_EFFECTS__
function Ig() {
  return /* @__PURE__ */ yn((o) => o.toLowerCase());
}
// @__NO_SIDE_EFFECTS__
function Sg() {
  return /* @__PURE__ */ yn((o) => o.toUpperCase());
}
// @__NO_SIDE_EFFECTS__
function xg() {
  return /* @__PURE__ */ yn((o) => O0(o));
}
// @__NO_SIDE_EFFECTS__
function vg(o, t, r) {
  return new o({
    type: "array",
    element: t,
    // get element() {
    //   return element;
    // },
    ...k(r)
  });
}
// @__NO_SIDE_EFFECTS__
function Ng(o, t, r) {
  return new o({
    type: "custom",
    check: "custom",
    fn: t,
    ...k(r)
  });
}
// @__NO_SIDE_EFFECTS__
function Fg(o) {
  const t = /* @__PURE__ */ wg((r) => (r.addIssue = (a) => {
    if (typeof a == "string")
      r.issues.push(Jn(a, r.value, t._zod.def));
    else {
      const u = a;
      u.fatal && (u.continue = !1), u.code ?? (u.code = "custom"), u.input ?? (u.input = r.value), u.inst ?? (u.inst = t), u.continue ?? (u.continue = !t._zod.def.abort), r.issues.push(Jn(u));
    }
  }, o(r.value, r)));
  return t;
}
// @__NO_SIDE_EFFECTS__
function wg(o, t) {
  const r = new Ce({
    check: "custom",
    ...k(t)
  });
  return r._zod.check = o, r;
}
function gl(o) {
  let t = o?.target ?? "draft-2020-12";
  return t === "draft-4" && (t = "draft-04"), t === "draft-7" && (t = "draft-07"), {
    processors: o.processors ?? {},
    metadataRegistry: o?.metadata ?? Kn,
    target: t,
    unrepresentable: o?.unrepresentable ?? "throw",
    override: o?.override ?? (() => {
    }),
    io: o?.io ?? "output",
    counter: 0,
    seen: /* @__PURE__ */ new Map(),
    cycles: o?.cycles ?? "ref",
    reused: o?.reused ?? "inline",
    external: o?.external ?? void 0
  };
}
function Ae(o, t, r = { path: [], schemaPath: [] }) {
  var a;
  const u = o._zod.def, f = t.seen.get(o);
  if (f)
    return f.count++, r.schemaPath.includes(o) && (f.cycle = r.path), f.schema;
  const p = { schema: {}, count: 1, cycle: void 0, path: r.path };
  t.seen.set(o, p);
  const b = o._zod.toJSONSchema?.();
  if (b)
    p.schema = b;
  else {
    const w = {
      ...r,
      schemaPath: [...r.schemaPath, o],
      path: r.path
    };
    if (o._zod.processJSONSchema)
      o._zod.processJSONSchema(t, p.schema, w);
    else {
      const B = p.schema, R = t.processors[u.type];
      if (!R)
        throw new Error(`[toJSONSchema]: Non-representable type encountered: ${u.type}`);
      R(o, t, B, w);
    }
    const z = o._zod.parent;
    z && (p.ref || (p.ref = z), Ae(z, t, w), t.seen.get(z).isParent = !0);
  }
  const T = t.metadataRegistry.get(o);
  return T && Object.assign(p.schema, T), t.io === "input" && Se(o) && (delete p.schema.examples, delete p.schema.default), t.io === "input" && p.schema._prefault && ((a = p.schema).default ?? (a.default = p.schema._prefault)), delete p.schema._prefault, t.seen.get(o).schema;
}
function yl(o, t) {
  const r = o.seen.get(t);
  if (!r)
    throw new Error("Unprocessed schema. This is a bug in Zod.");
  const a = /* @__PURE__ */ new Map();
  for (const p of o.seen.entries()) {
    const b = o.metadataRegistry.get(p[0])?.id;
    if (b) {
      const T = a.get(b);
      if (T && T !== p[0])
        throw new Error(`Duplicate schema id "${b}" detected during JSON Schema conversion. Two different schemas cannot share the same id when converted together.`);
      a.set(b, p[0]);
    }
  }
  const u = (p) => {
    const b = o.target === "draft-2020-12" ? "$defs" : "definitions";
    if (o.external) {
      const z = o.external.registry.get(p[0])?.id, B = o.external.uri ?? ((ae) => ae);
      if (z)
        return { ref: B(z) };
      const R = p[1].defId ?? p[1].schema.id ?? `schema${o.counter++}`;
      return p[1].defId = R, { defId: R, ref: `${B("__shared")}#/${b}/${R}` };
    }
    if (p[1] === r)
      return { ref: "#" };
    const v = `#/${b}/`, w = p[1].schema.id ?? `__schema${o.counter++}`;
    return { defId: w, ref: v + w };
  }, f = (p) => {
    if (p[1].schema.$ref)
      return;
    const b = p[1], { ref: T, defId: v } = u(p);
    b.def = { ...b.schema }, v && (b.defId = v);
    const w = b.schema;
    for (const z in w)
      delete w[z];
    w.$ref = T;
  };
  if (o.cycles === "throw")
    for (const p of o.seen.entries()) {
      const b = p[1];
      if (b.cycle)
        throw new Error(`Cycle detected: #/${b.cycle?.join("/")}/<root>

Set the \`cycles\` parameter to \`"ref"\` to resolve cyclical schemas with defs.`);
    }
  for (const p of o.seen.entries()) {
    const b = p[1];
    if (t === p[0]) {
      f(p);
      continue;
    }
    if (o.external) {
      const v = o.external.registry.get(p[0])?.id;
      if (t !== p[0] && v) {
        f(p);
        continue;
      }
    }
    if (o.metadataRegistry.get(p[0])?.id) {
      f(p);
      continue;
    }
    if (b.cycle) {
      f(p);
      continue;
    }
    if (b.count > 1 && o.reused === "ref") {
      f(p);
      continue;
    }
  }
}
function Tl(o, t) {
  const r = o.seen.get(t);
  if (!r)
    throw new Error("Unprocessed schema. This is a bug in Zod.");
  const a = (p) => {
    const b = o.seen.get(p);
    if (b.ref === null)
      return;
    const T = b.def ?? b.schema, v = { ...T }, w = b.ref;
    if (b.ref = null, w) {
      a(w);
      const B = o.seen.get(w), R = B.schema;
      if (R.$ref && (o.target === "draft-07" || o.target === "draft-04" || o.target === "openapi-3.0") ? (T.allOf = T.allOf ?? [], T.allOf.push(R)) : Object.assign(T, R), Object.assign(T, v), p._zod.parent === w)
        for (const ee in T)
          ee === "$ref" || ee === "allOf" || ee in v || delete T[ee];
      if (R.$ref && B.def)
        for (const ee in T)
          ee === "$ref" || ee === "allOf" || ee in B.def && JSON.stringify(T[ee]) === JSON.stringify(B.def[ee]) && delete T[ee];
    }
    const z = p._zod.parent;
    if (z && z !== w) {
      a(z);
      const B = o.seen.get(z);
      if (B?.schema.$ref && (T.$ref = B.schema.$ref, B.def))
        for (const R in T)
          R === "$ref" || R === "allOf" || R in B.def && JSON.stringify(T[R]) === JSON.stringify(B.def[R]) && delete T[R];
    }
    o.override({
      zodSchema: p,
      jsonSchema: T,
      path: b.path ?? []
    });
  };
  for (const p of [...o.seen.entries()].reverse())
    a(p[0]);
  const u = {};
  if (o.target === "draft-2020-12" ? u.$schema = "https://json-schema.org/draft/2020-12/schema" : o.target === "draft-07" ? u.$schema = "http://json-schema.org/draft-07/schema#" : o.target === "draft-04" ? u.$schema = "http://json-schema.org/draft-04/schema#" : o.target, o.external?.uri) {
    const p = o.external.registry.get(t)?.id;
    if (!p)
      throw new Error("Schema is missing an `id` property");
    u.$id = o.external.uri(p);
  }
  Object.assign(u, r.def ?? r.schema);
  const f = o.external?.defs ?? {};
  for (const p of o.seen.entries()) {
    const b = p[1];
    b.def && b.defId && (f[b.defId] = b.def);
  }
  o.external || Object.keys(f).length > 0 && (o.target === "draft-2020-12" ? u.$defs = f : u.definitions = f);
  try {
    const p = JSON.parse(JSON.stringify(u));
    return Object.defineProperty(p, "~standard", {
      value: {
        ...t["~standard"],
        jsonSchema: {
          input: Jt(t, "input", o.processors),
          output: Jt(t, "output", o.processors)
        }
      },
      enumerable: !1,
      writable: !1
    }), p;
  } catch {
    throw new Error("Error converting schema to JSON.");
  }
}
function Se(o, t) {
  const r = t ?? { seen: /* @__PURE__ */ new Set() };
  if (r.seen.has(o))
    return !1;
  r.seen.add(o);
  const a = o._zod.def;
  if (a.type === "transform")
    return !0;
  if (a.type === "array")
    return Se(a.element, r);
  if (a.type === "set")
    return Se(a.valueType, r);
  if (a.type === "lazy")
    return Se(a.getter(), r);
  if (a.type === "promise" || a.type === "optional" || a.type === "nonoptional" || a.type === "nullable" || a.type === "readonly" || a.type === "default" || a.type === "prefault")
    return Se(a.innerType, r);
  if (a.type === "intersection")
    return Se(a.left, r) || Se(a.right, r);
  if (a.type === "record" || a.type === "map")
    return Se(a.keyType, r) || Se(a.valueType, r);
  if (a.type === "pipe")
    return Se(a.in, r) || Se(a.out, r);
  if (a.type === "object") {
    for (const u in a.shape)
      if (Se(a.shape[u], r))
        return !0;
    return !1;
  }
  if (a.type === "union") {
    for (const u of a.options)
      if (Se(u, r))
        return !0;
    return !1;
  }
  if (a.type === "tuple") {
    for (const u of a.items)
      if (Se(u, r))
        return !0;
    return !!(a.rest && Se(a.rest, r));
  }
  return !1;
}
const Cg = (o, t = {}) => (r) => {
  const a = gl({ ...r, processors: t });
  return Ae(o, a), yl(a, o), Tl(a, o);
}, Jt = (o, t, r = {}) => (a) => {
  const { libraryOptions: u, target: f } = a ?? {}, p = gl({ ...u ?? {}, target: f, io: t, processors: r });
  return Ae(o, p), yl(p, o), Tl(p, o);
}, Eg = {
  guid: "uuid",
  url: "uri",
  datetime: "date-time",
  json_string: "json-string",
  regex: ""
  // do not set
}, Bg = (o, t, r, a) => {
  const u = r;
  u.type = "string";
  const { minimum: f, maximum: p, format: b, patterns: T, contentEncoding: v } = o._zod.bag;
  if (typeof f == "number" && (u.minLength = f), typeof p == "number" && (u.maxLength = p), b && (u.format = Eg[b] ?? b, u.format === "" && delete u.format, b === "time" && delete u.format), v && (u.contentEncoding = v), T && T.size > 0) {
    const w = [...T];
    w.length === 1 ? u.pattern = w[0].source : w.length > 1 && (u.allOf = [
      ...w.map((z) => ({
        ...t.target === "draft-07" || t.target === "draft-04" || t.target === "openapi-3.0" ? { type: "string" } : {},
        pattern: z.source
      }))
    ]);
  }
}, kg = (o, t, r, a) => {
  const u = r, { minimum: f, maximum: p, format: b, multipleOf: T, exclusiveMaximum: v, exclusiveMinimum: w } = o._zod.bag;
  typeof b == "string" && b.includes("int") ? u.type = "integer" : u.type = "number", typeof w == "number" && (t.target === "draft-04" || t.target === "openapi-3.0" ? (u.minimum = w, u.exclusiveMinimum = !0) : u.exclusiveMinimum = w), typeof f == "number" && (u.minimum = f, typeof w == "number" && t.target !== "draft-04" && (w >= f ? delete u.minimum : delete u.exclusiveMinimum)), typeof v == "number" && (t.target === "draft-04" || t.target === "openapi-3.0" ? (u.maximum = v, u.exclusiveMaximum = !0) : u.exclusiveMaximum = v), typeof p == "number" && (u.maximum = p, typeof v == "number" && t.target !== "draft-04" && (v <= p ? delete u.maximum : delete u.exclusiveMaximum)), typeof T == "number" && (u.multipleOf = T);
}, Dg = (o, t, r, a) => {
  r.not = {};
}, Lg = (o, t, r, a) => {
}, Pg = (o, t, r, a) => {
  const u = o._zod.def, f = Xu(u.entries);
  f.every((p) => typeof p == "number") && (r.type = "number"), f.every((p) => typeof p == "string") && (r.type = "string"), r.enum = f;
}, Rg = (o, t, r, a) => {
  const u = o._zod.def, f = [];
  for (const p of u.values)
    if (p === void 0) {
      if (t.unrepresentable === "throw")
        throw new Error("Literal `undefined` cannot be represented in JSON Schema");
    } else if (typeof p == "bigint") {
      if (t.unrepresentable === "throw")
        throw new Error("BigInt literals cannot be represented in JSON Schema");
      f.push(Number(p));
    } else
      f.push(p);
  if (f.length !== 0) if (f.length === 1) {
    const p = f[0];
    r.type = p === null ? "null" : typeof p, t.target === "draft-04" || t.target === "openapi-3.0" ? r.enum = [p] : r.const = p;
  } else
    f.every((p) => typeof p == "number") && (r.type = "number"), f.every((p) => typeof p == "string") && (r.type = "string"), f.every((p) => typeof p == "boolean") && (r.type = "boolean"), f.every((p) => p === null) && (r.type = "null"), r.enum = f;
}, Og = (o, t, r, a) => {
  if (t.unrepresentable === "throw")
    throw new Error("Custom types cannot be represented in JSON Schema");
}, zg = (o, t, r, a) => {
  if (t.unrepresentable === "throw")
    throw new Error("Transforms cannot be represented in JSON Schema");
}, Gg = (o, t, r, a) => {
  const u = r, f = o._zod.def, { minimum: p, maximum: b } = o._zod.bag;
  typeof p == "number" && (u.minItems = p), typeof b == "number" && (u.maxItems = b), u.type = "array", u.items = Ae(f.element, t, { ...a, path: [...a.path, "items"] });
}, Zg = (o, t, r, a) => {
  const u = r, f = o._zod.def;
  u.type = "object", u.properties = {};
  const p = f.shape;
  for (const v in p)
    u.properties[v] = Ae(p[v], t, {
      ...a,
      path: [...a.path, "properties", v]
    });
  const b = new Set(Object.keys(p)), T = new Set([...b].filter((v) => {
    const w = f.shape[v]._zod;
    return t.io === "input" ? w.optin === void 0 : w.optout === void 0;
  }));
  T.size > 0 && (u.required = Array.from(T)), f.catchall?._zod.def.type === "never" ? u.additionalProperties = !1 : f.catchall ? f.catchall && (u.additionalProperties = Ae(f.catchall, t, {
    ...a,
    path: [...a.path, "additionalProperties"]
  })) : t.io === "output" && (u.additionalProperties = !1);
}, Ug = (o, t, r, a) => {
  const u = o._zod.def, f = u.inclusive === !1, p = u.options.map((b, T) => Ae(b, t, {
    ...a,
    path: [...a.path, f ? "oneOf" : "anyOf", T]
  }));
  f ? r.oneOf = p : r.anyOf = p;
}, $g = (o, t, r, a) => {
  const u = o._zod.def, f = Ae(u.left, t, {
    ...a,
    path: [...a.path, "allOf", 0]
  }), p = Ae(u.right, t, {
    ...a,
    path: [...a.path, "allOf", 1]
  }), b = (v) => "allOf" in v && Object.keys(v).length === 1, T = [
    ...b(f) ? f.allOf : [f],
    ...b(p) ? p.allOf : [p]
  ];
  r.allOf = T;
}, Kg = (o, t, r, a) => {
  const u = o._zod.def, f = Ae(u.innerType, t, a), p = t.seen.get(o);
  t.target === "openapi-3.0" ? (p.ref = u.innerType, r.nullable = !0) : r.anyOf = [f, { type: "null" }];
}, qg = (o, t, r, a) => {
  const u = o._zod.def;
  Ae(u.innerType, t, a);
  const f = t.seen.get(o);
  f.ref = u.innerType;
}, Hg = (o, t, r, a) => {
  const u = o._zod.def;
  Ae(u.innerType, t, a);
  const f = t.seen.get(o);
  f.ref = u.innerType, r.default = JSON.parse(JSON.stringify(u.defaultValue));
}, Wg = (o, t, r, a) => {
  const u = o._zod.def;
  Ae(u.innerType, t, a);
  const f = t.seen.get(o);
  f.ref = u.innerType, t.io === "input" && (r._prefault = JSON.parse(JSON.stringify(u.defaultValue)));
}, Vg = (o, t, r, a) => {
  const u = o._zod.def;
  Ae(u.innerType, t, a);
  const f = t.seen.get(o);
  f.ref = u.innerType;
  let p;
  try {
    p = u.catchValue(void 0);
  } catch {
    throw new Error("Dynamic catch values are not supported in JSON Schema");
  }
  r.default = p;
}, Jg = (o, t, r, a) => {
  const u = o._zod.def, f = t.io === "input" ? u.in._zod.def.type === "transform" ? u.out : u.in : u.out;
  Ae(f, t, a);
  const p = t.seen.get(o);
  p.ref = f;
}, jg = (o, t, r, a) => {
  const u = o._zod.def;
  Ae(u.innerType, t, a);
  const f = t.seen.get(o);
  f.ref = u.innerType, r.readOnly = !0;
}, Ml = (o, t, r, a) => {
  const u = o._zod.def;
  Ae(u.innerType, t, a);
  const f = t.seen.get(o);
  f.ref = u.innerType;
}, Yg = /* @__PURE__ */ I("ZodISODateTime", (o, t) => {
  rA.init(o, t), ie.init(o, t);
});
function Xg(o) {
  return /* @__PURE__ */ sg(Yg, o);
}
const Qg = /* @__PURE__ */ I("ZodISODate", (o, t) => {
  iA.init(o, t), ie.init(o, t);
});
function e1(o) {
  return /* @__PURE__ */ ug(Qg, o);
}
const o1 = /* @__PURE__ */ I("ZodISOTime", (o, t) => {
  aA.init(o, t), ie.init(o, t);
});
function n1(o) {
  return /* @__PURE__ */ lg(o1, o);
}
const t1 = /* @__PURE__ */ I("ZodISODuration", (o, t) => {
  sA.init(o, t), ie.init(o, t);
});
function r1(o) {
  return /* @__PURE__ */ cg(t1, o);
}
const i1 = (o, t) => {
  tl.init(o, t), o.name = "ZodError", Object.defineProperties(o, {
    format: {
      value: (r) => Y0(o, r)
      // enumerable: false,
    },
    flatten: {
      value: (r) => j0(o, r)
      // enumerable: false,
    },
    addIssue: {
      value: (r) => {
        o.issues.push(r), o.message = JSON.stringify(o.issues, Ni, 2);
      }
      // enumerable: false,
    },
    addIssues: {
      value: (r) => {
        o.issues.push(...r), o.message = JSON.stringify(o.issues, Ni, 2);
      }
      // enumerable: false,
    },
    isEmpty: {
      get() {
        return o.issues.length === 0;
      }
      // enumerable: false,
    }
  });
}, We = I("ZodError", i1, {
  Parent: Error
}), a1 = /* @__PURE__ */ Oi(We), s1 = /* @__PURE__ */ zi(We), u1 = /* @__PURE__ */ Xt(We), l1 = /* @__PURE__ */ Qt(We), c1 = /* @__PURE__ */ eb(We), d1 = /* @__PURE__ */ ob(We), p1 = /* @__PURE__ */ nb(We), f1 = /* @__PURE__ */ tb(We), h1 = /* @__PURE__ */ rb(We), m1 = /* @__PURE__ */ ib(We), _1 = /* @__PURE__ */ ab(We), b1 = /* @__PURE__ */ sb(We), de = /* @__PURE__ */ I("ZodType", (o, t) => (ce.init(o, t), Object.assign(o["~standard"], {
  jsonSchema: {
    input: Jt(o, "input"),
    output: Jt(o, "output")
  }
}), o.toJSONSchema = Cg(o, {}), o.def = t, o.type = t.type, Object.defineProperty(o, "_def", { value: t }), o.check = (...r) => o.clone(Do(t, {
  checks: [
    ...t.checks ?? [],
    ...r.map((a) => typeof a == "function" ? { _zod: { check: a, def: { check: "custom" }, onattach: [] } } : a)
  ]
}), {
  parent: !0
}), o.with = o.check, o.clone = (r, a) => Lo(o, r, a), o.brand = () => o, o.register = ((r, a) => (r.add(o, a), o)), o.parse = (r, a) => a1(o, r, a, { callee: o.parse }), o.safeParse = (r, a) => u1(o, r, a), o.parseAsync = async (r, a) => s1(o, r, a, { callee: o.parseAsync }), o.safeParseAsync = async (r, a) => l1(o, r, a), o.spa = o.safeParseAsync, o.encode = (r, a) => c1(o, r, a), o.decode = (r, a) => d1(o, r, a), o.encodeAsync = async (r, a) => p1(o, r, a), o.decodeAsync = async (r, a) => f1(o, r, a), o.safeEncode = (r, a) => h1(o, r, a), o.safeDecode = (r, a) => m1(o, r, a), o.safeEncodeAsync = async (r, a) => _1(o, r, a), o.safeDecodeAsync = async (r, a) => b1(o, r, a), o.refine = (r, a) => o.check(cy(r, a)), o.superRefine = (r) => o.check(dy(r)), o.overwrite = (r) => o.check(/* @__PURE__ */ yn(r)), o.optional = () => qu(o), o.exactOptional = () => Y1(o), o.nullable = () => Hu(o), o.nullish = () => qu(Hu(o)), o.nonoptional = (r) => ty(o, r), o.array = () => Z1(o), o.or = (r) => xl([o, r]), o.and = (r) => q1(o, r), o.transform = (r) => Wu(o, J1(r)), o.default = (r) => ey(o, r), o.prefault = (r) => ny(o, r), o.catch = (r) => iy(o, r), o.pipe = (r) => Wu(o, r), o.readonly = () => uy(o), o.describe = (r) => {
  const a = o.clone();
  return Kn.add(a, { description: r }), a;
}, Object.defineProperty(o, "description", {
  get() {
    return Kn.get(o)?.description;
  },
  configurable: !0
}), o.meta = (...r) => {
  if (r.length === 0)
    return Kn.get(o);
  const a = o.clone();
  return Kn.add(a, r[0]), a;
}, o.isOptional = () => o.safeParse(void 0).success, o.isNullable = () => o.safeParse(null).success, o.apply = (r) => r(o), o)), Il = /* @__PURE__ */ I("_ZodString", (o, t) => {
  Gi.init(o, t), de.init(o, t), o._zod.processJSONSchema = (a, u, f) => Bg(o, a, u);
  const r = o._zod.bag;
  o.format = r.format ?? null, o.minLength = r.minimum ?? null, o.maxLength = r.maximum ?? null, o.regex = (...a) => o.check(/* @__PURE__ */ mg(...a)), o.includes = (...a) => o.check(/* @__PURE__ */ Ag(...a)), o.startsWith = (...a) => o.check(/* @__PURE__ */ gg(...a)), o.endsWith = (...a) => o.check(/* @__PURE__ */ yg(...a)), o.min = (...a) => o.check(/* @__PURE__ */ Vt(...a)), o.max = (...a) => o.check(/* @__PURE__ */ bl(...a)), o.length = (...a) => o.check(/* @__PURE__ */ Al(...a)), o.nonempty = (...a) => o.check(/* @__PURE__ */ Vt(1, ...a)), o.lowercase = (a) => o.check(/* @__PURE__ */ _g(a)), o.uppercase = (a) => o.check(/* @__PURE__ */ bg(a)), o.trim = () => o.check(/* @__PURE__ */ Mg()), o.normalize = (...a) => o.check(/* @__PURE__ */ Tg(...a)), o.toLowerCase = () => o.check(/* @__PURE__ */ Ig()), o.toUpperCase = () => o.check(/* @__PURE__ */ Sg()), o.slugify = () => o.check(/* @__PURE__ */ xg());
}), A1 = /* @__PURE__ */ I("ZodString", (o, t) => {
  Gi.init(o, t), Il.init(o, t), o.email = (r) => o.check(/* @__PURE__ */ ZA(g1, r)), o.url = (r) => o.check(/* @__PURE__ */ qA(y1, r)), o.jwt = (r) => o.check(/* @__PURE__ */ ag(L1, r)), o.emoji = (r) => o.check(/* @__PURE__ */ HA(T1, r)), o.guid = (r) => o.check(/* @__PURE__ */ Ru(Zu, r)), o.uuid = (r) => o.check(/* @__PURE__ */ _l(qn, r)), o.uuidv4 = (r) => o.check(/* @__PURE__ */ UA(qn, r)), o.uuidv6 = (r) => o.check(/* @__PURE__ */ $A(qn, r)), o.uuidv7 = (r) => o.check(/* @__PURE__ */ KA(qn, r)), o.nanoid = (r) => o.check(/* @__PURE__ */ WA(M1, r)), o.guid = (r) => o.check(/* @__PURE__ */ Ru(Zu, r)), o.cuid = (r) => o.check(/* @__PURE__ */ VA(I1, r)), o.cuid2 = (r) => o.check(/* @__PURE__ */ JA(S1, r)), o.ulid = (r) => o.check(/* @__PURE__ */ jA(x1, r)), o.base64 = (r) => o.check(/* @__PURE__ */ tg(B1, r)), o.base64url = (r) => o.check(/* @__PURE__ */ rg(k1, r)), o.xid = (r) => o.check(/* @__PURE__ */ YA(v1, r)), o.ksuid = (r) => o.check(/* @__PURE__ */ XA(N1, r)), o.ipv4 = (r) => o.check(/* @__PURE__ */ QA(F1, r)), o.ipv6 = (r) => o.check(/* @__PURE__ */ eg(w1, r)), o.cidrv4 = (r) => o.check(/* @__PURE__ */ og(C1, r)), o.cidrv6 = (r) => o.check(/* @__PURE__ */ ng(E1, r)), o.e164 = (r) => o.check(/* @__PURE__ */ ig(D1, r)), o.datetime = (r) => o.check(Xg(r)), o.date = (r) => o.check(e1(r)), o.time = (r) => o.check(n1(r)), o.duration = (r) => o.check(r1(r));
});
function xe(o) {
  return /* @__PURE__ */ GA(A1, o);
}
const ie = /* @__PURE__ */ I("ZodStringFormat", (o, t) => {
  te.init(o, t), Il.init(o, t);
}), g1 = /* @__PURE__ */ I("ZodEmail", (o, t) => {
  Jb.init(o, t), ie.init(o, t);
}), Zu = /* @__PURE__ */ I("ZodGUID", (o, t) => {
  Wb.init(o, t), ie.init(o, t);
}), qn = /* @__PURE__ */ I("ZodUUID", (o, t) => {
  Vb.init(o, t), ie.init(o, t);
});
function jt(o) {
  return /* @__PURE__ */ _l(qn, o);
}
const y1 = /* @__PURE__ */ I("ZodURL", (o, t) => {
  jb.init(o, t), ie.init(o, t);
}), T1 = /* @__PURE__ */ I("ZodEmoji", (o, t) => {
  Yb.init(o, t), ie.init(o, t);
}), M1 = /* @__PURE__ */ I("ZodNanoID", (o, t) => {
  Xb.init(o, t), ie.init(o, t);
}), I1 = /* @__PURE__ */ I("ZodCUID", (o, t) => {
  Qb.init(o, t), ie.init(o, t);
}), S1 = /* @__PURE__ */ I("ZodCUID2", (o, t) => {
  eA.init(o, t), ie.init(o, t);
}), x1 = /* @__PURE__ */ I("ZodULID", (o, t) => {
  oA.init(o, t), ie.init(o, t);
}), v1 = /* @__PURE__ */ I("ZodXID", (o, t) => {
  nA.init(o, t), ie.init(o, t);
}), N1 = /* @__PURE__ */ I("ZodKSUID", (o, t) => {
  tA.init(o, t), ie.init(o, t);
}), F1 = /* @__PURE__ */ I("ZodIPv4", (o, t) => {
  uA.init(o, t), ie.init(o, t);
}), w1 = /* @__PURE__ */ I("ZodIPv6", (o, t) => {
  lA.init(o, t), ie.init(o, t);
}), C1 = /* @__PURE__ */ I("ZodCIDRv4", (o, t) => {
  cA.init(o, t), ie.init(o, t);
}), E1 = /* @__PURE__ */ I("ZodCIDRv6", (o, t) => {
  dA.init(o, t), ie.init(o, t);
}), B1 = /* @__PURE__ */ I("ZodBase64", (o, t) => {
  pA.init(o, t), ie.init(o, t);
}), k1 = /* @__PURE__ */ I("ZodBase64URL", (o, t) => {
  hA.init(o, t), ie.init(o, t);
}), D1 = /* @__PURE__ */ I("ZodE164", (o, t) => {
  mA.init(o, t), ie.init(o, t);
}), L1 = /* @__PURE__ */ I("ZodJWT", (o, t) => {
  bA.init(o, t), ie.init(o, t);
}), Sl = /* @__PURE__ */ I("ZodNumber", (o, t) => {
  pl.init(o, t), de.init(o, t), o._zod.processJSONSchema = (a, u, f) => kg(o, a, u), o.gt = (a, u) => o.check(/* @__PURE__ */ zu(a, u)), o.gte = (a, u) => o.check(/* @__PURE__ */ vi(a, u)), o.min = (a, u) => o.check(/* @__PURE__ */ vi(a, u)), o.lt = (a, u) => o.check(/* @__PURE__ */ Ou(a, u)), o.lte = (a, u) => o.check(/* @__PURE__ */ xi(a, u)), o.max = (a, u) => o.check(/* @__PURE__ */ xi(a, u)), o.int = (a) => o.check($u(a)), o.safe = (a) => o.check($u(a)), o.positive = (a) => o.check(/* @__PURE__ */ zu(0, a)), o.nonnegative = (a) => o.check(/* @__PURE__ */ vi(0, a)), o.negative = (a) => o.check(/* @__PURE__ */ Ou(0, a)), o.nonpositive = (a) => o.check(/* @__PURE__ */ xi(0, a)), o.multipleOf = (a, u) => o.check(/* @__PURE__ */ Gu(a, u)), o.step = (a, u) => o.check(/* @__PURE__ */ Gu(a, u)), o.finite = () => o;
  const r = o._zod.bag;
  o.minValue = Math.max(r.minimum ?? Number.NEGATIVE_INFINITY, r.exclusiveMinimum ?? Number.NEGATIVE_INFINITY) ?? null, o.maxValue = Math.min(r.maximum ?? Number.POSITIVE_INFINITY, r.exclusiveMaximum ?? Number.POSITIVE_INFINITY) ?? null, o.isInt = (r.format ?? "").includes("int") || Number.isSafeInteger(r.multipleOf ?? 0.5), o.isFinite = !0, o.format = r.format ?? null;
});
function Uu(o) {
  return /* @__PURE__ */ dg(Sl, o);
}
const P1 = /* @__PURE__ */ I("ZodNumberFormat", (o, t) => {
  AA.init(o, t), Sl.init(o, t);
});
function $u(o) {
  return /* @__PURE__ */ pg(P1, o);
}
const R1 = /* @__PURE__ */ I("ZodUnknown", (o, t) => {
  gA.init(o, t), de.init(o, t), o._zod.processJSONSchema = (r, a, u) => Lg();
});
function Ku() {
  return /* @__PURE__ */ fg(R1);
}
const O1 = /* @__PURE__ */ I("ZodNever", (o, t) => {
  yA.init(o, t), de.init(o, t), o._zod.processJSONSchema = (r, a, u) => Dg(o, r, a);
});
function z1(o) {
  return /* @__PURE__ */ hg(O1, o);
}
const G1 = /* @__PURE__ */ I("ZodArray", (o, t) => {
  TA.init(o, t), de.init(o, t), o._zod.processJSONSchema = (r, a, u) => Gg(o, r, a, u), o.element = t.element, o.min = (r, a) => o.check(/* @__PURE__ */ Vt(r, a)), o.nonempty = (r) => o.check(/* @__PURE__ */ Vt(1, r)), o.max = (r, a) => o.check(/* @__PURE__ */ bl(r, a)), o.length = (r, a) => o.check(/* @__PURE__ */ Al(r, a)), o.unwrap = () => o.element;
});
function Z1(o, t) {
  return /* @__PURE__ */ vg(G1, o, t);
}
const U1 = /* @__PURE__ */ I("ZodObject", (o, t) => {
  IA.init(o, t), de.init(o, t), o._zod.processJSONSchema = (r, a, u) => Zg(o, r, a, u), j(o, "shape", () => t.shape), o.keyof = () => vl(Object.keys(o._zod.def.shape)), o.catchall = (r) => o.clone({ ...o._zod.def, catchall: r }), o.passthrough = () => o.clone({ ...o._zod.def, catchall: Ku() }), o.loose = () => o.clone({ ...o._zod.def, catchall: Ku() }), o.strict = () => o.clone({ ...o._zod.def, catchall: z1() }), o.strip = () => o.clone({ ...o._zod.def, catchall: void 0 }), o.extend = (r) => q0(o, r), o.safeExtend = (r) => H0(o, r), o.merge = (r) => W0(o, r), o.pick = (r) => $0(o, r), o.omit = (r) => K0(o, r), o.partial = (...r) => V0(Nl, o, r[0]), o.required = (...r) => J0(Fl, o, r[0]);
});
function or(o, t) {
  const r = {
    type: "object",
    shape: o ?? {},
    ...k(t)
  };
  return new U1(r);
}
const $1 = /* @__PURE__ */ I("ZodUnion", (o, t) => {
  SA.init(o, t), de.init(o, t), o._zod.processJSONSchema = (r, a, u) => Ug(o, r, a, u), o.options = t.options;
});
function xl(o, t) {
  return new $1({
    type: "union",
    options: o,
    ...k(t)
  });
}
const K1 = /* @__PURE__ */ I("ZodIntersection", (o, t) => {
  xA.init(o, t), de.init(o, t), o._zod.processJSONSchema = (r, a, u) => $g(o, r, a, u);
});
function q1(o, t) {
  return new K1({
    type: "intersection",
    left: o,
    right: t
  });
}
const wi = /* @__PURE__ */ I("ZodEnum", (o, t) => {
  vA.init(o, t), de.init(o, t), o._zod.processJSONSchema = (a, u, f) => Pg(o, a, u), o.enum = t.entries, o.options = Object.values(t.entries);
  const r = new Set(Object.keys(t.entries));
  o.extract = (a, u) => {
    const f = {};
    for (const p of a)
      if (r.has(p))
        f[p] = t.entries[p];
      else
        throw new Error(`Key ${p} not found in enum`);
    return new wi({
      ...t,
      checks: [],
      ...k(u),
      entries: f
    });
  }, o.exclude = (a, u) => {
    const f = { ...t.entries };
    for (const p of a)
      if (r.has(p))
        delete f[p];
      else
        throw new Error(`Key ${p} not found in enum`);
    return new wi({
      ...t,
      checks: [],
      ...k(u),
      entries: f
    });
  };
});
function vl(o, t) {
  const r = Array.isArray(o) ? Object.fromEntries(o.map((a) => [a, a])) : o;
  return new wi({
    type: "enum",
    entries: r,
    ...k(t)
  });
}
const H1 = /* @__PURE__ */ I("ZodLiteral", (o, t) => {
  NA.init(o, t), de.init(o, t), o._zod.processJSONSchema = (r, a, u) => Rg(o, r, a), o.values = new Set(t.values), Object.defineProperty(o, "value", {
    get() {
      if (t.values.length > 1)
        throw new Error("This schema contains multiple valid literal values. Use `.values` instead.");
      return t.values[0];
    }
  });
});
function W1(o, t) {
  return new H1({
    type: "literal",
    values: Array.isArray(o) ? o : [o],
    ...k(t)
  });
}
const V1 = /* @__PURE__ */ I("ZodTransform", (o, t) => {
  FA.init(o, t), de.init(o, t), o._zod.processJSONSchema = (r, a, u) => zg(o, r), o._zod.parse = (r, a) => {
    if (a.direction === "backward")
      throw new ju(o.constructor.name);
    r.addIssue = (f) => {
      if (typeof f == "string")
        r.issues.push(Jn(f, r.value, t));
      else {
        const p = f;
        p.fatal && (p.continue = !1), p.code ?? (p.code = "custom"), p.input ?? (p.input = r.value), p.inst ?? (p.inst = o), r.issues.push(Jn(p));
      }
    };
    const u = t.transform(r.value, r);
    return u instanceof Promise ? u.then((f) => (r.value = f, r)) : (r.value = u, r);
  };
});
function J1(o) {
  return new V1({
    type: "transform",
    transform: o
  });
}
const Nl = /* @__PURE__ */ I("ZodOptional", (o, t) => {
  ml.init(o, t), de.init(o, t), o._zod.processJSONSchema = (r, a, u) => Ml(o, r, a, u), o.unwrap = () => o._zod.def.innerType;
});
function qu(o) {
  return new Nl({
    type: "optional",
    innerType: o
  });
}
const j1 = /* @__PURE__ */ I("ZodExactOptional", (o, t) => {
  wA.init(o, t), de.init(o, t), o._zod.processJSONSchema = (r, a, u) => Ml(o, r, a, u), o.unwrap = () => o._zod.def.innerType;
});
function Y1(o) {
  return new j1({
    type: "optional",
    innerType: o
  });
}
const X1 = /* @__PURE__ */ I("ZodNullable", (o, t) => {
  CA.init(o, t), de.init(o, t), o._zod.processJSONSchema = (r, a, u) => Kg(o, r, a, u), o.unwrap = () => o._zod.def.innerType;
});
function Hu(o) {
  return new X1({
    type: "nullable",
    innerType: o
  });
}
const Q1 = /* @__PURE__ */ I("ZodDefault", (o, t) => {
  EA.init(o, t), de.init(o, t), o._zod.processJSONSchema = (r, a, u) => Hg(o, r, a, u), o.unwrap = () => o._zod.def.innerType, o.removeDefault = o.unwrap;
});
function ey(o, t) {
  return new Q1({
    type: "default",
    innerType: o,
    get defaultValue() {
      return typeof t == "function" ? t() : el(t);
    }
  });
}
const oy = /* @__PURE__ */ I("ZodPrefault", (o, t) => {
  BA.init(o, t), de.init(o, t), o._zod.processJSONSchema = (r, a, u) => Wg(o, r, a, u), o.unwrap = () => o._zod.def.innerType;
});
function ny(o, t) {
  return new oy({
    type: "prefault",
    innerType: o,
    get defaultValue() {
      return typeof t == "function" ? t() : el(t);
    }
  });
}
const Fl = /* @__PURE__ */ I("ZodNonOptional", (o, t) => {
  kA.init(o, t), de.init(o, t), o._zod.processJSONSchema = (r, a, u) => qg(o, r, a, u), o.unwrap = () => o._zod.def.innerType;
});
function ty(o, t) {
  return new Fl({
    type: "nonoptional",
    innerType: o,
    ...k(t)
  });
}
const ry = /* @__PURE__ */ I("ZodCatch", (o, t) => {
  DA.init(o, t), de.init(o, t), o._zod.processJSONSchema = (r, a, u) => Vg(o, r, a, u), o.unwrap = () => o._zod.def.innerType, o.removeCatch = o.unwrap;
});
function iy(o, t) {
  return new ry({
    type: "catch",
    innerType: o,
    catchValue: typeof t == "function" ? t : () => t
  });
}
const ay = /* @__PURE__ */ I("ZodPipe", (o, t) => {
  LA.init(o, t), de.init(o, t), o._zod.processJSONSchema = (r, a, u) => Jg(o, r, a, u), o.in = t.in, o.out = t.out;
});
function Wu(o, t) {
  return new ay({
    type: "pipe",
    in: o,
    out: t
    // ...util.normalizeParams(params),
  });
}
const sy = /* @__PURE__ */ I("ZodReadonly", (o, t) => {
  PA.init(o, t), de.init(o, t), o._zod.processJSONSchema = (r, a, u) => jg(o, r, a, u), o.unwrap = () => o._zod.def.innerType;
});
function uy(o) {
  return new sy({
    type: "readonly",
    innerType: o
  });
}
const ly = /* @__PURE__ */ I("ZodCustom", (o, t) => {
  RA.init(o, t), de.init(o, t), o._zod.processJSONSchema = (r, a, u) => Og(o, r);
});
function cy(o, t = {}) {
  return /* @__PURE__ */ Ng(ly, o, t);
}
function dy(o) {
  return /* @__PURE__ */ Fg(o);
}
const wl = or({
  userId: jt(),
  companyId: jt()
}), py = wl.extend({
  auctionId: jt()
}), fy = wl.extend({
  directSaleId: jt()
}), eT = xl([py, fy]), oT = 50, nT = 1, tT = "bnk_", hy = {
  // Exteriors
  photo_front: {
    name: "photo_front",
    position: 10,
    position_admin: 30,
    positionByType: {
      MinibusCityIntercity: 20,
      MinibusTouristic: 20,
      AutobusNormalFloor2Axle: 20,
      AutobusNormalFloor3Axle: 20,
      AutobusLowFloorLowEntry8_12Mt: 20,
      Autobus18Mt: 20,
      DoubleDecker: 20
    },
    positionAdminByType: {
      MinibusCityIntercity: 40,
      MinibusTouristic: 40,
      AutobusNormalFloor2Axle: 40,
      AutobusNormalFloor3Axle: 40,
      AutobusLowFloorLowEntry8_12Mt: 40,
      Autobus18Mt: 40,
      DoubleDecker: 40
    },
    label: "Front",
    group: "exteriors",
    description: "A photo capturing the front view of the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !0
  },
  photo_3_4_front_side_left: {
    name: "photo_3_4_front_side_left",
    position: 20,
    position_admin: 40,
    positionByType: {
      MinibusCityIntercity: 30,
      MinibusTouristic: 30,
      AutobusNormalFloor2Axle: 30,
      AutobusNormalFloor3Axle: 30,
      AutobusLowFloorLowEntry8_12Mt: 30,
      Autobus18Mt: 30,
      DoubleDecker: 30
    },
    positionAdminByType: {
      MinibusCityIntercity: 50,
      MinibusTouristic: 50,
      AutobusNormalFloor2Axle: 50,
      AutobusNormalFloor3Axle: 50,
      AutobusLowFloorLowEntry8_12Mt: 50,
      Autobus18Mt: 50,
      DoubleDecker: 50
    },
    label: "3/4 Front Left Side",
    group: "exteriors",
    description: "A 3/4 angled photo of the front side of the vehicle from the left.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !0
  },
  photo_side_left: {
    name: "photo_side_left",
    position: 30,
    position_admin: 70,
    positionByType: {
      MinibusCityIntercity: 40,
      MinibusTouristic: 40,
      AutobusNormalFloor2Axle: 40,
      AutobusNormalFloor3Axle: 40,
      AutobusLowFloorLowEntry8_12Mt: 40,
      Autobus18Mt: 40,
      DoubleDecker: 40
    },
    positionAdminByType: {
      MinibusCityIntercity: 60,
      MinibusTouristic: 60,
      AutobusNormalFloor2Axle: 60,
      AutobusNormalFloor3Axle: 60,
      AutobusLowFloorLowEntry8_12Mt: 60,
      Autobus18Mt: 60,
      DoubleDecker: 60
    },
    label: "Left Side",
    group: "exteriors",
    description: "A photo showing the left side of the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_3_4_side_left_rear: {
    name: "photo_3_4_side_left_rear",
    position: 40,
    position_admin: 120,
    positionByType: {
      MinibusCityIntercity: 50,
      MinibusTouristic: 50,
      AutobusNormalFloor2Axle: 50,
      AutobusNormalFloor3Axle: 50,
      AutobusLowFloorLowEntry8_12Mt: 50,
      Autobus18Mt: 50,
      DoubleDecker: 50
    },
    positionAdminByType: {
      MinibusCityIntercity: 70,
      MinibusTouristic: 70,
      AutobusNormalFloor2Axle: 70,
      AutobusNormalFloor3Axle: 70,
      AutobusLowFloorLowEntry8_12Mt: 70,
      Autobus18Mt: 70,
      DoubleDecker: 70
    },
    label: "3/4 Rear Left Side",
    group: "exteriors",
    description: "A 3/4 angled photo of the left rear side of the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_rear_hatch_closed: {
    name: "photo_rear_hatch_closed",
    position: 50,
    position_admin: 130,
    positionByType: {
      MinibusCityIntercity: 60,
      MinibusTouristic: 60,
      AutobusNormalFloor2Axle: 60,
      AutobusNormalFloor3Axle: 60,
      AutobusLowFloorLowEntry8_12Mt: 60,
      Autobus18Mt: 60,
      DoubleDecker: 60
    },
    positionAdminByType: {
      MinibusCityIntercity: 80,
      MinibusTouristic: 80,
      AutobusNormalFloor2Axle: 80,
      AutobusNormalFloor3Axle: 80,
      AutobusLowFloorLowEntry8_12Mt: 80,
      Autobus18Mt: 80,
      DoubleDecker: 80
    },
    label: "Rear",
    group: "exteriors",
    description: "A photo showing the rear of the vehicle with the hatch closed.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_3_4_side_right_rear_doors_closed: {
    name: "photo_3_4_side_right_rear_doors_closed",
    position: 60,
    position_admin: 190,
    positionByType: {
      MinibusCityIntercity: 70,
      MinibusTouristic: 70,
      AutobusNormalFloor2Axle: 70,
      AutobusNormalFloor3Axle: 70,
      AutobusLowFloorLowEntry8_12Mt: 70,
      Autobus18Mt: 70,
      DoubleDecker: 70
    },
    positionAdminByType: {
      MinibusCityIntercity: 90,
      MinibusTouristic: 90,
      AutobusNormalFloor2Axle: 90,
      AutobusNormalFloor3Axle: 90,
      AutobusLowFloorLowEntry8_12Mt: 90,
      Autobus18Mt: 90,
      DoubleDecker: 90
    },
    label: "3/4 Rear Right Side",
    group: "exteriors",
    description: "A 3/4 angled photo showing the right rear side with doors closed.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_side_right_doors_closed: {
    name: "photo_side_right_doors_closed",
    position: 70,
    position_admin: 200,
    positionByType: {
      MinibusCityIntercity: 80,
      MinibusTouristic: 100,
      AutobusNormalFloor2Axle: 80,
      AutobusNormalFloor3Axle: 80,
      AutobusLowFloorLowEntry8_12Mt: 80,
      Autobus18Mt: 80,
      DoubleDecker: 80
    },
    positionAdminByType: {
      MinibusCityIntercity: 100,
      MinibusTouristic: 120,
      AutobusNormalFloor2Axle: 100,
      AutobusNormalFloor3Axle: 100,
      AutobusLowFloorLowEntry8_12Mt: 100,
      Autobus18Mt: 100,
      DoubleDecker: 100
    },
    label: "Right Side",
    group: "exteriors",
    description: "A photo showing the right side of the vehicle with doors closed.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  turntable_photo_external_if_present_only_18mt: {
    name: "turntable_photo_external_if_present_only_18mt",
    position: 80,
    position_admin: 210,
    positionByType: { Autobus18Mt: 90 },
    positionAdminByType: { Autobus18Mt: 110 },
    label: "Turntable External",
    group: "exteriors",
    description: "An external photo of the turntable if present (only for 18 meters).",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_3_4_front_side_right_doors_closed: {
    name: "photo_3_4_front_side_right_doors_closed",
    position: 90,
    position_admin: 10,
    positionByType: {
      MinibusCityIntercity: 10,
      MinibusTouristic: 10,
      AutobusNormalFloor2Axle: 10,
      AutobusNormalFloor3Axle: 10,
      AutobusLowFloorLowEntry8_12Mt: 10,
      Autobus18Mt: 10,
      DoubleDecker: 10
    },
    positionAdminByType: {
      MinibusCityIntercity: 30,
      MinibusTouristic: 30,
      AutobusNormalFloor2Axle: 30,
      AutobusNormalFloor3Axle: 30,
      AutobusLowFloorLowEntry8_12Mt: 30,
      Autobus18Mt: 30,
      DoubleDecker: 30
    },
    label: "3/4 Front Right Side",
    group: "exteriors",
    description: "A 3/4 angled photo of the front side of the vehicle from the right, with doors closed.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !0
  },
  photo_3_4_side_right_front_doors_open: {
    name: "photo_3_4_side_right_front_doors_open",
    position: 100,
    position_admin: 230,
    positionByType: {
      MinibusCityIntercity: 110,
      MinibusTouristic: 110,
      AutobusNormalFloor2Axle: 90,
      AutobusNormalFloor3Axle: 90,
      AutobusLowFloorLowEntry8_12Mt: 90,
      Autobus18Mt: 100,
      DoubleDecker: 90
    },
    positionAdminByType: {
      MinibusCityIntercity: 130,
      MinibusTouristic: 130,
      AutobusNormalFloor2Axle: 110,
      AutobusNormalFloor3Axle: 110,
      AutobusLowFloorLowEntry8_12Mt: 110,
      Autobus18Mt: 120,
      DoubleDecker: 110
    },
    label: "3/4 Front Right Side Doors Open",
    group: "exteriors",
    description: "A 3/4 angled photo showing the right front side of the vehicle with doors open.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  front_photo_per_door_doors_open_door_1: {
    name: "front_photo_per_door_doors_open_door_1",
    position: 110,
    position_admin: 300,
    positionByType: {
      MinibusCityIntercity: 140,
      MinibusTouristic: 140,
      AutobusNormalFloor2Axle: 100,
      AutobusNormalFloor3Axle: 100,
      AutobusLowFloorLowEntry8_12Mt: 100,
      Autobus18Mt: 110,
      DoubleDecker: 100
    },
    positionAdminByType: {
      MinibusCityIntercity: 160,
      MinibusTouristic: 160,
      AutobusNormalFloor2Axle: 120,
      AutobusNormalFloor3Axle: 120,
      AutobusLowFloorLowEntry8_12Mt: 120,
      Autobus18Mt: 130,
      DoubleDecker: 120
    },
    label: "Front Door Open",
    group: "exteriors",
    description: "A photo of the front door 1 in an open position.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_side_right_doors_open: {
    name: "photo_side_right_doors_open",
    position: 120,
    position_admin: 240,
    positionByType: {
      MinibusCityIntercity: 120,
      MinibusTouristic: 120,
      AutobusNormalFloor2Axle: 110,
      AutobusNormalFloor3Axle: 110,
      AutobusLowFloorLowEntry8_12Mt: 110,
      Autobus18Mt: 120,
      DoubleDecker: 110
    },
    positionAdminByType: {
      MinibusCityIntercity: 140,
      MinibusTouristic: 140,
      AutobusNormalFloor2Axle: 130,
      AutobusNormalFloor3Axle: 130,
      AutobusLowFloorLowEntry8_12Mt: 130,
      Autobus18Mt: 140,
      DoubleDecker: 130
    },
    label: "Right Side Doors Open",
    group: "exteriors",
    description: "A photo showing the right side of the vehicle with doors open.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  front_photo_per_door_doors_open_door_2: {
    name: "front_photo_per_door_doors_open_door_2",
    position: 130,
    position_admin: 270,
    positionByType: {
      MinibusCityIntercity: 200,
      MinibusTouristic: 200,
      AutobusNormalFloor2Axle: 120,
      AutobusNormalFloor3Axle: 120,
      AutobusLowFloorLowEntry8_12Mt: 120,
      Autobus18Mt: 130,
      DoubleDecker: 120
    },
    positionAdminByType: {
      MinibusCityIntercity: 220,
      MinibusTouristic: 220,
      AutobusNormalFloor2Axle: 140,
      AutobusNormalFloor3Axle: 140,
      AutobusLowFloorLowEntry8_12Mt: 140,
      Autobus18Mt: 150,
      DoubleDecker: 140
    },
    label: "Second Door Open",
    group: "exteriors",
    description: "A photo of the front door 2 in an open position.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  front_photo_per_door_doors_open_door_3: {
    name: "front_photo_per_door_doors_open_door_3",
    position: 140,
    position_admin: 260,
    positionByType: { AutobusLowFloorLowEntry8_12Mt: 130, Autobus18Mt: 140 },
    positionAdminByType: { AutobusLowFloorLowEntry8_12Mt: 150, Autobus18Mt: 160 },
    label: "Third Door Open",
    group: "exteriors",
    description: "A photo of the front door 3 in an open position.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_3_4_side_right_rear_doors_open: {
    name: "photo_3_4_side_right_rear_doors_open",
    position: 150,
    position_admin: 250,
    positionByType: {
      MinibusCityIntercity: 130,
      MinibusTouristic: 130,
      AutobusNormalFloor2Axle: 130,
      AutobusNormalFloor3Axle: 130,
      AutobusLowFloorLowEntry8_12Mt: 140,
      Autobus18Mt: 160,
      DoubleDecker: 130
    },
    positionAdminByType: {
      MinibusCityIntercity: 150,
      MinibusTouristic: 150,
      AutobusNormalFloor2Axle: 150,
      AutobusNormalFloor3Axle: 150,
      AutobusLowFloorLowEntry8_12Mt: 160,
      Autobus18Mt: 180,
      DoubleDecker: 150
    },
    label: "3/4 Rear Right Side Doors Open",
    group: "exteriors",
    description: "A 3/4 angled photo showing the right rear side with doors open.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_luggage: {
    name: "photo_luggage",
    position: 160,
    position_admin: 80,
    positionByType: { MinibusTouristic: 210, AutobusNormalFloor2Axle: 220, AutobusNormalFloor3Axle: 220, DoubleDecker: 220 },
    positionAdminByType: { MinibusTouristic: 230, AutobusNormalFloor2Axle: 240, AutobusNormalFloor3Axle: 240, DoubleDecker: 240 },
    label: "Luggage Rack Left Side",
    group: "exteriors",
    description: "A photo showing the luggage rack in the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_internal_frame_for_potential_rust: {
    name: "photo_internal_frame_for_potential_rust",
    position: 170,
    position_admin: 90,
    positionByType: { MinibusTouristic: 220, AutobusNormalFloor2Axle: 230, AutobusNormalFloor3Axle: 230, DoubleDecker: 230 },
    positionAdminByType: { MinibusTouristic: 240, AutobusNormalFloor2Axle: 250, AutobusNormalFloor3Axle: 250, DoubleDecker: 250 },
    label: "Luggage",
    group: "exteriors",
    description: "A photo showing the luggage compartment of the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_under_carpet_if_carpet_present: {
    name: "photo_under_carpet_if_carpet_present",
    position: 180,
    position_admin: 95,
    positionByType: { AutobusNormalFloor2Axle: 240, AutobusNormalFloor3Axle: 240, DoubleDecker: 240 },
    positionAdminByType: { AutobusNormalFloor2Axle: 260, AutobusNormalFloor3Axle: 260, DoubleDecker: 260 },
    label: "Luggage Under Carpet Photo",
    group: "exteriors",
    description: "A photo showing the area under the carpet if present.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_hatch_open: {
    name: "photo_rear_hatch_open",
    position: 190,
    position_admin: 140,
    positionByType: {
      AutobusNormalFloor2Axle: 140,
      AutobusNormalFloor3Axle: 140,
      AutobusLowFloorLowEntry8_12Mt: 150,
      Autobus18Mt: 170,
      DoubleDecker: 140
    },
    positionAdminByType: {
      AutobusNormalFloor2Axle: 160,
      AutobusNormalFloor3Axle: 160,
      AutobusLowFloorLowEntry8_12Mt: 170,
      Autobus18Mt: 190,
      DoubleDecker: 160
    },
    label: "Rear Hatch Open",
    group: "exteriors",
    description: "A photo showing the rear of the vehicle with the hatch open.",
    requiredForToBeScrapped: !0,
    performTextInpaint: !1
  },
  photo_compressor_air_conditioning: {
    name: "photo_compressor_air_conditioning",
    position: 200,
    position_admin: 150,
    positionByType: {
      AutobusNormalFloor2Axle: 170,
      AutobusNormalFloor3Axle: 170,
      AutobusLowFloorLowEntry8_12Mt: 180,
      Autobus18Mt: 200,
      DoubleDecker: 170
    },
    positionAdminByType: {
      AutobusNormalFloor2Axle: 190,
      AutobusNormalFloor3Axle: 190,
      AutobusLowFloorLowEntry8_12Mt: 200,
      Autobus18Mt: 220,
      DoubleDecker: 190
    },
    label: "Air Conditioning Compressor",
    group: "exteriors",
    description: "A photo showing the air conditioning compressor.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_preheater_webasto_if_present: {
    name: "photo_preheater_webasto_if_present",
    position: 210,
    position_admin: 170,
    positionByType: {
      AutobusNormalFloor2Axle: 180,
      AutobusNormalFloor3Axle: 180,
      AutobusLowFloorLowEntry8_12Mt: 190,
      Autobus18Mt: 210,
      DoubleDecker: 180
    },
    positionAdminByType: {
      AutobusNormalFloor2Axle: 200,
      AutobusNormalFloor3Axle: 200,
      AutobusLowFloorLowEntry8_12Mt: 210,
      Autobus18Mt: 230,
      DoubleDecker: 200
    },
    label: "Preheater",
    group: "exteriors",
    description: "A photo of the preheater (webasto) system if present.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_fire_extinguishing_system: {
    name: "photo_fire_extinguishing_system",
    position: 220,
    position_admin: 160,
    label: "Fire Suppression System",
    group: "exteriors",
    description: "A photo showing the fire extinguishing system of the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_external_compartments_various_internal_photo: {
    name: "photo_external_compartments_various_internal_photo",
    position: 230,
    position_admin: 60,
    label: "external compartments photo",
    group: "exteriors",
    description: "A photo showing various external compartments.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_platform_open_platform: {
    name: "photo_platform_open_platform",
    position: 240,
    position_admin: 215,
    positionByType: {
      MinibusCityIntercity: 160,
      MinibusTouristic: 160,
      AutobusNormalFloor2Axle: 200,
      AutobusNormalFloor3Axle: 200,
      AutobusLowFloorLowEntry8_12Mt: 210,
      Autobus18Mt: 230,
      DoubleDecker: 200
    },
    positionAdminByType: {
      MinibusCityIntercity: 180,
      MinibusTouristic: 180,
      AutobusNormalFloor2Axle: 220,
      AutobusNormalFloor3Axle: 220,
      AutobusLowFloorLowEntry8_12Mt: 230,
      Autobus18Mt: 250,
      DoubleDecker: 220
    },
    label: "Platform Open",
    group: "exteriors",
    description: "A photo of the platform in an open position.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_platform_code: {
    name: "photo_platform_code",
    position: 250,
    position_admin: 216,
    positionByType: {
      MinibusCityIntercity: 170,
      MinibusTouristic: 170,
      AutobusNormalFloor2Axle: 210,
      AutobusNormalFloor3Axle: 210,
      AutobusLowFloorLowEntry8_12Mt: 220,
      Autobus18Mt: 240,
      DoubleDecker: 210
    },
    positionAdminByType: {
      MinibusCityIntercity: 190,
      MinibusTouristic: 190,
      AutobusNormalFloor2Axle: 230,
      AutobusNormalFloor3Axle: 230,
      AutobusLowFloorLowEntry8_12Mt: 240,
      Autobus18Mt: 260,
      DoubleDecker: 230
    },
    label: "Platform Code",
    group: "exteriors",
    description: "A photo showing the platform's code.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  engine_plate_photo_if_present: {
    name: "engine_plate_photo_if_present",
    position: 260,
    position_admin: 165,
    label: "engine plate photo",
    group: "exteriors",
    description: "A photo showing the engine plate if present.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_plate_vehicle: {
    name: "photo_plate_vehicle",
    position: 270,
    position_admin: 310,
    positionByType: {
      MinibusCityIntercity: 870,
      MinibusTouristic: 1050,
      AutobusNormalFloor2Axle: 1130,
      AutobusNormalFloor3Axle: 1280,
      AutobusLowFloorLowEntry8_12Mt: 950,
      Autobus18Mt: 1180,
      DoubleDecker: 1430
    },
    positionAdminByType: {
      MinibusCityIntercity: 20,
      MinibusTouristic: 20,
      AutobusNormalFloor2Axle: 20,
      AutobusNormalFloor3Axle: 20,
      AutobusLowFloorLowEntry8_12Mt: 20,
      Autobus18Mt: 20,
      DoubleDecker: 20
    },
    label: "Vehicle Plate",
    group: "technical-data",
    description: "A photo showing the vehicle's plate.",
    requiredForToBeScrapped: !0,
    performTextInpaint: !1
  },
  // Interiors
  photo_plate_seats: {
    name: "photo_plate_seats",
    position: 280,
    position_admin: 320,
    positionByType: {
      MinibusCityIntercity: 210,
      MinibusTouristic: 270,
      AutobusNormalFloor2Axle: 270,
      AutobusNormalFloor3Axle: 260,
      AutobusLowFloorLowEntry8_12Mt: 230,
      Autobus18Mt: 250,
      DoubleDecker: 260
    },
    positionAdminByType: {
      MinibusCityIntercity: 230,
      MinibusTouristic: 290,
      AutobusNormalFloor2Axle: 290,
      AutobusNormalFloor3Axle: 280,
      AutobusLowFloorLowEntry8_12Mt: 250,
      Autobus18Mt: 270,
      DoubleDecker: 280
    },
    label: "Seats Plate",
    group: "interiors",
    description: "A photo showing the seat plate inside the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_accessories_driver_microphone: {
    name: "photo_accessories_driver_microphone",
    position: 290,
    position_admin: 330,
    positionByType: { MinibusTouristic: 280, AutobusNormalFloor2Axle: 280, AutobusNormalFloor3Axle: 270, DoubleDecker: 270 },
    positionAdminByType: { MinibusTouristic: 300, AutobusNormalFloor2Axle: 300, AutobusNormalFloor3Axle: 290, DoubleDecker: 290 },
    label: "Driver Microphone",
    group: "interiors",
    description: "A photo showing the driver's microphone accessories in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_drive_seat: {
    name: "photo_drive_seat",
    position: 300,
    position_admin: 340,
    positionByType: {
      MinibusCityIntercity: 220,
      MinibusTouristic: 290,
      AutobusNormalFloor2Axle: 290,
      AutobusNormalFloor3Axle: 280,
      AutobusLowFloorLowEntry8_12Mt: 240,
      Autobus18Mt: 260,
      DoubleDecker: 280
    },
    positionAdminByType: {
      MinibusCityIntercity: 240,
      MinibusTouristic: 310,
      AutobusNormalFloor2Axle: 310,
      AutobusNormalFloor3Axle: 300,
      AutobusLowFloorLowEntry8_12Mt: 260,
      Autobus18Mt: 280,
      DoubleDecker: 300
    },
    label: "Driver's Seat",
    group: "interiors",
    description: "A photo of the driver's seat.",
    requiredForToBeScrapped: !0,
    performTextInpaint: !1
  },
  photo_steering_wheel: {
    name: "photo_steering_wheel",
    position: 310,
    position_admin: 350,
    positionByType: {
      MinibusCityIntercity: 230,
      MinibusTouristic: 300,
      AutobusNormalFloor2Axle: 300,
      AutobusNormalFloor3Axle: 290,
      AutobusLowFloorLowEntry8_12Mt: 250,
      Autobus18Mt: 270,
      DoubleDecker: 290
    },
    positionAdminByType: {
      MinibusCityIntercity: 250,
      MinibusTouristic: 320,
      AutobusNormalFloor2Axle: 320,
      AutobusNormalFloor3Axle: 310,
      AutobusLowFloorLowEntry8_12Mt: 270,
      Autobus18Mt: 290,
      DoubleDecker: 310
    },
    label: "Steering Wheel",
    group: "interiors",
    description: "A photo of the steering wheel in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_dashboard_on_for_number_km_and_lights_on: {
    name: "photo_dashboard_on_for_number_km_and_lights_on",
    position: 320,
    position_admin: 360,
    positionByType: {
      MinibusCityIntercity: 240,
      MinibusTouristic: 310,
      AutobusNormalFloor2Axle: 310,
      AutobusNormalFloor3Axle: 300,
      AutobusLowFloorLowEntry8_12Mt: 260,
      Autobus18Mt: 280,
      DoubleDecker: 300
    },
    positionAdminByType: {
      MinibusCityIntercity: 260,
      MinibusTouristic: 330,
      AutobusNormalFloor2Axle: 330,
      AutobusNormalFloor3Axle: 320,
      AutobusLowFloorLowEntry8_12Mt: 280,
      Autobus18Mt: 300,
      DoubleDecker: 320
    },
    label: "Dashboard Engine On",
    group: "interiors",
    description: "A photo showing the dashboard with the vehicle's odometer reading and warning lights illuminated.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_buttons_e_panels_on: {
    name: "photo_buttons_e_panels_on",
    position: 330,
    position_admin: 370,
    positionByType: {
      MinibusCityIntercity: 250,
      MinibusTouristic: 320,
      AutobusNormalFloor2Axle: 320,
      AutobusNormalFloor3Axle: 310,
      AutobusLowFloorLowEntry8_12Mt: 270,
      Autobus18Mt: 290,
      DoubleDecker: 310
    },
    positionAdminByType: {
      MinibusCityIntercity: 270,
      MinibusTouristic: 340,
      AutobusNormalFloor2Axle: 340,
      AutobusNormalFloor3Axle: 330,
      AutobusLowFloorLowEntry8_12Mt: 290,
      Autobus18Mt: 310,
      DoubleDecker: 330
    },
    label: "Complete Driver's Dashboard",
    group: "interiors",
    description: "A photo showing the vehicle's buttons and panels in an 'on' state.",
    requiredForToBeScrapped: !0,
    performTextInpaint: !1
  },
  photo_tachograph: {
    name: "photo_tachograph",
    position: 340,
    position_admin: 380,
    positionByType: {
      MinibusCityIntercity: 260,
      MinibusTouristic: 330,
      AutobusNormalFloor2Axle: 330,
      AutobusNormalFloor3Axle: 320,
      AutobusLowFloorLowEntry8_12Mt: 280,
      Autobus18Mt: 300,
      DoubleDecker: 320
    },
    positionAdminByType: {
      MinibusCityIntercity: 280,
      MinibusTouristic: 350,
      AutobusNormalFloor2Axle: 350,
      AutobusNormalFloor3Axle: 340,
      AutobusLowFloorLowEntry8_12Mt: 300,
      Autobus18Mt: 320,
      DoubleDecker: 340
    },
    label: "Tachograph",
    group: "interiors",
    description: "A photo of the Tachograph.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_accessories_radio: {
    name: "photo_accessories_radio",
    position: 350,
    position_admin: 390,
    positionByType: { AutobusNormalFloor2Axle: 340, AutobusNormalFloor3Axle: 330, DoubleDecker: 330 },
    positionAdminByType: { AutobusNormalFloor2Axle: 360, AutobusNormalFloor3Axle: 350, DoubleDecker: 350 },
    label: "Radio",
    group: "interiors",
    description: "A photo showing the radio accessories inside the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_any_devices_onboard_1: {
    name: "photo_any_devices_onboard_1",
    position: 360,
    position_admin: 400,
    positionByType: {
      MinibusCityIntercity: 270,
      MinibusTouristic: 340,
      AutobusNormalFloor2Axle: 350,
      AutobusNormalFloor3Axle: 340,
      AutobusLowFloorLowEntry8_12Mt: 290,
      Autobus18Mt: 310,
      DoubleDecker: 340
    },
    positionAdminByType: {
      MinibusCityIntercity: 290,
      MinibusTouristic: 360,
      AutobusNormalFloor2Axle: 370,
      AutobusNormalFloor3Axle: 360,
      AutobusLowFloorLowEntry8_12Mt: 310,
      Autobus18Mt: 330,
      DoubleDecker: 360
    },
    label: "Onboard Device 1",
    group: "interiors",
    description: "A photo of any onboard devices in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_any_devices_onboard_2: {
    name: "photo_any_devices_onboard_2",
    position: 370,
    position_admin: 410,
    positionByType: {
      MinibusCityIntercity: 280,
      MinibusTouristic: 350,
      AutobusNormalFloor2Axle: 360,
      AutobusNormalFloor3Axle: 350,
      AutobusLowFloorLowEntry8_12Mt: 300,
      Autobus18Mt: 320,
      DoubleDecker: 350
    },
    positionAdminByType: {
      MinibusCityIntercity: 300,
      MinibusTouristic: 370,
      AutobusNormalFloor2Axle: 380,
      AutobusNormalFloor3Axle: 370,
      AutobusLowFloorLowEntry8_12Mt: 320,
      Autobus18Mt: 340,
      DoubleDecker: 370
    },
    label: "Onboard Device 2",
    group: "interiors",
    description: "A photo of any onboard devices in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  control_unit_command_signs_indicators: {
    name: "control_unit_command_signs_indicators",
    position: 380,
    position_admin: 430,
    positionByType: {
      MinibusCityIntercity: 290,
      MinibusTouristic: 360,
      AutobusNormalFloor2Axle: 380,
      AutobusNormalFloor3Axle: 370,
      AutobusLowFloorLowEntry8_12Mt: 320,
      Autobus18Mt: 340,
      DoubleDecker: 370
    },
    positionAdminByType: {
      MinibusCityIntercity: 310,
      MinibusTouristic: 380,
      AutobusNormalFloor2Axle: 400,
      AutobusNormalFloor3Axle: 390,
      AutobusLowFloorLowEntry8_12Mt: 340,
      Autobus18Mt: 360,
      DoubleDecker: 390
    },
    label: "Command Unit Indicators",
    group: "interiors",
    description: "A photo of the control unit for signs and indicators.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_seat_hostess: {
    name: "photo_seat_hostess",
    position: 390,
    position_admin: 440,
    positionByType: { MinibusTouristic: 390, AutobusNormalFloor2Axle: 390, AutobusNormalFloor3Axle: 380, DoubleDecker: 380 },
    positionAdminByType: { MinibusTouristic: 410, AutobusNormalFloor2Axle: 410, AutobusNormalFloor3Axle: 400, DoubleDecker: 400 },
    label: "Hostess Seat",
    group: "interiors",
    description: "A photo of the hostess seat in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_accessories_hostes_microphone: {
    name: "photo_accessories_hostes_microphone",
    position: 400,
    position_admin: 450,
    positionByType: { MinibusTouristic: 400, AutobusNormalFloor2Axle: 400, AutobusNormalFloor3Axle: 390, DoubleDecker: 390 },
    positionAdminByType: { MinibusTouristic: 420, AutobusNormalFloor2Axle: 420, AutobusNormalFloor3Axle: 410, DoubleDecker: 410 },
    label: "Hostess Microphone",
    group: "interiors",
    description: "A photo showing the hostes's microphone accessories in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_handrails: {
    name: "photo_handrails",
    position: 410,
    position_admin: 460,
    label: "handrails photo",
    group: "interiors",
    description: "A photo showing the handrails inside the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_door_mechanism_internal_photo: {
    name: "photo_door_mechanism_internal_photo",
    position: 420,
    position_admin: 470,
    positionByType: {
      MinibusCityIntercity: 300,
      MinibusTouristic: 410,
      AutobusNormalFloor2Axle: 430,
      AutobusNormalFloor3Axle: 420,
      AutobusLowFloorLowEntry8_12Mt: 330,
      Autobus18Mt: 350,
      DoubleDecker: 420
    },
    positionAdminByType: {
      MinibusCityIntercity: 320,
      MinibusTouristic: 430,
      AutobusNormalFloor2Axle: 450,
      AutobusNormalFloor3Axle: 440,
      AutobusLowFloorLowEntry8_12Mt: 350,
      Autobus18Mt: 370,
      DoubleDecker: 440
    },
    label: "Door Mechanism",
    group: "interiors",
    description: "A photo of the internal door mechanism.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_interior_contromarcia_inquadrare_tutti_i_seats_height_seat_autista: {
    name: "photo_interior_contromarcia_inquadrare_tutti_i_seats_height_seat_autista",
    position: 430,
    position_admin: 480,
    positionByType: {
      MinibusCityIntercity: 310,
      MinibusTouristic: 420,
      AutobusNormalFloor2Axle: 440,
      AutobusNormalFloor3Axle: 430,
      AutobusLowFloorLowEntry8_12Mt: 340,
      Autobus18Mt: 360,
      DoubleDecker: 430
    },
    positionAdminByType: {
      MinibusCityIntercity: 330,
      MinibusTouristic: 440,
      AutobusNormalFloor2Axle: 460,
      AutobusNormalFloor3Axle: 450,
      AutobusLowFloorLowEntry8_12Mt: 360,
      Autobus18Mt: 380,
      DoubleDecker: 450
    },
    label: "Reverse Seats From Driver Position",
    group: "interiors",
    description: "A photo showing the interior seats in reverse view, including driver seat height.",
    requiredForToBeScrapped: !0,
    performTextInpaint: !1
  },
  photo_interior_reverse_view_from_middle_aisle: {
    name: "photo_interior_reverse_view_from_middle_aisle",
    position: 440,
    position_admin: 490,
    positionByType: {
      AutobusNormalFloor2Axle: 450,
      AutobusNormalFloor3Axle: 440,
      AutobusLowFloorLowEntry8_12Mt: 350,
      Autobus18Mt: 380,
      DoubleDecker: 440
    },
    positionAdminByType: {
      AutobusNormalFloor2Axle: 470,
      AutobusNormalFloor3Axle: 460,
      AutobusLowFloorLowEntry8_12Mt: 370,
      Autobus18Mt: 400,
      DoubleDecker: 460
    },
    label: "Reverse Seats From Middle Position",
    group: "interiors",
    description: "A reverse view photo from the middle aisle of the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_interior_senso_di_marcia_inquadrare_tutti_i_seats_height_ultima_fila: {
    name: "photo_interior_senso_di_marcia_inquadrare_tutti_i_seats_height_ultima_fila",
    position: 450,
    position_admin: 500,
    positionByType: {
      MinibusCityIntercity: 320,
      MinibusTouristic: 430,
      AutobusNormalFloor2Axle: 460,
      AutobusNormalFloor3Axle: 450,
      AutobusLowFloorLowEntry8_12Mt: 360,
      Autobus18Mt: 390,
      DoubleDecker: 450
    },
    positionAdminByType: {
      MinibusCityIntercity: 340,
      MinibusTouristic: 450,
      AutobusNormalFloor2Axle: 480,
      AutobusNormalFloor3Axle: 470,
      AutobusLowFloorLowEntry8_12Mt: 380,
      Autobus18Mt: 410,
      DoubleDecker: 470
    },
    label: "Forward Seats From End Position",
    group: "interiors",
    description: "A forward view photo showing all seats, focusing on the height of the last row.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_overhead_compartments: {
    name: "photo_overhead_compartments",
    position: 460,
    position_admin: 510,
    positionByType: {
      MinibusCityIntercity: 330,
      MinibusTouristic: 440,
      AutobusNormalFloor2Axle: 470,
      AutobusNormalFloor3Axle: 460,
      AutobusLowFloorLowEntry8_12Mt: 370,
      Autobus18Mt: 400,
      DoubleDecker: 460
    },
    positionAdminByType: {
      MinibusCityIntercity: 350,
      MinibusTouristic: 460,
      AutobusNormalFloor2Axle: 490,
      AutobusNormalFloor3Axle: 480,
      AutobusLowFloorLowEntry8_12Mt: 390,
      Autobus18Mt: 420,
      DoubleDecker: 480
    },
    label: "Overhead Compartments",
    group: "interiors",
    description: "A photo showing the overhead compartments inside the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_accessories_toilette: {
    name: "photo_accessories_toilette",
    position: 470,
    position_admin: 520,
    positionByType: { AutobusNormalFloor2Axle: 490, AutobusNormalFloor3Axle: 480, DoubleDecker: 480 },
    positionAdminByType: { AutobusNormalFloor2Axle: 510, AutobusNormalFloor3Axle: 500, DoubleDecker: 500 },
    label: "Toilette",
    group: "interiors",
    description: "A photo showing the toilette accessories inside the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_interior_forward_view_from_middle_aisle: {
    name: "photo_interior_forward_view_from_middle_aisle",
    position: 480,
    position_admin: 530,
    positionByType: {
      AutobusNormalFloor2Axle: 480,
      AutobusNormalFloor3Axle: 470,
      AutobusLowFloorLowEntry8_12Mt: 380,
      Autobus18Mt: 410,
      DoubleDecker: 470
    },
    positionAdminByType: {
      AutobusNormalFloor2Axle: 500,
      AutobusNormalFloor3Axle: 490,
      AutobusLowFloorLowEntry8_12Mt: 400,
      Autobus18Mt: 430,
      DoubleDecker: 490
    },
    label: "Forward Seats From Middle Position",
    group: "interiors",
    description: "A forward view photo from the middle aisle of the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_hatches_floor: {
    name: "photo_hatches_floor",
    position: 490,
    position_admin: 535,
    label: "floor hatches photo",
    group: "interiors",
    description: "A photo of the floor hatches in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_central_seat_with_safety_belt_fastened: {
    name: "photo_central_seat_with_safety_belt_fastened",
    position: 500,
    position_admin: 540,
    label: "central seat safety belt",
    group: "interiors",
    description: "A photo showing the central seat with the safety belt fastened.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  turntable_photo_internal_if_present_only_18mt: {
    name: "turntable_photo_internal_if_present_only_18mt",
    position: 510,
    position_admin: 550,
    positionByType: { Autobus18Mt: 370 },
    positionAdminByType: { Autobus18Mt: 390 },
    label: "Turntable Internal",
    group: "interiors",
    description: "An internal photo of the turntable if present (only for 18 meters).",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_hatches_roof_1: {
    name: "photo_hatches_roof_1",
    position: 520,
    position_admin: 560,
    positionByType: {
      MinibusCityIntercity: 340,
      MinibusTouristic: 450,
      AutobusNormalFloor2Axle: 500,
      AutobusNormalFloor3Axle: 490,
      AutobusLowFloorLowEntry8_12Mt: 390,
      Autobus18Mt: 420,
      DoubleDecker: 740
    },
    positionAdminByType: {
      MinibusCityIntercity: 360,
      MinibusTouristic: 470,
      AutobusNormalFloor2Axle: 520,
      AutobusNormalFloor3Axle: 510,
      AutobusLowFloorLowEntry8_12Mt: 410,
      Autobus18Mt: 440,
      DoubleDecker: 760
    },
    label: "Roof Hatch 1",
    group: "interiors",
    description: "A photo of the roof hatch number 1.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_hatches_roof_2: {
    name: "photo_hatches_roof_2",
    position: 530,
    position_admin: 570,
    positionByType: {
      MinibusCityIntercity: 350,
      MinibusTouristic: 460,
      AutobusNormalFloor2Axle: 510,
      AutobusNormalFloor3Axle: 500,
      AutobusLowFloorLowEntry8_12Mt: 400,
      Autobus18Mt: 430,
      DoubleDecker: 750
    },
    positionAdminByType: {
      MinibusCityIntercity: 370,
      MinibusTouristic: 480,
      AutobusNormalFloor2Axle: 530,
      AutobusNormalFloor3Axle: 520,
      AutobusLowFloorLowEntry8_12Mt: 420,
      Autobus18Mt: 450,
      DoubleDecker: 770
    },
    label: "Roof Hatch 2",
    group: "interiors",
    description: "A photo of the roof hatch number 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_hatches_roof_3: {
    name: "photo_hatches_roof_3",
    position: 540,
    position_admin: 575,
    positionByType: {
      MinibusTouristic: 470,
      AutobusNormalFloor2Axle: 520,
      AutobusNormalFloor3Axle: 510,
      AutobusLowFloorLowEntry8_12Mt: 410,
      Autobus18Mt: 440,
      DoubleDecker: 760
    },
    positionAdminByType: {
      MinibusTouristic: 490,
      AutobusNormalFloor2Axle: 540,
      AutobusNormalFloor3Axle: 530,
      AutobusLowFloorLowEntry8_12Mt: 430,
      Autobus18Mt: 460,
      DoubleDecker: 780
    },
    label: "Roof Hatch 3",
    group: "interiors",
    description: "A photo of the roof hatch number 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_disabled_area: {
    name: "photo_disabled_area",
    position: 550,
    position_admin: 580,
    positionByType: {
      MinibusCityIntercity: 360,
      AutobusNormalFloor2Axle: 530,
      AutobusNormalFloor3Axle: 520,
      AutobusLowFloorLowEntry8_12Mt: 420,
      Autobus18Mt: 450,
      DoubleDecker: 490
    },
    positionAdminByType: {
      MinibusCityIntercity: 380,
      AutobusNormalFloor2Axle: 550,
      AutobusNormalFloor3Axle: 540,
      AutobusLowFloorLowEntry8_12Mt: 440,
      Autobus18Mt: 470,
      DoubleDecker: 510
    },
    label: "Disabled Area",
    group: "interiors",
    description: "A photo showing the designated disabled area in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_folding_seat: {
    name: "photo_folding_seat",
    position: 560,
    position_admin: 590,
    positionByType: {
      MinibusCityIntercity: 370,
      AutobusNormalFloor2Axle: 540,
      AutobusNormalFloor3Axle: 530,
      AutobusLowFloorLowEntry8_12Mt: 430,
      Autobus18Mt: 460,
      DoubleDecker: 500
    },
    positionAdminByType: {
      MinibusCityIntercity: 390,
      AutobusNormalFloor2Axle: 560,
      AutobusNormalFloor3Axle: 550,
      AutobusLowFloorLowEntry8_12Mt: 450,
      Autobus18Mt: 480,
      DoubleDecker: 520
    },
    label: "Folding Seats",
    group: "interiors",
    description: "A photo showing the folding seat in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_detail_of_single_seat: {
    name: "photo_detail_of_single_seat",
    position: 570,
    position_admin: 620,
    positionByType: {
      MinibusCityIntercity: 380,
      MinibusTouristic: 480,
      AutobusNormalFloor2Axle: 550,
      AutobusNormalFloor3Axle: 540,
      AutobusLowFloorLowEntry8_12Mt: 440,
      Autobus18Mt: 470,
      DoubleDecker: 510
    },
    positionAdminByType: {
      MinibusCityIntercity: 400,
      MinibusTouristic: 500,
      AutobusNormalFloor2Axle: 570,
      AutobusNormalFloor3Axle: 560,
      AutobusLowFloorLowEntry8_12Mt: 460,
      Autobus18Mt: 490,
      DoubleDecker: 530
    },
    label: "Seats",
    group: "interiors",
    description: "A detailed photo of a single seat in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_detail_of_mesh: {
    name: "photo_detail_of_mesh",
    position: 580,
    position_admin: 630,
    positionByType: { MinibusTouristic: 490, AutobusNormalFloor2Axle: 570, AutobusNormalFloor3Axle: 560, DoubleDecker: 530 },
    positionAdminByType: { MinibusTouristic: 510, AutobusNormalFloor2Axle: 590, AutobusNormalFloor3Axle: 580, DoubleDecker: 550 },
    label: "Mesh",
    group: "interiors",
    description: "A detailed photo of the mesh inside the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_table_detail: {
    name: "photo_table_detail",
    position: 590,
    position_admin: 640,
    positionByType: { MinibusTouristic: 500, AutobusNormalFloor2Axle: 580, AutobusNormalFloor3Axle: 570, DoubleDecker: 540 },
    positionAdminByType: { MinibusTouristic: 520, AutobusNormalFloor2Axle: 600, AutobusNormalFloor3Axle: 590, DoubleDecker: 560 },
    label: "Table",
    group: "interiors",
    description: "A detailed photo of the table inside the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_charging_usb_detail: {
    name: "photo_charging_usb_detail",
    position: 600,
    position_admin: 650,
    positionByType: { MinibusTouristic: 510, AutobusNormalFloor2Axle: 590, AutobusNormalFloor3Axle: 580, DoubleDecker: 550 },
    positionAdminByType: { MinibusTouristic: 530, AutobusNormalFloor2Axle: 610, AutobusNormalFloor3Axle: 600, DoubleDecker: 570 },
    label: "Usb Charging",
    group: "interiors",
    description: "A detailed photo showing the USB charging ports.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_armrest_detail: {
    name: "photo_armrest_detail",
    position: 610,
    position_admin: 660,
    positionByType: { MinibusTouristic: 520, AutobusNormalFloor2Axle: 560, AutobusNormalFloor3Axle: 550, DoubleDecker: 520 },
    positionAdminByType: { MinibusTouristic: 540, AutobusNormalFloor2Axle: 580, AutobusNormalFloor3Axle: 570, DoubleDecker: 540 },
    label: "Armrest",
    group: "interiors",
    description: "A detailed photo of the armrest in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_footrest_detail: {
    name: "photo_footrest_detail",
    position: 620,
    position_admin: 670,
    positionByType: { MinibusTouristic: 530, AutobusNormalFloor2Axle: 600, AutobusNormalFloor3Axle: 590, DoubleDecker: 560 },
    positionAdminByType: { MinibusTouristic: 550, AutobusNormalFloor2Axle: 620, AutobusNormalFloor3Axle: 610, DoubleDecker: 580 },
    label: "Footrest",
    group: "interiors",
    description: "A detailed photo of the footrest in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_monitor_detail: {
    name: "photo_monitor_detail",
    position: 630,
    position_admin: 680,
    positionByType: { MinibusTouristic: 540, AutobusNormalFloor2Axle: 620, AutobusNormalFloor3Axle: 610, DoubleDecker: 580 },
    positionAdminByType: { MinibusTouristic: 560, AutobusNormalFloor2Axle: 640, AutobusNormalFloor3Axle: 630, DoubleDecker: 600 },
    label: "Monitor",
    group: "interiors",
    description: "A detailed photo of the monitor in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_outlets_di_current_detail: {
    name: "photo_outlets_di_current_detail",
    position: 640,
    position_admin: 690,
    positionByType: { MinibusTouristic: 550, AutobusNormalFloor2Axle: 610, AutobusNormalFloor3Axle: 600, DoubleDecker: 570 },
    positionAdminByType: { MinibusTouristic: 570, AutobusNormalFloor2Axle: 630, AutobusNormalFloor3Axle: 620, DoubleDecker: 590 },
    label: "Power Outlets",
    group: "interiors",
    description: "A detailed photo of the power outlets in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_coffee_machine_accessories: {
    name: "photo_coffee_machine_accessories",
    position: 650,
    position_admin: 710,
    positionByType: { MinibusTouristic: 370, AutobusNormalFloor2Axle: 410, AutobusNormalFloor3Axle: 400, DoubleDecker: 400 },
    positionAdminByType: { MinibusTouristic: 390, AutobusNormalFloor2Axle: 430, AutobusNormalFloor3Axle: 420, DoubleDecker: 420 },
    label: "Coffee Machine",
    group: "interiors",
    description: "A photo of the coffee machine accessories in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_brackets_seats: {
    name: "photo_brackets_seats",
    position: 660,
    position_admin: 710,
    positionByType: {
      MinibusCityIntercity: 390,
      MinibusTouristic: 560,
      AutobusNormalFloor2Axle: 630,
      AutobusNormalFloor3Axle: 620,
      AutobusLowFloorLowEntry8_12Mt: 450,
      Autobus18Mt: 480,
      DoubleDecker: 620
    },
    positionAdminByType: {
      MinibusCityIntercity: 410,
      MinibusTouristic: 580,
      AutobusNormalFloor2Axle: 650,
      AutobusNormalFloor3Axle: 640,
      AutobusLowFloorLowEntry8_12Mt: 470,
      Autobus18Mt: 500,
      DoubleDecker: 640
    },
    label: "Seats Bracket",
    group: "interiors",
    description: "A photo showing the seat brackets in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_accessories_cameras: {
    name: "photo_accessories_cameras",
    position: 670,
    position_admin: 720,
    positionByType: {
      MinibusCityIntercity: 400,
      MinibusTouristic: 570,
      AutobusNormalFloor2Axle: 640,
      AutobusNormalFloor3Axle: 630,
      AutobusLowFloorLowEntry8_12Mt: 460,
      Autobus18Mt: 490,
      DoubleDecker: 630
    },
    positionAdminByType: {
      MinibusCityIntercity: 420,
      MinibusTouristic: 590,
      AutobusNormalFloor2Axle: 660,
      AutobusNormalFloor3Axle: 650,
      AutobusLowFloorLowEntry8_12Mt: 480,
      Autobus18Mt: 510,
      DoubleDecker: 650
    },
    label: "Camera",
    group: "interiors",
    description: "A photo showing the camera accessories inside the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  jack_e_keys_for_driver: {
    name: "jack_e_keys_for_driver",
    position: 680,
    position_admin: 730,
    label: "jack and driver keys",
    group: "interiors",
    description: "A photo showing the jack and keys for the driver.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  // Tire sizes
  spare_wheel: {
    name: "spare_wheel",
    position: 690,
    position_admin: 20,
    positionByType: {
      MinibusTouristic: 940,
      AutobusNormalFloor2Axle: 1020,
      AutobusNormalFloor3Axle: 1120,
      AutobusLowFloorLowEntry8_12Mt: 840,
      DoubleDecker: 1270
    },
    positionAdminByType: {
      MinibusTouristic: 960,
      AutobusNormalFloor2Axle: 1040,
      AutobusNormalFloor3Axle: 1140,
      AutobusLowFloorLowEntry8_12Mt: 860,
      DoubleDecker: 1290
    },
    label: "Spare Tyre",
    group: "tire-sizes",
    description: "A photo of the spare wheel in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_tire_front_left_measurements: {
    name: "photo_tire_front_left_measurements",
    position: 700,
    position_admin: 50,
    positionByType: {
      MinibusCityIntercity: 780,
      MinibusTouristic: 960,
      AutobusNormalFloor2Axle: 1040,
      AutobusNormalFloor3Axle: 1140,
      AutobusLowFloorLowEntry8_12Mt: 860,
      Autobus18Mt: 1040,
      DoubleDecker: 1290
    },
    positionAdminByType: {
      MinibusCityIntercity: 800,
      MinibusTouristic: 980,
      AutobusNormalFloor2Axle: 1060,
      AutobusNormalFloor3Axle: 1160,
      AutobusLowFloorLowEntry8_12Mt: 880,
      Autobus18Mt: 1060,
      DoubleDecker: 1310
    },
    label: "First Axle Left Side: Tyre Size",
    group: "tire-sizes",
    description: "A photo showing the measurements of the front left tire.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_tire_rear_left: {
    name: "photo_tire_rear_left",
    position: 710,
    position_admin: 110,
    positionByType: {
      MinibusCityIntercity: 800,
      MinibusTouristic: 980,
      AutobusNormalFloor2Axle: 1060,
      AutobusNormalFloor3Axle: 1160,
      AutobusLowFloorLowEntry8_12Mt: 880,
      Autobus18Mt: 1060,
      DoubleDecker: 1310
    },
    positionAdminByType: {
      MinibusCityIntercity: 820,
      MinibusTouristic: 1e3,
      AutobusNormalFloor2Axle: 1080,
      AutobusNormalFloor3Axle: 1180,
      AutobusLowFloorLowEntry8_12Mt: 900,
      Autobus18Mt: 1080,
      DoubleDecker: 1330
    },
    label: "First Axle Left Side: Tyre Tread",
    group: "tire-sizes",
    description: "A photo of the tyre tread on the first axle, left side.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_of_tires_with_tread_pattern_and_condition_front_right: {
    name: "photo_of_tires_with_tread_pattern_and_condition_front_right",
    position: 720,
    position_admin: 760,
    positionByType: {
      MinibusCityIntercity: 810,
      MinibusTouristic: 990,
      AutobusNormalFloor2Axle: 1070,
      AutobusNormalFloor3Axle: 1170,
      AutobusLowFloorLowEntry8_12Mt: 890,
      Autobus18Mt: 1070,
      DoubleDecker: 1320
    },
    positionAdminByType: {
      MinibusCityIntercity: 830,
      MinibusTouristic: 1010,
      AutobusNormalFloor2Axle: 1090,
      AutobusNormalFloor3Axle: 1190,
      AutobusLowFloorLowEntry8_12Mt: 910,
      Autobus18Mt: 1090,
      DoubleDecker: 1340
    },
    label: "Second Axle Left Side: Complete Wheel",
    group: "tire-sizes",
    description: "A photo of the complete wheel on the second axle, left side.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_of_tires_with_tread_pattern_and_condition_front_left: {
    name: "photo_of_tires_with_tread_pattern_and_condition_front_left",
    position: 730,
    position_admin: 1190,
    positionByType: {
      MinibusCityIntercity: 830,
      MinibusTouristic: 1010,
      AutobusNormalFloor2Axle: 1090,
      AutobusNormalFloor3Axle: 1190,
      AutobusLowFloorLowEntry8_12Mt: 910,
      Autobus18Mt: 1090,
      DoubleDecker: 1340
    },
    positionAdminByType: {
      MinibusCityIntercity: 850,
      MinibusTouristic: 1030,
      AutobusNormalFloor2Axle: 1110,
      AutobusNormalFloor3Axle: 1210,
      AutobusLowFloorLowEntry8_12Mt: 930,
      Autobus18Mt: 1110,
      DoubleDecker: 1360
    },
    label: "Second Axle Left Side: Tyre Thickness",
    group: "tire-sizes",
    description: "A photo of the tyre thickness on the second axle, left side.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_of_tires_with_tread_pattern_and_condition_second_axle_left: {
    name: "photo_of_tires_with_tread_pattern_and_condition_second_axle_left",
    position: 740,
    position_admin: 1190,
    positionByType: { AutobusNormalFloor3Axle: 1210, Autobus18Mt: 1110, DoubleDecker: 1360 },
    positionAdminByType: { AutobusNormalFloor3Axle: 1230, Autobus18Mt: 1130, DoubleDecker: 1380 },
    label: "Third Axle Left Side: Complete Wheel",
    group: "tire-sizes",
    description: "A photo of the complete wheel on the third axle, left side.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_of_tires_with_tread_pattern_and_condition_second_axle_right: {
    name: "photo_of_tires_with_tread_pattern_and_condition_second_axle_right",
    position: 750,
    position_admin: 1200,
    positionByType: { AutobusNormalFloor3Axle: 1230, Autobus18Mt: 1130, DoubleDecker: 1380 },
    positionAdminByType: { AutobusNormalFloor3Axle: 1250, Autobus18Mt: 1150, DoubleDecker: 1400 },
    label: "Third Axle Left Side: Tyre Thickness",
    group: "tire-sizes",
    description: "A photo of the tyre thickness on the third axle, left side.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_of_tires_with_tread_pattern_and_condition_third_axle_left: {
    name: "photo_of_tires_with_tread_pattern_and_condition_third_axle_left",
    position: 760,
    position_admin: 1210,
    positionByType: { AutobusNormalFloor3Axle: 1250, Autobus18Mt: 1150, DoubleDecker: 1400 },
    positionAdminByType: { AutobusNormalFloor3Axle: 1270, Autobus18Mt: 1170, DoubleDecker: 1420 },
    label: "Third Axle Right Side: Tyre Tread",
    group: "tire-sizes",
    description: "A photo of the tyre tread on the third axle, right side.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_of_tires_with_tread_pattern_and_condition_third_axle_right: {
    name: "photo_of_tires_with_tread_pattern_and_condition_third_axle_right",
    position: 770,
    position_admin: 1220,
    positionByType: {
      MinibusCityIntercity: 860,
      MinibusTouristic: 1040,
      AutobusNormalFloor2Axle: 1120,
      AutobusNormalFloor3Axle: 1270,
      AutobusLowFloorLowEntry8_12Mt: 940,
      Autobus18Mt: 1170,
      DoubleDecker: 1420
    },
    positionAdminByType: {
      MinibusCityIntercity: 880,
      MinibusTouristic: 1060,
      AutobusNormalFloor2Axle: 1140,
      AutobusNormalFloor3Axle: 1290,
      AutobusLowFloorLowEntry8_12Mt: 960,
      Autobus18Mt: 1190,
      DoubleDecker: 1440
    },
    label: "First Axle Right Side: Tyre Tread",
    group: "tire-sizes",
    description: "A photo of the tyre tread on the first axle, right side.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  // Undercarriage
  photo_undercarriage_front_part_from_front: {
    name: "photo_undercarriage_front_part_from_front",
    position: 780,
    position_admin: 740,
    positionByType: {
      MinibusCityIntercity: 420,
      MinibusTouristic: 590,
      AutobusNormalFloor2Axle: 670,
      AutobusNormalFloor3Axle: 660,
      AutobusLowFloorLowEntry8_12Mt: 490,
      Autobus18Mt: 520,
      DoubleDecker: 810
    },
    positionAdminByType: {
      MinibusCityIntercity: 440,
      MinibusTouristic: 610,
      AutobusNormalFloor2Axle: 690,
      AutobusNormalFloor3Axle: 680,
      AutobusLowFloorLowEntry8_12Mt: 510,
      Autobus18Mt: 540,
      DoubleDecker: 830
    },
    label: "Front Undercarriage",
    group: "undercarriage",
    description: "A photo showing the front part of the undercarriage from the front.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_undercarriage_axle_front_side_right: {
    name: "photo_undercarriage_axle_front_side_right",
    position: 790,
    position_admin: 770,
    positionByType: {
      MinibusCityIntercity: 490,
      MinibusTouristic: 660,
      AutobusNormalFloor2Axle: 690,
      AutobusNormalFloor3Axle: 680,
      AutobusLowFloorLowEntry8_12Mt: 510,
      Autobus18Mt: 540,
      DoubleDecker: 830
    },
    positionAdminByType: {
      MinibusCityIntercity: 510,
      MinibusTouristic: 680,
      AutobusNormalFloor2Axle: 710,
      AutobusNormalFloor3Axle: 700,
      AutobusLowFloorLowEntry8_12Mt: 530,
      Autobus18Mt: 560,
      DoubleDecker: 850
    },
    label: "First Axle Right Side",
    group: "undercarriage",
    description: "A photo of the front axle from the right side of the undercarriage.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_front_discs_right: {
    name: "photo_front_discs_right",
    position: 800,
    position_admin: 780,
    positionByType: {
      MinibusCityIntercity: 500,
      MinibusTouristic: 670,
      AutobusNormalFloor2Axle: 700,
      AutobusNormalFloor3Axle: 690,
      AutobusLowFloorLowEntry8_12Mt: 520,
      Autobus18Mt: 550,
      DoubleDecker: 840
    },
    positionAdminByType: {
      MinibusCityIntercity: 520,
      MinibusTouristic: 690,
      AutobusNormalFloor2Axle: 720,
      AutobusNormalFloor3Axle: 710,
      AutobusLowFloorLowEntry8_12Mt: 540,
      Autobus18Mt: 570,
      DoubleDecker: 860
    },
    label: "First Axle Discs Right Side",
    group: "undercarriage",
    description: "A photo of the right front brake discs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_front_brake_calipers_right: {
    name: "photo_front_brake_calipers_right",
    position: 810,
    position_admin: 790,
    positionByType: {
      MinibusCityIntercity: 510,
      MinibusTouristic: 680,
      AutobusNormalFloor2Axle: 710,
      AutobusNormalFloor3Axle: 700,
      AutobusLowFloorLowEntry8_12Mt: 530,
      Autobus18Mt: 560,
      DoubleDecker: 850
    },
    positionAdminByType: {
      MinibusCityIntercity: 530,
      MinibusTouristic: 700,
      AutobusNormalFloor2Axle: 730,
      AutobusNormalFloor3Axle: 720,
      AutobusLowFloorLowEntry8_12Mt: 550,
      Autobus18Mt: 580,
      DoubleDecker: 870
    },
    label: "First Axle Brake Calipers Right Side",
    group: "undercarriage",
    description: "A photo of the right front brake calipers.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_front_shock_absorbers_if_separate_from_springs_right: {
    name: "photo_front_shock_absorbers_if_separate_from_springs_right",
    position: 820,
    position_admin: 800,
    positionByType: {
      MinibusCityIntercity: 520,
      MinibusTouristic: 690,
      AutobusNormalFloor2Axle: 720,
      AutobusNormalFloor3Axle: 710,
      AutobusLowFloorLowEntry8_12Mt: 540,
      Autobus18Mt: 570,
      DoubleDecker: 860
    },
    positionAdminByType: {
      MinibusCityIntercity: 540,
      MinibusTouristic: 710,
      AutobusNormalFloor2Axle: 740,
      AutobusNormalFloor3Axle: 730,
      AutobusLowFloorLowEntry8_12Mt: 560,
      Autobus18Mt: 590,
      DoubleDecker: 880
    },
    label: "First Axle Shock Absorbers Right Side",
    group: "undercarriage",
    description: "A photo of the right front shock absorbers, if they are separate from the springs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_front_air_springs_or_group_of_springs_and_shock_absorbers_right: {
    name: "photo_front_air_springs_or_group_of_springs_and_shock_absorbers_right",
    position: 830,
    position_admin: 810,
    positionByType: {
      MinibusCityIntercity: 530,
      MinibusTouristic: 700,
      AutobusNormalFloor2Axle: 730,
      AutobusNormalFloor3Axle: 720,
      AutobusLowFloorLowEntry8_12Mt: 550,
      Autobus18Mt: 580,
      DoubleDecker: 870
    },
    positionAdminByType: {
      MinibusCityIntercity: 550,
      MinibusTouristic: 720,
      AutobusNormalFloor2Axle: 750,
      AutobusNormalFloor3Axle: 740,
      AutobusLowFloorLowEntry8_12Mt: 570,
      Autobus18Mt: 600,
      DoubleDecker: 890
    },
    label: "First Axle Air Springs Right Side",
    group: "undercarriage",
    description: "A photo of the right front air springs or group of springs and shock absorbers.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_undercarriage_axle_front_central: {
    name: "photo_undercarriage_axle_front_central",
    position: 840,
    position_admin: 820,
    positionByType: {
      MinibusCityIntercity: 480,
      MinibusTouristic: 650,
      AutobusNormalFloor2Axle: 680,
      AutobusNormalFloor3Axle: 670,
      AutobusLowFloorLowEntry8_12Mt: 500,
      Autobus18Mt: 530,
      DoubleDecker: 820
    },
    positionAdminByType: {
      MinibusCityIntercity: 500,
      MinibusTouristic: 670,
      AutobusNormalFloor2Axle: 700,
      AutobusNormalFloor3Axle: 690,
      AutobusLowFloorLowEntry8_12Mt: 520,
      Autobus18Mt: 550,
      DoubleDecker: 840
    },
    label: "First Axle Central",
    group: "undercarriage",
    description: "A photo of the front axle from the central part of the undercarriage.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_undercarriage_axle_front_side_left: {
    name: "photo_undercarriage_axle_front_side_left",
    position: 850,
    position_admin: 830,
    positionByType: {
      MinibusCityIntercity: 540,
      MinibusTouristic: 710,
      AutobusNormalFloor2Axle: 740,
      AutobusNormalFloor3Axle: 730,
      AutobusLowFloorLowEntry8_12Mt: 560,
      Autobus18Mt: 590,
      DoubleDecker: 880
    },
    positionAdminByType: {
      MinibusCityIntercity: 560,
      MinibusTouristic: 730,
      AutobusNormalFloor2Axle: 760,
      AutobusNormalFloor3Axle: 750,
      AutobusLowFloorLowEntry8_12Mt: 580,
      Autobus18Mt: 610,
      DoubleDecker: 900
    },
    label: "First Axle Left Side",
    group: "undercarriage",
    description: "A photo of the front axle from the left side of the undercarriage.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_front_discs_left: {
    name: "photo_front_discs_left",
    position: 860,
    position_admin: 840,
    positionByType: {
      MinibusCityIntercity: 550,
      MinibusTouristic: 720,
      AutobusNormalFloor2Axle: 750,
      AutobusNormalFloor3Axle: 740,
      AutobusLowFloorLowEntry8_12Mt: 570,
      Autobus18Mt: 600,
      DoubleDecker: 890
    },
    positionAdminByType: {
      MinibusCityIntercity: 570,
      MinibusTouristic: 740,
      AutobusNormalFloor2Axle: 770,
      AutobusNormalFloor3Axle: 760,
      AutobusLowFloorLowEntry8_12Mt: 590,
      Autobus18Mt: 620,
      DoubleDecker: 910
    },
    label: "First Axle Discs Left Side",
    group: "undercarriage",
    description: "A photo of the left front brake discs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_front_brake_calipers_left: {
    name: "photo_front_brake_calipers_left",
    position: 870,
    position_admin: 850,
    positionByType: {
      MinibusCityIntercity: 560,
      MinibusTouristic: 730,
      AutobusNormalFloor2Axle: 760,
      AutobusNormalFloor3Axle: 750,
      AutobusLowFloorLowEntry8_12Mt: 580,
      Autobus18Mt: 610,
      DoubleDecker: 900
    },
    positionAdminByType: {
      MinibusCityIntercity: 580,
      MinibusTouristic: 750,
      AutobusNormalFloor2Axle: 780,
      AutobusNormalFloor3Axle: 770,
      AutobusLowFloorLowEntry8_12Mt: 600,
      Autobus18Mt: 630,
      DoubleDecker: 920
    },
    label: "First Axle Brake Calipers Left Side",
    group: "undercarriage",
    description: "A photo of the left front brake calipers.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_front_shock_absorbers_if_separate_from_springs_left: {
    name: "photo_front_shock_absorbers_if_separate_from_springs_left",
    position: 880,
    position_admin: 860,
    positionByType: {
      MinibusCityIntercity: 570,
      MinibusTouristic: 740,
      AutobusNormalFloor2Axle: 770,
      AutobusNormalFloor3Axle: 760,
      AutobusLowFloorLowEntry8_12Mt: 590,
      Autobus18Mt: 620,
      DoubleDecker: 910
    },
    positionAdminByType: {
      MinibusCityIntercity: 590,
      MinibusTouristic: 760,
      AutobusNormalFloor2Axle: 790,
      AutobusNormalFloor3Axle: 780,
      AutobusLowFloorLowEntry8_12Mt: 610,
      Autobus18Mt: 640,
      DoubleDecker: 930
    },
    label: "First Axle Shock Absorbers Left Side",
    group: "undercarriage",
    description: "A photo of the left front shock absorbers, if they are separate from the springs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_front_air_springs_or_group_of_springs_and_shock_absorbers_left: {
    name: "photo_front_air_springs_or_group_of_springs_and_shock_absorbers_left",
    position: 890,
    position_admin: 870,
    positionByType: {
      MinibusCityIntercity: 580,
      MinibusTouristic: 750,
      AutobusNormalFloor2Axle: 780,
      AutobusNormalFloor3Axle: 770,
      AutobusLowFloorLowEntry8_12Mt: 600,
      Autobus18Mt: 630,
      DoubleDecker: 920
    },
    positionAdminByType: {
      MinibusCityIntercity: 600,
      MinibusTouristic: 770,
      AutobusNormalFloor2Axle: 800,
      AutobusNormalFloor3Axle: 790,
      AutobusLowFloorLowEntry8_12Mt: 620,
      Autobus18Mt: 650,
      DoubleDecker: 940
    },
    label: "First Axle Air Springs Left Side",
    group: "undercarriage",
    description: "A photo of the left front air springs or group of springs and shock absorbers.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_undercarriage_central: {
    name: "photo_undercarriage_central",
    position: 900,
    position_admin: 880,
    positionByType: {
      MinibusCityIntercity: 590,
      MinibusTouristic: 760,
      AutobusNormalFloor2Axle: 790,
      AutobusNormalFloor3Axle: 780,
      AutobusLowFloorLowEntry8_12Mt: 610,
      Autobus18Mt: 640,
      DoubleDecker: 930
    },
    positionAdminByType: {
      MinibusCityIntercity: 610,
      MinibusTouristic: 780,
      AutobusNormalFloor2Axle: 810,
      AutobusNormalFloor3Axle: 800,
      AutobusLowFloorLowEntry8_12Mt: 630,
      Autobus18Mt: 660,
      DoubleDecker: 950
    },
    label: "Central Undercarriage",
    group: "undercarriage",
    description: "A photo of the central part of the undercarriage.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_discs_axle_central_right: {
    name: "photo_discs_axle_central_right",
    position: 910,
    position_admin: 890,
    positionByType: {
      MinibusCityIntercity: 620,
      MinibusTouristic: 790,
      AutobusNormalFloor2Axle: 820,
      AutobusNormalFloor3Axle: 810,
      AutobusLowFloorLowEntry8_12Mt: 640,
      Autobus18Mt: 670,
      DoubleDecker: 960
    },
    positionAdminByType: {
      MinibusCityIntercity: 640,
      MinibusTouristic: 810,
      AutobusNormalFloor2Axle: 840,
      AutobusNormalFloor3Axle: 830,
      AutobusLowFloorLowEntry8_12Mt: 660,
      Autobus18Mt: 690,
      DoubleDecker: 980
    },
    label: "Second Axle Discs Right Side",
    group: "undercarriage",
    description: "A photo of the right brake discs on the axle 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_caliper_brakes_axle_central_right: {
    name: "photo_caliper_brakes_axle_central_right",
    position: 920,
    position_admin: 900,
    positionByType: {
      MinibusCityIntercity: 630,
      MinibusTouristic: 800,
      AutobusNormalFloor2Axle: 830,
      AutobusNormalFloor3Axle: 820,
      AutobusLowFloorLowEntry8_12Mt: 650,
      Autobus18Mt: 680,
      DoubleDecker: 970
    },
    positionAdminByType: {
      MinibusCityIntercity: 650,
      MinibusTouristic: 820,
      AutobusNormalFloor2Axle: 850,
      AutobusNormalFloor3Axle: 840,
      AutobusLowFloorLowEntry8_12Mt: 670,
      Autobus18Mt: 700,
      DoubleDecker: 990
    },
    label: "Second Axle Caliper Brakes Right Side",
    group: "undercarriage",
    description: "A photo of the right brake calipers on the axle 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_shock_absorbers_central_axle_if_separate_from_springs_right_1: {
    name: "photo_shock_absorbers_central_axle_if_separate_from_springs_right_1",
    position: 930,
    position_admin: 910,
    positionByType: {
      MinibusCityIntercity: 640,
      MinibusTouristic: 810,
      AutobusNormalFloor2Axle: 840,
      AutobusNormalFloor3Axle: 830,
      AutobusLowFloorLowEntry8_12Mt: 660,
      Autobus18Mt: 690,
      DoubleDecker: 980
    },
    positionAdminByType: {
      MinibusCityIntercity: 660,
      MinibusTouristic: 830,
      AutobusNormalFloor2Axle: 860,
      AutobusNormalFloor3Axle: 850,
      AutobusLowFloorLowEntry8_12Mt: 680,
      Autobus18Mt: 710,
      DoubleDecker: 1e3
    },
    label: "Second Axle Shock Absorbers Right Side",
    group: "undercarriage",
    description: "A photo of the first right shock absorbers on the axle 2, if they are separate from the springs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_shock_absorbers_central_axle_if_separate_from_springs_right_2: {
    name: "photo_shock_absorbers_central_axle_if_separate_from_springs_right_2",
    position: 940,
    position_admin: 920,
    positionByType: {
      MinibusCityIntercity: 650,
      MinibusTouristic: 820,
      AutobusNormalFloor2Axle: 850,
      AutobusNormalFloor3Axle: 840,
      AutobusLowFloorLowEntry8_12Mt: 670,
      Autobus18Mt: 700,
      DoubleDecker: 990
    },
    positionAdminByType: {
      MinibusCityIntercity: 670,
      MinibusTouristic: 840,
      AutobusNormalFloor2Axle: 870,
      AutobusNormalFloor3Axle: 860,
      AutobusLowFloorLowEntry8_12Mt: 690,
      Autobus18Mt: 720,
      DoubleDecker: 1010
    },
    label: "Second Axle Shock Absorbers Left Side",
    group: "undercarriage",
    description: "A photo of the left shock absorbers on the axle 2, if they are separate from the springs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_air_springs_central_axle_or_group_of_springs_and_shock_absorbers_right_1: {
    name: "photo_air_springs_central_axle_or_group_of_springs_and_shock_absorbers_right_1",
    position: 950,
    position_admin: 930,
    positionByType: {
      MinibusCityIntercity: 660,
      MinibusTouristic: 830,
      AutobusNormalFloor2Axle: 860,
      AutobusNormalFloor3Axle: 850,
      AutobusLowFloorLowEntry8_12Mt: 680,
      Autobus18Mt: 710,
      DoubleDecker: 1e3
    },
    positionAdminByType: {
      MinibusCityIntercity: 680,
      MinibusTouristic: 850,
      AutobusNormalFloor2Axle: 880,
      AutobusNormalFloor3Axle: 870,
      AutobusLowFloorLowEntry8_12Mt: 700,
      Autobus18Mt: 730,
      DoubleDecker: 1020
    },
    label: "Second Axle First Air Springs Right Side",
    group: "undercarriage",
    description: "A photo of the first right air springs or group of springs and shock absorbers on the axle 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_air_springs_central_axle_or_group_of_springs_and_shock_absorbers_right_2: {
    name: "photo_air_springs_central_axle_or_group_of_springs_and_shock_absorbers_right_2",
    position: 960,
    position_admin: 940,
    positionByType: {
      MinibusCityIntercity: 670,
      MinibusTouristic: 840,
      AutobusNormalFloor2Axle: 870,
      AutobusNormalFloor3Axle: 860,
      AutobusLowFloorLowEntry8_12Mt: 690,
      Autobus18Mt: 720,
      DoubleDecker: 1010
    },
    positionAdminByType: {
      MinibusCityIntercity: 690,
      MinibusTouristic: 860,
      AutobusNormalFloor2Axle: 890,
      AutobusNormalFloor3Axle: 880,
      AutobusLowFloorLowEntry8_12Mt: 710,
      Autobus18Mt: 740,
      DoubleDecker: 1030
    },
    label: "Second Axle Second Air Springs Right Side",
    group: "undercarriage",
    description: "A photo of the second right air springs or group of springs and shock absorbers on the axle 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_discs_axle_central_left: {
    name: "photo_discs_axle_central_left",
    position: 970,
    position_admin: 950,
    positionByType: {
      MinibusCityIntercity: 690,
      MinibusTouristic: 860,
      AutobusNormalFloor2Axle: 890,
      AutobusNormalFloor3Axle: 880,
      AutobusLowFloorLowEntry8_12Mt: 710,
      Autobus18Mt: 740,
      DoubleDecker: 1030
    },
    positionAdminByType: {
      MinibusCityIntercity: 710,
      MinibusTouristic: 880,
      AutobusNormalFloor2Axle: 910,
      AutobusNormalFloor3Axle: 900,
      AutobusLowFloorLowEntry8_12Mt: 730,
      Autobus18Mt: 760,
      DoubleDecker: 1050
    },
    label: "Second Axle Discs Left Side",
    group: "undercarriage",
    description: "A photo of the left brake discs on the axle 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_caliper_brakes_axle_central_left: {
    name: "photo_caliper_brakes_axle_central_left",
    position: 980,
    position_admin: 960,
    positionByType: {
      MinibusCityIntercity: 700,
      MinibusTouristic: 870,
      AutobusNormalFloor2Axle: 900,
      AutobusNormalFloor3Axle: 890,
      AutobusLowFloorLowEntry8_12Mt: 720,
      Autobus18Mt: 750,
      DoubleDecker: 1040
    },
    positionAdminByType: {
      MinibusCityIntercity: 720,
      MinibusTouristic: 890,
      AutobusNormalFloor2Axle: 920,
      AutobusNormalFloor3Axle: 910,
      AutobusLowFloorLowEntry8_12Mt: 740,
      Autobus18Mt: 770,
      DoubleDecker: 1060
    },
    label: "Second Axle Caliper Brakes Left Side",
    group: "undercarriage",
    description: "A photo of the left brake calipers on the axle 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_shock_absorbers_central_axle_if_separate_from_springs_left_1: {
    name: "photo_shock_absorbers_central_axle_if_separate_from_springs_left_1",
    position: 990,
    position_admin: 970,
    positionByType: {
      MinibusCityIntercity: 710,
      MinibusTouristic: 880,
      AutobusNormalFloor2Axle: 910,
      AutobusNormalFloor3Axle: 900,
      AutobusLowFloorLowEntry8_12Mt: 730,
      Autobus18Mt: 760,
      DoubleDecker: 1050
    },
    positionAdminByType: {
      MinibusCityIntercity: 730,
      MinibusTouristic: 900,
      AutobusNormalFloor2Axle: 930,
      AutobusNormalFloor3Axle: 920,
      AutobusLowFloorLowEntry8_12Mt: 750,
      Autobus18Mt: 780,
      DoubleDecker: 1070
    },
    label: "Second Axle First Shock Absorbers Left Side",
    group: "undercarriage",
    description: "A photo of the first left shock absorbers on the axle 2, if they are separate from the springs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_air_springs_central_axle_or_group_of_springs_and_shock_absorbers_left_1: {
    name: "photo_air_springs_central_axle_or_group_of_springs_and_shock_absorbers_left_1",
    position: 1e3,
    position_admin: 980,
    positionByType: {
      MinibusCityIntercity: 720,
      MinibusTouristic: 890,
      AutobusNormalFloor2Axle: 920,
      AutobusNormalFloor3Axle: 910,
      AutobusLowFloorLowEntry8_12Mt: 740,
      Autobus18Mt: 770,
      DoubleDecker: 1060
    },
    positionAdminByType: {
      MinibusCityIntercity: 740,
      MinibusTouristic: 910,
      AutobusNormalFloor2Axle: 940,
      AutobusNormalFloor3Axle: 930,
      AutobusLowFloorLowEntry8_12Mt: 760,
      Autobus18Mt: 790,
      DoubleDecker: 1080
    },
    label: "Second Axle First Air Springs Left Side",
    group: "undercarriage",
    description: "A photo of the first left air springs or group of springs and shock absorbers on the axle 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_shock_absorbers_central_axle_if_separate_from_springs_left_2: {
    name: "photo_shock_absorbers_central_axle_if_separate_from_springs_left_2",
    position: 1010,
    position_admin: 990,
    positionByType: {
      MinibusCityIntercity: 730,
      MinibusTouristic: 900,
      AutobusNormalFloor2Axle: 930,
      AutobusNormalFloor3Axle: 920,
      AutobusLowFloorLowEntry8_12Mt: 750,
      Autobus18Mt: 780,
      DoubleDecker: 1070
    },
    positionAdminByType: {
      MinibusCityIntercity: 750,
      MinibusTouristic: 920,
      AutobusNormalFloor2Axle: 950,
      AutobusNormalFloor3Axle: 940,
      AutobusLowFloorLowEntry8_12Mt: 770,
      Autobus18Mt: 800,
      DoubleDecker: 1090
    },
    label: "Second Axle Second Shock Absorbers Left Side",
    group: "undercarriage",
    description: "A photo of the second left shock absorbers on the axle 2, if they are separate from the springs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_air_springs_central_axle_or_group_of_springs_and_shock_absorbers_left_2: {
    name: "photo_air_springs_central_axle_or_group_of_springs_and_shock_absorbers_left_2",
    position: 1020,
    position_admin: 1e3,
    positionByType: {
      MinibusCityIntercity: 740,
      MinibusTouristic: 910,
      AutobusNormalFloor2Axle: 940,
      AutobusNormalFloor3Axle: 930,
      AutobusLowFloorLowEntry8_12Mt: 760,
      Autobus18Mt: 790,
      DoubleDecker: 1080
    },
    positionAdminByType: {
      MinibusCityIntercity: 760,
      MinibusTouristic: 930,
      AutobusNormalFloor2Axle: 960,
      AutobusNormalFloor3Axle: 950,
      AutobusLowFloorLowEntry8_12Mt: 780,
      Autobus18Mt: 810,
      DoubleDecker: 1100
    },
    label: "Second Axle Second Air Springs Left Side",
    group: "undercarriage",
    description: "A photo of the second left air springs or group of springs and shock absorbers on the axle 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_undercarriage_axle_rear_central: {
    name: "photo_undercarriage_axle_rear_central",
    position: 1030,
    position_admin: 1010,
    positionByType: {
      MinibusCityIntercity: 600,
      MinibusTouristic: 770,
      AutobusNormalFloor2Axle: 800,
      AutobusNormalFloor3Axle: 790,
      AutobusLowFloorLowEntry8_12Mt: 620,
      Autobus18Mt: 650,
      DoubleDecker: 940
    },
    positionAdminByType: {
      MinibusCityIntercity: 620,
      MinibusTouristic: 790,
      AutobusNormalFloor2Axle: 820,
      AutobusNormalFloor3Axle: 810,
      AutobusLowFloorLowEntry8_12Mt: 640,
      Autobus18Mt: 670,
      DoubleDecker: 960
    },
    label: "Second Axle Central",
    group: "undercarriage",
    description: "A photo of the second axle from the central part of the undercarriage.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_undercarriage_axle_rear_side_right: {
    name: "photo_undercarriage_axle_rear_side_right",
    position: 1040,
    position_admin: 1020,
    positionByType: {
      MinibusCityIntercity: 680,
      MinibusTouristic: 850,
      AutobusNormalFloor2Axle: 810,
      AutobusNormalFloor3Axle: 800,
      AutobusLowFloorLowEntry8_12Mt: 630,
      Autobus18Mt: 660,
      DoubleDecker: 950
    },
    positionAdminByType: {
      MinibusCityIntercity: 700,
      MinibusTouristic: 870,
      AutobusNormalFloor2Axle: 830,
      AutobusNormalFloor3Axle: 820,
      AutobusLowFloorLowEntry8_12Mt: 650,
      Autobus18Mt: 680,
      DoubleDecker: 970
    },
    label: "Second Axle Left Side",
    group: "undercarriage",
    description: "A photo of the second axle from the left side of the undercarriage.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_discs_rear_right: {
    name: "photo_discs_rear_right",
    position: 1050,
    position_admin: 1030,
    positionByType: { AutobusNormalFloor3Axle: 960, Autobus18Mt: 830, DoubleDecker: 1110 },
    positionAdminByType: { AutobusNormalFloor3Axle: 980, Autobus18Mt: 850, DoubleDecker: 1130 },
    label: "Third Axle Discs Right Side",
    group: "undercarriage",
    description: "A photo of the right brake discs axle 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_caliper_brakes_rear_right: {
    name: "photo_caliper_brakes_rear_right",
    position: 1060,
    position_admin: 1040,
    positionByType: { AutobusNormalFloor3Axle: 970, Autobus18Mt: 840, DoubleDecker: 1120 },
    positionAdminByType: { AutobusNormalFloor3Axle: 990, Autobus18Mt: 860, DoubleDecker: 1140 },
    label: "Third Axle Caliper Brakes Right Side",
    group: "undercarriage",
    description: "A photo of the right caliper brakes axle 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_shock_absorbers_right_1: {
    name: "photo_rear_shock_absorbers_right_1",
    position: 1070,
    position_admin: 1050,
    positionByType: { AutobusNormalFloor3Axle: 980, Autobus18Mt: 850, DoubleDecker: 1130 },
    positionAdminByType: { AutobusNormalFloor3Axle: 1e3, Autobus18Mt: 870, DoubleDecker: 1150 },
    label: "Third Axle First Shock Absorbers Right Side",
    group: "undercarriage",
    description: "A photo of the right shock absorbers (position 1) axel 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_air_springs_if_present_right_1: {
    name: "photo_rear_air_springs_if_present_right_1",
    position: 1080,
    position_admin: 1060,
    positionByType: { AutobusNormalFloor3Axle: 990, Autobus18Mt: 860, DoubleDecker: 1140 },
    positionAdminByType: { AutobusNormalFloor3Axle: 1010, Autobus18Mt: 880, DoubleDecker: 1160 },
    label: "Third Axle First Air Springs Right Side",
    group: "undercarriage",
    description: "A photo of the right air springs if present (position 1) axel 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_shock_absorbers_right_2: {
    name: "photo_rear_shock_absorbers_right_2",
    position: 1090,
    position_admin: 1070,
    positionByType: { Autobus18Mt: 870 },
    positionAdminByType: { Autobus18Mt: 890 },
    label: "Third Axle Second Shock Absorbers Right Side",
    group: "undercarriage",
    description: "A photo of the right shock absorbers (position 2) axel 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_air_springs_if_present_right_2: {
    name: "photo_rear_air_springs_if_present_right_2",
    position: 1100,
    position_admin: 1080,
    positionByType: { Autobus18Mt: 880 },
    positionAdminByType: { Autobus18Mt: 900 },
    label: "Third Axle Second Air Springs Right Side",
    group: "undercarriage",
    description: "A photo of the right air springs if present (position 2) axel 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_leaf_spring_if_present_right: {
    name: "photo_rear_leaf_spring_if_present_right",
    position: 1110,
    position_admin: 1090,
    label: "axel 2 leaf spring right",
    group: "undercarriage",
    description: "A photo of the right leaf spring if present axle 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_undercarriage_axle_rear_side_left: {
    name: "photo_undercarriage_axle_rear_side_left",
    position: 1120,
    position_admin: 1100,
    positionByType: {
      AutobusNormalFloor2Axle: 880,
      AutobusNormalFloor3Axle: 950,
      AutobusLowFloorLowEntry8_12Mt: 700,
      Autobus18Mt: 820,
      DoubleDecker: 1100
    },
    positionAdminByType: {
      AutobusNormalFloor2Axle: 900,
      AutobusNormalFloor3Axle: 970,
      AutobusLowFloorLowEntry8_12Mt: 720,
      Autobus18Mt: 840,
      DoubleDecker: 1120
    },
    label: "Third Axle Right Side",
    group: "undercarriage",
    description: "A photo of the third axle from the right side of the undercarriage.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_discs_rear_left: {
    name: "photo_discs_rear_left",
    position: 1130,
    position_admin: 1110,
    positionByType: { AutobusNormalFloor3Axle: 1010, Autobus18Mt: 900, DoubleDecker: 1160 },
    positionAdminByType: { AutobusNormalFloor3Axle: 1030, Autobus18Mt: 920, DoubleDecker: 1180 },
    label: "Third Axle Discs Left Side",
    group: "undercarriage",
    description: "A photo of the left brake discs axle 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_caliper_brakes_rear_left: {
    name: "photo_caliper_brakes_rear_left",
    position: 1140,
    position_admin: 1120,
    positionByType: { AutobusNormalFloor3Axle: 1020, Autobus18Mt: 910, DoubleDecker: 1170 },
    positionAdminByType: { AutobusNormalFloor3Axle: 1040, Autobus18Mt: 930, DoubleDecker: 1190 },
    label: "Third Axle Caliper Brakes Left Side",
    group: "undercarriage",
    description: "A photo of the left caliper brakes axle 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_shock_absorbers_left_1: {
    name: "photo_rear_shock_absorbers_left_1",
    position: 1150,
    position_admin: 1130,
    positionByType: { AutobusNormalFloor3Axle: 1030, Autobus18Mt: 920, DoubleDecker: 1180 },
    positionAdminByType: { AutobusNormalFloor3Axle: 1050, Autobus18Mt: 940, DoubleDecker: 1200 },
    label: "Third Axle First Shock Absorbers Left Side",
    group: "undercarriage",
    description: "A photo of the left shock absorbers (position 1) axel 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_shock_absorbers_left_2: {
    name: "photo_rear_shock_absorbers_left_2",
    position: 1160,
    position_admin: 1140,
    positionByType: { Autobus18Mt: 940 },
    positionAdminByType: { Autobus18Mt: 960 },
    label: "Third Axle Second Shock Absorbers Left Side",
    group: "undercarriage",
    description: "A photo of the left shock absorbers (position 2) axel 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_air_springs_if_present_left_1: {
    name: "photo_rear_air_springs_if_present_left_1",
    position: 1170,
    position_admin: 1150,
    positionByType: { AutobusNormalFloor3Axle: 1040, Autobus18Mt: 930, DoubleDecker: 1190 },
    positionAdminByType: { AutobusNormalFloor3Axle: 1060, Autobus18Mt: 950, DoubleDecker: 1210 },
    label: "Third Axle First Air Springs Left Side",
    group: "undercarriage",
    description: "A photo of the left air springs if present (position 1) axle 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_air_springs_if_present_left_2: {
    name: "photo_rear_air_springs_if_present_left_2",
    position: 1180,
    position_admin: 1160,
    positionByType: { Autobus18Mt: 950 },
    positionAdminByType: { Autobus18Mt: 970 },
    label: "Third Axle Second Air Springs Left Side",
    group: "undercarriage",
    description: "A photo of the left rear air springs if present (position 2).",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_leaf_spring_if_present_left: {
    name: "photo_rear_leaf_spring_if_present_left",
    position: 1190,
    position_admin: 1170,
    label: "axel 3 leaf spring left",
    group: "undercarriage",
    description: "A photo of the left leaf spring if present. Axle 3",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_differential: {
    name: "photo_differential",
    position: 1200,
    position_admin: 1180,
    positionByType: {
      MinibusCityIntercity: 750,
      MinibusTouristic: 920,
      AutobusNormalFloor2Axle: 950,
      AutobusNormalFloor3Axle: 1050,
      AutobusLowFloorLowEntry8_12Mt: 770,
      Autobus18Mt: 960,
      DoubleDecker: 1200
    },
    positionAdminByType: {
      MinibusCityIntercity: 770,
      MinibusTouristic: 940,
      AutobusNormalFloor2Axle: 970,
      AutobusNormalFloor3Axle: 1070,
      AutobusLowFloorLowEntry8_12Mt: 790,
      Autobus18Mt: 980,
      DoubleDecker: 1220
    },
    label: "Differential",
    group: "undercarriage",
    description: "A photo of the vehicle's differential.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_gearbox: {
    name: "photo_gearbox",
    position: 1210,
    position_admin: 1230,
    positionByType: {
      MinibusCityIntercity: 430,
      MinibusTouristic: 600,
      AutobusNormalFloor2Axle: 970,
      AutobusNormalFloor3Axle: 1070,
      AutobusLowFloorLowEntry8_12Mt: 790,
      Autobus18Mt: 980,
      DoubleDecker: 1220
    },
    positionAdminByType: {
      MinibusCityIntercity: 450,
      MinibusTouristic: 620,
      AutobusNormalFloor2Axle: 990,
      AutobusNormalFloor3Axle: 1090,
      AutobusLowFloorLowEntry8_12Mt: 810,
      Autobus18Mt: 1e3,
      DoubleDecker: 1240
    },
    label: "Gearbox",
    group: "undercarriage",
    description: "A photo of the vehicle's gearbox.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_plate_gearbox: {
    name: "photo_plate_gearbox",
    position: 1220,
    position_admin: 1240,
    positionByType: {
      AutobusNormalFloor2Axle: 980,
      AutobusNormalFloor3Axle: 1080,
      AutobusLowFloorLowEntry8_12Mt: 800,
      Autobus18Mt: 990,
      DoubleDecker: 1230
    },
    positionAdminByType: {
      AutobusNormalFloor2Axle: 1e3,
      AutobusNormalFloor3Axle: 1100,
      AutobusLowFloorLowEntry8_12Mt: 820,
      Autobus18Mt: 1010,
      DoubleDecker: 1250
    },
    label: "Gearbox Plate",
    group: "undercarriage",
    description: "A photo of the vehicle's gearbox plate.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_driveshaft: {
    name: "photo_driveshaft",
    position: 1230,
    position_admin: 1250,
    positionByType: {
      MinibusCityIntercity: 460,
      MinibusTouristic: 630,
      AutobusNormalFloor2Axle: 960,
      AutobusNormalFloor3Axle: 1060,
      AutobusLowFloorLowEntry8_12Mt: 780,
      Autobus18Mt: 970,
      DoubleDecker: 1210
    },
    positionAdminByType: {
      MinibusCityIntercity: 480,
      MinibusTouristic: 650,
      AutobusNormalFloor2Axle: 980,
      AutobusNormalFloor3Axle: 1080,
      AutobusLowFloorLowEntry8_12Mt: 800,
      Autobus18Mt: 990,
      DoubleDecker: 1230
    },
    label: "Driveshaft",
    group: "undercarriage",
    description: "A photo of the vehicle's driveshaft.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_engine_below_without_protection: {
    name: "photo_engine_below_without_protection",
    position: 1240,
    position_admin: 1260,
    positionByType: {
      MinibusCityIntercity: 440,
      MinibusTouristic: 610,
      AutobusNormalFloor2Axle: 990,
      AutobusNormalFloor3Axle: 1090,
      AutobusLowFloorLowEntry8_12Mt: 810,
      Autobus18Mt: 1e3,
      DoubleDecker: 1240
    },
    positionAdminByType: {
      MinibusCityIntercity: 460,
      MinibusTouristic: 630,
      AutobusNormalFloor2Axle: 1010,
      AutobusNormalFloor3Axle: 1110,
      AutobusLowFloorLowEntry8_12Mt: 830,
      Autobus18Mt: 1020,
      DoubleDecker: 1260
    },
    label: "Engine Without Protection",
    group: "undercarriage",
    description: "A photo showing the engine from below without any protection.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_exhaust: {
    name: "photo_exhaust",
    position: 1250,
    position_admin: 1270,
    positionByType: {
      MinibusCityIntercity: 470,
      MinibusTouristic: 640,
      AutobusNormalFloor2Axle: 1e3,
      AutobusNormalFloor3Axle: 1100,
      AutobusLowFloorLowEntry8_12Mt: 820,
      Autobus18Mt: 1010,
      DoubleDecker: 1250
    },
    positionAdminByType: {
      MinibusCityIntercity: 490,
      MinibusTouristic: 660,
      AutobusNormalFloor2Axle: 1020,
      AutobusNormalFloor3Axle: 1120,
      AutobusLowFloorLowEntry8_12Mt: 840,
      Autobus18Mt: 1030,
      DoubleDecker: 1270
    },
    label: "Exhaust",
    group: "undercarriage",
    description: "A photo showing the vehicle's exhaust.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_axle_central_18_meters: {
    name: "photo_axle_central_18_meters",
    position: 1260,
    position_admin: 1280,
    label: "central axle (18m)",
    group: "undercarriage",
    description: "A photo of the central axle for 18-meter vehicles.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_bellows_turntable_18_meters: {
    name: "photo_bellows_turntable_18_meters",
    position: 1270,
    position_admin: 1290,
    positionByType: { Autobus18Mt: 800 },
    positionAdminByType: { Autobus18Mt: 820 },
    label: "Undercarriage Turntable",
    group: "undercarriage",
    description: "A photo showing the bellows of the turntable for 18-meter vehicles.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  // Technical Data
  photo_chassis_vin: {
    name: "photo_chassis_vin",
    position: 1280,
    position_admin: 1300,
    positionByType: {
      MinibusCityIntercity: 880,
      MinibusTouristic: 1060,
      AutobusNormalFloor2Axle: 1140,
      AutobusNormalFloor3Axle: 1290,
      AutobusLowFloorLowEntry8_12Mt: 960,
      Autobus18Mt: 1190,
      DoubleDecker: 1440
    },
    positionAdminByType: {
      MinibusCityIntercity: 10,
      MinibusTouristic: 10,
      AutobusNormalFloor2Axle: 10,
      AutobusNormalFloor3Axle: 10,
      AutobusLowFloorLowEntry8_12Mt: 10,
      Autobus18Mt: 10,
      DoubleDecker: 10
    },
    label: "Vin",
    group: "technical-data",
    description: "A photo of the vehicle's chassis VIN.",
    requiredForToBeScrapped: !0,
    performTextInpaint: !1
  },
  photo_any_devices_onboard_3: {
    name: "photo_any_devices_onboard_3",
    position: 1290,
    position_admin: 1310,
    positionByType: { MinibusCityIntercity: 90, MinibusTouristic: 80 },
    positionAdminByType: { MinibusCityIntercity: 110, MinibusTouristic: 100 },
    label: "Front Engine",
    group: "exteriors",
    description: "A photo of the engine at the front of the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_fourth_door_open: {
    name: "photo_fourth_door_open",
    position: 145,
    position_admin: 145,
    positionByType: { Autobus18Mt: 150 },
    positionAdminByType: { Autobus18Mt: 170 },
    label: "Fourth Door Open",
    group: "exteriors",
    description: "A photo of: Fourth Door Open.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_first_axle_left_side_complete_tyre: {
    name: "photo_first_axle_left_side_complete_tyre",
    position: 695,
    position_admin: 695,
    positionByType: {
      MinibusCityIntercity: 770,
      MinibusTouristic: 950,
      AutobusNormalFloor2Axle: 1030,
      AutobusNormalFloor3Axle: 1130,
      AutobusLowFloorLowEntry8_12Mt: 850,
      Autobus18Mt: 1030,
      DoubleDecker: 1280
    },
    positionAdminByType: {
      MinibusCityIntercity: 790,
      MinibusTouristic: 970,
      AutobusNormalFloor2Axle: 1050,
      AutobusNormalFloor3Axle: 1150,
      AutobusLowFloorLowEntry8_12Mt: 870,
      Autobus18Mt: 1050,
      DoubleDecker: 1300
    },
    label: "First Axle Left Side: Complete Tyre",
    group: "tire-sizes",
    description: "A photo of: First Axle Left Side: Complete Tyre.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_first_axle_left_side_tyre_thickness: {
    name: "photo_first_axle_left_side_tyre_thickness",
    position: 705,
    position_admin: 705,
    positionByType: {
      MinibusCityIntercity: 790,
      MinibusTouristic: 970,
      AutobusNormalFloor2Axle: 1050,
      AutobusNormalFloor3Axle: 1150,
      AutobusLowFloorLowEntry8_12Mt: 870,
      Autobus18Mt: 1050,
      DoubleDecker: 1300
    },
    positionAdminByType: {
      MinibusCityIntercity: 810,
      MinibusTouristic: 990,
      AutobusNormalFloor2Axle: 1070,
      AutobusNormalFloor3Axle: 1170,
      AutobusLowFloorLowEntry8_12Mt: 890,
      Autobus18Mt: 1070,
      DoubleDecker: 1320
    },
    label: "First Axle Left Side: Tyre Thickness",
    group: "tire-sizes",
    description: "A photo of: First Axle Left Side: Tyre Thickness.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_second_axle_left_side_tyre_size: {
    name: "photo_second_axle_left_side_tyre_size",
    position: 725,
    position_admin: 725,
    positionByType: {
      MinibusCityIntercity: 820,
      MinibusTouristic: 1e3,
      AutobusNormalFloor2Axle: 1080,
      AutobusNormalFloor3Axle: 1180,
      AutobusLowFloorLowEntry8_12Mt: 900,
      Autobus18Mt: 1080,
      DoubleDecker: 1330
    },
    positionAdminByType: {
      MinibusCityIntercity: 840,
      MinibusTouristic: 1020,
      AutobusNormalFloor2Axle: 1100,
      AutobusNormalFloor3Axle: 1200,
      AutobusLowFloorLowEntry8_12Mt: 920,
      Autobus18Mt: 1100,
      DoubleDecker: 1350
    },
    label: "Second Axle Left Side: Tyre Size",
    group: "tire-sizes",
    description: "A photo of: Second Axle Left Side: Tyre Size.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_second_axle_left_side_tyre_tread: {
    name: "photo_second_axle_left_side_tyre_tread",
    position: 735,
    position_admin: 735,
    positionByType: {
      MinibusCityIntercity: 840,
      MinibusTouristic: 1020,
      AutobusNormalFloor2Axle: 1100,
      AutobusNormalFloor3Axle: 1200,
      AutobusLowFloorLowEntry8_12Mt: 920,
      Autobus18Mt: 1100,
      DoubleDecker: 1350
    },
    positionAdminByType: {
      MinibusCityIntercity: 860,
      MinibusTouristic: 1040,
      AutobusNormalFloor2Axle: 1120,
      AutobusNormalFloor3Axle: 1220,
      AutobusLowFloorLowEntry8_12Mt: 940,
      Autobus18Mt: 1120,
      DoubleDecker: 1370
    },
    label: "Second Axle Left Side: Tyre Tread",
    group: "tire-sizes",
    description: "A photo of: Second Axle Left Side: Tyre Tread.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_third_axle_left_side_tyre_size: {
    name: "photo_third_axle_left_side_tyre_size",
    position: 745,
    position_admin: 745,
    positionByType: { AutobusNormalFloor3Axle: 1220, Autobus18Mt: 1120, DoubleDecker: 1370 },
    positionAdminByType: { AutobusNormalFloor3Axle: 1240, Autobus18Mt: 1140, DoubleDecker: 1390 },
    label: "Third Axle Left Side: Tyre Size",
    group: "tire-sizes",
    description: "A photo of: Third Axle Left Side: Tyre Size.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_third_axle_left_side_tyre_tread: {
    name: "photo_third_axle_left_side_tyre_tread",
    position: 755,
    position_admin: 755,
    positionByType: { AutobusNormalFloor3Axle: 1240, Autobus18Mt: 1140, DoubleDecker: 1390 },
    positionAdminByType: { AutobusNormalFloor3Axle: 1260, Autobus18Mt: 1160, DoubleDecker: 1410 },
    label: "Third Axle Left Side: Tyre Tread",
    group: "tire-sizes",
    description: "A photo of: Third Axle Left Side: Tyre Tread.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_second_axle_right_side_tyre_tread: {
    name: "photo_second_axle_right_side_tyre_tread",
    position: 765,
    position_admin: 765,
    positionByType: {
      MinibusCityIntercity: 850,
      MinibusTouristic: 1030,
      AutobusNormalFloor2Axle: 1110,
      AutobusNormalFloor3Axle: 1260,
      AutobusLowFloorLowEntry8_12Mt: 930,
      Autobus18Mt: 1160,
      DoubleDecker: 1410
    },
    positionAdminByType: {
      MinibusCityIntercity: 870,
      MinibusTouristic: 1050,
      AutobusNormalFloor2Axle: 1130,
      AutobusNormalFloor3Axle: 1280,
      AutobusLowFloorLowEntry8_12Mt: 950,
      Autobus18Mt: 1180,
      DoubleDecker: 1430
    },
    label: "Second Axle Right Side: Tyre Tread",
    group: "tire-sizes",
    description: "A photo of: Second Axle Right Side: Tyre Tread.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_third_axle_left_side: {
    name: "photo_third_axle_left_side",
    position: 1185,
    position_admin: 1185,
    positionByType: { AutobusNormalFloor3Axle: 1e3, Autobus18Mt: 890, DoubleDecker: 1150 },
    positionAdminByType: { AutobusNormalFloor3Axle: 1020, Autobus18Mt: 910, DoubleDecker: 1170 },
    label: "Third Axle Left Side",
    group: "undercarriage",
    description: "A photo of: Third Axle Left Side.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_third_axle_central: {
    name: "photo_third_axle_central",
    position: 1195,
    position_admin: 1195,
    positionByType: { AutobusNormalFloor3Axle: 940, Autobus18Mt: 810, DoubleDecker: 1090 },
    positionAdminByType: { AutobusNormalFloor3Axle: 960, Autobus18Mt: 830, DoubleDecker: 1110 },
    label: "Third Axle Central",
    group: "undercarriage",
    description: "A photo of: Third Axle Central.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_driver_door_open: {
    name: "photo_driver_door_open",
    position: 1300,
    position_admin: 1300,
    positionByType: { MinibusCityIntercity: 180, MinibusTouristic: 180 },
    positionAdminByType: { MinibusCityIntercity: 200, MinibusTouristic: 200 },
    label: "Driver Door Open",
    group: "exteriors",
    description: "A photo of: Driver Door Open.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_doors_open: {
    name: "photo_rear_doors_open",
    position: 1310,
    position_admin: 1310,
    positionByType: { MinibusCityIntercity: 190, MinibusTouristic: 190 },
    positionAdminByType: { MinibusCityIntercity: 210, MinibusTouristic: 210 },
    label: "Rear Doors Open",
    group: "exteriors",
    description: "A photo of: Rear Doors Open.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_electric_parking_brake: {
    name: "photo_electric_parking_brake",
    position: 1320,
    position_admin: 1320,
    positionByType: { MinibusCityIntercity: 450, MinibusTouristic: 620 },
    positionAdminByType: { MinibusCityIntercity: 470, MinibusTouristic: 640 },
    label: "Electric Parking Brake",
    group: "undercarriage",
    description: "A photo of: Electric Parking Brake.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_undercarriage: {
    name: "photo_rear_undercarriage",
    position: 1330,
    position_admin: 1330,
    positionByType: {
      MinibusCityIntercity: 760,
      MinibusTouristic: 930,
      AutobusNormalFloor2Axle: 1010,
      AutobusNormalFloor3Axle: 1110,
      AutobusLowFloorLowEntry8_12Mt: 830,
      Autobus18Mt: 1020,
      DoubleDecker: 1260
    },
    positionAdminByType: {
      MinibusCityIntercity: 780,
      MinibusTouristic: 950,
      AutobusNormalFloor2Axle: 1030,
      AutobusNormalFloor3Axle: 1130,
      AutobusLowFloorLowEntry8_12Mt: 850,
      Autobus18Mt: 1040,
      DoubleDecker: 1280
    },
    label: "Rear Undercarriage",
    group: "undercarriage",
    description: "A photo of: Rear Undercarriage.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_luggage_rear_1: {
    name: "photo_luggage_rear_1",
    position: 1340,
    position_admin: 1340,
    positionByType: { MinibusTouristic: 230 },
    positionAdminByType: { MinibusTouristic: 250 },
    label: "Luggage Rear 1",
    group: "exteriors",
    description: "A photo of: Luggage Rear 1.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_luggage_rear_2: {
    name: "photo_luggage_rear_2",
    position: 1350,
    position_admin: 1350,
    positionByType: { MinibusTouristic: 240 },
    positionAdminByType: { MinibusTouristic: 260 },
    label: "Luggage Rear 2",
    group: "exteriors",
    description: "A photo of: Luggage Rear 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_luggage_rear_3: {
    name: "photo_luggage_rear_3",
    position: 1360,
    position_admin: 1360,
    positionByType: { MinibusTouristic: 250 },
    positionAdminByType: { MinibusTouristic: 270 },
    label: "Luggage Rear 3",
    group: "exteriors",
    description: "A photo of: Luggage Rear 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_luggage_rack_right: {
    name: "photo_luggage_rack_right",
    position: 1370,
    position_admin: 1370,
    positionByType: { MinibusTouristic: 260 },
    positionAdminByType: { MinibusTouristic: 280 },
    label: "Luggage Rack Right",
    group: "exteriors",
    description: "A photo of: Luggage Rack Right.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_refrigerator: {
    name: "photo_refrigerator",
    position: 1380,
    position_admin: 1380,
    positionByType: { MinibusTouristic: 380, AutobusNormalFloor2Axle: 420, AutobusNormalFloor3Axle: 410, DoubleDecker: 410 },
    positionAdminByType: { MinibusTouristic: 400, AutobusNormalFloor2Axle: 440, AutobusNormalFloor3Axle: 430, DoubleDecker: 430 },
    label: "Refrigerator",
    group: "interiors",
    description: "A photo of: Refrigerator.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_fire_suppression_nozzles: {
    name: "photo_fire_suppression_nozzles",
    position: 1390,
    position_admin: 1390,
    positionByType: {
      AutobusNormalFloor2Axle: 150,
      AutobusNormalFloor3Axle: 150,
      AutobusLowFloorLowEntry8_12Mt: 160,
      Autobus18Mt: 180,
      DoubleDecker: 150
    },
    positionAdminByType: {
      AutobusNormalFloor2Axle: 170,
      AutobusNormalFloor3Axle: 170,
      AutobusLowFloorLowEntry8_12Mt: 180,
      Autobus18Mt: 200,
      DoubleDecker: 170
    },
    label: "Fire Suppression Nozzles",
    group: "exteriors",
    description: "A photo of: Fire Suppression Nozzles.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_driver_s_bunk: {
    name: "photo_driver_s_bunk",
    position: 1400,
    position_admin: 1400,
    positionByType: { AutobusNormalFloor2Axle: 250, AutobusNormalFloor3Axle: 250, DoubleDecker: 250 },
    positionAdminByType: { AutobusNormalFloor2Axle: 270, AutobusNormalFloor3Axle: 270, DoubleDecker: 270 },
    label: "Driver's Bunk",
    group: "exteriors",
    description: "A photo of: Driver's Bunk.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_onboard_device_3_left_side: {
    name: "photo_onboard_device_3_left_side",
    position: 1410,
    position_admin: 1410,
    positionByType: {
      AutobusNormalFloor2Axle: 370,
      AutobusNormalFloor3Axle: 360,
      AutobusLowFloorLowEntry8_12Mt: 310,
      Autobus18Mt: 330,
      DoubleDecker: 360
    },
    positionAdminByType: {
      AutobusNormalFloor2Axle: 390,
      AutobusNormalFloor3Axle: 380,
      AutobusLowFloorLowEntry8_12Mt: 330,
      Autobus18Mt: 350,
      DoubleDecker: 380
    },
    label: "Onboard Device 3 Left Side",
    group: "interiors",
    description: "A photo of: Onboard Device 3 Left Side.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_monitor_2: {
    name: "photo_monitor_2",
    position: 1420,
    position_admin: 1420,
    positionByType: { DoubleDecker: 590 },
    positionAdminByType: { DoubleDecker: 610 },
    label: "Monitor 2",
    group: "interiors",
    description: "A photo of: Monitor 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_monitor_3: {
    name: "photo_monitor_3",
    position: 1430,
    position_admin: 1430,
    positionByType: { DoubleDecker: 600 },
    positionAdminByType: { DoubleDecker: 620 },
    label: "Monitor 3",
    group: "interiors",
    description: "A photo of: Monitor 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_monitor_4: {
    name: "photo_monitor_4",
    position: 1440,
    position_admin: 1440,
    positionByType: { DoubleDecker: 610 },
    positionAdminByType: { DoubleDecker: 630 },
    label: "Monitor 4",
    group: "interiors",
    description: "A photo of: Monitor 4.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_second_refrigerator: {
    name: "photo_second_refrigerator",
    position: 1450,
    position_admin: 1450,
    positionByType: { DoubleDecker: 640 },
    positionAdminByType: { DoubleDecker: 660 },
    label: "Second Refrigerator",
    group: "interiors",
    description: "A photo of: Second Refrigerator.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_kitchen: {
    name: "photo_kitchen",
    position: 1460,
    position_admin: 1460,
    positionByType: { DoubleDecker: 650 },
    positionAdminByType: { DoubleDecker: 670 },
    label: "Kitchen",
    group: "interiors",
    description: "A photo of: Kitchen.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_ladder_1: {
    name: "photo_ladder_1",
    position: 1470,
    position_admin: 1470,
    positionByType: { DoubleDecker: 680 },
    positionAdminByType: { DoubleDecker: 700 },
    label: "Ladder 1",
    group: "interiors",
    description: "A photo of: Ladder 1.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_ladder_2: {
    name: "photo_ladder_2",
    position: 1480,
    position_admin: 1480,
    positionByType: { DoubleDecker: 690 },
    positionAdminByType: { DoubleDecker: 710 },
    label: "Ladder 2",
    group: "interiors",
    description: "A photo of: Ladder 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_second_floor_reverse_seats_from_windscreen_position: {
    name: "photo_second_floor_reverse_seats_from_windscreen_position",
    position: 1490,
    position_admin: 1490,
    positionByType: { DoubleDecker: 700 },
    positionAdminByType: { DoubleDecker: 720 },
    label: "Second Floor: Reverse Seats From Windscreen Position",
    group: "interiors",
    description: "A photo of: Second Floor: Reverse Seats From Windscreen Position.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_second_floor_reverse_seats_from_middle_position: {
    name: "photo_second_floor_reverse_seats_from_middle_position",
    position: 1500,
    position_admin: 1500,
    positionByType: { DoubleDecker: 710 },
    positionAdminByType: { DoubleDecker: 730 },
    label: "Second Floor: Reverse Seats From Middle Position",
    group: "interiors",
    description: "A photo of: Second Floor: Reverse Seats From Middle Position.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_second_floor_forward_seats_from_end_position: {
    name: "photo_second_floor_forward_seats_from_end_position",
    position: 1510,
    position_admin: 1510,
    positionByType: { DoubleDecker: 720 },
    positionAdminByType: { DoubleDecker: 740 },
    label: "Second Floor: Forward Seats From End Position",
    group: "interiors",
    description: "A photo of: Second Floor: Forward Seats From End Position.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_second_floor_overhead_compartments: {
    name: "photo_second_floor_overhead_compartments",
    position: 1520,
    position_admin: 1520,
    positionByType: { DoubleDecker: 730 },
    positionAdminByType: { DoubleDecker: 750 },
    label: "Second Floor: Overhead Compartments",
    group: "interiors",
    description: "A photo of: Second Floor: Overhead compartments.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_second_floor_monitor_1: {
    name: "photo_second_floor_monitor_1",
    position: 1530,
    position_admin: 1530,
    positionByType: { DoubleDecker: 770 },
    positionAdminByType: { DoubleDecker: 790 },
    label: "Second Floor: Monitor 1",
    group: "interiors",
    description: "A photo of: Second Floor: Monitor 1.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_second_floor_monitor_2: {
    name: "photo_second_floor_monitor_2",
    position: 1540,
    position_admin: 1540,
    positionByType: { DoubleDecker: 780 },
    positionAdminByType: { DoubleDecker: 800 },
    label: "Second Floor: Monitor 2",
    group: "interiors",
    description: "A photo of: Second Floor: Monitor 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  }
}, rT = {
  photo_cover_base: {
    name: "photo_cover_base",
    position: 2e3,
    position_admin: 2e3,
    label: "Base cover photo",
    group: "cover",
    description: "The photo displayed in the listing page (default: photo_3_4_front_side_right_doors_closed)",
    performTextInpaint: !0
  },
  photo_cover_hover: {
    name: "photo_cover_hover",
    position: 2010,
    position_admin: 2010,
    label: "Hover cover photo",
    group: "cover",
    description: "The photo usually on mouse hover in the listing page, (default: photo_front)",
    performTextInpaint: !0
  }
}, my = {
  video_internal_second_floor_reverse_seats_full: {
    name: "video_internal_second_floor_reverse_seats_full",
    label: "Video: Internal-Second Floor: Reverse Seats From Windscreen Position to the End Of The Vehicle",
    group: "interiors",
    isInternal: !1,
    positionByType: { DoubleDecker: 790 },
    positionAdminByType: { DoubleDecker: 810 }
  },
  video_internal_second_floor_second: {
    name: "video_internal_second_floor_second",
    label: "Video: Internal-Second Floor-Second Video",
    group: "interiors",
    isInternal: !1,
    positionByType: { DoubleDecker: 800 },
    positionAdminByType: { DoubleDecker: 820 }
  },
  video_engine_working: {
    name: "video_engine_working",
    label: "Video: Engine Working",
    group: "exteriors",
    isInternal: !1,
    positionByType: {
      MinibusCityIntercity: 100,
      MinibusTouristic: 90,
      AutobusNormalFloor2Axle: 160,
      AutobusNormalFloor3Axle: 160,
      AutobusLowFloorLowEntry8_12Mt: 170,
      Autobus18Mt: 190,
      DoubleDecker: 160
    },
    positionAdminByType: {
      MinibusCityIntercity: 120,
      MinibusTouristic: 110,
      AutobusNormalFloor2Axle: 180,
      AutobusNormalFloor3Axle: 180,
      AutobusLowFloorLowEntry8_12Mt: 190,
      Autobus18Mt: 210,
      DoubleDecker: 180
    }
  },
  video_wheelchair_ramp_working: {
    name: "video_wheelchair_ramp_working",
    label: "Video: Automatic Wheelchair Ramp Working",
    group: "exteriors",
    isInternal: !1,
    positionByType: {
      MinibusCityIntercity: 150,
      MinibusTouristic: 150,
      AutobusNormalFloor2Axle: 190,
      AutobusNormalFloor3Axle: 190,
      AutobusLowFloorLowEntry8_12Mt: 200,
      Autobus18Mt: 220,
      DoubleDecker: 190
    },
    positionAdminByType: {
      MinibusCityIntercity: 170,
      MinibusTouristic: 170,
      AutobusNormalFloor2Axle: 210,
      AutobusNormalFloor3Axle: 210,
      AutobusLowFloorLowEntry8_12Mt: 220,
      Autobus18Mt: 240,
      DoubleDecker: 210
    }
  },
  video_internal_driver_to_end: {
    name: "video_internal_driver_to_end",
    label: "Video: Internal-From Driver Position To The End Of The Vehicle",
    group: "interiors",
    isInternal: !1,
    positionByType: {
      MinibusCityIntercity: 410,
      MinibusTouristic: 580,
      AutobusNormalFloor2Axle: 650,
      AutobusNormalFloor3Axle: 640,
      AutobusLowFloorLowEntry8_12Mt: 470,
      Autobus18Mt: 500,
      DoubleDecker: 660
    },
    positionAdminByType: {
      MinibusCityIntercity: 430,
      MinibusTouristic: 600,
      AutobusNormalFloor2Axle: 670,
      AutobusNormalFloor3Axle: 660,
      AutobusLowFloorLowEntry8_12Mt: 490,
      Autobus18Mt: 520,
      DoubleDecker: 680
    }
  },
  video_internal_second: {
    name: "video_internal_second",
    label: "Video: Internal-Second Video",
    group: "interiors",
    isInternal: !1,
    positionByType: {
      AutobusNormalFloor2Axle: 660,
      AutobusNormalFloor3Axle: 650,
      AutobusLowFloorLowEntry8_12Mt: 480,
      Autobus18Mt: 510,
      DoubleDecker: 670
    },
    positionAdminByType: {
      AutobusNormalFloor2Axle: 680,
      AutobusNormalFloor3Axle: 670,
      AutobusLowFloorLowEntry8_12Mt: 500,
      Autobus18Mt: 530,
      DoubleDecker: 690
    }
  },
  video_warranty: {
    name: "video_warranty",
    label: "Video: Fleequid Internal Use Video",
    group: "exteriors",
    isInternal: !0,
    positionAdminByType: {
      MinibusCityIntercity: 890,
      MinibusTouristic: 14500,
      AutobusNormalFloor2Axle: 14500,
      AutobusNormalFloor3Axle: 14500,
      AutobusLowFloorLowEntry8_12Mt: 14500,
      Autobus18Mt: 14500,
      DoubleDecker: 14500
    }
  }
}, _y = [
  {
    name: "Baden-Württemberg",
    code: "DE-BW",
    provinces: [{ name: "Baden-Württemberg", code: "BW" }]
  },
  {
    name: "Bayern",
    code: "DE-BY",
    provinces: [{ name: "Bayern", code: "BY" }]
  },
  {
    name: "Berlin",
    code: "DE-BE",
    provinces: [{ name: "Berlin", code: "BE" }]
  },
  {
    name: "Brandenburg",
    code: "DE-BB",
    provinces: [{ name: "Brandenburg", code: "BB" }]
  },
  {
    name: "Bremen",
    code: "DE-HB",
    provinces: [{ name: "Bremen", code: "HB" }]
  },
  {
    name: "Hamburg",
    code: "DE-HH",
    provinces: [{ name: "Hamburg", code: "HH" }]
  },
  {
    name: "Hessen",
    code: "DE-HE",
    provinces: [{ name: "Hessen", code: "HE" }]
  },
  {
    name: "Mecklenburg-Vorpommern",
    code: "DE-MV",
    provinces: [{ name: "Mecklenburg-Vorpommern", code: "MV" }]
  },
  {
    name: "Niedersachsen",
    code: "DE-NI",
    provinces: [{ name: "Niedersachsen", code: "NI" }]
  },
  {
    name: "Nordrhein-Westfalen",
    code: "DE-NW",
    provinces: [{ name: "Nordrhein-Westfalen", code: "NW" }]
  },
  {
    name: "Rheinland-Pfalz",
    code: "DE-RP",
    provinces: [{ name: "Rheinland-Pfalz", code: "RP" }]
  },
  {
    name: "Saarland",
    code: "DE-SL",
    provinces: [{ name: "Saarland", code: "SL" }]
  },
  {
    name: "Sachsen",
    code: "DE-SN",
    provinces: [{ name: "Sachsen", code: "SN" }]
  },
  {
    name: "Sachsen-Anhalt",
    code: "DE-ST",
    provinces: [{ name: "Sachsen-Anhalt", code: "ST" }]
  },
  {
    name: "Schleswig-Holstein",
    code: "DE-SH",
    provinces: [{ name: "Schleswig-Holstein", code: "SH" }]
  },
  {
    name: "Thüringen",
    code: "DE-TH",
    provinces: [{ name: "Thüringen", code: "TH" }]
  }
], by = [
  {
    name: "Abruzzo",
    code: "IT-65",
    regionMacro: "center",
    provinces: [
      { name: "L'Aquila", code: "AQ" },
      { name: "Chieti", code: "CH" },
      { name: "Pescara", code: "PE" },
      { name: "Teramo", code: "TE" }
    ]
  },
  {
    name: "Basilicata",
    code: "IT-77",
    regionMacro: "south",
    provinces: [
      { name: "Matera", code: "MT" },
      { name: "Potenza", code: "PZ" }
    ]
  },
  {
    name: "Calabria",
    code: "IT-78",
    regionMacro: "south",
    provinces: [
      { name: "Cosenza", code: "CS" },
      { name: "Catanzaro", code: "CZ" },
      { name: "Crotone", code: "KR" },
      { name: "Reggio Calabria", code: "RC" },
      { name: "Vibo Valentia", code: "VV" }
    ]
  },
  {
    name: "Campania",
    code: "IT-72",
    regionMacro: "south",
    provinces: [
      { name: "Avellino", code: "AV" },
      { name: "Benevento", code: "BN" },
      { name: "Caserta", code: "CE" },
      { name: "Napoli", code: "NA" },
      { name: "Salerno", code: "SA" }
    ]
  },
  {
    name: "Emilia-Romagna",
    code: "IT-45",
    regionMacro: "north",
    provinces: [
      { name: "Bologna", code: "BO" },
      { name: "Forlì-Cesena", code: "FC" },
      { name: "Ferrara", code: "FE" },
      { name: "Modena", code: "MO" },
      { name: "Piacenza", code: "PC" },
      { name: "Parma", code: "PR" },
      { name: "Ravenna", code: "RA" },
      { name: "Reggio Emilia", code: "RE" },
      { name: "Rimini", code: "RN" }
    ]
  },
  {
    name: "Friuli-Venezia Giulia",
    code: "IT-36",
    regionMacro: "north",
    provinces: [
      { name: "Gorizia", code: "GO" },
      { name: "Pordenone", code: "PN" },
      { name: "Trieste", code: "TS" },
      { name: "Udine", code: "UD" }
    ]
  },
  {
    name: "Lazio",
    code: "IT-62",
    regionMacro: "center",
    provinces: [
      { name: "Frosinone", code: "FR" },
      { name: "Latina", code: "LT" },
      { name: "Rieti", code: "RI" },
      { name: "Roma", code: "RM" },
      { name: "Viterbo", code: "VT" }
    ]
  },
  {
    name: "Liguria",
    code: "IT-42",
    regionMacro: "north",
    provinces: [
      { name: "Genova", code: "GE" },
      { name: "Imperia", code: "IM" },
      { name: "La Spezia", code: "SP" },
      { name: "Savona", code: "SV" }
    ]
  },
  {
    name: "Lombardia",
    code: "IT-25",
    regionMacro: "north",
    provinces: [
      { name: "Bergamo", code: "BG" },
      { name: "Brescia", code: "BS" },
      { name: "Como", code: "CO" },
      { name: "Cremona", code: "CR" },
      { name: "Lecco", code: "LC" },
      { name: "Lodi", code: "LO" },
      { name: "Monza e della Brianza", code: "MB" },
      { name: "Milano", code: "MI" },
      { name: "Mantova", code: "MN" },
      { name: "Pavia", code: "PV" },
      { name: "Sondrio", code: "SO" },
      { name: "Varese", code: "VA" }
    ]
  },
  {
    name: "Marche",
    code: "IT-57",
    regionMacro: "center",
    provinces: [
      { name: "Ancona", code: "AN" },
      { name: "Ascoli Piceno", code: "AP" },
      { name: "Fermo", code: "FM" },
      { name: "Macerata", code: "MC" },
      { name: "Pesaro e Urbino", code: "PU" }
    ]
  },
  {
    name: "Molise",
    code: "IT-67",
    regionMacro: "south",
    provinces: [
      { name: "Campobasso", code: "CB" },
      { name: "Isernia", code: "IS" }
    ]
  },
  {
    name: "Piemonte",
    code: "IT-21",
    regionMacro: "north",
    provinces: [
      { name: "Alessandria", code: "AL" },
      { name: "Asti", code: "AT" },
      { name: "Biella", code: "BI" },
      { name: "Cuneo", code: "CN" },
      { name: "Novara", code: "NO" },
      { name: "Torino", code: "TO" },
      { name: "Verbano-Cusio-Ossola", code: "VB" },
      { name: "Vercelli", code: "VC" }
    ]
  },
  {
    name: "Puglia",
    code: "IT-75",
    regionMacro: "south",
    provinces: [
      { name: "Bari", code: "BA" },
      { name: "Brindisi", code: "BR" },
      { name: "Barletta-Andria-Trani", code: "BT" },
      { name: "Foggia", code: "FG" },
      { name: "Lecce", code: "LE" },
      { name: "Taranto", code: "TA" }
    ]
  },
  {
    name: "Sardegna",
    code: "IT-88",
    regionMacro: "excluded",
    provinces: [
      { name: "Cagliari", code: "CA" },
      { name: "Nuoro", code: "NU" },
      { name: "Oristano", code: "OR" },
      { name: "Sassari", code: "SS" },
      { name: "Carbonia-Iglesias", code: "CI" },
      { name: "Olbia-Tempio", code: "OT" },
      { name: "Medio Campidano", code: "VS" },
      { name: "Ogliastra", code: "OG" }
    ]
  },
  {
    name: "Sicilia",
    code: "IT-82",
    regionMacro: "excluded",
    provinces: [
      { name: "Agrigento", code: "AG" },
      { name: "Caltanissetta", code: "CL" },
      { name: "Catania", code: "CT" },
      { name: "Enna", code: "EN" },
      { name: "Messina", code: "ME" },
      { name: "Palermo", code: "PA" },
      { name: "Ragusa", code: "RG" },
      { name: "Siracusa", code: "SR" },
      { name: "Trapani", code: "TP" }
    ]
  },
  {
    name: "Toscana",
    code: "IT-52",
    regionMacro: "center",
    provinces: [
      { name: "Arezzo", code: "AR" },
      { name: "Firenze", code: "FI" },
      { name: "Grosseto", code: "GR" },
      { name: "Livorno", code: "LI" },
      { name: "Lucca", code: "LU" },
      { name: "Massa-Carrara", code: "MS" },
      { name: "Pisa", code: "PI" },
      { name: "Prato", code: "PO" },
      { name: "Pistoia", code: "PT" },
      { name: "Siena", code: "SI" }
    ]
  },
  {
    name: "Trentino-Alto Adige, Trentino-Südtirol",
    code: "IT-32",
    regionMacro: "north",
    provinces: [
      { name: "Bolzano", code: "BZ" },
      { name: "Trento", code: "TN" }
    ]
  },
  {
    name: "Umbria",
    code: "IT-55",
    regionMacro: "center",
    provinces: [
      { name: "Perugia", code: "PG" },
      { name: "Terni", code: "TR" }
    ]
  },
  { name: "Valle d'Aosta, Vallée d'Aoste", code: "IT-23", regionMacro: "north", provinces: [{ name: "Aosta", code: "AO" }] },
  {
    name: "Veneto",
    code: "IT-34",
    regionMacro: "north",
    provinces: [
      { name: "Belluno", code: "BL" },
      { name: "Padova", code: "PD" },
      { name: "Rovigo", code: "RO" },
      { name: "Treviso", code: "TV" },
      { name: "Venezia", code: "VE" },
      { name: "Vicenza", code: "VI" },
      { name: "Verona", code: "VR" }
    ]
  }
], Ay = [
  {
    name: "Dolnośląskie",
    code: "PL-02",
    provinces: [{ name: "Dolnośląskie", code: "DS" }]
  },
  {
    name: "Kujawsko-Pomorskie",
    code: "PL-04",
    provinces: [{ name: "Kujawsko-Pomorskie", code: "KP" }]
  },
  {
    name: "Lubelskie",
    code: "PL-06",
    provinces: [{ name: "Lubelskie", code: "LU" }]
  },
  {
    name: "Lubuskie",
    code: "PL-08",
    provinces: [{ name: "Lubuskie", code: "LB" }]
  },
  {
    name: "Łódzkie",
    code: "PL-10",
    provinces: [{ name: "Łódzkie", code: "LD" }]
  },
  {
    name: "Małopolskie",
    code: "PL-12",
    provinces: [{ name: "Małopolskie", code: "MP" }]
  },
  {
    name: "Mazowieckie",
    code: "PL-14",
    provinces: [{ name: "Mazowieckie", code: "MZ" }]
  },
  {
    name: "Opolskie",
    code: "PL-16",
    provinces: [{ name: "Opolskie", code: "OP" }]
  },
  {
    name: "Podkarpackie",
    code: "PL-18",
    provinces: [{ name: "Podkarpackie", code: "PK" }]
  },
  {
    name: "Podlaskie",
    code: "PL-20",
    provinces: [{ name: "Podlaskie", code: "PD" }]
  },
  {
    name: "Pomorskie",
    code: "PL-22",
    provinces: [{ name: "Pomorskie", code: "PM" }]
  },
  {
    name: "Śląskie",
    code: "PL-24",
    provinces: [{ name: "Śląskie", code: "SL" }]
  },
  {
    name: "Świętokrzyskie",
    code: "PL-26",
    provinces: [{ name: "Świętokrzyskie", code: "SK" }]
  },
  {
    name: "Warmińsko-Mazurskie",
    code: "PL-28",
    provinces: [{ name: "Warmińsko-Mazurskie", code: "WM" }]
  },
  {
    name: "Wielkopolskie",
    code: "PL-30",
    provinces: [{ name: "Wielkopolskie", code: "WP" }]
  },
  {
    name: "Zachodniopomorskie",
    code: "PL-32",
    provinces: [{ name: "Zachodniopomorskie", code: "ZP" }]
  }
], gy = [
  {
    name: "Andalucía",
    code: "ES-AN",
    provinces: [
      { name: "Almería", code: "AL" },
      { name: "Cádiz", code: "CA" },
      { name: "Córdoba", code: "CO" },
      { name: "Granada", code: "GR" },
      { name: "Huelva", code: "H" },
      { name: "Jaén", code: "J" },
      { name: "Málaga", code: "MA" },
      { name: "Sevilla", code: "SE" }
    ]
  },
  {
    name: "Aragón",
    code: "ES-AR",
    provinces: [
      { name: "Huesca", code: "HU" },
      { name: "Teruel", code: "TE" },
      { name: "Zaragoza", code: "Z" }
    ]
  },
  {
    name: "Asturias",
    code: "ES-AS",
    provinces: [{ name: "Asturias", code: "AS" }]
  },
  {
    name: "Islas Baleares",
    code: "ES-IB",
    provinces: [{ name: "Islas Baleares", code: "IB" }]
  },
  {
    name: "País Vasco",
    code: "ES-PV",
    provinces: [
      { name: "Álava", code: "VI" },
      { name: "Bizkaia", code: "BI" },
      { name: "Gipuzkoa", code: "SS" }
    ]
  },
  {
    name: "Canarias",
    code: "ES-CN",
    provinces: [
      { name: "Las Palmas", code: "GC" },
      { name: "Santa Cruz de Tenerife", code: "TF" }
    ]
  },
  {
    name: "Cantabria",
    code: "ES-CB",
    provinces: [{ name: "Cantabria", code: "CB" }]
  },
  {
    name: "Castilla y León",
    code: "ES-CL",
    provinces: [
      { name: "Ávila", code: "AV" },
      { name: "Burgos", code: "BU" },
      { name: "León", code: "LE" },
      { name: "Palencia", code: "P" },
      { name: "Salamanca", code: "SA" },
      { name: "Segovia", code: "SG" },
      { name: "Soria", code: "SO" },
      { name: "Valladolid", code: "VA" },
      { name: "Zamora", code: "ZA" }
    ]
  },
  {
    name: "Castilla-La Mancha",
    code: "ES-CM",
    provinces: [
      { name: "Albacete", code: "AB" },
      { name: "Ciudad Real", code: "CR" },
      { name: "Cuenca", code: "CU" },
      { name: "Guadalajara", code: "GU" },
      { name: "Toledo", code: "TO" }
    ]
  },
  {
    name: "Cataluña",
    code: "ES-CT",
    provinces: [
      { name: "Barcelona", code: "B" },
      { name: "Girona", code: "GI" },
      { name: "Lleida", code: "L" },
      { name: "Tarragona", code: "T" }
    ]
  },
  {
    name: "Extremadura",
    code: "ES-EX",
    provinces: [
      { name: "Badajoz", code: "BA" },
      { name: "Cáceres", code: "CC" }
    ]
  },
  {
    name: "Galicia",
    code: "ES-GA",
    provinces: [
      { name: "A Coruña", code: "C" },
      { name: "Lugo", code: "LU" },
      { name: "Ourense", code: "OR" },
      { name: "Pontevedra", code: "PO" }
    ]
  },
  {
    name: "La Rioja",
    code: "ES-RI",
    provinces: [{ name: "La Rioja", code: "RI" }]
  },
  {
    name: "Comunidad de Madrid",
    code: "ES-MD",
    provinces: [{ name: "Madrid", code: "MD" }]
  },
  {
    name: "Región de Murcia",
    code: "ES-MC",
    provinces: [{ name: "Murcia", code: "MC" }]
  },
  {
    name: "Navarra",
    code: "ES-NC",
    provinces: [{ name: "Navarra", code: "NC" }]
  },
  {
    name: "Comunidad Valenciana",
    code: "ES-VC",
    provinces: [
      { name: "Alicante", code: "A" },
      { name: "Castellón", code: "CS" },
      { name: "Valencia", code: "V" }
    ]
  },
  {
    name: "Ceuta",
    code: "ES-CE",
    provinces: [{ name: "Ceuta", code: "CE" }]
  },
  {
    name: "Melilla",
    code: "ES-ML",
    provinces: [{ name: "Melilla", code: "ML" }]
  }
], Zi = {
  AD: {
    i18nNames: {
      en: "Andorra",
      it: "Andorra",
      es: "Andorra",
      de: "Andorra",
      pl: "Andora",
      fr: "Andorre",
      nl: "Andorra",
      pt: "Andorra",
      cs: "Andorra",
      ro: "Andorra",
      ru: "Андорра"
    },
    rootIddCode: "+376",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^[A-Z]-\\d{6}-[A-Z]$",
    taxIdExample: "X-123456-Y"
  },
  AE: {
    i18nNames: {
      en: "United Arab Emirates",
      es: "Emiratos Árabes Unidos",
      it: "Emirati Arabi Uniti",
      de: "Vereinigte Arabische Emirate",
      pl: "Zjednoczone Emiraty Arabskie",
      fr: "Émirats arabes unis",
      nl: "Verenigde Arabische Emiraten",
      pt: "Emirados Árabes Unidos",
      cs: "Spojené arabské emiráty",
      ro: "Emiratele Arabe Unite",
      ru: "Объединённые Арабские Эмираты"
    },
    rootIddCode: "+971",
    continent: "Asia",
    taxIdMandatory: !1,
    taxIdPattern: "^\\d{15}$",
    taxIdExample: "123456789012345"
  },
  AF: {
    i18nNames: {
      en: "Afghanistan",
      it: "Afghanistan",
      es: "Afganistán",
      de: "Afghanistan",
      pl: "Afganistan",
      fr: "Afghanistan",
      nl: "Afghanistan",
      pt: "Afeganistão",
      cs: "Afghánistán",
      ro: "Afganistan",
      ru: "Афганистан"
    },
    rootIddCode: "+93",
    continent: "Asia"
  },
  AG: {
    i18nNames: {
      en: "Antigua and Barbuda",
      es: "Antigua y Barbuda",
      it: "Antigua e Barbuda",
      de: "Antigua und Barbuda",
      pl: "Antigua i Barbuda",
      fr: "Antigua-et-Barbuda",
      nl: "Antigua en Barbuda",
      pt: "Antígua e Barbuda",
      cs: "Antigua a Barbuda",
      ro: "Antigua și Barbuda",
      ru: "Антигуа и Барбуда"
    },
    rootIddCode: "+1268",
    continent: "NorthAmerica"
  },
  AI: {
    i18nNames: {
      en: "Anguilla",
      it: "Anguilla",
      es: "Anguila",
      de: "Anguilla",
      pl: "Anguilla",
      fr: "Anguilla",
      nl: "Anguilla",
      pt: "Anguila",
      cs: "Anguilla",
      ro: "Anguilla",
      ru: "Ангилья"
    },
    rootIddCode: "+1264",
    continent: "NorthAmerica"
  },
  AL: {
    i18nNames: {
      en: "Albania",
      it: "Albania",
      es: "Albania",
      de: "Albanien",
      pl: "Albania",
      fr: "Albanie",
      nl: "Albanië",
      pt: "Albânia",
      cs: "Albánie",
      ro: "Albania",
      ru: "Албания"
    },
    rootIddCode: "+355",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^[JKLM]\\d{8}[A-Z]$",
    taxIdExample: "J12345678K"
  },
  AM: {
    i18nNames: {
      en: "Armenia",
      it: "Armenia",
      es: "Armenia",
      de: "Armenien",
      pl: "Armenia",
      fr: "Arménie",
      nl: "Armenië",
      pt: "Arménia",
      cs: "Arménie",
      ro: "Armenia",
      ru: "Армения"
    },
    rootIddCode: "+374",
    continent: "Asia"
  },
  AO: {
    i18nNames: {
      en: "Angola",
      it: "Angola",
      es: "Angola",
      de: "Angola",
      pl: "Angola",
      fr: "Angola",
      nl: "Angola",
      pt: "Angola",
      cs: "Angola",
      ro: "Angola",
      ru: "Ангола"
    },
    rootIddCode: "+244",
    continent: "Africa"
  },
  AQ: {
    i18nNames: {
      en: "Antarctica",
      it: "Antartide",
      es: "Antártida",
      de: "Antarktis",
      pl: "Antarktyka",
      fr: "Antarctique",
      nl: "Antarctica",
      pt: "Antártica",
      cs: "Antarktida",
      ro: "Antarctica",
      ru: "Антарктида"
    },
    rootIddCode: "undefined",
    continent: "Antarctica"
  },
  AR: {
    i18nNames: {
      en: "Argentina",
      it: "Argentina",
      es: "Argentina",
      de: "Argentinien",
      pl: "Argentyna",
      fr: "Argentine",
      nl: "Argentinië",
      pt: "Argentina",
      cs: "Argentina",
      ro: "Argentina",
      ru: "Аргентина"
    },
    rootIddCode: "+54",
    continent: "SouthAmerica"
  },
  AS: {
    i18nNames: {
      en: "American Samoa",
      it: "Samoa Americane",
      es: "Samoa Americana",
      de: "Amerikanisch-Samoa",
      pl: "Samoa Amerykańskie",
      fr: "Samoa américaines",
      nl: "Amerikaans-Samoa",
      pt: "Samoa Americana",
      cs: "Americká Samoa",
      ro: "Samoa Americană",
      ru: "Американское Самоа"
    },
    rootIddCode: "+1684",
    continent: "Oceania"
  },
  AT: {
    i18nNames: {
      en: "Austria",
      it: "Austria",
      es: "Austria",
      de: "Österreich",
      pl: "Austria",
      fr: "Autriche",
      nl: "Oostenrijk",
      pt: "Áustria",
      cs: "Rakousko",
      ro: "Austria",
      ru: "Австрия"
    },
    rootIddCode: "+43",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !1,
    taxIdPattern: "^ATU\\d{8}$",
    taxIdExample: "ATU12345678"
  },
  AU: {
    i18nNames: {
      en: "Australia",
      it: "Australia",
      es: "Australia",
      de: "Australien",
      pl: "Australia",
      fr: "Australie",
      nl: "Australië",
      pt: "Austrália",
      cs: "Austrálie",
      ro: "Australia",
      ru: "Австралия"
    },
    rootIddCode: "+61",
    continent: "Oceania"
  },
  AW: {
    i18nNames: {
      en: "Aruba",
      it: "Aruba",
      es: "Aruba",
      de: "Aruba",
      pl: "Aruba",
      fr: "Aruba",
      nl: "Aruba",
      pt: "Aruba",
      cs: "Aruba",
      ro: "Aruba",
      ru: "Аруба"
    },
    rootIddCode: "+297",
    continent: "NorthAmerica"
  },
  AX: {
    i18nNames: {
      en: "Åland Islands",
      it: "Isole Aland",
      es: "Islas Åland",
      de: "Ålandinseln",
      pl: "Wyspy Alandzkie",
      fr: "Îles Åland",
      nl: "Ålandeilanden",
      pt: "Ilhas Åland",
      cs: "Ålandské ostrovy",
      ro: "Insulele Åland",
      ru: "Аландские острова"
    },
    rootIddCode: "+35818",
    continent: "Europe",
    blocMemberships: ["EU"]
  },
  AZ: {
    i18nNames: {
      en: "Azerbaijan",
      it: "Azerbaijan",
      es: "Azerbaiyán",
      de: "Aserbaidschan",
      pl: "Azerbejdżan",
      fr: "Azerbaïdjan",
      nl: "Azerbeidzjan",
      pt: "Azerbaijão",
      cs: "Ázerbájdžán",
      ro: "Azerbaidjan",
      ru: "Азербайджан"
    },
    rootIddCode: "+994",
    continent: "Asia"
  },
  BB: {
    i18nNames: {
      en: "Barbados",
      it: "Barbados",
      es: "Barbados",
      de: "Barbados",
      pl: "Barbados",
      fr: "Barbade",
      nl: "Barbados",
      pt: "Barbados",
      cs: "Barbados",
      ro: "Barbados",
      ru: "Барбадос"
    },
    rootIddCode: "+1246",
    continent: "NorthAmerica"
  },
  BD: {
    i18nNames: {
      en: "Bangladesh",
      it: "Bangladesh",
      es: "Bangladés",
      de: "Bangladesch",
      pl: "Bangladesz",
      fr: "Bangladesh",
      nl: "Bangladesh",
      pt: "Bangladesh",
      cs: "Bangladéš",
      ro: "Bangladesh",
      ru: "Бангладеш"
    },
    rootIddCode: "+880",
    continent: "Asia"
  },
  BE: {
    i18nNames: {
      en: "Belgium",
      it: "Belgio",
      es: "Bélgica",
      de: "Belgien",
      pl: "Belgia",
      fr: "Belgique",
      nl: "België",
      pt: "Bélgica",
      cs: "Belgie",
      ro: "Belgia",
      ru: "Бельгия"
    },
    rootIddCode: "+32",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^BE\\d{10}$",
    taxIdExample: "BE0123456789"
  },
  BF: {
    i18nNames: {
      en: "Burkina Faso",
      it: "Burkina Faso",
      es: "Burkina Faso",
      de: "Burkina Faso",
      pl: "Burkina Faso",
      fr: "Burkina Faso",
      nl: "Burkina Faso",
      pt: "Burquina Faso",
      cs: "Burkina Faso",
      ro: "Burkina Faso",
      ru: "Буркина-Фасо"
    },
    rootIddCode: "+226",
    continent: "Africa"
  },
  BG: {
    i18nNames: {
      en: "Bulgaria",
      it: "Bulgaria",
      es: "Bulgaria",
      de: "Bulgarien",
      pl: "Bułgaria",
      fr: "Bulgarie",
      nl: "Bulgarije",
      pt: "Bulgária",
      cs: "Bulharsko",
      ro: "Bulgaria",
      ru: "Болгария"
    },
    rootIddCode: "+359",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^BG(\\d{9}|\\d{10})$",
    taxIdExample: "BG123456789"
  },
  BH: {
    i18nNames: {
      en: "Bahrain",
      it: "Bahrein",
      es: "Baréin",
      de: "Bahrain",
      pl: "Bahrajn",
      fr: "Bahreïn",
      nl: "Bahrein",
      pt: "Bahrein",
      cs: "Bahrajn",
      ro: "Bahrein",
      ru: "Бахрейн"
    },
    rootIddCode: "+973",
    continent: "Asia",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{15}$",
    taxIdExample: "123456789012345"
  },
  BI: {
    i18nNames: {
      en: "Burundi",
      it: "Burundi",
      es: "Burundi",
      de: "Burundi",
      pl: "Burundi",
      fr: "Burundi",
      nl: "Burundi",
      pt: "Burundi",
      cs: "Burundi",
      ro: "Burundi",
      ru: "Бурунди"
    },
    rootIddCode: "+257",
    continent: "Africa"
  },
  BJ: {
    i18nNames: {
      en: "Benin",
      it: "Benin",
      es: "Benín",
      de: "Benin",
      pl: "Benin",
      fr: "Bénin",
      nl: "Benin",
      pt: "Benim",
      cs: "Benin",
      ro: "Benin",
      ru: "Бенин"
    },
    rootIddCode: "+229",
    continent: "Africa"
  },
  BL: {
    i18nNames: {
      en: "Saint Barthélemy",
      es: "San Bartolomé",
      it: "Antille Francesi",
      de: "Saint-Barthélemy",
      pl: "Saint-Barthélemy",
      fr: "Saint-Barthélemy",
      nl: "Saint-Barthélemy",
      pt: "São Bartolomeu",
      cs: "Svatý Bartoloměj",
      ro: "Sfântul Bartolomeu",
      ru: "Сен-Бартелеми"
    },
    rootIddCode: "+590",
    continent: "NorthAmerica"
  },
  BM: {
    i18nNames: {
      en: "Bermuda",
      it: "Bermuda",
      es: "Bermudas",
      de: "Bermuda",
      pl: "Bermudy",
      fr: "Bermudes",
      nl: "Bermuda",
      pt: "Bermudas",
      cs: "Bermudy",
      ro: "Bermuda",
      ru: "Бермуды"
    },
    rootIddCode: "+1441",
    continent: "NorthAmerica"
  },
  BN: {
    i18nNames: {
      en: "Brunei",
      it: "Brunei",
      es: "Brunéi",
      de: "Brunei",
      pl: "Brunei",
      fr: "Brunei",
      nl: "Brunei",
      pt: "Brunei",
      cs: "Brunej",
      ro: "Brunei",
      ru: "Бруней"
    },
    rootIddCode: "+673",
    continent: "Asia"
  },
  BO: {
    i18nNames: {
      en: "Bolivia",
      it: "Bolivia",
      es: "Bolivia",
      de: "Bolivien",
      pl: "Boliwia",
      fr: "Bolivie",
      nl: "Bolivia",
      pt: "Bolívia",
      cs: "Bolívie",
      ro: "Bolivia",
      ru: "Боливия"
    },
    rootIddCode: "+591",
    continent: "SouthAmerica"
  },
  BQ: {
    i18nNames: {
      en: "Caribbean Netherlands",
      es: "Bonaire, San Eustaquio y Saba",
      it: "Paesi Bassi caraibici",
      de: "Karibische Niederlande",
      pl: "Niderlandy Karaibskie",
      fr: "Pays-Bas caribéens",
      nl: "Caribisch Nederland",
      pt: "Países Baixos Caribenhos",
      cs: "Karibské Nizozemsko",
      ro: "Antilele Olandeze",
      ru: "Карибские Нидерланды"
    },
    rootIddCode: "+599",
    continent: "NorthAmerica"
  },
  BR: {
    i18nNames: {
      en: "Brazil",
      it: "Brasile",
      es: "Brasil",
      de: "Brasilien",
      pl: "Brazylia",
      fr: "Brésil",
      nl: "Brazilië",
      pt: "Brasil",
      cs: "Brazílie",
      ro: "Brazilia",
      ru: "Бразилия"
    },
    rootIddCode: "+55",
    continent: "SouthAmerica"
  },
  BS: {
    i18nNames: {
      en: "Bahamas",
      it: "Bahamas",
      es: "Bahamas",
      de: "Bahamas",
      pl: "Bahamy",
      fr: "Bahamas",
      nl: "Bahama's",
      pt: "Bahamas",
      cs: "Bahamy",
      ro: "Bahamas",
      ru: "Багамы"
    },
    rootIddCode: "+1242",
    continent: "NorthAmerica"
  },
  BT: {
    i18nNames: {
      en: "Bhutan",
      it: "Bhutan",
      es: "Bután",
      de: "Bhutan",
      pl: "Bhutan",
      fr: "Bhoutan",
      nl: "Bhutan",
      pt: "Butão",
      cs: "Bhútán",
      ro: "Bhutan",
      ru: "Бутан"
    },
    rootIddCode: "+975",
    continent: "Asia"
  },
  BV: {
    i18nNames: {
      en: "Bouvet Island",
      it: "Isola Bouvet",
      es: "Isla Bouvet",
      de: "Bouvetinsel",
      pl: "Wyspa Bouveta",
      fr: "Île Bouvet",
      nl: "Bouveteiland",
      pt: "Ilha Bouvet",
      cs: "Bouvetův ostrov",
      ro: "Insula Bouvet",
      ru: "Остров Буве"
    },
    rootIddCode: "+47",
    continent: "Antarctica"
  },
  BW: {
    i18nNames: {
      en: "Botswana",
      it: "Botswana",
      es: "Botsuana",
      de: "Botswana",
      pl: "Botswana",
      fr: "Botswana",
      nl: "Botswana",
      pt: "Botsuana",
      cs: "Botswana",
      ro: "Botswana",
      ru: "Ботсвана"
    },
    rootIddCode: "+267",
    continent: "Africa"
  },
  BY: {
    i18nNames: {
      en: "Belarus",
      it: "Bielorussia",
      es: "Bielorrusia",
      de: "Weißrussland",
      pl: "Białoruś",
      fr: "Biélorussie",
      nl: "Wit-Rusland",
      pt: "Bielorrússia",
      cs: "Bělorusko",
      ro: "Belarus",
      ru: "Беларусь"
    },
    rootIddCode: "+375",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{9}$",
    taxIdExample: "123456789"
  },
  BZ: {
    i18nNames: {
      en: "Belize",
      it: "Belize",
      es: "Belice",
      de: "Belize",
      pl: "Belize",
      fr: "Belize",
      nl: "Belize",
      pt: "Belize",
      cs: "Belize",
      ro: "Belize",
      ru: "Белиз"
    },
    rootIddCode: "+501",
    continent: "NorthAmerica"
  },
  CA: {
    i18nNames: {
      en: "Canada",
      it: "Canada",
      es: "Canadá",
      de: "Kanada",
      pl: "Kanada",
      fr: "Canada",
      nl: "Canada",
      pt: "Canadá",
      cs: "Kanada",
      ro: "Canada",
      ru: "Канада"
    },
    //quando verrà mappata aggiungere taxIdMandatory: false, in quanto non obbligatorio
    rootIddCode: "+1",
    continent: "NorthAmerica"
  },
  CC: {
    i18nNames: {
      en: "Cocos (Keeling) Islands",
      es: "Islas Cocos",
      it: "Isole Cocos e Keeling",
      de: "Kokosinseln",
      pl: "Wyspy Kokosowe",
      fr: "Îles Cocos",
      nl: "Cocoseilanden",
      pt: "Ilhas Cocos (Keeling)",
      cs: "Kokosové ostrovy",
      ro: "Insulele Cocos (Keeling)",
      ru: "Кокосовые (Килинг) острова"
    },
    rootIddCode: "+61",
    continent: "Oceania"
  },
  CD: {
    i18nNames: {
      en: "DR Congo",
      it: "Congo (Rep. Dem.)",
      es: "República Democrática del Congo",
      de: "Demokratische Republik Kongo",
      pl: "Demokratyczna Republika Konga",
      fr: "RDC (République Démocratique du Congo)",
      nl: "Congo (DRC)",
      pt: "RD Congo",
      cs: "Demokratická republika Kongo",
      ro: "Congo (R.D.)",
      ru: "Демократическая Республика Конго"
    },
    rootIddCode: "+243",
    continent: "Africa"
  },
  CF: {
    i18nNames: {
      en: "Central African Republic",
      es: "República Centroafricana",
      it: "Repubblica Centrafricana",
      de: "Zentralafrikanische Republik",
      pl: "Republika Środkowoafrykańska",
      fr: "République centrafricaine",
      nl: "Centraal-Afrikaanse Republiek",
      pt: "República Centro-Africana",
      cs: "Středoafrická republika",
      ro: "Republica Centrafricană",
      ru: "Центральноафриканская Республика"
    },
    rootIddCode: "+236",
    continent: "Africa"
  },
  CG: {
    i18nNames: {
      en: "Republic of the Congo",
      it: "Congo",
      es: "República del Congo",
      de: "Republik Kongo",
      pl: "Kongo",
      fr: "République du Congo",
      nl: "Republiek Congo",
      pt: "República do Congo",
      cs: "Republika Kongo",
      ro: "Republica Congo",
      ru: "Республика Конго"
    },
    rootIddCode: "+242",
    continent: "Africa"
  },
  CH: {
    i18nNames: {
      en: "Switzerland",
      it: "Svizzera",
      es: "Suiza",
      de: "Schweiz",
      pl: "Szwajcaria",
      fr: "Suisse",
      nl: "Zwitserland",
      pt: "Suíça",
      cs: "Švýcarsko",
      ro: "Elveția",
      ru: "Швейцария"
    },
    rootIddCode: "+41",
    continent: "Europe",
    taxIdMandatory: !1,
    taxIdPattern: "^CHE\\d{9}(MWST|TVA|IVA)?$",
    taxIdExample: "CHE123456789MWST"
  },
  CI: {
    i18nNames: {
      en: "Ivory Coast",
      it: "Costa d'Avorio",
      es: "Costa de Marfil",
      de: "Elfenbeinküste",
      pl: "Wybrzeże Kości Słoniowej",
      fr: "Côte d'Ivoire",
      nl: "Ivoorkust",
      pt: "Costa do Marfim",
      cs: "Pobřeží slonoviny",
      ro: "Coasta de Fildeș",
      ru: "Кот-д’Ивуар"
    },
    rootIddCode: "+225",
    continent: "Africa"
  },
  CK: {
    i18nNames: {
      en: "Cook Islands",
      it: "Isole Cook",
      es: "Islas Cook",
      de: "Cookinseln",
      pl: "Wyspy Cooka",
      fr: "Îles Cook",
      nl: "Cookeilanden",
      pt: "Ilhas Cook",
      cs: "Cookovy ostrovy",
      ro: "Insulele Cook",
      ru: "Острова Кука"
    },
    rootIddCode: "+682",
    continent: "Oceania"
  },
  CL: {
    i18nNames: {
      en: "Chile",
      it: "Cile",
      es: "Chile",
      de: "Chile",
      pl: "Chile",
      fr: "Chili",
      nl: "Chili",
      pt: "Chile",
      cs: "Chile",
      ro: "Chile",
      ru: "Чили"
    },
    rootIddCode: "+56",
    continent: "SouthAmerica"
  },
  CM: {
    i18nNames: {
      en: "Cameroon",
      it: "Camerun",
      es: "Camerún",
      de: "Kamerun",
      pl: "Kamerun",
      fr: "Cameroun",
      nl: "Kameroen",
      pt: "Camarões",
      cs: "Kamerun",
      ro: "Camerun",
      ru: "Камерун"
    },
    rootIddCode: "+237",
    continent: "Africa"
  },
  CN: {
    i18nNames: {
      en: "China",
      it: "Cina",
      es: "China",
      de: "China",
      pl: "Chiny",
      fr: "Chine",
      nl: "China",
      pt: "China",
      cs: "Čína",
      ro: "China",
      ru: "Китай"
    },
    rootIddCode: "+86",
    continent: "Asia"
  },
  CO: {
    i18nNames: {
      en: "Colombia",
      it: "Colombia",
      es: "Colombia",
      de: "Kolumbien",
      pl: "Kolumbia",
      fr: "Colombie",
      nl: "Colombia",
      pt: "Colômbia",
      cs: "Kolumbie",
      ro: "Columbia",
      ru: "Колумбия"
    },
    rootIddCode: "+57",
    continent: "SouthAmerica"
  },
  CR: {
    i18nNames: {
      en: "Costa Rica",
      it: "Costa Rica",
      es: "Costa Rica",
      de: "Costa Rica",
      pl: "Kostaryka",
      fr: "Costa Rica",
      nl: "Costa Rica",
      pt: "Costa Rica",
      cs: "Kostarika",
      ro: "Costa Rica",
      ru: "Коста-Рика"
    },
    rootIddCode: "+506",
    continent: "NorthAmerica"
  },
  CU: {
    i18nNames: {
      en: "Cuba",
      it: "Cuba",
      es: "Cuba",
      de: "Kuba",
      pl: "Kuba",
      fr: "Cuba",
      nl: "Cuba",
      pt: "Cuba",
      cs: "Kuba",
      ro: "Cuba",
      ru: "Куба"
    },
    rootIddCode: "+53",
    continent: "NorthAmerica"
  },
  CV: {
    i18nNames: {
      en: "Cape Verde",
      it: "Capo Verde",
      es: "Cabo Verde",
      de: "Kap Verde",
      pl: "Republika Zielonego Przylądka",
      fr: "Cap-Vert",
      nl: "Kaapverdië",
      pt: "Cabo Verde",
      cs: "Kapverdy",
      ro: "Capul Verde",
      ru: "Кабо-Верде"
    },
    rootIddCode: "+238",
    continent: "Africa"
  },
  CW: {
    i18nNames: {
      en: "Curaçao",
      it: "Curaçao",
      es: "Curazao",
      de: "Curaçao",
      pl: "Curaçao",
      fr: "Curaçao",
      nl: "Curaçao",
      pt: "Curaçau",
      cs: "Curaçao",
      ro: "Curaçao",
      ru: "Кюрасао"
    },
    rootIddCode: "+599",
    continent: "NorthAmerica"
  },
  CX: {
    i18nNames: {
      en: "Christmas Island",
      es: "Isla Christmas",
      it: "Isola di Natale",
      de: "Weihnachtsinsel",
      pl: "Wyspa Bożego Narodzenia",
      fr: "Île Christmas",
      nl: "Christmaseiland",
      pt: "Ilha Christmas",
      cs: "Vánoční ostrov",
      ro: "Insula Christmas",
      ru: "Остров Рождества"
    },
    rootIddCode: "+61",
    continent: "Oceania"
  },
  CY: {
    i18nNames: {
      en: "Cyprus",
      it: "Cipro",
      es: "Chipre",
      de: "Zypern",
      pl: "Cypr",
      fr: "Chypre",
      nl: "Cyprus",
      pt: "Chipre",
      cs: "Kypr",
      ro: "Cipru",
      ru: "Кипр"
    },
    rootIddCode: "+357",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^CY\\d{8}[A-Z]$",
    taxIdExample: "CY12345678A"
  },
  CZ: {
    i18nNames: {
      en: "Czech Republic",
      it: "Repubblica Ceca",
      es: "República Checa",
      de: "Tschechische Republik",
      pl: "Czechy",
      fr: "République tchèque",
      nl: "Tsjechië",
      pt: "República Checa",
      cs: "Česko",
      ro: "Republica Cehă",
      ru: "Чешская Республика"
    },
    rootIddCode: "+420",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^CZ(\\d{8}|\\d{9}|\\d{10})$",
    taxIdExample: "CZ12345678"
  },
  DE: {
    i18nNames: {
      en: "Germany",
      it: "Germania",
      es: "Alemania",
      de: "Deutschland",
      pl: "Niemcy",
      fr: "Allemagne",
      nl: "Duitsland",
      pt: "Alemanha",
      cs: "Německo",
      ro: "Germania",
      ru: "Германия"
    },
    rootIddCode: "+49",
    continent: "Europe",
    blocMemberships: ["EU"],
    regions: _y,
    taxIdMandatory: !1,
    taxIdPattern: "^DE\\d{9}$",
    taxIdExample: "DE123456789"
  },
  DJ: {
    i18nNames: {
      en: "Djibouti",
      it: "Gibuti",
      es: "Yibuti",
      de: "Dschibuti",
      pl: "Dżibuti",
      fr: "Djibouti",
      nl: "Djibouti",
      pt: "Djibuti",
      cs: "Džibutsko",
      ro: "Djibouti",
      ru: "Джибути"
    },
    rootIddCode: "+253",
    continent: "Africa"
  },
  DK: {
    i18nNames: {
      en: "Denmark",
      it: "Danimarca",
      es: "Dinamarca",
      de: "Dänemark",
      pl: "Dania",
      fr: "Danemark",
      nl: "Denemarken",
      pt: "Dinamarca",
      cs: "Dánsko",
      ro: "Danemarca",
      ru: "Дания"
    },
    rootIddCode: "+45",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^DK\\d{8}$",
    taxIdExample: "DK12345678"
  },
  DM: {
    i18nNames: {
      en: "Dominica",
      it: "Dominica",
      es: "Dominica",
      de: "Dominica",
      pl: "Dominika",
      fr: "Dominique",
      nl: "Dominica",
      pt: "Dominica",
      cs: "Dominika",
      ro: "Dominica",
      ru: "Доминика"
    },
    rootIddCode: "+1767",
    continent: "NorthAmerica"
  },
  DO: {
    i18nNames: {
      en: "Dominican Republic",
      es: "República Dominicana",
      it: "Repubblica Dominicana",
      de: "Dominikanische Republik",
      pl: "Dominikana",
      fr: "République dominicaine",
      nl: "Dominicaanse Republiek",
      pt: "República Dominicana",
      cs: "Dominikánská republika",
      ro: "Republica Dominicană",
      ru: "Доминиканская Республика"
    },
    rootIddCode: "+1849",
    continent: "NorthAmerica"
  },
  DZ: {
    i18nNames: {
      en: "Algeria",
      it: "Algeria",
      es: "Argelia",
      de: "Algerien",
      pl: "Algieria",
      fr: "Algérie",
      nl: "Algerije",
      pt: "Argélia",
      cs: "Alžírsko",
      ro: "Algeria",
      ru: "Алжир"
    },
    rootIddCode: "+213",
    continent: "Africa",
    taxIdMandatory: !0,
    taxIdPattern: "^(\\d{15}|\\d{20})$",
    taxIdExample: "123456789012345"
  },
  EC: {
    i18nNames: {
      en: "Ecuador",
      it: "Ecuador",
      es: "Ecuador",
      de: "Ecuador",
      pl: "Ekwador",
      fr: "Équateur",
      nl: "Ecuador",
      pt: "Equador",
      cs: "Ekvádor",
      ro: "Ecuador",
      ru: "Эквадор"
    },
    rootIddCode: "+593",
    continent: "SouthAmerica"
  },
  EE: {
    i18nNames: {
      en: "Estonia",
      it: "Estonia",
      es: "Estonia",
      de: "Estland",
      pl: "Estonia",
      fr: "Estonie",
      nl: "Estland",
      pt: "Estónia",
      cs: "Estonsko",
      ro: "Estonia",
      ru: "Эстония"
    },
    rootIddCode: "+372",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^EE\\d{9}$",
    taxIdExample: "EE123456789"
  },
  EG: {
    i18nNames: {
      en: "Egypt",
      it: "Egitto",
      es: "Egipto",
      de: "Ägypten",
      pl: "Egipt",
      fr: "Égypte",
      nl: "Egypte",
      pt: "Egito",
      cs: "Egypt",
      ro: "Egipt",
      ru: "Египет"
    },
    rootIddCode: "+20",
    continent: "Africa",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{9}$",
    taxIdExample: "123456789"
  },
  EH: {
    i18nNames: {
      en: "Western Sahara",
      it: "Sahara Occidentale",
      es: "Sáhara Occidental",
      de: "Westsahara",
      pl: "Sahara Zachodnia",
      fr: "Sahara occidental",
      nl: "Westelijke Sahara",
      pt: "Saara Ocidental",
      cs: "Západní Sahara",
      ro: "Sahara Occidentală",
      ru: "Западная Сахара"
    },
    rootIddCode: "+2125289",
    continent: "Africa"
  },
  ER: {
    i18nNames: {
      en: "Eritrea",
      it: "Eritrea",
      es: "Eritrea",
      de: "Eritrea",
      pl: "Erytrea",
      fr: "Érythrée",
      nl: "Eritrea",
      pt: "Eritreia",
      cs: "Eritrea",
      ro: "Eritreea",
      ru: "Эритрея"
    },
    rootIddCode: "+291",
    continent: "Africa"
  },
  ES: {
    i18nNames: {
      en: "Spain",
      it: "Spagna",
      es: "España",
      de: "Spanien",
      pl: "Hiszpania",
      fr: "Espagne",
      nl: "Spanje",
      pt: "Espanha",
      cs: "Španělsko",
      ro: "Spania",
      ru: "Испания"
    },
    rootIddCode: "+34",
    continent: "Europe",
    blocMemberships: ["EU"],
    regions: gy,
    taxIdMandatory: !0,
    taxIdPattern: "^ES[A-Z0-9]\\d{7}[A-Z0-9]$",
    taxIdExample: "ESX1234567Y"
  },
  ET: {
    i18nNames: {
      en: "Ethiopia",
      it: "Etiopia",
      es: "Etiopía",
      de: "Äthiopien",
      pl: "Etiopia",
      fr: "Éthiopie",
      nl: "Ethiopië",
      pt: "Etiópia",
      cs: "Etiopie",
      ro: "Etiopia",
      ru: "Эфиопия"
    },
    rootIddCode: "+251",
    continent: "Africa"
  },
  FI: {
    i18nNames: {
      en: "Finland",
      it: "Finlandia",
      es: "Finlandia",
      de: "Finnland",
      pl: "Finlandia",
      fr: "Finlande",
      nl: "Finland",
      pt: "Finlândia",
      cs: "Finsko",
      ro: "Finlanda",
      ru: "Финляндия"
    },
    rootIddCode: "+358",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^FI\\d{8}$",
    taxIdExample: "FI12345678"
  },
  FJ: {
    i18nNames: {
      en: "Fiji",
      it: "Figi",
      es: "Fiyi",
      de: "Fidschi",
      pl: "Fidżi",
      fr: "Fidji",
      nl: "Fiji",
      pt: "Fiji",
      cs: "Fidži",
      ro: "Fiji",
      ru: "Фиджи"
    },
    rootIddCode: "+679",
    continent: "Oceania"
  },
  FK: {
    i18nNames: {
      en: "Falkland Islands",
      es: "Islas Malvinas",
      it: "Isole Falkland o Isole Malvine",
      de: "Falklandinseln",
      pl: "Wyspy Falklandzkie",
      fr: "Îles Falkland",
      nl: "Falklandeilanden",
      pt: "Ilhas Malvinas",
      cs: "Falklandské ostrovy",
      ro: "Insulele Falkland",
      ru: "Фолклендские острова"
    },
    rootIddCode: "+500",
    continent: "SouthAmerica"
  },
  FM: {
    i18nNames: {
      en: "Micronesia",
      it: "Micronesia",
      es: "Estados Federados de Micronesia",
      de: "Mikronesien",
      pl: "Mikronezja",
      fr: "Micronésie",
      nl: "Micronesië",
      pt: "Micronésia",
      cs: "Mikronésie",
      ro: "Micronezia",
      ru: "Микронезия"
    },
    rootIddCode: "+691",
    continent: "Oceania"
  },
  FO: {
    i18nNames: {
      en: "Faroe Islands",
      it: "Isole Far Oer",
      es: "Islas Feroe",
      de: "Färöer-Inseln",
      pl: "Wyspy Owcze",
      fr: "Îles Féroé",
      nl: "Faeröer",
      pt: "Ilhas Faroé",
      cs: "Faerské ostrovy",
      ro: "Insulele Feroe",
      ru: "Фарерские острова"
    },
    rootIddCode: "+298",
    continent: "Europe"
  },
  FR: {
    i18nNames: {
      en: "France",
      it: "Francia",
      es: "Francia",
      de: "Frankreich",
      pl: "Francja",
      fr: "France",
      nl: "Frankrijk",
      pt: "França",
      cs: "Francie",
      ro: "Franța",
      ru: "Франция"
    },
    rootIddCode: "+33",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^FR[A-Z0-9]{2}\\d{9}$",
    taxIdExample: "FR1A123456789"
  },
  GA: {
    i18nNames: {
      en: "Gabon",
      it: "Gabon",
      es: "Gabón",
      de: "Gabun",
      pl: "Gabon",
      fr: "Gabon",
      nl: "Gabon",
      pt: "Gabão",
      cs: "Gabon",
      ro: "Gabon",
      ru: "Габон"
    },
    rootIddCode: "+241",
    continent: "Africa"
  },
  GB: {
    i18nNames: {
      en: "United Kingdom",
      it: "Regno Unito",
      es: "Reino Unido",
      de: "Vereinigtes Königreich",
      pl: "Zjednoczone Królestwo",
      fr: "Royaume-Uni",
      nl: "Verenigd Koninkrijk",
      pt: "Reino Unido",
      cs: "Spojené království",
      ro: "Regatul Unit",
      ru: "Великобритания"
    },
    rootIddCode: "+44",
    continent: "Europe",
    taxIdMandatory: !1,
    taxIdPattern: "^GB(\\d{9}|\\d{12}|GD(0\\d{2}|[1-4]\\d{2})|HA([5-9]\\d{2}))$",
    taxIdExample: "GB123456789"
  },
  GD: {
    i18nNames: {
      en: "Grenada",
      it: "Grenada",
      es: "Granada",
      de: "Grenada",
      pl: "Grenada",
      fr: "Grenade",
      nl: "Grenada",
      pt: "Granada",
      cs: "Grenada",
      ro: "Grenada",
      ru: "Гренада"
    },
    rootIddCode: "+1473",
    continent: "NorthAmerica"
  },
  GE: {
    i18nNames: {
      en: "Georgia",
      it: "Georgia",
      es: "Georgia",
      de: "Georgien",
      pl: "Gruzja",
      fr: "Géorgie",
      nl: "Georgië",
      pt: "Geórgia",
      cs: "Gruzie",
      ro: "Georgia",
      ru: "Грузия"
    },
    rootIddCode: "+995",
    continent: "Europe"
  },
  GF: {
    i18nNames: {
      en: "French Guiana",
      it: "Guyana francese",
      es: "Guayana Francesa",
      de: "Französisch-Guayana",
      pl: "Gujana Francuska",
      fr: "Guyane française",
      nl: "Frans-Guyana",
      pt: "Guiana Francesa",
      cs: "Francouzská Guyana",
      ro: "Guyana Franceză",
      ru: "Французская Гвиана"
    },
    rootIddCode: "+594",
    continent: "SouthAmerica",
    blocMemberships: ["EU"]
  },
  GG: {
    i18nNames: {
      en: "Guernsey",
      it: "Guernsey",
      es: "Guernsey",
      de: "Guernsey",
      pl: "Guernsey",
      fr: "Guernesey",
      nl: "Guernsey",
      pt: "Guernsey",
      cs: "Guernsey",
      ro: "Guernsey",
      ru: "Гернси"
    },
    rootIddCode: "+44",
    continent: "Europe"
  },
  GH: {
    i18nNames: {
      en: "Ghana",
      it: "Ghana",
      es: "Ghana",
      de: "Ghana",
      pl: "Ghana",
      fr: "Ghana",
      nl: "Ghana",
      pt: "Gana",
      cs: "Ghana",
      ro: "Ghana",
      ru: "Гана"
    },
    rootIddCode: "+233",
    continent: "Africa"
  },
  GI: {
    i18nNames: {
      en: "Gibraltar",
      it: "Gibilterra",
      es: "Gibraltar",
      de: "Gibraltar",
      pl: "Gibraltar",
      fr: "Gibraltar",
      nl: "Gibraltar",
      pt: "Gibraltar",
      cs: "Gibraltar",
      ro: "Gibraltar",
      ru: "Гибралтар"
    },
    rootIddCode: "+350",
    continent: "Europe"
  },
  GL: {
    i18nNames: {
      en: "Greenland",
      it: "Groenlandia",
      es: "Groenlandia",
      de: "Grönland",
      pl: "Grenlandia",
      fr: "Groenland",
      nl: "Groenland",
      pt: "Gronelândia",
      cs: "Grónsko",
      ro: "Groenlanda",
      ru: "Гренландия"
    },
    rootIddCode: "+299",
    continent: "NorthAmerica"
  },
  GM: {
    i18nNames: {
      en: "Gambia",
      it: "Gambia",
      es: "Gambia",
      de: "Gambia",
      pl: "Gambia",
      fr: "Gambie",
      nl: "Gambia",
      pt: "Gâmbia",
      cs: "Gambie",
      ro: "Gambia",
      ru: "Гамбия"
    },
    rootIddCode: "+220",
    continent: "Africa"
  },
  GN: {
    i18nNames: {
      en: "Guinea",
      it: "Guinea",
      es: "Guinea",
      de: "Guinea",
      pl: "Gwinea",
      fr: "Guinée",
      nl: "Guinee",
      pt: "Guiné",
      cs: "Guinea",
      ro: "Guineea",
      ru: "Гвинея"
    },
    rootIddCode: "+224",
    continent: "Africa"
  },
  GP: {
    i18nNames: {
      en: "Guadeloupe",
      it: "Guadeloupa",
      es: "Guadalupe",
      de: "Guadeloupe",
      pl: "Gwadelupa",
      fr: "Guadeloupe",
      nl: "Guadeloupe",
      pt: "Guadalupe",
      cs: "Guadeloupe",
      ro: "Guadelupa",
      ru: "Гваделупа"
    },
    rootIddCode: "+590",
    continent: "NorthAmerica"
  },
  GQ: {
    i18nNames: {
      en: "Equatorial Guinea",
      es: "Guinea Ecuatorial",
      it: "Guinea Equatoriale",
      de: "Äquatorialguinea",
      pl: "Gwinea Równikowa",
      fr: "Guinée équatoriale",
      nl: "Equatoriaal-Guinea",
      pt: "Guiné Equatorial",
      cs: "Rovníková Guinea",
      ro: "Guineea Ecuatorială",
      ru: "Экваториальная Гвинея"
    },
    rootIddCode: "+240",
    continent: "Africa"
  },
  GR: {
    i18nNames: {
      en: "Greece",
      it: "Grecia",
      es: "Grecia",
      de: "Griechenland",
      pl: "Grecja",
      fr: "Grèce",
      nl: "Griekenland",
      pt: "Grécia",
      cs: "Řecko",
      ro: "Grecia",
      ru: "Греция"
    },
    rootIddCode: "+30",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^EL\\d{9}$",
    taxIdExample: "EL123456789"
  },
  GS: {
    i18nNames: {
      en: "South Georgia",
      it: "Georgia del Sud e Isole Sandwich Meridionali",
      es: "Islas Georgias del Sur y Sandwich del Sur",
      de: "Südgeorgien",
      pl: "Georgia Południowa",
      fr: "Géorgie du Sud et îles Sandwich du Sud",
      nl: "Zuid-Georgië en Zuidelijke Sandwicheilanden",
      pt: "Geórgia do Sul e Ilhas Sandwich do Sul",
      cs: "Jižní Georgie a Jižní Sandwichovy ostrovy",
      ro: "Georgia de Sud și Insulele Sandwich de Sud",
      ru: "Южная Георгия и Южные Сандвичевы острова"
    },
    rootIddCode: "+500",
    continent: "Oceania"
  },
  GT: {
    i18nNames: {
      en: "Guatemala",
      it: "Guatemala",
      es: "Guatemala",
      de: "Guatemala",
      pl: "Gwatemala",
      fr: "Guatemala",
      nl: "Guatemala",
      pt: "Guatemala",
      cs: "Guatemala",
      ro: "Guatemala",
      ru: "Гватемала"
    },
    rootIddCode: "+502",
    continent: "NorthAmerica"
  },
  GU: {
    i18nNames: {
      en: "Guam",
      it: "Guam",
      es: "Guam",
      de: "Guam",
      pl: "Guam",
      fr: "Guam",
      nl: "Guam",
      pt: "Guam",
      cs: "Guam",
      ro: "Guam",
      ru: "Гуам"
    },
    rootIddCode: "+1671",
    continent: "NorthAmerica"
  },
  GW: {
    i18nNames: {
      en: "Guinea-Bissau",
      it: "Guinea-Bissau",
      es: "Guinea-Bisáu",
      de: "Guinea-Bissau",
      pl: "Gwinea-Bissau",
      fr: "Guinée-Bissau",
      nl: "Guinee-Bissau",
      pt: "Guiné-Bissau",
      cs: "Guinea-Bissau",
      ro: "Guineea-Bissau",
      ru: "Гвинея-Бисау"
    },
    rootIddCode: "+245",
    continent: "Africa"
  },
  GY: {
    i18nNames: {
      en: "Guyana",
      it: "Guyana",
      es: "Guyana",
      de: "Guyana",
      pl: "Gujana",
      fr: "Guyana",
      nl: "Guyana",
      pt: "Guiana",
      cs: "Guyana",
      ro: "Guyana",
      ru: "Гайана"
    },
    rootIddCode: "+592",
    continent: "NorthAmerica"
  },
  HK: {
    i18nNames: {
      en: "Hong Kong",
      it: "Hong Kong",
      es: "Hong Kong",
      de: "Hongkong",
      pl: "Hongkong",
      fr: "Hong Kong",
      nl: "Hongkong",
      pt: "Hong Kong",
      cs: "Hongkong",
      ro: "Hong Kong",
      ru: "Гонконг"
    },
    rootIddCode: "+852",
    continent: "Asia"
  },
  HM: {
    i18nNames: {
      en: "Heard Island and McDonald Islands",
      es: "Islas Heard y McDonald",
      it: "Isole Heard e McDonald",
      de: "Heard und McDonaldinseln",
      pl: "Wyspy Heard i McDonalda",
      fr: "Îles Heard et McDonald",
      nl: "Heard en McDonaldeilanden",
      pt: "Ilhas Heard e McDonald",
      cs: "Heardův ostrov a McDonaldovy ostrovy",
      ro: "Insula Heard și Insulele McDonald",
      ru: "Остров Херд и острова Макдональд"
    },
    rootIddCode: "undefined",
    continent: "Oceania"
  },
  HN: {
    i18nNames: {
      en: "Honduras",
      it: "Honduras",
      es: "Honduras",
      de: "Honduras",
      pl: "Honduras",
      fr: "Honduras",
      nl: "Honduras",
      pt: "Honduras",
      cs: "Honduras",
      ro: "Honduras",
      ru: "Гондурас"
    },
    rootIddCode: "+504",
    continent: "NorthAmerica"
  },
  HR: {
    i18nNames: {
      en: "Croatia",
      it: "Croazia",
      es: "Croacia",
      de: "Kroatien",
      pl: "Chorwacja",
      fr: "Croatie",
      nl: "Kroatië",
      pt: "Croácia",
      cs: "Chorvatsko",
      ro: "Croația",
      ru: "Хорватия"
    },
    rootIddCode: "+385",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^HR\\d{11}$",
    taxIdExample: "HR12345678901"
  },
  HT: {
    i18nNames: {
      en: "Haiti",
      it: "Haiti",
      es: "Haití",
      de: "Haiti",
      pl: "Haiti",
      fr: "Haïti",
      nl: "Haïti",
      pt: "Haiti",
      cs: "Haiti",
      ro: "Haiti",
      ru: "Гаити"
    },
    rootIddCode: "+509",
    continent: "NorthAmerica"
  },
  HU: {
    i18nNames: {
      en: "Hungary",
      it: "Ungheria",
      es: "Hungría",
      de: "Ungarn",
      pl: "Węgry",
      fr: "Hongrie",
      nl: "Hongarije",
      pt: "Hungria",
      cs: "Maďarsko",
      ro: "Ungaria",
      ru: "Венгрия"
    },
    rootIddCode: "+36",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^HU\\d{8}$",
    taxIdExample: "HU12345678"
  },
  ID: {
    i18nNames: {
      en: "Indonesia",
      it: "Indonesia",
      es: "Indonesia",
      de: "Indonesien",
      pl: "Indonezja",
      fr: "Indonésie",
      nl: "Indonesië",
      pt: "Indonésia",
      cs: "Indonésie",
      ro: "Indonezia",
      ru: "Индонезия"
    },
    rootIddCode: "+62",
    continent: "Asia"
  },
  IE: {
    i18nNames: {
      en: "Ireland",
      it: "Irlanda",
      es: "Irlanda",
      de: "Irland",
      pl: "Irlandia",
      fr: "Irlande",
      nl: "Ierland",
      pt: "Irlanda",
      cs: "Irsko",
      ro: "Irlanda",
      ru: "Ирландия"
    },
    rootIddCode: "+353",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^IE\\d{7}[A-Z]{1,2}$",
    taxIdExample: "IE1234567A"
  },
  IL: {
    i18nNames: {
      en: "Israel",
      it: "Israele",
      es: "Israel",
      de: "Israel",
      pl: "Израиль",
      fr: "Israël",
      nl: "Israël",
      pt: "Israel",
      cs: "Izrael",
      ro: "Israel",
      ru: "Израиль"
    },
    rootIddCode: "+972",
    continent: "Asia",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{9}$",
    taxIdExample: "123456789"
  },
  IM: {
    i18nNames: {
      en: "Isle of Man",
      it: "Isola di Man",
      es: "Isla de Man",
      de: "Isle of Man",
      pl: "Wyspa Man",
      fr: "Île de Man",
      nl: "Isle of Man",
      pt: "Ilha de Man",
      cs: "Ostrov Man",
      ro: "Insula Man",
      ru: "Остров Мэн"
    },
    rootIddCode: "+44",
    continent: "Europe"
  },
  IN: {
    i18nNames: {
      en: "India",
      it: "India",
      es: "India",
      de: "Indien",
      pl: "Indie",
      fr: "Inde",
      nl: "India",
      pt: "Índia",
      cs: "Indie",
      ro: "India",
      ru: "Индия"
    },
    rootIddCode: "+91",
    continent: "Asia"
  },
  IO: {
    i18nNames: {
      en: "British Indian Ocean Territory",
      es: "Territorio Británico del Océano Índico",
      it: "Territorio britannico dell'oceano indiano",
      de: "Britisches Territorium im Indischen Ozean",
      pl: "Brytyjskie Terytorium Oceanu Indyjskiego",
      fr: "Territoire britannique de l'océan Indien",
      nl: "Brits Indische Oceaanterritorium",
      pt: "Território Britânico do Oceano Índico",
      cs: "Britské indickooceánské území",
      ro: "Teritoriul Britanic din Oceanul Indian",
      ru: "Британская территория в Индийском океане"
    },
    rootIddCode: "+246",
    continent: "Asia"
  },
  IQ: {
    i18nNames: {
      en: "Iraq",
      it: "Iraq",
      es: "Irak",
      de: "Ирак",
      pl: "Irak",
      fr: "Irak",
      nl: "Irak",
      pt: "Iraque",
      cs: "Irák",
      ro: "Irak",
      ru: "Ирак"
    },
    rootIddCode: "+964",
    continent: "Asia"
  },
  IR: {
    i18nNames: {
      en: "Iran",
      it: "Iran",
      es: "Irán",
      de: "Iran",
      pl: "Iran",
      fr: "Iran",
      nl: "Iran",
      pt: "Irã",
      cs: "Írán",
      ro: "Iran",
      ru: "Иран"
    },
    rootIddCode: "+98",
    continent: "Asia"
  },
  IS: {
    i18nNames: {
      en: "Iceland",
      it: "Islanda",
      es: "Islandia",
      de: "Island",
      pl: "Islandia",
      fr: "Islande",
      nl: "IJsland",
      pt: "Islândia",
      cs: "Island",
      ro: "Islanda",
      ru: "Исландия"
    },
    rootIddCode: "+354",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^IS\\d{5,6}$",
    taxIdExample: "IS123456"
  },
  IT: {
    i18nNames: {
      en: "Italy",
      it: "Italia",
      es: "Italia",
      de: "Italien",
      pl: "Włochy",
      fr: "Italie",
      nl: "Italie",
      pt: "Itália",
      cs: "Itálie",
      ro: "Italia",
      ru: "Италия"
    },
    rootIddCode: "+39",
    continent: "Europe",
    blocMemberships: ["EU"],
    regions: by,
    taxIdMandatory: !0,
    taxIdPattern: "^IT\\d{11}$",
    taxIdExample: "IT12345678901"
  },
  JE: {
    i18nNames: {
      en: "Jersey",
      it: "Isola di Jersey",
      es: "Jersey",
      de: "Jersey",
      pl: "Jersey",
      fr: "Jersey",
      nl: "Jersey",
      pt: "Jersey",
      cs: "Jersey",
      ro: "Jersey",
      ru: "Джерси"
    },
    rootIddCode: "+44",
    continent: "Europe"
  },
  JM: {
    i18nNames: {
      en: "Jamaica",
      it: "Giamaica",
      es: "Jamaica",
      de: "Jamaika",
      pl: "Jamajka",
      fr: "Jamaïque",
      nl: "Jamaica",
      pt: "Jamaica",
      cs: "Jamajka",
      ro: "Jamaica",
      ru: "Ямайка"
    },
    rootIddCode: "+1876",
    continent: "NorthAmerica"
  },
  JO: {
    i18nNames: {
      en: "Jordan",
      it: "Giordania",
      es: "Jordania",
      de: "Jordanien",
      pl: "Jordania",
      fr: "Jordanie",
      nl: "Jordanië",
      pt: "Jordânia",
      cs: "Jordánsko",
      ro: "Iordania",
      ru: "Иордания"
    },
    rootIddCode: "+962",
    continent: "Asia",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{7}$",
    taxIdExample: "1234567"
  },
  JP: {
    i18nNames: {
      en: "Japan",
      it: "Giappone",
      es: "Japón",
      de: "Japan",
      pl: "Japonia",
      fr: "Japon",
      nl: "Japan",
      pt: "Japão",
      cs: "Japonsko",
      ro: "Japonia",
      ru: "Япония"
    },
    rootIddCode: "+81",
    continent: "Asia"
  },
  KE: {
    i18nNames: {
      en: "Kenya",
      it: "Kenya",
      es: "Kenia",
      de: "Kenia",
      pl: "Kenia",
      fr: "Kenya",
      nl: "Kenia",
      pt: "Quênia",
      cs: "Keňa",
      ro: "Kenya",
      ru: "Кения"
    },
    rootIddCode: "+254",
    continent: "Africa"
  },
  KG: {
    i18nNames: {
      en: "Kyrgyzstan",
      it: "Kirghizistan",
      es: "Kirguistán",
      de: "Kirgisistan",
      pl: "Kirgistan",
      fr: "Kirghizistan",
      nl: "Kirgizië",
      pt: "Quirguistão",
      cs: "Kyrgyzstán",
      ro: "Kârgâzstan",
      ru: "Киргизия"
    },
    rootIddCode: "+996",
    continent: "Asia"
  },
  KH: {
    i18nNames: {
      en: "Cambodia",
      it: "Cambogia",
      es: "Camboya",
      de: "Kambodscha",
      pl: "Kambodża",
      fr: "Cambodge",
      nl: "Cambodja",
      pt: "Camboja",
      cs: "Kambodža",
      ro: "Cambodgia",
      ru: "Камбоджа"
    },
    rootIddCode: "+855",
    continent: "Asia"
  },
  KI: {
    i18nNames: {
      en: "Kiribati",
      it: "Kiribati",
      es: "Kiribati",
      de: "Kiribati",
      pl: "Kiribati",
      fr: "Kiribati",
      nl: "Kiribati",
      pt: "Kiribati",
      cs: "Kiribati",
      ro: "Kiribati",
      ru: "Кирибати"
    },
    rootIddCode: "+686",
    continent: "Oceania"
  },
  KM: {
    i18nNames: {
      en: "Comoros",
      it: "Comore",
      es: "Comoras",
      de: "Komoren",
      pl: "Komory",
      fr: "Comores",
      nl: "Comoren",
      pt: "Comores",
      cs: "Komory",
      ro: "Comore",
      ru: "Коморы"
    },
    rootIddCode: "+269",
    continent: "Africa"
  },
  KN: {
    i18nNames: {
      en: "Saint Kitts and Nevis",
      es: "San Cristóbal y Nieves",
      it: "Saint Kitts e Nevis",
      de: "St. Kitts und Nevis",
      pl: "Saint Kitts i Nevis",
      fr: "Saint-Christophe-et-Niévès",
      nl: "Saint Kitts en Nevis",
      pt: "São Cristóvão e Névis",
      cs: "Svatý Kryštof a Nevis",
      ro: "Sfântul Kitts și Nevis",
      ru: "Сент-Китс и Невис"
    },
    rootIddCode: "+1869",
    continent: "NorthAmerica"
  },
  KP: {
    i18nNames: {
      en: "North Korea",
      it: "Corea del Nord",
      es: "Corea del Norte",
      de: "Nordkorea",
      pl: "Korea Północna",
      fr: "Corée du Nord",
      nl: "Noord-Korea",
      pt: "Coreia do Norte",
      cs: "Severní Korea",
      ro: "Coreea de Nord",
      ru: "Северная Корея"
    },
    rootIddCode: "+850",
    continent: "Asia"
  },
  KR: {
    i18nNames: {
      en: "South Korea",
      it: "Corea del Sud",
      es: "Corea del Sur",
      de: "Südkorea",
      pl: "Korea Południowa",
      fr: "Corée du Sud",
      nl: "Zuid-Korea",
      pt: "Coreia do Sul",
      cs: "Jižní Korea",
      ro: "Coreea de Sud",
      ru: "Южная Корея"
    },
    rootIddCode: "+82",
    continent: "Asia"
  },
  KW: {
    i18nNames: {
      en: "Kuwait",
      it: "Kuwait",
      es: "Kuwait",
      de: "Kuwait",
      pl: "Kuwejt",
      fr: "Koweït",
      nl: "Кувейт",
      pt: "Kuwait",
      cs: "Kuvajt",
      ro: "Kuweit",
      ru: "Кувейт"
    },
    rootIddCode: "+965",
    continent: "Asia"
  },
  KY: {
    i18nNames: {
      en: "Cayman Islands",
      it: "Isole Cayman",
      es: "Islas Caimán",
      de: "Kaimaninseln",
      pl: "Kajmany",
      fr: "Îles Caïmans",
      nl: "Kaaimaneilanden",
      pt: "Ilhas Cayman",
      cs: "Kajmanské ostrovy",
      ro: "Insulele Cayman",
      ru: "Каймановы острова"
    },
    rootIddCode: "+1345",
    continent: "NorthAmerica"
  },
  KZ: {
    i18nNames: {
      en: "Kazakhstan",
      it: "Kazakistan",
      es: "Kazajistán",
      de: "Kasachstan",
      pl: "Kazachstan",
      fr: "Kazakhstan",
      nl: "Kazachstan",
      pt: "Cazaquistão",
      cs: "Kazachstán",
      ro: "Kazahstan",
      ru: "Казахстан"
    },
    rootIddCode: "+77",
    continent: "Asia"
  },
  LA: {
    i18nNames: {
      en: "Laos",
      it: "Laos",
      es: "Laos",
      de: "Laos",
      pl: "Laos",
      fr: "Laos",
      nl: "Laos",
      pt: "Laos",
      cs: "Laos",
      ro: "Laos",
      ru: "Лаос"
    },
    rootIddCode: "+856",
    continent: "Asia"
  },
  LB: {
    i18nNames: {
      en: "Lebanon",
      it: "Libano",
      es: "Líbano",
      de: "Libanon",
      pl: "Liban",
      fr: "Liban",
      nl: "Libanon",
      pt: "Líbano",
      cs: "Libanon",
      ro: "Liban",
      ru: "Ливан"
    },
    rootIddCode: "+961",
    continent: "Asia",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{1,15}(-(601|603|604))?$",
    taxIdExample: "123456789-601"
  },
  LC: {
    i18nNames: {
      en: "Saint Lucia",
      it: "Santa Lucia",
      es: "Santa Lucía",
      de: "St. Lucia",
      pl: "Saint Lucia",
      fr: "Sainte-Lucie",
      nl: "Saint Lucia",
      pt: "Santa Lúcia",
      cs: "Svatá Lucie",
      ro: "Sfânta Lucia",
      ru: "Сент-Люсия"
    },
    rootIddCode: "+1758",
    continent: "NorthAmerica"
  },
  LI: {
    i18nNames: {
      en: "Liechtenstein",
      it: "Liechtenstein",
      es: "Liechtenstein",
      de: "Liechtenstein",
      pl: "Liechtenstein",
      fr: "Liechtenstein",
      nl: "Liechtenstein",
      pt: "Liechtenstein",
      cs: "Lichtenštejnsko",
      ro: "Liechtenstein",
      ru: "Лихтенштейн"
    },
    rootIddCode: "+423",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{5}$",
    taxIdExample: "12345"
  },
  LK: {
    i18nNames: {
      en: "Sri Lanka",
      it: "Sri Lanka",
      es: "Sri Lanka",
      de: "Sri Lanka",
      pl: "Sri Lanka",
      fr: "Sri Lanka",
      nl: "Sri Lanka",
      pt: "Sri Lanka",
      cs: "Srí Lanka",
      ro: "Sri Lanka",
      ru: "Шри-Ланка"
    },
    rootIddCode: "+94",
    continent: "Asia"
  },
  LR: {
    i18nNames: {
      en: "Liberia",
      it: "Liberia",
      es: "Liberia",
      de: "Liberia",
      pl: "Liberia",
      fr: "Libéria",
      nl: "Liberia",
      pt: "Libéria",
      cs: "Libérie",
      ro: "Liberia",
      ru: "Либерия"
    },
    rootIddCode: "+231",
    continent: "Africa"
  },
  LS: {
    i18nNames: {
      en: "Lesotho",
      it: "Lesotho",
      es: "Lesoto",
      de: "Lesotho",
      pl: "Lesotho",
      fr: "Lesotho",
      nl: "Lesotho",
      pt: "Lesoto",
      cs: "Lesotho",
      ro: "Lesotho",
      ru: "Лесото"
    },
    rootIddCode: "+266",
    continent: "Africa"
  },
  LT: {
    i18nNames: {
      en: "Lithuania",
      it: "Lituania",
      es: "Lituania",
      de: "Litauen",
      pl: "Litwa",
      fr: "Lituanie",
      nl: "Litouwen",
      pt: "Lituânia",
      cs: "Litva",
      ro: "Lituania",
      ru: "Литва"
    },
    rootIddCode: "+370",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^LT(\\d{9}|\\d{12})$",
    taxIdExample: "LT123456789"
  },
  LU: {
    i18nNames: {
      en: "Luxembourg",
      it: "Lussemburgo",
      es: "Luxemburgo",
      de: "Luxemburg",
      pl: "Luksemburg",
      fr: "Luxembourg",
      nl: "Luxemburg",
      pt: "Luxemburgo",
      cs: "Lucembursko",
      ro: "Luxemburg",
      ru: "Люксембург"
    },
    rootIddCode: "+352",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^LU\\d{8}$",
    taxIdExample: "LU12345678"
  },
  LV: {
    i18nNames: {
      en: "Latvia",
      it: "Lettonia",
      es: "Letonia",
      de: "Lettland",
      pl: "Łotwa",
      fr: "Lettonie",
      nl: "Letland",
      pt: "Letónia",
      cs: "Lotyšsko",
      ro: "Letonia",
      ru: "Латвия"
    },
    rootIddCode: "+371",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^LV\\d{11}$",
    taxIdExample: "LV12345678901"
  },
  LY: {
    i18nNames: {
      en: "Libya",
      it: "Libia",
      es: "Libia",
      de: "Libyen",
      pl: "Libia",
      fr: "Libye",
      nl: "Libië",
      pt: "Líbia",
      cs: "Libye",
      ro: "Libia",
      ru: "Ливия"
    },
    rootIddCode: "+218",
    continent: "Africa"
  },
  MA: {
    i18nNames: {
      en: "Morocco",
      it: "Marocco",
      es: "Marruecos",
      de: "Marokko",
      pl: "Maroko",
      fr: "Maroc",
      nl: "Marokko",
      pt: "Marrocos",
      cs: "Maroko",
      ro: "Maroc",
      ru: "Марокко"
    },
    rootIddCode: "+212",
    continent: "Africa",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{8}$",
    taxIdExample: "12345678"
  },
  MC: {
    i18nNames: {
      en: "Monaco",
      it: "Principato di Monaco",
      es: "Mónaco",
      de: "Monaco",
      pl: "Monako",
      fr: "Monaco",
      nl: "Monaco",
      pt: "Mônaco",
      cs: "Monako",
      ro: "Monaco",
      ru: "Монако"
    },
    rootIddCode: "+377",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^FR[A-Z0-9]{2}\\d{9}$",
    taxIdExample: "FR9Z123456789"
  },
  MD: {
    i18nNames: {
      en: "Moldova",
      it: "Moldavia",
      es: "Moldavia",
      de: "Moldawien",
      pl: "Mołdawia",
      fr: "Moldavie",
      nl: "Moldavië",
      pt: "Moldávia",
      cs: "Moldavsko",
      ro: "Moldova",
      ru: "Молдова"
    },
    rootIddCode: "+373",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^MD\\d{7}$",
    taxIdExample: "MD1234567"
  },
  ME: {
    i18nNames: {
      en: "Montenegro",
      it: "Montenegro",
      es: "Montenegro",
      de: "Montenegro",
      pl: "Czarnogóra",
      fr: "Monténégro",
      nl: "Montenegro",
      pt: "Montenegro",
      cs: "Černá Hora",
      ro: "Muntenegru",
      ru: "Черногория"
    },
    rootIddCode: "+382",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{8}$",
    taxIdExample: "12345678"
  },
  MF: {
    i18nNames: {
      en: "Saint Martin",
      it: "Saint Martin",
      es: "San Martín (parte francesa)",
      de: "Saint-Martin",
      pl: "Saint-Martin",
      fr: "Saint-Martin",
      nl: "Saint Martin",
      pt: "São Martinho",
      cs: "Saint-Martin",
      ro: "Sfântul Martin",
      ru: "Сен-Мартен"
    },
    rootIddCode: "+590",
    continent: "NorthAmerica"
  },
  MG: {
    i18nNames: {
      en: "Madagascar",
      it: "Madagascar",
      es: "Madagascar",
      de: "Madagaskar",
      pl: "Madagaskar",
      fr: "Madagascar",
      nl: "Madagaskar",
      pt: "Madagáscar",
      cs: "Madagaskar",
      ro: "Madagascar",
      ru: "Мадагаскар"
    },
    rootIddCode: "+261",
    continent: "Africa"
  },
  MH: {
    i18nNames: {
      en: "Marshall Islands",
      es: "Islas Marshall",
      it: "Isole Marshall",
      de: "Marshallinseln",
      pl: "Wyspy Marshalla",
      fr: "Îles Marshall",
      nl: "Marshalleilanden",
      pt: "Ilhas Marshall",
      cs: "Marshallovy ostrovy",
      ro: "Insulele Marshall",
      ru: "Маршалловы Острова"
    },
    rootIddCode: "+692",
    continent: "Oceania"
  },
  MK: {
    i18nNames: {
      en: "North Macedonia",
      it: "Macedonia del Nord",
      es: "Macedonia del Norte",
      de: "Nordmazedonien",
      pl: "Macedonia Północna",
      fr: "Macédoine du Nord",
      nl: "Noord-Macedonië",
      pt: "Macedônia do Norte",
      cs: "Severní Makedonie",
      ro: "Macedonia de Nord",
      ru: "Северная Македония"
    },
    rootIddCode: "+389",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{13}$",
    taxIdExample: "1234567890123"
  },
  ML: {
    i18nNames: {
      en: "Mali",
      it: "Mali",
      es: "Malí",
      de: "Mali",
      pl: "Mali",
      fr: "Mali",
      nl: "Mali",
      pt: "Mali",
      cs: "Mali",
      ro: "Mali",
      ru: "Мали"
    },
    rootIddCode: "+223",
    continent: "Africa"
  },
  MM: {
    i18nNames: {
      en: "Myanmar",
      it: "Birmania",
      es: "Birmania",
      de: "Myanmar",
      pl: "Mjanma",
      fr: "Birmanie",
      nl: "Myanmar",
      pt: "Mianmar",
      cs: "Myanmar",
      ro: "Myanmar",
      ru: "Мьянма"
    },
    rootIddCode: "+95",
    continent: "Asia"
  },
  MN: {
    i18nNames: {
      en: "Mongolia",
      it: "Mongolia",
      es: "Mongolia",
      de: "Mongolei",
      pl: "Mongolia",
      fr: "Mongolie",
      nl: "Mongolië",
      pt: "Mongólia",
      cs: "Mongolsko",
      ro: "Mongolia",
      ru: "Монголия"
    },
    rootIddCode: "+976",
    continent: "Asia"
  },
  MO: {
    i18nNames: {
      en: "Macau",
      it: "Macao",
      es: "Macao",
      de: "Macau",
      pl: "Makau",
      fr: "Macao",
      nl: "Macau",
      pt: "Macau",
      cs: "Macao",
      ro: "Macao",
      ru: "Макао"
    },
    rootIddCode: "+853",
    continent: "Asia"
  },
  MP: {
    i18nNames: {
      en: "Northern Mariana Islands",
      es: "Islas Marianas del Norte",
      it: "Isole Marianne Settentrionali",
      de: "Nördliche Marianen",
      pl: "Mariany Północne",
      fr: "Îles Mariannes du Nord",
      nl: "Noordelijke Marianen",
      pt: "Ilhas Marianas do Norte",
      cs: "Severní Mariany",
      ro: "Insulele Mariane de Nord",
      ru: "Северные Марианские острова"
    },
    rootIddCode: "+1670",
    continent: "NorthAmerica"
  },
  MQ: {
    i18nNames: {
      en: "Martinique",
      it: "Martinica",
      es: "Martinica",
      de: "Martinique",
      pl: "Martynika",
      fr: "Martinique",
      nl: "Martinique",
      pt: "Martinica",
      cs: "Martinik",
      ro: "Martinica",
      ru: "Мартиника"
    },
    rootIddCode: "+596",
    continent: "NorthAmerica"
  },
  MR: {
    i18nNames: {
      en: "Mauritania",
      it: "Mauritania",
      es: "Mauritania",
      de: "Mauretanien",
      pl: "Mauretania",
      fr: "Mauritanie",
      nl: "Mauritanië",
      pt: "Mauritânia",
      cs: "Mauritánie",
      ro: "Mauritania",
      ru: "Мавритания"
    },
    rootIddCode: "+222",
    continent: "Africa"
  },
  MS: {
    i18nNames: {
      en: "Montserrat",
      it: "Montserrat",
      es: "Montserrat",
      de: "Montserrat",
      pl: "Montserrat",
      fr: "Montserrat",
      nl: "Montserrat",
      pt: "Montserrat",
      cs: "Montserrat",
      ro: "Montserrat",
      ru: "Монтсеррат"
    },
    rootIddCode: "+1664",
    continent: "NorthAmerica"
  },
  MT: {
    i18nNames: {
      en: "Malta",
      it: "Malta",
      es: "Malta",
      de: "Malta",
      pl: "Malta",
      fr: "Malte",
      nl: "Malta",
      pt: "Malta",
      cs: "Malta",
      ro: "Malta",
      ru: "Мальта"
    },
    rootIddCode: "+356",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^MT\\d{8}$",
    taxIdExample: "MT12345678"
  },
  MU: {
    i18nNames: {
      en: "Mauritius",
      it: "Mauritius",
      es: "Mauricio",
      de: "Mauritius",
      pl: "Mauritius",
      fr: "Île Maurice",
      nl: "Mauritius",
      pt: "Maurício",
      cs: "Mauricius",
      ro: "Mauritius",
      ru: "Маврикий"
    },
    rootIddCode: "+230",
    continent: "Africa"
  },
  MV: {
    i18nNames: {
      en: "Maldives",
      it: "Maldive",
      es: "Maldivas",
      de: "Malediven",
      pl: "Malediwy",
      fr: "Maldives",
      nl: "Maldiven",
      pt: "Maldivas",
      cs: "Maledivy",
      ro: "Maldive",
      ru: "Мальдивы"
    },
    rootIddCode: "+960",
    continent: "Asia"
  },
  MW: {
    i18nNames: {
      en: "Malawi",
      it: "Malawi",
      es: "Malaui",
      de: "Malawi",
      pl: "Malawi",
      fr: "Malawi",
      nl: "Malawi",
      pt: "Maláui",
      cs: "Malawi",
      ro: "Malawi",
      ru: "Малави"
    },
    rootIddCode: "+265",
    continent: "Africa"
  },
  MX: {
    i18nNames: {
      en: "Mexico",
      it: "Messico",
      es: "México",
      de: "Mexiko",
      pl: "Meksyk",
      fr: "Mexique",
      nl: "Mexico",
      pt: "México",
      cs: "Mexiko",
      ro: "Mexic",
      ru: "Мексика"
    },
    rootIddCode: "+52",
    continent: "NorthAmerica"
  },
  MY: {
    i18nNames: {
      en: "Malaysia",
      it: "Malesia",
      es: "Malasia",
      de: "Malaysia",
      pl: "Malezja",
      fr: "Malaisie",
      nl: "Maleisië",
      pt: "Malásia",
      cs: "Malajsie",
      ro: "Malaezia",
      ru: "Малайзия"
    },
    rootIddCode: "+60",
    continent: "Asia"
  },
  MZ: {
    i18nNames: {
      en: "Mozambique",
      it: "Mozambico",
      es: "Mozambique",
      de: "Mosambik",
      pl: "Mozambik",
      fr: "Mozambique",
      nl: "Mozambique",
      pt: "Moçambique",
      cs: "Mosambik",
      ro: "Mozambic",
      ru: "Мозамбик"
    },
    rootIddCode: "+258",
    continent: "Africa"
  },
  NA: {
    i18nNames: {
      en: "Namibia",
      it: "Namibia",
      es: "Namibia",
      de: "Namibia",
      pl: "Namibia",
      fr: "Namibie",
      nl: "Namibië",
      pt: "Namíbia",
      cs: "Namibie",
      ro: "Namibia",
      ru: "Намибия"
    },
    rootIddCode: "+264",
    continent: "Africa"
  },
  NC: {
    i18nNames: {
      en: "New Caledonia",
      it: "Nuova Caledonia",
      es: "Nueva Caledonia",
      de: "Neukaledonien",
      pl: "Nowa Kaledonia",
      fr: "Nouvelle-Calédonie",
      nl: "Nieuw-Caledonië",
      pt: "Nova Caledônia",
      cs: "Nová Kaledonie",
      ro: "Noua Caledonie",
      ru: "Новая Каледония"
    },
    rootIddCode: "+687",
    continent: "Oceania"
  },
  NE: {
    i18nNames: {
      en: "Niger",
      it: "Niger",
      es: "Níger",
      de: "Niger",
      pl: "Niger",
      fr: "Niger",
      nl: "Niger",
      pt: "Níger",
      cs: "Niger",
      ro: "Niger",
      ru: "Нигер"
    },
    rootIddCode: "+227",
    continent: "Africa"
  },
  NF: {
    i18nNames: {
      en: "Norfolk Island",
      it: "Isola Norfolk",
      es: "Isla Norfolk",
      de: "Norfolkinsel",
      pl: "Wyspa Norfolk",
      fr: "Île Norfolk",
      nl: "Norfolkeiland",
      pt: "Ilha Norfolk",
      cs: "Ostrov Norfolk",
      ro: "Insula Norfolk",
      ru: "Остров Норфолк"
    },
    rootIddCode: "+672",
    continent: "Oceania"
  },
  NG: {
    i18nNames: {
      en: "Nigeria",
      it: "Nigeria",
      es: "Nigeria",
      de: "Nigeria",
      pl: "Nigeria",
      fr: "Nigeria",
      nl: "Nigeria",
      pt: "Nigéria",
      cs: "Nigérie",
      ro: "Nigeria",
      ru: "Нигерия"
    },
    rootIddCode: "+234",
    continent: "Africa"
  },
  NI: {
    i18nNames: {
      en: "Nicaragua",
      it: "Nicaragua",
      es: "Nicaragua",
      de: "Nicaragua",
      pl: "Nikaragua",
      fr: "Nicaragua",
      nl: "Nicaragua",
      pt: "Nicarágua",
      cs: "Nikaragua",
      ro: "Nicaragua",
      ru: "Никарагуа"
    },
    rootIddCode: "+505",
    continent: "NorthAmerica"
  },
  NL: {
    i18nNames: {
      en: "Netherlands",
      it: "Paesi Bassi",
      es: "Países Bajos",
      de: "Niederlande",
      pl: "Holandia",
      fr: "Pays-Bas",
      nl: "Nederland",
      pt: "Países Baixos",
      cs: "Nizozemsko",
      ro: "Țările de Jos",
      ru: "Нидерланды"
    },
    rootIddCode: "+31",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !1,
    taxIdPattern: "^NL\\d{9}B\\d{2}$",
    taxIdExample: "NL123456789B01"
  },
  NO: {
    i18nNames: {
      en: "Norway",
      it: "Norvegia",
      es: "Noruega",
      de: "Norwegen",
      pl: "Norwegia",
      fr: "Norvège",
      nl: "Noorwegen",
      pt: "Noruega",
      cs: "Norsko",
      ro: "Norvegia",
      ru: "Норвегия"
    },
    rootIddCode: "+47",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^NO\\d{9}MVA$",
    taxIdExample: "NO123456789MVA"
  },
  NP: {
    i18nNames: {
      en: "Nepal",
      it: "Nepal",
      es: "Nepal",
      de: "Nepal",
      pl: "Nepal",
      fr: "Népal",
      nl: "Nepal",
      pt: "Nepal",
      cs: "Nepál",
      ro: "Nepal",
      ru: "Непал"
    },
    rootIddCode: "+977",
    continent: "Asia"
  },
  NR: {
    i18nNames: {
      en: "Nauru",
      it: "Nauru",
      es: "Nauru",
      de: "Nauru",
      pl: "Nauru",
      fr: "Nauru",
      nl: "Nauru",
      pt: "Nauru",
      cs: "Nauru",
      ro: "Nauru",
      ru: "Науру"
    },
    rootIddCode: "+674",
    continent: "Oceania"
  },
  NU: {
    i18nNames: {
      en: "Niue",
      it: "Niue",
      es: "Niue",
      de: "Niue",
      pl: "Niue",
      fr: "Niue",
      nl: "Niue",
      pt: "Niue",
      cs: "Niue",
      ro: "Niue",
      ru: "Ниуэ"
    },
    rootIddCode: "+683",
    continent: "Oceania"
  },
  NZ: {
    i18nNames: {
      en: "New Zealand",
      it: "Nuova Zelanda",
      es: "Nueva Zelanda",
      de: "Neuseeland",
      pl: "Nowa Zelandia",
      fr: "Nouvelle-Zélande",
      nl: "Nieuw-Zeeland",
      pt: "Nova Zelândia",
      cs: "Nový Zéland",
      ro: "Noua Zeelandă",
      ru: "Новая Зеландия"
    },
    rootIddCode: "+64",
    continent: "Oceania"
  },
  OM: {
    i18nNames: {
      en: "Oman",
      it: "Oman",
      es: "Omán",
      de: "Oman",
      pl: "Oman",
      fr: "Oman",
      nl: "Oman",
      pt: "Omã",
      cs: "Omán",
      ro: "Oman",
      ru: "Оман"
    },
    rootIddCode: "+968",
    continent: "Asia",
    taxIdMandatory: !0,
    taxIdPattern: "^OM\\d{10}$",
    taxIdExample: "OM1234567890"
  },
  PA: {
    i18nNames: {
      en: "Panama",
      it: "Panama",
      es: "Panamá",
      de: "Panama",
      pl: "Panama",
      fr: "Panama",
      nl: "Panama",
      pt: "Panamá",
      cs: "Panama",
      ro: "Panama",
      ru: "Панама"
    },
    rootIddCode: "+507",
    continent: "NorthAmerica"
  },
  PE: {
    i18nNames: {
      en: "Peru",
      it: "Perù",
      es: "Perú",
      de: "Peru",
      pl: "Peru",
      fr: "Pérou",
      nl: "Peru",
      pt: "Peru",
      cs: "Peru",
      ro: "Peru",
      ru: "Перу"
    },
    rootIddCode: "+51",
    continent: "SouthAmerica"
  },
  PF: {
    i18nNames: {
      en: "French Polynesia",
      es: "Polinesia Francesa",
      it: "Polinesia Francese",
      de: "Französisch-Polynesien",
      pl: "Polinezja Francuska",
      fr: "Polynésie française",
      nl: "Frans-Polynesië",
      pt: "Polinésia Francesa",
      cs: "Francouzská Polynésie",
      ro: "Polinezia Franceză",
      ru: "Французская Полинезия"
    },
    rootIddCode: "+689",
    continent: "Oceania"
  },
  PG: {
    i18nNames: {
      en: "Papua New Guinea",
      es: "Papúa Nueva Guinea",
      it: "Papua Nuova Guinea",
      de: "Papua-Neuguinea",
      pl: "Papua-Nowa Gwinea",
      fr: "Papouasie-Nouvelle-Guinée",
      nl: "Papoea-Nieuw-Guinea",
      pt: "Papua-Nova Guiné",
      cs: "Papua-Nová Guinea",
      ro: "Papua Noua Guinee",
      ru: "Папуа — Новая Гвинея"
    },
    rootIddCode: "+675",
    continent: "Oceania"
  },
  PH: {
    i18nNames: {
      en: "Philippines",
      it: "Filippine",
      es: "Filipinas",
      de: "Philippinen",
      pl: "Filipiny",
      fr: "Philippines",
      nl: "Filipijnen",
      pt: "Filipinas",
      cs: "Filipíny",
      ro: "Filipine",
      ru: "Филиппины"
    },
    rootIddCode: "+63",
    continent: "Asia"
  },
  PK: {
    i18nNames: {
      en: "Pakistan",
      it: "Pakistan",
      es: "Pakistán",
      de: "Pakistan",
      pl: "Pakistan",
      fr: "Pakistan",
      nl: "Pakistan",
      pt: "Paquistão",
      cs: "Pákistán",
      ro: "Pakistan",
      ru: "Пакистан"
    },
    rootIddCode: "+92",
    continent: "Asia"
  },
  PL: {
    i18nNames: {
      en: "Poland",
      it: "Polonia",
      es: "Polonia",
      de: "Polen",
      pl: "Polska",
      fr: "Pologne",
      nl: "Polen",
      pt: "Polónia",
      cs: "Polsko",
      ro: "Polonia",
      ru: "Польша"
    },
    rootIddCode: "+48",
    continent: "Europe",
    blocMemberships: ["EU"],
    regions: Ay,
    taxIdMandatory: !0,
    taxIdPattern: "^PL\\d{10}$",
    taxIdExample: "PL1234567890"
  },
  PM: {
    i18nNames: {
      en: "Saint Pierre and Miquelon",
      es: "San Pedro y Miquelón",
      it: "Saint-Pierre e Miquelon",
      de: "Saint-Pierre und Miquelon",
      pl: "Saint-Pierre i Miquelon",
      fr: "Saint-Pierre-et-Miquelon",
      nl: "Saint-Pierre en Miquelon",
      pt: "Saint Pierre e Miquelon",
      cs: "Saint Pierre a Miquelon",
      ro: "Saint Pierre și Miquelon",
      ru: "Сен-Пьер и Микелон"
    },
    rootIddCode: "+508",
    continent: "NorthAmerica"
  },
  PN: {
    i18nNames: {
      en: "Pitcairn Islands",
      es: "Islas Pitcairn",
      it: "Isole Pitcairn",
      de: "Pitcairninseln",
      pl: "Wyspy Pitcairn",
      fr: "Îles Pitcairn",
      nl: "Pitcairneilanden",
      pt: "Ilhas Pitcairn",
      cs: "Pitcairnovy ostrovy",
      ro: "Insulele Pitcairn",
      ru: "Острова Питкэрн"
    },
    rootIddCode: "+64",
    continent: "Oceania"
  },
  PR: {
    i18nNames: {
      en: "Puerto Rico",
      it: "Porto Rico",
      es: "Puerto Rico",
      de: "Puerto Rico",
      pl: "Portoryko",
      fr: "Porto Rico",
      nl: "Puerto Rico",
      pt: "Porto Rico",
      cs: "Portoriko",
      ro: "Puerto Rico",
      ru: "Пуэрто-Рико"
    },
    rootIddCode: "+1939",
    continent: "NorthAmerica"
  },
  PS: {
    i18nNames: {
      en: "Palestine",
      it: "Palestina",
      es: "Palestina",
      de: "Palästina",
      pl: "Palestyna",
      fr: "Palestine",
      nl: "Palestina",
      pt: "Palestina",
      cs: "Palestina",
      ro: "Palestina",
      ru: "Палестина"
    },
    rootIddCode: "+970",
    continent: "Asia",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{9}$",
    taxIdExample: "123456789"
  },
  PT: {
    i18nNames: {
      en: "Portugal",
      it: "Portogallo",
      es: "Portugal",
      de: "Portugal",
      pl: "Portugalia",
      fr: "Portugal",
      nl: "Portugal",
      pt: "Portugal",
      cs: "Portugalsko",
      ro: "Portugalia",
      ru: "Португалия"
    },
    rootIddCode: "+351",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^PT\\d{9}$",
    taxIdExample: "PT123456789"
  },
  PW: {
    i18nNames: {
      en: "Palau",
      it: "Palau",
      es: "Palaos",
      de: "Palau",
      pl: "Palau",
      fr: "Palaos",
      nl: "Palau",
      pt: "Palau",
      cs: "Palau",
      ro: "Palau",
      ru: "Палау"
    },
    rootIddCode: "+680",
    continent: "Oceania"
  },
  PY: {
    i18nNames: {
      en: "Paraguay",
      it: "Paraguay",
      es: "Paraguay",
      de: "Paraguay",
      pl: "Paragwaj",
      fr: "Paraguay",
      nl: "Paraguay",
      pt: "Paraguai",
      cs: "Paraguay",
      ro: "Paraguay",
      ru: "Парагвай"
    },
    rootIddCode: "+595",
    continent: "SouthAmerica"
  },
  QA: {
    i18nNames: {
      en: "Qatar",
      it: "Qatar",
      es: "Catar",
      de: "Katar",
      pl: "Katar",
      fr: "Qatar",
      nl: "Qatar",
      pt: "Catar",
      cs: "Katar",
      ro: "Qatar",
      ru: "Катар"
    },
    rootIddCode: "+974",
    continent: "Asia"
  },
  RE: {
    i18nNames: {
      en: "Réunion",
      it: "Riunione",
      es: "Reunión",
      de: "Réunion",
      pl: "Reunion",
      fr: "Réunion",
      nl: "Réunion",
      pt: "Reunião",
      cs: "Réunion",
      ro: "Réunion",
      ru: "Реюньон"
    },
    rootIddCode: "+262",
    continent: "Africa"
  },
  RO: {
    i18nNames: {
      en: "Romania",
      it: "Romania",
      es: "Rumanía",
      de: "Rumänien",
      pl: "Rumunia",
      fr: "Roumanie",
      nl: "Roemenië",
      pt: "Romênia",
      cs: "Rumunsko",
      ro: "România",
      ru: "Румыния"
    },
    rootIddCode: "+40",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^RO\\d{2,10}$",
    taxIdExample: "RO123456"
  },
  RS: {
    i18nNames: {
      en: "Serbia",
      it: "Serbia",
      es: "Serbia",
      de: "Serbien",
      pl: "Serbia",
      fr: "Serbie",
      nl: "Servië",
      pt: "Sérvia",
      cs: "Srbsko",
      ro: "Serbia",
      ru: "Сербия"
    },
    rootIddCode: "+381",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{9}$",
    taxIdExample: "123456789"
  },
  RU: {
    i18nNames: {
      en: "Russia",
      it: "Russia",
      es: "Rusia",
      de: "Russland",
      pl: "Rosja",
      fr: "Russie",
      nl: "Rusland",
      pt: "Rússia",
      cs: "Rusko",
      ro: "Rusia",
      ru: "Россия"
    },
    rootIddCode: "+79",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{10}$",
    taxIdExample: "1234567890"
  },
  RW: {
    i18nNames: {
      en: "Rwanda",
      it: "Ruanda",
      es: "Ruanda",
      de: "Ruanda",
      pl: "Rwanda",
      fr: "Rwanda",
      nl: "Rwanda",
      pt: "Ruanda",
      cs: "Rwanda",
      ro: "Rwanda",
      ru: "Руанда"
    },
    rootIddCode: "+250",
    continent: "Africa"
  },
  SA: {
    i18nNames: {
      en: "Saudi Arabia",
      it: "Arabia Saudita",
      es: "Arabia Saudita",
      de: "Saudi-Arabien",
      pl: "Arabia Saudyjska",
      fr: "Arabie Saoudite",
      nl: "Saoedi-Arabië",
      pt: "Arábia Saudita",
      cs: "Saúdská Arábie",
      ro: "Arabia Saudită",
      ru: "Саудовская Аравия"
    },
    rootIddCode: "+966",
    continent: "Asia",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{15}$",
    taxIdExample: "123456789012345"
  },
  BA: {
    i18nNames: {
      en: "Bosnia and Herzegovina",
      es: "Bosnia y Herzegovina",
      it: "Bosnia ed Erzegovina",
      de: "Bosnien und Herzegовина",
      pl: "Bośnia i Hercegowina",
      fr: "Bosnie-Herzégovine",
      nl: "Bosnië en Herzegovina",
      pt: "Bósnia e Herzegovina",
      cs: "Bosna a Hercegovina",
      ro: "Bosnia și Herțegovina",
      ru: "Босния и Герцеговина"
    },
    rootIddCode: "+387",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^(\\d{12}|\\d{13})$",
    taxIdExample: "123456789012"
  },
  SB: {
    i18nNames: {
      en: "Solomon Islands",
      it: "Isole Salomone",
      es: "Islas Salomón",
      de: "Salomonen",
      pl: "Wyspy Salomona",
      fr: "Îles Salomon",
      nl: "Salomonseilanden",
      pt: "Ilhas Salomão",
      cs: "Šalamounovy ostrovy",
      ro: "Insulele Solomon",
      ru: "Соломоновы Острова"
    },
    rootIddCode: "+677",
    continent: "Oceania"
  },
  SC: {
    i18nNames: {
      en: "Seychelles",
      it: "Seychelles",
      es: "Seychelles",
      de: "Seychellen",
      pl: "Seszele",
      fr: "Seychelles",
      nl: "Seychellen",
      pt: "Seicheles",
      cs: "Seychely",
      ro: "Seychelles",
      ru: "Сейшельские Острова"
    },
    rootIddCode: "+248",
    continent: "Africa"
  },
  SD: {
    i18nNames: {
      en: "Sudan",
      it: "Sudan",
      es: "Sudán",
      de: "Sudan",
      pl: "Sudan",
      fr: "Soudan",
      nl: "Soedan",
      pt: "Sudão",
      cs: "Súdán",
      ro: "Sudan",
      ru: "Судан"
    },
    rootIddCode: "+249",
    continent: "Africa",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{12}$",
    taxIdExample: "123456789012"
  },
  SE: {
    i18nNames: {
      en: "Sweden",
      it: "Svezia",
      es: "Suecia",
      de: "Schweden",
      pl: "Szwecja",
      fr: "Suède",
      nl: "Zweden",
      pt: "Suécia",
      cs: "Švédsko",
      ro: "Suedia",
      ru: "Швеция"
    },
    rootIddCode: "+46",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^SE\\d{12}$",
    taxIdExample: "SE123456789012"
  },
  SG: {
    i18nNames: {
      en: "Singapore",
      it: "Singapore",
      es: "Singapur",
      de: "Singapur",
      pl: "Singapur",
      fr: "Singapour",
      nl: "Singapore",
      pt: "Singapura",
      cs: "Singapur",
      ro: "Singapore",
      ru: "Сингапур"
    },
    rootIddCode: "+65",
    continent: "Asia"
    //quando verrà mappata aggiungere taxIdMandatory: false, in quanto non obbligatorio
  },
  SH: {
    i18nNames: {
      en: "Saint Helena, Ascension and Tristan da Cunha",
      es: "Santa Elena",
      it: "Sant'Elena, Ascensione e Tristan da Cunha",
      de: "Sankt Helena, Ascension und Tristan da Cunha",
      pl: "Wyspa Świętej Heleny, Wniebowstąpienia i Tristan da Cunha",
      fr: "Sainte-Hélène, Ascension et Tristan da Cunha",
      nl: "Sint-Helena, Ascension en Tristan da Cunha",
      pt: "Santa Helena, Ascensão e Tristão da Cunha",
      cs: "Svatá Helena, Ascension a Tristan da Cunha",
      ro: "Sfânta Elena, Ascension și Tristan da Cunha",
      ru: "Остров Святой Елены, Вознесения и Тристан-да-Кунья"
    },
    rootIddCode: "+247",
    continent: "Africa"
  },
  SI: {
    i18nNames: {
      en: "Slovenia",
      it: "Slovenia",
      es: "Eslovenia",
      de: "Slowenien",
      pl: "Słowenia",
      fr: "Slovénie",
      nl: "Slovenië",
      pt: "Eslovênia",
      cs: "Slovinsko",
      ro: "Slovenia",
      ru: "Словения"
    },
    rootIddCode: "+386",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^SI\\d{8}$",
    taxIdExample: "SI12345678"
  },
  SJ: {
    i18nNames: {
      en: "Svalbard and Jan Mayen",
      es: "Svalbard y Jan Mayen",
      it: "Svalbard e Jan Mayen",
      de: "Svalbard und Jan Mayen",
      pl: "Svalbard i Jan Mayen",
      fr: "Svalbard et Jan Mayen",
      nl: "Spitsbergen en Jan Mayen",
      pt: "Svalbard e Jan Mayen",
      cs: "Špicberky a Jan Mayen",
      ro: "Svalbard și Jan Mayen",
      ru: "Шпицберген и Ян-Майен"
    },
    rootIddCode: "+4779",
    continent: "Europe"
  },
  SK: {
    i18nNames: {
      en: "Slovakia",
      it: "Slovacchia",
      es: "Eslovaquia",
      de: "Slowakei",
      pl: "Słowacja",
      fr: "Slovaquie",
      nl: "Slowakije",
      pt: "Eslováquia",
      cs: "Slovensko",
      ro: "Slovacia",
      ru: "Словакия"
    },
    rootIddCode: "+421",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^SK\\d{10}$",
    taxIdExample: "SK1234567890"
  },
  SL: {
    i18nNames: {
      en: "Sierra Leone",
      it: "Sierra Leone",
      es: "Sierra Leona",
      de: "Sierra Leone",
      pl: "Sierra Leone",
      fr: "Sierra Leone",
      nl: "Sierra Leone",
      pt: "Serra Leoa",
      cs: "Sierra Leone",
      ro: "Sierra Leone",
      ru: "Сьерра-Леоне"
    },
    rootIddCode: "+232",
    continent: "Africa"
  },
  SM: {
    i18nNames: {
      en: "San Marino",
      it: "San Marino",
      es: "San Marino",
      de: "San Marino",
      pl: "San Marino",
      fr: "Saint-Marin",
      nl: "San Marino",
      pt: "San Marino",
      cs: "San Marino",
      ro: "San Marino",
      ru: "Сан-Марино"
    },
    rootIddCode: "+378",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^SM\\d{5}$",
    taxIdExample: "SM12345"
  },
  SN: {
    i18nNames: {
      en: "Senegal",
      it: "Senegal",
      es: "Senegal",
      de: "Senegal",
      pl: "Senegal",
      fr: "Sénégal",
      nl: "Senegal",
      pt: "Senegal",
      cs: "Senegal",
      ro: "Senegal",
      ru: "Сенегал"
    },
    rootIddCode: "+221",
    continent: "Africa"
  },
  SO: {
    i18nNames: {
      en: "Somalia",
      it: "Somalia",
      es: "Somalia",
      de: "Somalia",
      pl: "Somalia",
      fr: "Somalie",
      nl: "Somalië",
      pt: "Somália",
      cs: "Somálsko",
      ro: "Somalia",
      ru: "Сомали"
    },
    rootIddCode: "+252",
    continent: "Africa"
  },
  SR: {
    i18nNames: {
      en: "Suriname",
      it: "Suriname",
      es: "Surinam",
      de: "Suriname",
      pl: "Surinam",
      fr: "Suriname",
      nl: "Suriname",
      pt: "Suriname",
      cs: "Surinam",
      ro: "Surinam",
      ru: "Суринам"
    },
    rootIddCode: "+597",
    continent: "SouthAmerica"
  },
  SS: {
    i18nNames: {
      en: "South Sudan",
      it: "Sudan del sud",
      es: "Sudán del Sur",
      de: "Südsudan",
      pl: "Sudan Południowy",
      fr: "Soudan du Sud",
      nl: "Zuid-Soedan",
      pt: "Sudão do Sul",
      cs: "Jižní Súdán",
      ro: "Sudanul de Sud",
      ru: "Южный Судан"
    },
    rootIddCode: "+211",
    continent: "Africa"
  },
  ST: {
    i18nNames: {
      en: "São Tomé and Príncipe",
      es: "Santo Tomé y Príncipe",
      it: "São Tomé e Príncipe",
      de: "São Tomé und Príncipe",
      pl: "Wyspy Świętego Tomasza i Książęca",
      fr: "Sao Tomé-et-Principe",
      nl: "Sao Tomé en Principe",
      pt: "São Tomé e Príncipe",
      cs: "Svatý Tomáš a Princův ostrov",
      ro: "São Tomé și Príncipe",
      ru: "Сан-Томе и Принсипи"
    },
    rootIddCode: "+239",
    continent: "Africa"
  },
  SV: {
    i18nNames: {
      en: "El Salvador",
      it: "El Salvador",
      es: "El Salvador",
      de: "El Salvador",
      pl: "Salwador",
      fr: "Le Salvador",
      nl: "El Salvador",
      pt: "El Salvador",
      cs: "Salvador",
      ro: "El Salvador",
      ru: "Сальвадор"
    },
    rootIddCode: "+503",
    continent: "NorthAmerica"
  },
  SX: {
    i18nNames: {
      en: "Sint Maarten",
      it: "Sint Maarten",
      es: "San Martín (parte neerlandesa)",
      de: "Sint Maarten",
      pl: "Sint Maarten",
      fr: "Saint-Martin (partie néerlandaise)",
      nl: "Sint Maarten",
      pt: "Sint Maarten",
      cs: "Svatý Martin (nizozemská část)",
      ro: "Sint Maarten",
      ru: "Синт-Мартен"
    },
    rootIddCode: "+1721",
    continent: "NorthAmerica"
  },
  SY: {
    i18nNames: {
      en: "Syria",
      it: "Siria",
      es: "Siria",
      de: "Сирия",
      pl: "Syria",
      fr: "Syrie",
      nl: "Syrië",
      pt: "Síria",
      cs: "Sýrie",
      ro: "Siria",
      ru: "Сирия"
    },
    rootIddCode: "+963",
    continent: "Asia"
  },
  SZ: {
    i18nNames: {
      en: "Eswatini",
      it: "Swaziland",
      es: "Suazilandia",
      de: "Eswatini",
      pl: "Eswatini",
      fr: "Eswatini",
      nl: "Eswatini",
      pt: "Essuatíni",
      cs: "Eswatini",
      ro: "Eswatini",
      ru: "Эсватини"
    },
    rootIddCode: "+268",
    continent: "Africa"
  },
  TC: {
    i18nNames: {
      en: "Turks and Caicos Islands",
      es: "Islas Turcas y Caicos",
      it: "Isole Turks e Caicos",
      de: "Turks- und Caicosinseln",
      pl: "Turks i Caicos",
      fr: "Îles Turques-et-Caïques",
      nl: "Turks- en Caicoseilanden",
      pt: "Ilhas Turcas e Caicos",
      cs: "Ostrovy Turks a Caicos",
      ro: "Insulele Turks și Caicos",
      ru: "Теркс и Кайкос"
    },
    rootIddCode: "+1649",
    continent: "NorthAmerica"
  },
  TD: {
    i18nNames: {
      en: "Chad",
      it: "Ciad",
      es: "Chad",
      de: "Tschad",
      pl: "Czad",
      fr: "Tchad",
      nl: "Tsjaad",
      pt: "Chade",
      cs: "Čад",
      ro: "Ciad",
      ru: "Чад"
    },
    rootIddCode: "+235",
    continent: "Africa"
  },
  TF: {
    i18nNames: {
      en: "French Southern and Antarctic Lands",
      es: "Territorios Australes Franceses",
      it: "Territori Francesi del Sud",
      de: "Französische Süd- und Antarktisgebiete",
      pl: "Francuskie Terytoria Południowe i Antarktyczne",
      fr: "Terres australes et antarctiques françaises",
      nl: "Franse Zuidelijke en Antarctische Gebieden",
      pt: "Terras Austrais e Antárticas Francesas",
      cs: "Francouzská jižní a antarktická území",
      ro: "Teritoriile Australe și Antarctice Franceze",
      ru: "Французские южные и антарктические территории"
    },
    rootIddCode: "+262",
    continent: "Oceania"
  },
  TG: {
    i18nNames: {
      en: "Togo",
      it: "Togo",
      es: "Togo",
      de: "Togo",
      pl: "Togo",
      fr: "Togo",
      nl: "Togo",
      pt: "Togo",
      cs: "Togo",
      ro: "Togo",
      ru: "Того"
    },
    rootIddCode: "+228",
    continent: "Africa"
  },
  TH: {
    i18nNames: {
      en: "Thailand",
      it: "Tailandia",
      es: "Tailandia",
      de: "Thailand",
      pl: "Tajlandia",
      fr: "Thaïlande",
      nl: "Thailand",
      pt: "Tailândia",
      cs: "Thajsko",
      ro: "Thailanda",
      ru: "Таиланд"
    },
    rootIddCode: "+66",
    continent: "Asia"
  },
  TJ: {
    i18nNames: {
      en: "Tajikistan",
      it: "Tagikistan",
      es: "Tayikistán",
      de: "Tadschikistan",
      pl: "Tadżykistan",
      fr: "Tadjikistan",
      nl: "Tadzjikistan",
      pt: "Tajiquistão",
      cs: "Tádžikistán",
      ro: "Tadjikistan",
      ru: "Таджикистан"
    },
    rootIddCode: "+992",
    continent: "Asia"
  },
  TK: {
    i18nNames: {
      en: "Tokelau",
      it: "Isole Tokelau",
      es: "Tokelau",
      de: "Tokelau",
      pl: "Tokelau",
      fr: "Tokelau",
      nl: "Tokelau",
      pt: "Tokelau",
      cs: "Tokelau",
      ro: "Tokelau",
      ru: "Токелау"
    },
    rootIddCode: "+690",
    continent: "Oceania"
  },
  TL: {
    i18nNames: {
      en: "Timor-Leste",
      it: "Timor Est",
      es: "Timor-Leste",
      de: "Osttimor",
      pl: "Timor Wschodni",
      fr: "Timor oriental",
      nl: "Oost-Timor",
      pt: "Timor-Leste",
      cs: "Východní Timor",
      ro: "Timorul de Est",
      ru: "Восточный Тимор"
    },
    rootIddCode: "+670",
    continent: "Asia"
  },
  TM: {
    i18nNames: {
      en: "Turkmenistan",
      it: "Turkmenistan",
      es: "Turkmenistán",
      de: "Turkmenistan",
      pl: "Turkmenistan",
      fr: "Turkménistan",
      nl: "Turkmenistan",
      pt: "Turquemenistão",
      cs: "Turkmenistán",
      ro: "Turkmenistan",
      ru: "Туркменистан"
    },
    rootIddCode: "+993",
    continent: "Asia"
  },
  TN: {
    i18nNames: {
      en: "Tunisia",
      it: "Tunisia",
      es: "Túnez",
      de: "Tunesien",
      pl: "Tunezja",
      fr: "Tunisie",
      nl: "Tunesië",
      pt: "Tunísia",
      cs: "Tunisko",
      ro: "Tunisia",
      ru: "Тунис"
    },
    rootIddCode: "+216",
    continent: "Africa",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{8}$",
    taxIdExample: "12345678"
  },
  TO: {
    i18nNames: {
      en: "Tonga",
      it: "Tonga",
      es: "Tonga",
      de: "Tonga",
      pl: "Tonga",
      fr: "Tonga",
      nl: "Tonga",
      pt: "Tonga",
      cs: "Tonga",
      ro: "Tonga",
      ru: "Тонга"
    },
    rootIddCode: "+676",
    continent: "Oceania"
  },
  TR: {
    i18nNames: {
      en: "Turkey",
      it: "Turchia",
      es: "Turquía",
      de: "Türkei",
      pl: "Turcja",
      fr: "Turquie",
      nl: "Turkije",
      pt: "Turquia",
      cs: "Turecko",
      ro: "Turcia",
      ru: "Турция"
    },
    rootIddCode: "+90",
    continent: "Europe"
  },
  TT: {
    i18nNames: {
      en: "Trinidad and Tobago",
      es: "Trinidad y Tobago",
      it: "Trinidad e Tobago",
      de: "Trinidad und Tobago",
      pl: "Trynidad i Tobago",
      fr: "Trinité-et-Tobago",
      nl: "Trinidad en Tobago",
      pt: "Trinidad e Tobago",
      cs: "Trinidad a Tobago",
      ro: "Trinidad și Tobago",
      ru: "Тринидад и Тобаго"
    },
    rootIddCode: "+1868",
    continent: "NorthAmerica"
  },
  TV: {
    i18nNames: {
      en: "Tuvalu",
      it: "Tuvalu",
      es: "Tuvalu",
      de: "Tuvalu",
      pl: "Tuvalu",
      fr: "Tuvalu",
      nl: "Tuvalu",
      pt: "Tuvalu",
      cs: "Tuvalu",
      ro: "Tuvalu",
      ru: "Тувалу"
    },
    rootIddCode: "+688",
    continent: "Oceania"
  },
  TW: {
    i18nNames: {
      en: "Taiwan",
      it: "Taiwan",
      es: "Taiwán",
      de: "Taiwan",
      pl: "Tajwan",
      fr: "Taïwan",
      nl: "Taiwan",
      pt: "Taiwan",
      cs: "Tchaj-wan",
      ro: "Taiwan",
      ru: "Тайвань"
    },
    rootIddCode: "+886",
    continent: "Asia"
  },
  TZ: {
    i18nNames: {
      en: "Tanzania",
      it: "Tanzania",
      es: "Tanzania",
      de: "Tansania",
      pl: "Tanzania",
      fr: "Tanzanie",
      nl: "Tanzania",
      pt: "Tanzânia",
      cs: "Tanzanie",
      ro: "Tanzania",
      ru: "Танзания"
    },
    rootIddCode: "+255",
    continent: "Africa"
  },
  UA: {
    i18nNames: {
      en: "Ukraine",
      it: "Ucraina",
      es: "Ucrania",
      de: "Ukraine",
      pl: "Ukraina",
      fr: "Ukraine",
      nl: "Oekraïne",
      pt: "Ucrânia",
      cs: "Ukrajina",
      ro: "Ucraina",
      ru: "Украина"
    },
    rootIddCode: "+380",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^(\\d{8}|\\d{12})$",
    taxIdExample: "12345678"
  },
  UG: {
    i18nNames: {
      en: "Uganda",
      it: "Uganda",
      es: "Uganda",
      de: "Uganda",
      pl: "Uganda",
      fr: "Ouganda",
      nl: "Oeganda",
      pt: "Uganda",
      cs: "Uganda",
      ro: "Uganda",
      ru: "Уганда"
    },
    rootIddCode: "+256",
    continent: "Africa"
  },
  UM: {
    i18nNames: {
      en: "United States Minor Outlying Islands",
      es: "Islas menores alejadas de los Estados Unidos",
      it: "Isole minori esterne degli Stati Uniti d'America",
      de: "Kleinere Inselbesitzungen der Vereinigten Staaten",
      pl: "Dalekie Wyspy Mniejsze Stanów Zjednoczonych",
      fr: "Îles mineures éloignées des États-Unis",
      nl: "Kleine afgelegen eilanden van de Verenigde Staten",
      pt: "Ilhas Menores Distantes dos EUA",
      cs: "Menší odlehlé ostrovy USA",
      ro: "Insulele S.U.A. din Oceanul Pacific",
      ru: "Внешние малые острова США"
    },
    rootIddCode: "+268",
    continent: "NorthAmerica"
  },
  US: {
    i18nNames: {
      en: "United States",
      it: "Stati Uniti d'America",
      es: "Estados Unidos",
      de: "Vereinigte Staaten",
      pl: "Stany Zjednoczone",
      fr: "États-Unis",
      nl: "Verenigde Staten",
      pt: "Estados Unidos",
      cs: "Spojené státy americké",
      ro: "Statele Unite ale Americii",
      ru: "Соединённые Штаты"
    },
    rootIddCode: "+1989",
    continent: "NorthAmerica"
    //quando verrà mappata aggiungere taxIdMandatory: false, in quanto non obbligatorio
  },
  UY: {
    i18nNames: {
      en: "Uruguay",
      it: "Uruguay",
      es: "Uruguay",
      de: "Uruguay",
      pl: "Urugwaj",
      fr: "Uruguay",
      nl: "Uruguay",
      pt: "Uruguai",
      cs: "Uruguay",
      ro: "Uruguay",
      ru: "Уругвай"
    },
    rootIddCode: "+598",
    continent: "SouthAmerica"
  },
  UZ: {
    i18nNames: {
      en: "Uzbekistan",
      it: "Uzbekistan",
      es: "Uzbekistán",
      de: "Usbekistan",
      pl: "Uzbekistan",
      fr: "Ouzbékistan",
      nl: "Oezbekistan",
      pt: "Uzbequistão",
      cs: "Uzbekistán",
      ro: "Uzbekistan",
      ru: "Узбекистан"
    },
    rootIddCode: "+998",
    continent: "Asia"
  },
  VA: {
    i18nNames: {
      en: "Vatican City",
      it: "Città del Vaticano",
      es: "Ciudad del Vaticano",
      de: "Vatikanstadt",
      pl: "Watykan",
      fr: "Cité du Vatican",
      nl: "Vaticaanstad",
      pt: "Cidade do Vaticano",
      cs: "Vatikán",
      ro: "Vatican",
      ru: "Ватикан"
    },
    rootIddCode: "+379",
    continent: "Europe"
  },
  VC: {
    i18nNames: {
      en: "Saint Vincent and the Grenadines",
      es: "San Vicente y las Granadinas",
      it: "Saint Vincent e Grenadine",
      de: "St. Vincent und die Grenadinen",
      pl: "Saint Vincent i Grenadyny",
      fr: "Saint-Vincent-et-les-Grenadines",
      nl: "Saint Vincent en de Grenadines",
      pt: "São Vicente e Granadinas",
      cs: "Svatý Vincenc a Grenadiny",
      ro: "Sfântul Vincent și Grenadine",
      ru: "Сент-Винсент и Гренадины"
    },
    rootIddCode: "+1784",
    continent: "NorthAmerica"
  },
  VE: {
    i18nNames: {
      en: "Venezuela",
      it: "Venezuela",
      es: "Venezuela",
      de: "Venezuela",
      pl: "Wenezuela",
      fr: "Venezuela",
      nl: "Venezuela",
      pt: "Venezuela",
      cs: "Venezuela",
      ro: "Venezuela",
      ru: "Венесуэла"
    },
    rootIddCode: "+58",
    continent: "SouthAmerica"
  },
  VG: {
    i18nNames: {
      en: "British Virgin Islands",
      es: "Islas Vírgenes Británicas",
      it: "Isole Vergini Britanniche",
      de: "Britische Jungferninseln",
      pl: "Brytyjskie Wyspy Dziewicze",
      fr: "Îles Vierges britanniques",
      nl: "Britse Maagdeneilanden",
      pt: "Ilhas Virgens Britânicas",
      cs: "Britské Panenské ostrovy",
      ro: "Insulele Virgine Britanice",
      ru: "Британские Виргинские острова"
    },
    rootIddCode: "+1284",
    continent: "NorthAmerica"
  },
  VI: {
    i18nNames: {
      en: "United States Virgin Islands",
      es: "Islas Vírgenes de los Estados Unidos",
      it: "Isole Vergini americane",
      de: "Amerikanische Jungferninseln",
      pl: "Wyspy Dziewицze Stanów Зjednoczonych",
      fr: "Îles Vierges des États-Unis",
      nl: "Amerikaanse Maagdeneilanden",
      pt: "Ilhas Virgens dos Estados Unidos",
      cs: "Americké Panenské остроvy",
      ro: "Insulele Virgine Americane",
      ru: "Виргинские острова США"
    },
    rootIddCode: "+1340",
    continent: "NorthAmerica"
  },
  VN: {
    i18nNames: {
      en: "Vietnam",
      it: "Vietnam",
      es: "Vietnam",
      de: "Vietnam",
      pl: "Wietnam",
      fr: "Vietnam",
      nl: "Vietnam",
      pt: "Vietnã",
      cs: "Vietnam",
      ro: "Vietnam",
      ru: "Вьетнам"
    },
    rootIddCode: "+84",
    continent: "Asia"
  },
  VU: {
    i18nNames: {
      en: "Vanuatu",
      it: "Vanuatu",
      es: "Vanuatu",
      de: "Vanuatu",
      pl: "Vanuatu",
      fr: "Vanuatu",
      nl: "Vanuatu",
      pt: "Vanuatu",
      cs: "Vanuatu",
      ro: "Vanuatu",
      ru: "Вануату"
    },
    rootIddCode: "+678",
    continent: "Oceania"
  },
  WF: {
    i18nNames: {
      en: "Wallis and Futuna",
      es: "Wallis y Futuna",
      it: "Wallis e Futuna",
      de: "Wallis und Futuna",
      pl: "Wallis i Futuna",
      fr: "Wallis-et-Futuna",
      nl: "Wallis en Futuna",
      pt: "Wallis e Futuna",
      cs: "Wallis a Futuna",
      ro: "Wallis și Futuna",
      ru: "Уоллис и Футуна"
    },
    rootIddCode: "+681",
    continent: "Oceania"
  },
  WS: {
    i18nNames: {
      en: "Samoa",
      it: "Samoa",
      es: "Samoa",
      de: "Samoa",
      pl: "Samoa",
      fr: "Samoa",
      nl: "Samoa",
      pt: "Samoa",
      cs: "Samoa",
      ro: "Samoa",
      ru: "Самоа"
    },
    rootIddCode: "+685",
    continent: "Oceania"
  },
  XK: {
    i18nNames: {
      en: "Kosovo",
      it: "Kosovo",
      es: "Kosovo",
      de: "Kosovo",
      pl: "Kosowo",
      fr: "Kosovo",
      nl: "Kosovo",
      pt: "Kosovo",
      cs: "Kosovo",
      ro: "Kosovo",
      ru: "Косово"
    },
    rootIddCode: "+383",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{9}$",
    taxIdExample: "123456789"
  },
  YE: {
    i18nNames: {
      en: "Yemen",
      it: "Yemen",
      es: "Yemen",
      de: "Jemen",
      pl: "Jemen",
      fr: "Yémen",
      nl: "Jemen",
      pt: "Iémen",
      cs: "Jemen",
      ro: "Yemen",
      ru: "Йемен"
    },
    rootIddCode: "+967",
    continent: "Asia"
  },
  YT: {
    i18nNames: {
      en: "Mayotte",
      it: "Mayotte",
      es: "Mayotte",
      de: "Mayotte",
      pl: "Majotta",
      fr: "Mayotte",
      nl: "Mayotte",
      pt: "Mayotte",
      cs: "Mayotte",
      ro: "Mayotte",
      ru: "Майотта"
    },
    rootIddCode: "+262",
    continent: "Africa"
  },
  ZA: {
    i18nNames: {
      en: "South Africa",
      it: "Sud Africa",
      es: "Sudáfrica",
      de: "Südafrika",
      pl: "Republika Południowej Afryki",
      fr: "Afrique du Sud",
      nl: "Zuid-Afrika",
      pt: "África do Sul",
      cs: "Jihoafrická republika",
      ro: "Africa de Sud",
      ru: "Южная Африка"
    },
    rootIddCode: "+27",
    continent: "Africa"
  },
  ZM: {
    i18nNames: {
      en: "Zambia",
      it: "Zambia",
      es: "Zambia",
      de: "Sambia",
      pl: "Zambia",
      fr: "Zambie",
      nl: "Zambia",
      pt: "Zâmbia",
      cs: "Zambie",
      ro: "Zambia",
      ru: "Замбия"
    },
    rootIddCode: "+260",
    continent: "Africa"
  },
  ZW: {
    i18nNames: {
      en: "Zimbabwe",
      it: "Zimbabwe",
      es: "Zimbabue",
      de: "Simbabwe",
      pl: "Zimbabwe",
      fr: "Zimbabwe",
      nl: "Zimbabwe",
      pt: "Zimbábue",
      cs: "Zimbabwe",
      ro: "Zimbabwe",
      ru: "Зимбабве"
    },
    rootIddCode: "+263",
    continent: "Africa"
  }
}, iT = (o) => Zi[o].i18nNames.en;
function aT(...o) {
  const t = /* @__PURE__ */ new Set();
  for (const [r, a] of Object.entries(Zi))
    o.includes(a.continent) && t.add(r);
  return t;
}
const Cl = [
  "AD",
  "AE",
  "AF",
  "AG",
  "AI",
  "AL",
  "AM",
  "AO",
  "AQ",
  "AR",
  "AS",
  "AT",
  "AU",
  "AW",
  "AX",
  "AZ",
  "BA",
  "BB",
  "BD",
  "BE",
  "BF",
  "BG",
  "BH",
  "BI",
  "BJ",
  "BL",
  "BM",
  "BN",
  "BO",
  "BQ",
  "BR",
  "BS",
  "BT",
  "BV",
  "BW",
  "BY",
  "BZ",
  "CA",
  "CC",
  "CD",
  "CF",
  "CG",
  "CH",
  "CI",
  "CK",
  "CL",
  "CM",
  "CN",
  "CO",
  "CR",
  "CU",
  "CV",
  "CW",
  "CX",
  "CY",
  "CZ",
  "DE",
  "DJ",
  "DK",
  "DM",
  "DO",
  "DZ",
  "EC",
  "EE",
  "EG",
  "EH",
  "ER",
  "ES",
  "ET",
  "FI",
  "FJ",
  "FK",
  "FM",
  "FO",
  "FR",
  "GA",
  "GB",
  "GD",
  "GE",
  "GF",
  "GG",
  "GH",
  "GI",
  "GL",
  "GM",
  "GN",
  "GP",
  "GQ",
  "GR",
  "GS",
  "GT",
  "GU",
  "GW",
  "GY",
  "HK",
  "HM",
  "HN",
  "HR",
  "HT",
  "HU",
  "ID",
  "IE",
  "IL",
  "IM",
  "IN",
  "IO",
  "IQ",
  "IR",
  "IS",
  "IT",
  "JE",
  "JM",
  "JO",
  "JP",
  "KE",
  "KG",
  "KH",
  "KI",
  "KM",
  "KN",
  "KP",
  "KR",
  "KW",
  "KY",
  "KZ",
  "LA",
  "LB",
  "LC",
  "LI",
  "LK",
  "LR",
  "LS",
  "LT",
  "LU",
  "LV",
  "LY",
  "MA",
  "MC",
  "MD",
  "ME",
  "MF",
  "MG",
  "MH",
  "MK",
  "ML",
  "MM",
  "MN",
  "MO",
  "MP",
  "MQ",
  "MR",
  "MS",
  "MT",
  "MU",
  "MV",
  "MW",
  "MX",
  "MY",
  "MZ",
  "NA",
  "NC",
  "NE",
  "NF",
  "NG",
  "NI",
  "NL",
  "NO",
  "NP",
  "NR",
  "NU",
  "NZ",
  "OM",
  "PA",
  "PE",
  "PF",
  "PG",
  "PH",
  "PK",
  "PL",
  "PM",
  "PN",
  "PR",
  "PS",
  "PT",
  "PW",
  "PY",
  "QA",
  "RE",
  "RO",
  "RS",
  "RU",
  "RW",
  "SA",
  "SB",
  "SC",
  "SD",
  "SE",
  "SG",
  "SH",
  "SI",
  "SJ",
  "SK",
  "SL",
  "SM",
  "SN",
  "SO",
  "SR",
  "SS",
  "ST",
  "SV",
  "SX",
  "SY",
  "SZ",
  "TC",
  "TD",
  "TF",
  "TG",
  "TH",
  "TJ",
  "TK",
  "TL",
  "TM",
  "TN",
  "TO",
  "TR",
  "TT",
  "TV",
  "TW",
  "TZ",
  "UA",
  "UG",
  "UM",
  "US",
  "UY",
  "UZ",
  "VA",
  "VC",
  "VE",
  "VG",
  "VI",
  "VN",
  "VU",
  "WF",
  "WS",
  "XK",
  // Kosovo
  "YE",
  "YT",
  "ZA",
  "ZM",
  "ZW"
];
function sT(o) {
  if (yy(o) !== !0)
    throw new Error(`'${o}' is not a valid ISO 3166-1 alpha-2 Country code`);
  return o;
}
function yy(o) {
  return typeof o == "string" && Cl.includes(o);
}
const El = {
  AD: "AND",
  AE: "ARE",
  AF: "AFG",
  AG: "ATG",
  AI: "AIA",
  AL: "ALB",
  AM: "ARM",
  AO: "AGO",
  AQ: "ATA",
  AR: "ARG",
  AS: "ASM",
  AT: "AUT",
  AU: "AUS",
  AW: "ABW",
  AX: "ALA",
  AZ: "AZE",
  BB: "BRB",
  BD: "BGD",
  BE: "BEL",
  BF: "BFA",
  BG: "BGR",
  BH: "BHR",
  BI: "BDI",
  BJ: "BEN",
  BL: "BLM",
  BM: "BMU",
  BN: "BRN",
  BO: "BOL",
  BQ: "BES",
  BR: "BRA",
  BS: "BHS",
  BT: "BTN",
  BV: "BVT",
  BW: "BWA",
  BY: "BLR",
  BZ: "BLZ",
  CA: "CAN",
  CC: "CCK",
  CD: "COD",
  CF: "CAF",
  CG: "COG",
  CH: "CHE",
  CI: "CIV",
  CK: "COK",
  CL: "CHL",
  CM: "CMR",
  CN: "CHN",
  CO: "COL",
  CR: "CRI",
  CU: "CUB",
  CV: "CPV",
  CW: "CUW",
  CX: "CXR",
  CY: "CYP",
  CZ: "CZE",
  DE: "DEU",
  DJ: "DJI",
  DK: "DNK",
  DM: "DMA",
  DO: "DOM",
  DZ: "DZA",
  EC: "ECU",
  EE: "EST",
  EG: "EGY",
  EH: "ESH",
  ER: "ERI",
  ES: "ESP",
  ET: "ETH",
  FI: "FIN",
  FJ: "FJI",
  FK: "FLK",
  FM: "FSM",
  FO: "FRO",
  FR: "FRA",
  GA: "GAB",
  GB: "GBR",
  GD: "GRD",
  GE: "GEO",
  GF: "GUF",
  GG: "GGY",
  GH: "GHA",
  GI: "GIB",
  GL: "GRL",
  GM: "GMB",
  GN: "GIN",
  GP: "GLP",
  GQ: "GNQ",
  GR: "GRC",
  GS: "SGS",
  GT: "GTM",
  GU: "GUM",
  GW: "GNB",
  GY: "GUY",
  HK: "HKG",
  HM: "HMD",
  HN: "HND",
  HR: "HRV",
  HT: "HTI",
  HU: "HUN",
  ID: "IDN",
  IE: "IRL",
  IL: "ISR",
  IM: "IMN",
  IN: "IND",
  IO: "IOT",
  IQ: "IRQ",
  IR: "IRN",
  IS: "ISL",
  IT: "ITA",
  JE: "JEY",
  JM: "JAM",
  JO: "JOR",
  JP: "JPN",
  KE: "KEN",
  KG: "KGZ",
  KH: "KHM",
  KI: "KIR",
  KM: "COM",
  KN: "KNA",
  KP: "PRK",
  KR: "KOR",
  KW: "KWT",
  KY: "CYM",
  KZ: "KAZ",
  LA: "LAO",
  LB: "LBN",
  LC: "LCA",
  LI: "LIE",
  LK: "LKA",
  LR: "LBR",
  LS: "LSO",
  LT: "LTU",
  LU: "LUX",
  LV: "LVA",
  LY: "LBY",
  MA: "MAR",
  MC: "MCO",
  MD: "MDA",
  ME: "MNE",
  MF: "MAF",
  MG: "MDG",
  MH: "MHL",
  MK: "MKD",
  ML: "MLI",
  MM: "MMR",
  MN: "MNG",
  MO: "MAC",
  MP: "MNP",
  MQ: "MTQ",
  MR: "MRT",
  MS: "MSR",
  MT: "MLT",
  MU: "MUS",
  MV: "MDV",
  MW: "MWI",
  MX: "MEX",
  MY: "MYS",
  MZ: "MOZ",
  NA: "NAM",
  NC: "NCL",
  NE: "NER",
  NF: "NFK",
  NG: "NGA",
  NI: "NIC",
  NL: "NLD",
  NO: "NOR",
  NP: "NPL",
  NR: "NRU",
  NU: "NIU",
  NZ: "NZL",
  OM: "OMN",
  PA: "PAN",
  PE: "PER",
  PF: "PYF",
  PG: "PNG",
  PH: "PHL",
  PK: "PAK",
  PL: "POL",
  PM: "SPM",
  PN: "PCN",
  PR: "PRI",
  PS: "PSE",
  PT: "PRT",
  PW: "PLW",
  PY: "PRY",
  QA: "QAT",
  RE: "REU",
  RO: "ROU",
  RS: "SRB",
  RU: "RUS",
  RW: "RWA",
  SA: "SAU",
  BA: "BIH",
  SB: "SLB",
  SC: "SYC",
  SD: "SDN",
  SE: "SWE",
  SG: "SGP",
  SH: "SHN",
  SI: "SVN",
  SJ: "SJM",
  SK: "SVK",
  SL: "SLE",
  SM: "SMR",
  SN: "SEN",
  SO: "SOM",
  SR: "SUR",
  SS: "SSD",
  ST: "STP",
  SV: "SLV",
  SX: "SXM",
  SY: "SYR",
  SZ: "SWZ",
  TC: "TCA",
  TD: "TCD",
  TF: "ATF",
  TG: "TGO",
  TH: "THA",
  TJ: "TJK",
  TK: "TKL",
  TL: "TLS",
  TM: "TKM",
  TN: "TUN",
  TO: "TON",
  TR: "TUR",
  TT: "TTO",
  TV: "TUV",
  TW: "TWN",
  TZ: "TZA",
  UA: "UKR",
  UG: "UGA",
  UM: "UMI",
  US: "USA",
  UY: "URY",
  UZ: "UZB",
  VA: "VAT",
  VC: "VCT",
  VE: "VEN",
  VG: "VGB",
  VI: "VIR",
  VN: "VNM",
  VU: "VUT",
  WF: "WLF",
  WS: "WSM",
  XK: "UNK",
  YE: "YEM",
  YT: "MYT",
  ZA: "ZAF",
  ZM: "ZMB",
  ZW: "ZWE"
};
function Ty(o) {
  return typeof o == "string" && Object.values(El).includes(o);
}
function uT(o) {
  if (Ty(o) !== !0)
    throw new Error(`'${o}' is not a valid ISO 3166-1 alpha-3 Country code`);
  return o;
}
function lT(o) {
  return El[o];
}
const cT = 10 * 1024 * 1024, dT = "pdf", My = Object.fromEntries(
  Object.entries(Zi).map(([o, t]) => [
    o,
    ("regions" in t ? t.regions : []).flatMap(
      (r) => ("provinces" in r ? r.provinces : []).map((a) => a)
    )
  ])
), Iy = [
  "aa",
  "ab",
  "ae",
  "af",
  "ak",
  "am",
  "an",
  "ar",
  "as",
  "av",
  "ay",
  "az",
  "ba",
  "be",
  "bg",
  "bh",
  "bi",
  "bm",
  "bn",
  "bo",
  "br",
  "bs",
  "ca",
  "ce",
  "ch",
  "co",
  "cr",
  "cs",
  "cu",
  "cv",
  "cy",
  "da",
  "de",
  "dv",
  "dz",
  "ee",
  "el",
  "en",
  "eo",
  "es",
  "et",
  "eu",
  "fa",
  "ff",
  "fi",
  "fj",
  "fo",
  "fr",
  "fy",
  "ga",
  "gd",
  "gl",
  "gn",
  "gu",
  "gv",
  "ha",
  "he",
  "hi",
  "ho",
  "hr",
  "ht",
  "hu",
  "hy",
  "hz",
  "ia",
  "id",
  "ie",
  "ig",
  "ii",
  "ik",
  "io",
  "is",
  "it",
  "iu",
  "ja",
  "jv",
  "ka",
  "kg",
  "ki",
  "kj",
  "kk",
  "kl",
  "km",
  "kn",
  "ko",
  "kr",
  "ks",
  "ku",
  "kv",
  "kw",
  "ky",
  "la",
  "lb",
  "lg",
  "li",
  "ln",
  "lo",
  "lt",
  "lu",
  "lv",
  "mg",
  "mh",
  "mi",
  "mk",
  "ml",
  "mn",
  "mr",
  "ms",
  "mt",
  "my",
  "na",
  "nb",
  "nd",
  "ne",
  "ng",
  "nl",
  "nn",
  "no",
  "nr",
  "nv",
  "ny",
  "oc",
  "oj",
  "om",
  "or",
  "os",
  "pa",
  "pi",
  "pl",
  "ps",
  "pt",
  "qu",
  "rm",
  "rn",
  "ro",
  "ru",
  "rw",
  "sa",
  "sc",
  "sd",
  "se",
  "sg",
  "si",
  "sk",
  "sl",
  "sm",
  "sn",
  "so",
  "sq",
  "sr",
  "ss",
  "st",
  "su",
  "sv",
  "sw",
  "ta",
  "te",
  "tg",
  "th",
  "ti",
  "tk",
  "tl",
  "tn",
  "to",
  "tr",
  "ts",
  "tt",
  "tw",
  "ty",
  "ug",
  "uk",
  "ur",
  "uz",
  "ve",
  "vi",
  "vo",
  "wa",
  "wo",
  "xh",
  "yi",
  "yo",
  "za",
  "zh",
  "zu"
], Sy = vl(Iy), pT = (o) => Sy.parse(o), fT = {
  aa: "Afar",
  ab: "Abkhazian",
  ae: "Avestan",
  af: "Afrikaans",
  ak: "Akan",
  am: "Amharic",
  an: "Aragonese",
  ar: "Arabic",
  as: "Assamese",
  av: "Avaric",
  ay: "Aymara",
  az: "Azerbaijani",
  ba: "Bashkir",
  be: "Belarusian",
  bg: "Bulgarian",
  bh: "Bihari languages",
  bi: "Bislama",
  bm: "Bambara",
  bn: "Bengali",
  bo: "Tibetan",
  br: "Breton",
  bs: "Bosnian",
  ca: "Catalan",
  ce: "Chechen",
  ch: "Chamorro",
  co: "Corsican",
  cr: "Cree",
  cs: "Czech",
  cu: "Church Slavic",
  cv: "Chuvash",
  cy: "Welsh",
  da: "Danish",
  de: "German",
  dv: "Dhivehi",
  dz: "Dzongkha",
  ee: "Ewe",
  el: "Greek",
  en: "English",
  eo: "Esperanto",
  es: "Spanish",
  et: "Estonian",
  eu: "Basque",
  fa: "Persian",
  ff: "Fulah",
  fi: "Finnish",
  fj: "Fijian",
  fo: "Faroese",
  fr: "French",
  fy: "Western Frisian",
  ga: "Irish",
  gd: "Scottish Gaelic",
  gl: "Galician",
  gn: "Guarani",
  gu: "Gujarati",
  gv: "Manx",
  ha: "Hausa",
  he: "Hebrew",
  hi: "Hindi",
  ho: "Hiri Motu",
  hr: "Croatian",
  ht: "Haitian Creole",
  hu: "Hungarian",
  hy: "Armenian",
  hz: "Herero",
  ia: "Interlingua",
  id: "Indonesian",
  ie: "Interlingue",
  ig: "Igbo",
  ii: "Sichuan Yi (Nuosu)",
  ik: "Inupiaq",
  io: "Ido",
  is: "Icelandic",
  it: "Italian",
  iu: "Inuktitut",
  ja: "Japanese",
  jv: "Javanese",
  ka: "Georgian",
  kg: "Kongo",
  ki: "Kikuyu",
  kj: "Kuanyama",
  kk: "Kazakh",
  kl: "Kalaallisut",
  km: "Khmer",
  kn: "Kannada",
  ko: "Korean",
  kr: "Kanuri",
  ks: "Kashmiri",
  ku: "Kurdish",
  kv: "Komi",
  kw: "Cornish",
  ky: "Kyrgyz",
  la: "Latin",
  lb: "Luxembourgish",
  lg: "Ganda",
  li: "Limburgish",
  ln: "Lingala",
  lo: "Lao",
  lt: "Lithuanian",
  lu: "Luba-Katanga",
  lv: "Latvian",
  mg: "Malagasy",
  mh: "Marshallese",
  mi: "Māori",
  mk: "Macedonian",
  ml: "Malayalam",
  mn: "Mongolian",
  mr: "Marathi",
  ms: "Malay",
  mt: "Maltese",
  my: "Burmese",
  na: "Nauru",
  nb: "Norwegian Bokmål",
  nd: "North Ndebele",
  ne: "Nepali",
  ng: "Ndonga",
  nl: "Dutch",
  nn: "Norwegian Nynorsk",
  no: "Norwegian",
  nr: "South Ndebele",
  nv: "Navajo",
  ny: "Chichewa",
  oc: "Occitan",
  oj: "Ojibwa",
  om: "Oromo",
  or: "Odia",
  os: "Ossetian",
  pa: "Punjabi",
  pi: "Pali",
  pl: "Polish",
  ps: "Pashto",
  pt: "Portuguese",
  qu: "Quechua",
  rm: "Romansh",
  rn: "Rundi",
  ro: "Romanian",
  ru: "Russian",
  rw: "Kinyarwanda",
  sa: "Sanskrit",
  sc: "Sardinian",
  sd: "Sindhi",
  se: "Northern Sami",
  sg: "Sango",
  si: "Sinhala",
  sk: "Slovak",
  sl: "Slovenian",
  sm: "Samoan",
  sn: "Shona",
  so: "Somali",
  sq: "Albanian",
  sr: "Serbian",
  ss: "Swati",
  st: "Southern Sotho",
  su: "Sundanese",
  sv: "Swedish",
  sw: "Swahili",
  ta: "Tamil",
  te: "Telugu",
  tg: "Tajik",
  th: "Thai",
  ti: "Tigrinya",
  tk: "Turkmen",
  tl: "Tagalog",
  tn: "Tswana",
  to: "Tongan",
  tr: "Turkish",
  ts: "Tsonga",
  tt: "Tatar",
  tw: "Twi",
  ty: "Tahitian",
  ug: "Uyghur",
  uk: "Ukrainian",
  ur: "Urdu",
  uz: "Uzbek",
  ve: "Venda",
  vi: "Vietnamese",
  vo: "Volapük",
  wa: "Walloon",
  wo: "Wolof",
  xh: "Xhosa",
  yi: "Yiddish",
  yo: "Yoruba",
  za: "Zhuang",
  zh: "Chinese",
  zu: "Zulu"
}, xy = [...Cl, "EU", "EXTRA_EU"];
function vy(o) {
  return typeof o == "string" && xy.includes(o);
}
function hT(o) {
  if (vy(o) !== !0)
    throw new Error(`'${o}' is not a valid tax code origin`);
  return o;
}
const Ui = "https://145031484.fs1.hubspotusercontent-eu1.net/hubfs/145031484", mT = (o) => `${Ui}/sales/${o}.jpeg`, _T = `${Ui}/sales/fleequid-expert.webp`, bT = (o) => `${Ui}/flags/${o}.svg`, AT = "backoffice@fleequid.com", gT = "+39 0287176063", yT = {
  geocodeForward: {
    url: "https://api.mapbox.com/search/geocode/v6/forward",
    params: { types: "place,street,address" }
  }
}, Ny = {
  AD: "ca",
  AE: "ar",
  AF: "ps",
  AG: "en",
  AI: "en",
  AL: "sq",
  AM: "hy",
  AO: "pt",
  AQ: "en",
  AR: "es",
  AS: "sm",
  AT: "de",
  AU: "en",
  AW: "nl",
  AX: "sv",
  AZ: "az",
  BA: "bs",
  BB: "en",
  BD: "bn",
  BE: "fr",
  BF: "fr",
  BG: "bg",
  BH: "ar",
  BI: "rn",
  BJ: "fr",
  BL: "fr",
  BM: "en",
  BN: "ms",
  BO: "es",
  BQ: "nl",
  BR: "pt",
  BS: "en",
  BT: "dz",
  BV: "no",
  BW: "en",
  BY: "ru",
  BZ: "en",
  CA: "fr",
  CC: "en",
  CD: "fr",
  CF: "fr",
  CG: "fr",
  CH: "de",
  CI: "fr",
  CK: "en",
  CL: "es",
  CM: "fr",
  CN: "zh",
  CO: "es",
  CR: "es",
  CU: "es",
  CV: "pt",
  CW: "nl",
  CX: "en",
  CY: "el",
  CZ: "cs",
  DE: "de",
  DJ: "fr",
  DK: "da",
  DM: "en",
  DO: "es",
  DZ: "ar",
  EC: "es",
  EE: "et",
  EG: "ar",
  EH: "ar",
  ER: "ti",
  ES: "es",
  ET: "am",
  FI: "fi",
  FJ: "en",
  FK: "en",
  FM: "en",
  FO: "fo",
  FR: "fr",
  GA: "fr",
  GB: "en",
  GD: "en",
  GE: "ka",
  GF: "fr",
  GG: "en",
  GH: "en",
  GI: "en",
  GL: "kl",
  GM: "en",
  GN: "fr",
  GP: "fr",
  GQ: "es",
  GR: "el",
  GS: "en",
  GT: "es",
  GU: "en",
  GW: "pt",
  GY: "en",
  HK: "zh",
  HM: "en",
  HN: "es",
  HR: "hr",
  HT: "fr",
  HU: "hu",
  ID: "id",
  IE: "en",
  IL: "he",
  IM: "en",
  IN: "hi",
  IO: "en",
  IQ: "ar",
  IR: "fa",
  IS: "is",
  IT: "it",
  JE: "en",
  JM: "en",
  JO: "ar",
  JP: "ja",
  KE: "sw",
  KG: "ru",
  KH: "km",
  KI: "en",
  KM: "ar",
  KN: "en",
  KP: "ko",
  KR: "ko",
  KW: "ar",
  KY: "en",
  KZ: "ru",
  LA: "lo",
  LB: "ar",
  LC: "en",
  LI: "de",
  LK: "si",
  LR: "en",
  LS: "st",
  LT: "lt",
  LU: "de",
  LV: "lv",
  LY: "ar",
  MA: "ar",
  MC: "fr",
  MD: "ro",
  ME: "sr",
  MF: "fr",
  MG: "fr",
  MH: "en",
  MK: "mk",
  ML: "fr",
  MM: "my",
  MN: "mn",
  MO: "zh",
  MP: "en",
  MQ: "fr",
  MR: "ar",
  MS: "en",
  MT: "mt",
  MU: "en",
  MV: "dv",
  MW: "ny",
  MX: "es",
  MY: "ms",
  MZ: "pt",
  NA: "en",
  NC: "fr",
  NE: "fr",
  NF: "en",
  NG: "en",
  NI: "es",
  NL: "nl",
  NO: "no",
  NP: "ne",
  NR: "en",
  NU: "en",
  NZ: "en",
  OM: "ar",
  PA: "es",
  PE: "es",
  PF: "fr",
  PG: "en",
  PH: "tl",
  PK: "ur",
  PL: "pl",
  PM: "fr",
  PN: "en",
  PR: "es",
  PS: "ar",
  PT: "pt",
  PW: "en",
  PY: "es",
  QA: "ar",
  RE: "fr",
  RO: "ro",
  RS: "sr",
  RU: "ru",
  RW: "fr",
  SA: "ar",
  SB: "en",
  SC: "en",
  SD: "ar",
  SE: "sv",
  SG: "en",
  SH: "en",
  SI: "sl",
  SJ: "no",
  SK: "sk",
  SL: "en",
  SM: "it",
  SN: "fr",
  SO: "so",
  SR: "nl",
  SS: "en",
  ST: "pt",
  SV: "es",
  SX: "nl",
  SY: "ar",
  SZ: "ss",
  TC: "en",
  TD: "fr",
  TF: "fr",
  TG: "fr",
  TH: "th",
  TJ: "tg",
  TK: "en",
  TL: "pt",
  TM: "tk",
  TN: "ar",
  TO: "to",
  TR: "tr",
  TT: "en",
  TV: "en",
  TW: "zh",
  TZ: "sw",
  UA: "uk",
  UG: "en",
  UM: "en",
  US: "en",
  UY: "es",
  UZ: "uz",
  VA: "it",
  VC: "en",
  VE: "es",
  VG: "en",
  VI: "en",
  VN: "vi",
  VU: "bi",
  WF: "fr",
  WS: "sm",
  XK: "sq",
  YE: "ar",
  YT: "fr",
  ZA: "en",
  ZM: "en",
  ZW: "en"
};
function TT(o) {
  return Ny[o];
}
const MT = {
  cs: "CZ",
  de: "DE",
  en: "GB",
  es: "ES",
  fr: "FR",
  it: "IT",
  nl: "NL",
  pl: "PL",
  pt: "PT",
  ro: "RO",
  ru: "RU"
}, IT = 2, ST = 100, Bl = {
  addressNumber: xe().optional().nullable(),
  alternate: xe().optional().nullable(),
  country: xe(),
  countryCode: xe(),
  fullAddress: xe(),
  latitude: Uu(),
  longitude: Uu(),
  mapboxId: xe(),
  place: xe(),
  postcode: xe().optional().nullable(),
  region: xe(),
  streetName: xe().optional().nullable()
}, xT = or(Bl), vT = (o) => or(Bl, { error: o }), Fy = "AdminUserPasswordResetToken", NT = or({
  type: W1(Fy),
  adminUserId: xe(),
  /**
   * NB: this field is consumed by the client only, only has a presentational purposes
   */
  email: xe()
}), wy = /^\+[1-9]\d{1,14}$/, FT = (o) => /^[+]?[\s0-9]{6,}$/.test(o), kl = (o) => typeof o != "string" || (o.match(/\s/g)?.length ?? 0) > 1 ? !1 : wy.test(o.replace(/\s/g, "")), Dl = "Phone must be in E.164 format (e.g. +393331234567)", wT = () => xe().refine(kl, { message: Dl }), CT = () => xe().refine((o) => !o || kl(o), { message: Dl }).optional(), Ll = xe().min(5).brand("Tin");
function ET(o) {
  return Ll.safeParse(o).success;
}
function Cy(o) {
  const t = Ll.safeParse(o);
  if (t.success)
    return t.data;
  throw new Error(`Could not parse '${o}' as Tin: ${t.error.issues.map(({ message: r }) => r).join(", ")}`);
}
function BT(o) {
  return Cy(o.replace(/[^a-zA-Z0-9]/g, ""));
}
const kT = (o) => Math.ceil(o * 1.35962), DT = (o, ...t) => o ? t.map((r) => typeof r == "function" ? r() : r) : [];
function Ey(o) {
  return o.length > 0 && !!o[0] && typeof o[0] == "object";
}
const LT = (o) => {
  if (!o)
    return {};
  const r = Object.keys(o).map((a) => Array.isArray(o[a]) && o[a].length > 0 ? Ey(o[a]) ? o[a].map(
    (u, f) => Object.keys(u).map((p) => [`${a}[${f}][${p}]`, u[p]])
  ).flat() : [[`${a}[]`, o[a]]] : o[a] !== null && typeof o[a] == "object" && !Array.isArray(o[a]) ? Object.keys(o[a]).map((u) => [`${a}[${u}]`, o[a][u]]) : [[a, o[a]]]).flat();
  return Object.fromEntries(r);
};
var qt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, Hn = { exports: {} };
var By = Hn.exports, Vu;
function ky() {
  return Vu || (Vu = 1, (function(o, t) {
    (function() {
      var r, a = "4.18.1", u = 200, f = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", p = "Expected a function", b = "Invalid `variable` option passed into `_.template`", T = "Invalid `imports` option passed into `_.template`", v = "__lodash_hash_undefined__", w = 500, z = "__lodash_placeholder__", B = 1, R = 2, ae = 4, ee = 1, uo = 2, Ee = 1, To = 2, Be = 4, oe = 8, me = 16, oo = 32, Po = 64, lo = 128, Tn = 256, nr = 512, Zl = 30, Ul = "...", $l = 800, Kl = 16, qi = 1, ql = 2, Hl = 3, Ro = 1 / 0, Mo = 9007199254740991, Wl = 17976931348623157e292, Yn = NaN, no = 4294967295, Vl = no - 1, Jl = no >>> 1, jl = [
        ["ary", lo],
        ["bind", Ee],
        ["bindKey", To],
        ["curry", oe],
        ["curryRight", me],
        ["flip", nr],
        ["partial", oo],
        ["partialRight", Po],
        ["rearg", Tn]
      ], Yo = "[object Arguments]", Xn = "[object Array]", Yl = "[object AsyncFunction]", Mn = "[object Boolean]", In = "[object Date]", Xl = "[object DOMException]", Qn = "[object Error]", et = "[object Function]", Hi = "[object GeneratorFunction]", Ve = "[object Map]", Sn = "[object Number]", Ql = "[object Null]", co = "[object Object]", Wi = "[object Promise]", ec = "[object Proxy]", xn = "[object RegExp]", Je = "[object Set]", vn = "[object String]", ot = "[object Symbol]", oc = "[object Undefined]", Nn = "[object WeakMap]", nc = "[object WeakSet]", Fn = "[object ArrayBuffer]", Xo = "[object DataView]", tr = "[object Float32Array]", rr = "[object Float64Array]", ir = "[object Int8Array]", ar = "[object Int16Array]", sr = "[object Int32Array]", ur = "[object Uint8Array]", lr = "[object Uint8ClampedArray]", cr = "[object Uint16Array]", dr = "[object Uint32Array]", tc = /\b__p \+= '';/g, rc = /\b(__p \+=) '' \+/g, ic = /(__e\(.*?\)|\b__t\)) \+\n'';/g, Vi = /&(?:amp|lt|gt|quot|#39);/g, Ji = /[&<>"']/g, ac = RegExp(Vi.source), sc = RegExp(Ji.source), uc = /<%-([\s\S]+?)%>/g, lc = /<%([\s\S]+?)%>/g, ji = /<%=([\s\S]+?)%>/g, cc = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, dc = /^\w*$/, pc = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, pr = /[\\^$.*+?()[\]{}|]/g, fc = RegExp(pr.source), fr = /^\s+/, hc = /\s/, mc = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, _c = /\{\n\/\* \[wrapped with (.+)\] \*/, bc = /,? & /, Ac = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, Yi = /[()=,{}\[\]\/\s]/, gc = /\\(\\)?/g, yc = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, Xi = /\w*$/, Tc = /^[-+]0x[0-9a-f]+$/i, Mc = /^0b[01]+$/i, Ic = /^\[object .+?Constructor\]$/, Sc = /^0o[0-7]+$/i, xc = /^(?:0|[1-9]\d*)$/, vc = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, nt = /($^)/, Nc = /['\n\r\u2028\u2029\\]/g, tt = "\\ud800-\\udfff", Fc = "\\u0300-\\u036f", wc = "\\ufe20-\\ufe2f", Cc = "\\u20d0-\\u20ff", Qi = Fc + wc + Cc, ea = "\\u2700-\\u27bf", oa = "a-z\\xdf-\\xf6\\xf8-\\xff", Ec = "\\xac\\xb1\\xd7\\xf7", Bc = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", kc = "\\u2000-\\u206f", Dc = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", na = "A-Z\\xc0-\\xd6\\xd8-\\xde", ta = "\\ufe0e\\ufe0f", ra = Ec + Bc + kc + Dc, hr = "['’]", Lc = "[" + tt + "]", ia = "[" + ra + "]", rt = "[" + Qi + "]", aa = "\\d+", Pc = "[" + ea + "]", sa = "[" + oa + "]", ua = "[^" + tt + ra + aa + ea + oa + na + "]", mr = "\\ud83c[\\udffb-\\udfff]", Rc = "(?:" + rt + "|" + mr + ")", la = "[^" + tt + "]", _r = "(?:\\ud83c[\\udde6-\\uddff]){2}", br = "[\\ud800-\\udbff][\\udc00-\\udfff]", Qo = "[" + na + "]", ca = "\\u200d", da = "(?:" + sa + "|" + ua + ")", Oc = "(?:" + Qo + "|" + ua + ")", pa = "(?:" + hr + "(?:d|ll|m|re|s|t|ve))?", fa = "(?:" + hr + "(?:D|LL|M|RE|S|T|VE))?", ha = Rc + "?", ma = "[" + ta + "]?", zc = "(?:" + ca + "(?:" + [la, _r, br].join("|") + ")" + ma + ha + ")*", Gc = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Zc = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", _a = ma + ha + zc, Uc = "(?:" + [Pc, _r, br].join("|") + ")" + _a, $c = "(?:" + [la + rt + "?", rt, _r, br, Lc].join("|") + ")", Kc = RegExp(hr, "g"), qc = RegExp(rt, "g"), Ar = RegExp(mr + "(?=" + mr + ")|" + $c + _a, "g"), Hc = RegExp([
        Qo + "?" + sa + "+" + pa + "(?=" + [ia, Qo, "$"].join("|") + ")",
        Oc + "+" + fa + "(?=" + [ia, Qo + da, "$"].join("|") + ")",
        Qo + "?" + da + "+" + pa,
        Qo + "+" + fa,
        Zc,
        Gc,
        aa,
        Uc
      ].join("|"), "g"), Wc = RegExp("[" + ca + tt + Qi + ta + "]"), Vc = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, Jc = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
      ], jc = -1, Q = {};
      Q[tr] = Q[rr] = Q[ir] = Q[ar] = Q[sr] = Q[ur] = Q[lr] = Q[cr] = Q[dr] = !0, Q[Yo] = Q[Xn] = Q[Fn] = Q[Mn] = Q[Xo] = Q[In] = Q[Qn] = Q[et] = Q[Ve] = Q[Sn] = Q[co] = Q[xn] = Q[Je] = Q[vn] = Q[Nn] = !1;
      var X = {};
      X[Yo] = X[Xn] = X[Fn] = X[Xo] = X[Mn] = X[In] = X[tr] = X[rr] = X[ir] = X[ar] = X[sr] = X[Ve] = X[Sn] = X[co] = X[xn] = X[Je] = X[vn] = X[ot] = X[ur] = X[lr] = X[cr] = X[dr] = !0, X[Qn] = X[et] = X[Nn] = !1;
      var Yc = {
        // Latin-1 Supplement block.
        À: "A",
        Á: "A",
        Â: "A",
        Ã: "A",
        Ä: "A",
        Å: "A",
        à: "a",
        á: "a",
        â: "a",
        ã: "a",
        ä: "a",
        å: "a",
        Ç: "C",
        ç: "c",
        Ð: "D",
        ð: "d",
        È: "E",
        É: "E",
        Ê: "E",
        Ë: "E",
        è: "e",
        é: "e",
        ê: "e",
        ë: "e",
        Ì: "I",
        Í: "I",
        Î: "I",
        Ï: "I",
        ì: "i",
        í: "i",
        î: "i",
        ï: "i",
        Ñ: "N",
        ñ: "n",
        Ò: "O",
        Ó: "O",
        Ô: "O",
        Õ: "O",
        Ö: "O",
        Ø: "O",
        ò: "o",
        ó: "o",
        ô: "o",
        õ: "o",
        ö: "o",
        ø: "o",
        Ù: "U",
        Ú: "U",
        Û: "U",
        Ü: "U",
        ù: "u",
        ú: "u",
        û: "u",
        ü: "u",
        Ý: "Y",
        ý: "y",
        ÿ: "y",
        Æ: "Ae",
        æ: "ae",
        Þ: "Th",
        þ: "th",
        ß: "ss",
        // Latin Extended-A block.
        Ā: "A",
        Ă: "A",
        Ą: "A",
        ā: "a",
        ă: "a",
        ą: "a",
        Ć: "C",
        Ĉ: "C",
        Ċ: "C",
        Č: "C",
        ć: "c",
        ĉ: "c",
        ċ: "c",
        č: "c",
        Ď: "D",
        Đ: "D",
        ď: "d",
        đ: "d",
        Ē: "E",
        Ĕ: "E",
        Ė: "E",
        Ę: "E",
        Ě: "E",
        ē: "e",
        ĕ: "e",
        ė: "e",
        ę: "e",
        ě: "e",
        Ĝ: "G",
        Ğ: "G",
        Ġ: "G",
        Ģ: "G",
        ĝ: "g",
        ğ: "g",
        ġ: "g",
        ģ: "g",
        Ĥ: "H",
        Ħ: "H",
        ĥ: "h",
        ħ: "h",
        Ĩ: "I",
        Ī: "I",
        Ĭ: "I",
        Į: "I",
        İ: "I",
        ĩ: "i",
        ī: "i",
        ĭ: "i",
        į: "i",
        ı: "i",
        Ĵ: "J",
        ĵ: "j",
        Ķ: "K",
        ķ: "k",
        ĸ: "k",
        Ĺ: "L",
        Ļ: "L",
        Ľ: "L",
        Ŀ: "L",
        Ł: "L",
        ĺ: "l",
        ļ: "l",
        ľ: "l",
        ŀ: "l",
        ł: "l",
        Ń: "N",
        Ņ: "N",
        Ň: "N",
        Ŋ: "N",
        ń: "n",
        ņ: "n",
        ň: "n",
        ŋ: "n",
        Ō: "O",
        Ŏ: "O",
        Ő: "O",
        ō: "o",
        ŏ: "o",
        ő: "o",
        Ŕ: "R",
        Ŗ: "R",
        Ř: "R",
        ŕ: "r",
        ŗ: "r",
        ř: "r",
        Ś: "S",
        Ŝ: "S",
        Ş: "S",
        Š: "S",
        ś: "s",
        ŝ: "s",
        ş: "s",
        š: "s",
        Ţ: "T",
        Ť: "T",
        Ŧ: "T",
        ţ: "t",
        ť: "t",
        ŧ: "t",
        Ũ: "U",
        Ū: "U",
        Ŭ: "U",
        Ů: "U",
        Ű: "U",
        Ų: "U",
        ũ: "u",
        ū: "u",
        ŭ: "u",
        ů: "u",
        ű: "u",
        ų: "u",
        Ŵ: "W",
        ŵ: "w",
        Ŷ: "Y",
        ŷ: "y",
        Ÿ: "Y",
        Ź: "Z",
        Ż: "Z",
        Ž: "Z",
        ź: "z",
        ż: "z",
        ž: "z",
        Ĳ: "IJ",
        ĳ: "ij",
        Œ: "Oe",
        œ: "oe",
        ŉ: "'n",
        ſ: "s"
      }, Xc = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      }, Qc = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
      }, ed = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
      }, od = parseFloat, nd = parseInt, ba = typeof qt == "object" && qt && qt.Object === Object && qt, td = typeof self == "object" && self && self.Object === Object && self, _e = ba || td || Function("return this")(), gr = t && !t.nodeType && t, Oo = gr && !0 && o && !o.nodeType && o, Aa = Oo && Oo.exports === gr, yr = Aa && ba.process, Ge = (function() {
        try {
          var _ = Oo && Oo.require && Oo.require("util").types;
          return _ || yr && yr.binding && yr.binding("util");
        } catch {
        }
      })(), ga = Ge && Ge.isArrayBuffer, ya = Ge && Ge.isDate, Ta = Ge && Ge.isMap, Ma = Ge && Ge.isRegExp, Ia = Ge && Ge.isSet, Sa = Ge && Ge.isTypedArray;
      function ke(_, y, g) {
        switch (g.length) {
          case 0:
            return _.call(y);
          case 1:
            return _.call(y, g[0]);
          case 2:
            return _.call(y, g[0], g[1]);
          case 3:
            return _.call(y, g[0], g[1], g[2]);
        }
        return _.apply(y, g);
      }
      function rd(_, y, g, F) {
        for (var O = -1, W = _ == null ? 0 : _.length; ++O < W; ) {
          var pe = _[O];
          y(F, pe, g(pe), _);
        }
        return F;
      }
      function De(_, y) {
        for (var g = -1, F = _ == null ? 0 : _.length; ++g < F && y(_[g], g, _) !== !1; )
          ;
        return _;
      }
      function id(_, y) {
        for (var g = _ == null ? 0 : _.length; g-- && y(_[g], g, _) !== !1; )
          ;
        return _;
      }
      function xa(_, y) {
        for (var g = -1, F = _ == null ? 0 : _.length; ++g < F; )
          if (!y(_[g], g, _))
            return !1;
        return !0;
      }
      function Io(_, y) {
        for (var g = -1, F = _ == null ? 0 : _.length, O = 0, W = []; ++g < F; ) {
          var pe = _[g];
          y(pe, g, _) && (W[O++] = pe);
        }
        return W;
      }
      function it(_, y) {
        var g = _ == null ? 0 : _.length;
        return !!g && en(_, y, 0) > -1;
      }
      function Tr(_, y, g) {
        for (var F = -1, O = _ == null ? 0 : _.length; ++F < O; )
          if (g(y, _[F]))
            return !0;
        return !1;
      }
      function ne(_, y) {
        for (var g = -1, F = _ == null ? 0 : _.length, O = Array(F); ++g < F; )
          O[g] = y(_[g], g, _);
        return O;
      }
      function So(_, y) {
        for (var g = -1, F = y.length, O = _.length; ++g < F; )
          _[O + g] = y[g];
        return _;
      }
      function Mr(_, y, g, F) {
        var O = -1, W = _ == null ? 0 : _.length;
        for (F && W && (g = _[++O]); ++O < W; )
          g = y(g, _[O], O, _);
        return g;
      }
      function ad(_, y, g, F) {
        var O = _ == null ? 0 : _.length;
        for (F && O && (g = _[--O]); O--; )
          g = y(g, _[O], O, _);
        return g;
      }
      function Ir(_, y) {
        for (var g = -1, F = _ == null ? 0 : _.length; ++g < F; )
          if (y(_[g], g, _))
            return !0;
        return !1;
      }
      var sd = Sr("length");
      function ud(_) {
        return _.split("");
      }
      function ld(_) {
        return _.match(Ac) || [];
      }
      function va(_, y, g) {
        var F;
        return g(_, function(O, W, pe) {
          if (y(O, W, pe))
            return F = W, !1;
        }), F;
      }
      function at(_, y, g, F) {
        for (var O = _.length, W = g + (F ? 1 : -1); F ? W-- : ++W < O; )
          if (y(_[W], W, _))
            return W;
        return -1;
      }
      function en(_, y, g) {
        return y === y ? Td(_, y, g) : at(_, Na, g);
      }
      function cd(_, y, g, F) {
        for (var O = g - 1, W = _.length; ++O < W; )
          if (F(_[O], y))
            return O;
        return -1;
      }
      function Na(_) {
        return _ !== _;
      }
      function Fa(_, y) {
        var g = _ == null ? 0 : _.length;
        return g ? vr(_, y) / g : Yn;
      }
      function Sr(_) {
        return function(y) {
          return y == null ? r : y[_];
        };
      }
      function xr(_) {
        return function(y) {
          return _ == null ? r : _[y];
        };
      }
      function wa(_, y, g, F, O) {
        return O(_, function(W, pe, Y) {
          g = F ? (F = !1, W) : y(g, W, pe, Y);
        }), g;
      }
      function dd(_, y) {
        var g = _.length;
        for (_.sort(y); g--; )
          _[g] = _[g].value;
        return _;
      }
      function vr(_, y) {
        for (var g, F = -1, O = _.length; ++F < O; ) {
          var W = y(_[F]);
          W !== r && (g = g === r ? W : g + W);
        }
        return g;
      }
      function Nr(_, y) {
        for (var g = -1, F = Array(_); ++g < _; )
          F[g] = y(g);
        return F;
      }
      function pd(_, y) {
        return ne(y, function(g) {
          return [g, _[g]];
        });
      }
      function Ca(_) {
        return _ && _.slice(0, Da(_) + 1).replace(fr, "");
      }
      function Le(_) {
        return function(y) {
          return _(y);
        };
      }
      function Fr(_, y) {
        return ne(y, function(g) {
          return _[g];
        });
      }
      function wn(_, y) {
        return _.has(y);
      }
      function Ea(_, y) {
        for (var g = -1, F = _.length; ++g < F && en(y, _[g], 0) > -1; )
          ;
        return g;
      }
      function Ba(_, y) {
        for (var g = _.length; g-- && en(y, _[g], 0) > -1; )
          ;
        return g;
      }
      function fd(_, y) {
        for (var g = _.length, F = 0; g--; )
          _[g] === y && ++F;
        return F;
      }
      var hd = xr(Yc), md = xr(Xc);
      function _d(_) {
        return "\\" + ed[_];
      }
      function bd(_, y) {
        return _ == null ? r : _[y];
      }
      function on(_) {
        return Wc.test(_);
      }
      function Ad(_) {
        return Vc.test(_);
      }
      function gd(_) {
        for (var y, g = []; !(y = _.next()).done; )
          g.push(y.value);
        return g;
      }
      function wr(_) {
        var y = -1, g = Array(_.size);
        return _.forEach(function(F, O) {
          g[++y] = [O, F];
        }), g;
      }
      function ka(_, y) {
        return function(g) {
          return _(y(g));
        };
      }
      function xo(_, y) {
        for (var g = -1, F = _.length, O = 0, W = []; ++g < F; ) {
          var pe = _[g];
          (pe === y || pe === z) && (_[g] = z, W[O++] = g);
        }
        return W;
      }
      function st(_) {
        var y = -1, g = Array(_.size);
        return _.forEach(function(F) {
          g[++y] = F;
        }), g;
      }
      function yd(_) {
        var y = -1, g = Array(_.size);
        return _.forEach(function(F) {
          g[++y] = [F, F];
        }), g;
      }
      function Td(_, y, g) {
        for (var F = g - 1, O = _.length; ++F < O; )
          if (_[F] === y)
            return F;
        return -1;
      }
      function Md(_, y, g) {
        for (var F = g + 1; F--; )
          if (_[F] === y)
            return F;
        return F;
      }
      function nn(_) {
        return on(_) ? Sd(_) : sd(_);
      }
      function je(_) {
        return on(_) ? xd(_) : ud(_);
      }
      function Da(_) {
        for (var y = _.length; y-- && hc.test(_.charAt(y)); )
          ;
        return y;
      }
      var Id = xr(Qc);
      function Sd(_) {
        for (var y = Ar.lastIndex = 0; Ar.test(_); )
          ++y;
        return y;
      }
      function xd(_) {
        return _.match(Ar) || [];
      }
      function vd(_) {
        return _.match(Hc) || [];
      }
      var Nd = (function _(y) {
        y = y == null ? _e : tn.defaults(_e.Object(), y, tn.pick(_e, Jc));
        var g = y.Array, F = y.Date, O = y.Error, W = y.Function, pe = y.Math, Y = y.Object, Cr = y.RegExp, Fd = y.String, Ze = y.TypeError, ut = g.prototype, wd = W.prototype, rn = Y.prototype, lt = y["__core-js_shared__"], ct = wd.toString, V = rn.hasOwnProperty, Cd = 0, La = (function() {
          var e = /[^.]+$/.exec(lt && lt.keys && lt.keys.IE_PROTO || "");
          return e ? "Symbol(src)_1." + e : "";
        })(), dt = rn.toString, Ed = ct.call(Y), Bd = _e._, kd = Cr(
          "^" + ct.call(V).replace(pr, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
        ), pt = Aa ? y.Buffer : r, vo = y.Symbol, ft = y.Uint8Array, Pa = pt ? pt.allocUnsafe : r, ht = ka(Y.getPrototypeOf, Y), Ra = Y.create, Oa = rn.propertyIsEnumerable, mt = ut.splice, za = vo ? vo.isConcatSpreadable : r, Cn = vo ? vo.iterator : r, zo = vo ? vo.toStringTag : r, _t = (function() {
          try {
            var e = Ko(Y, "defineProperty");
            return e({}, "", {}), e;
          } catch {
          }
        })(), Dd = y.clearTimeout !== _e.clearTimeout && y.clearTimeout, Ld = F && F.now !== _e.Date.now && F.now, Pd = y.setTimeout !== _e.setTimeout && y.setTimeout, bt = pe.ceil, At = pe.floor, Er = Y.getOwnPropertySymbols, Rd = pt ? pt.isBuffer : r, Ga = y.isFinite, Od = ut.join, zd = ka(Y.keys, Y), fe = pe.max, ge = pe.min, Gd = F.now, Zd = y.parseInt, Za = pe.random, Ud = ut.reverse, Br = Ko(y, "DataView"), En = Ko(y, "Map"), kr = Ko(y, "Promise"), an = Ko(y, "Set"), Bn = Ko(y, "WeakMap"), kn = Ko(Y, "create"), gt = Bn && new Bn(), sn = {}, $d = qo(Br), Kd = qo(En), qd = qo(kr), Hd = qo(an), Wd = qo(Bn), yt = vo ? vo.prototype : r, Dn = yt ? yt.valueOf : r, Ua = yt ? yt.toString : r;
        function c(e) {
          if (se(e) && !G(e) && !(e instanceof q)) {
            if (e instanceof Ue)
              return e;
            if (V.call(e, "__wrapped__"))
              return $s(e);
          }
          return new Ue(e);
        }
        var un = /* @__PURE__ */ (function() {
          function e() {
          }
          return function(n) {
            if (!re(n))
              return {};
            if (Ra)
              return Ra(n);
            e.prototype = n;
            var i = new e();
            return e.prototype = r, i;
          };
        })();
        function Tt() {
        }
        function Ue(e, n) {
          this.__wrapped__ = e, this.__actions__ = [], this.__chain__ = !!n, this.__index__ = 0, this.__values__ = r;
        }
        c.templateSettings = {
          /**
           * Used to detect `data` property values to be HTML-escaped.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          escape: uc,
          /**
           * Used to detect code to be evaluated.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          evaluate: lc,
          /**
           * Used to detect `data` property values to inject.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          interpolate: ji,
          /**
           * Used to reference the data object in the template text.
           *
           * @memberOf _.templateSettings
           * @type {string}
           */
          variable: "",
          /**
           * Used to import variables into the compiled template.
           *
           * @memberOf _.templateSettings
           * @type {Object}
           */
          imports: {
            /**
             * A reference to the `lodash` function.
             *
             * @memberOf _.templateSettings.imports
             * @type {Function}
             */
            _: c
          }
        }, c.prototype = Tt.prototype, c.prototype.constructor = c, Ue.prototype = un(Tt.prototype), Ue.prototype.constructor = Ue;
        function q(e) {
          this.__wrapped__ = e, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = no, this.__views__ = [];
        }
        function Vd() {
          var e = new q(this.__wrapped__);
          return e.__actions__ = ve(this.__actions__), e.__dir__ = this.__dir__, e.__filtered__ = this.__filtered__, e.__iteratees__ = ve(this.__iteratees__), e.__takeCount__ = this.__takeCount__, e.__views__ = ve(this.__views__), e;
        }
        function Jd() {
          if (this.__filtered__) {
            var e = new q(this);
            e.__dir__ = -1, e.__filtered__ = !0;
          } else
            e = this.clone(), e.__dir__ *= -1;
          return e;
        }
        function jd() {
          var e = this.__wrapped__.value(), n = this.__dir__, i = G(e), s = n < 0, l = i ? e.length : 0, d = lf(0, l, this.__views__), h = d.start, m = d.end, A = m - h, M = s ? m : h - 1, S = this.__iteratees__, x = S.length, N = 0, C = ge(A, this.__takeCount__);
          if (!i || !s && l == A && C == A)
            return ps(e, this.__actions__);
          var P = [];
          e:
            for (; A-- && N < C; ) {
              M += n;
              for (var U = -1, D = e[M]; ++U < x; ) {
                var K = S[U], H = K.iteratee, Oe = K.type, Ie = H(D);
                if (Oe == ql)
                  D = Ie;
                else if (!Ie) {
                  if (Oe == qi)
                    continue e;
                  break e;
                }
              }
              P[N++] = D;
            }
          return P;
        }
        q.prototype = un(Tt.prototype), q.prototype.constructor = q;
        function Go(e) {
          var n = -1, i = e == null ? 0 : e.length;
          for (this.clear(); ++n < i; ) {
            var s = e[n];
            this.set(s[0], s[1]);
          }
        }
        function Yd() {
          this.__data__ = kn ? kn(null) : {}, this.size = 0;
        }
        function Xd(e) {
          var n = this.has(e) && delete this.__data__[e];
          return this.size -= n ? 1 : 0, n;
        }
        function Qd(e) {
          var n = this.__data__;
          if (kn) {
            var i = n[e];
            return i === v ? r : i;
          }
          return V.call(n, e) ? n[e] : r;
        }
        function ep(e) {
          var n = this.__data__;
          return kn ? n[e] !== r : V.call(n, e);
        }
        function op(e, n) {
          var i = this.__data__;
          return this.size += this.has(e) ? 0 : 1, i[e] = kn && n === r ? v : n, this;
        }
        Go.prototype.clear = Yd, Go.prototype.delete = Xd, Go.prototype.get = Qd, Go.prototype.has = ep, Go.prototype.set = op;
        function po(e) {
          var n = -1, i = e == null ? 0 : e.length;
          for (this.clear(); ++n < i; ) {
            var s = e[n];
            this.set(s[0], s[1]);
          }
        }
        function np() {
          this.__data__ = [], this.size = 0;
        }
        function tp(e) {
          var n = this.__data__, i = Mt(n, e);
          if (i < 0)
            return !1;
          var s = n.length - 1;
          return i == s ? n.pop() : mt.call(n, i, 1), --this.size, !0;
        }
        function rp(e) {
          var n = this.__data__, i = Mt(n, e);
          return i < 0 ? r : n[i][1];
        }
        function ip(e) {
          return Mt(this.__data__, e) > -1;
        }
        function ap(e, n) {
          var i = this.__data__, s = Mt(i, e);
          return s < 0 ? (++this.size, i.push([e, n])) : i[s][1] = n, this;
        }
        po.prototype.clear = np, po.prototype.delete = tp, po.prototype.get = rp, po.prototype.has = ip, po.prototype.set = ap;
        function fo(e) {
          var n = -1, i = e == null ? 0 : e.length;
          for (this.clear(); ++n < i; ) {
            var s = e[n];
            this.set(s[0], s[1]);
          }
        }
        function sp() {
          this.size = 0, this.__data__ = {
            hash: new Go(),
            map: new (En || po)(),
            string: new Go()
          };
        }
        function up(e) {
          var n = Dt(this, e).delete(e);
          return this.size -= n ? 1 : 0, n;
        }
        function lp(e) {
          return Dt(this, e).get(e);
        }
        function cp(e) {
          return Dt(this, e).has(e);
        }
        function dp(e, n) {
          var i = Dt(this, e), s = i.size;
          return i.set(e, n), this.size += i.size == s ? 0 : 1, this;
        }
        fo.prototype.clear = sp, fo.prototype.delete = up, fo.prototype.get = lp, fo.prototype.has = cp, fo.prototype.set = dp;
        function Zo(e) {
          var n = -1, i = e == null ? 0 : e.length;
          for (this.__data__ = new fo(); ++n < i; )
            this.add(e[n]);
        }
        function pp(e) {
          return this.__data__.set(e, v), this;
        }
        function fp(e) {
          return this.__data__.has(e);
        }
        Zo.prototype.add = Zo.prototype.push = pp, Zo.prototype.has = fp;
        function Ye(e) {
          var n = this.__data__ = new po(e);
          this.size = n.size;
        }
        function hp() {
          this.__data__ = new po(), this.size = 0;
        }
        function mp(e) {
          var n = this.__data__, i = n.delete(e);
          return this.size = n.size, i;
        }
        function _p(e) {
          return this.__data__.get(e);
        }
        function bp(e) {
          return this.__data__.has(e);
        }
        function Ap(e, n) {
          var i = this.__data__;
          if (i instanceof po) {
            var s = i.__data__;
            if (!En || s.length < u - 1)
              return s.push([e, n]), this.size = ++i.size, this;
            i = this.__data__ = new fo(s);
          }
          return i.set(e, n), this.size = i.size, this;
        }
        Ye.prototype.clear = hp, Ye.prototype.delete = mp, Ye.prototype.get = _p, Ye.prototype.has = bp, Ye.prototype.set = Ap;
        function $a(e, n) {
          var i = G(e), s = !i && Ho(e), l = !i && !s && Eo(e), d = !i && !s && !l && pn(e), h = i || s || l || d, m = h ? Nr(e.length, Fd) : [], A = m.length;
          for (var M in e)
            (n || V.call(e, M)) && !(h && // Safari 9 has enumerable `arguments.length` in strict mode.
            (M == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            l && (M == "offset" || M == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            d && (M == "buffer" || M == "byteLength" || M == "byteOffset") || // Skip index properties.
            _o(M, A))) && m.push(M);
          return m;
        }
        function Ka(e) {
          var n = e.length;
          return n ? e[Kr(0, n - 1)] : r;
        }
        function gp(e, n) {
          return Lt(ve(e), Uo(n, 0, e.length));
        }
        function yp(e) {
          return Lt(ve(e));
        }
        function Dr(e, n, i) {
          (i !== r && !Qe(e[n], i) || i === r && !(n in e)) && to(e, n, i);
        }
        function Ln(e, n, i) {
          var s = e[n];
          (!(V.call(e, n) && Qe(s, i)) || i === r && !(n in e)) && to(e, n, i);
        }
        function Mt(e, n) {
          for (var i = e.length; i--; )
            if (Qe(e[i][0], n))
              return i;
          return -1;
        }
        function Tp(e, n, i, s) {
          return No(e, function(l, d, h) {
            n(s, l, i(l), h);
          }), s;
        }
        function qa(e, n) {
          return e && io(n, he(n), e);
        }
        function Mp(e, n) {
          return e && io(n, Fe(n), e);
        }
        function to(e, n, i) {
          n == "__proto__" && _t ? _t(e, n, {
            configurable: !0,
            enumerable: !0,
            value: i,
            writable: !0
          }) : e[n] = i;
        }
        function Lr(e, n) {
          for (var i = -1, s = n.length, l = g(s), d = e == null; ++i < s; )
            l[i] = d ? r : _i(e, n[i]);
          return l;
        }
        function Uo(e, n, i) {
          return e === e && (i !== r && (e = e <= i ? e : i), n !== r && (e = e >= n ? e : n)), e;
        }
        function $e(e, n, i, s, l, d) {
          var h, m = n & B, A = n & R, M = n & ae;
          if (i && (h = l ? i(e, s, l, d) : i(e)), h !== r)
            return h;
          if (!re(e))
            return e;
          var S = G(e);
          if (S) {
            if (h = df(e), !m)
              return ve(e, h);
          } else {
            var x = ye(e), N = x == et || x == Hi;
            if (Eo(e))
              return ms(e, m);
            if (x == co || x == Yo || N && !l) {
              if (h = A || N ? {} : Ds(e), !m)
                return A ? Qp(e, Mp(h, e)) : Xp(e, qa(h, e));
            } else {
              if (!X[x])
                return l ? e : {};
              h = pf(e, x, m);
            }
          }
          d || (d = new Ye());
          var C = d.get(e);
          if (C)
            return C;
          d.set(e, h), lu(e) ? e.forEach(function(D) {
            h.add($e(D, n, i, D, e, d));
          }) : su(e) && e.forEach(function(D, K) {
            h.set(K, $e(D, n, i, K, e, d));
          });
          var P = M ? A ? oi : ei : A ? Fe : he, U = S ? r : P(e);
          return De(U || e, function(D, K) {
            U && (K = D, D = e[K]), Ln(h, K, $e(D, n, i, K, e, d));
          }), h;
        }
        function Ip(e) {
          var n = he(e);
          return function(i) {
            return Ha(i, e, n);
          };
        }
        function Ha(e, n, i) {
          var s = i.length;
          if (e == null)
            return !s;
          for (e = Y(e); s--; ) {
            var l = i[s], d = n[l], h = e[l];
            if (h === r && !(l in e) || !d(h))
              return !1;
          }
          return !0;
        }
        function Wa(e, n, i) {
          if (typeof e != "function")
            throw new Ze(p);
          return Un(function() {
            e.apply(r, i);
          }, n);
        }
        function Pn(e, n, i, s) {
          var l = -1, d = it, h = !0, m = e.length, A = [], M = n.length;
          if (!m)
            return A;
          i && (n = ne(n, Le(i))), s ? (d = Tr, h = !1) : n.length >= u && (d = wn, h = !1, n = new Zo(n));
          e:
            for (; ++l < m; ) {
              var S = e[l], x = i == null ? S : i(S);
              if (S = s || S !== 0 ? S : 0, h && x === x) {
                for (var N = M; N--; )
                  if (n[N] === x)
                    continue e;
                A.push(S);
              } else d(n, x, s) || A.push(S);
            }
          return A;
        }
        var No = ys(ro), Va = ys(Rr, !0);
        function Sp(e, n) {
          var i = !0;
          return No(e, function(s, l, d) {
            return i = !!n(s, l, d), i;
          }), i;
        }
        function It(e, n, i) {
          for (var s = -1, l = e.length; ++s < l; ) {
            var d = e[s], h = n(d);
            if (h != null && (m === r ? h === h && !Re(h) : i(h, m)))
              var m = h, A = d;
          }
          return A;
        }
        function xp(e, n, i, s) {
          var l = e.length;
          for (i = Z(i), i < 0 && (i = -i > l ? 0 : l + i), s = s === r || s > l ? l : Z(s), s < 0 && (s += l), s = i > s ? 0 : du(s); i < s; )
            e[i++] = n;
          return e;
        }
        function Ja(e, n) {
          var i = [];
          return No(e, function(s, l, d) {
            n(s, l, d) && i.push(s);
          }), i;
        }
        function be(e, n, i, s, l) {
          var d = -1, h = e.length;
          for (i || (i = hf), l || (l = []); ++d < h; ) {
            var m = e[d];
            n > 0 && i(m) ? n > 1 ? be(m, n - 1, i, s, l) : So(l, m) : s || (l[l.length] = m);
          }
          return l;
        }
        var Pr = Ts(), ja = Ts(!0);
        function ro(e, n) {
          return e && Pr(e, n, he);
        }
        function Rr(e, n) {
          return e && ja(e, n, he);
        }
        function St(e, n) {
          return Io(n, function(i) {
            return bo(e[i]);
          });
        }
        function $o(e, n) {
          n = wo(n, e);
          for (var i = 0, s = n.length; e != null && i < s; )
            e = e[Xe(n[i++])];
          return i && i == s ? e : r;
        }
        function Ya(e, n, i) {
          var s = n(e);
          return G(e) ? s : So(s, i(e));
        }
        function Te(e) {
          return e == null ? e === r ? oc : Ql : zo && zo in Y(e) ? uf(e) : Tf(e);
        }
        function Or(e, n) {
          return e > n;
        }
        function vp(e, n) {
          return e != null && V.call(e, n);
        }
        function Np(e, n) {
          return e != null && n in Y(e);
        }
        function Fp(e, n, i) {
          return e >= ge(n, i) && e < fe(n, i);
        }
        function zr(e, n, i) {
          for (var s = i ? Tr : it, l = e[0].length, d = e.length, h = d, m = g(d), A = 1 / 0, M = []; h--; ) {
            var S = e[h];
            h && n && (S = ne(S, Le(n))), A = ge(S.length, A), m[h] = !i && (n || l >= 120 && S.length >= 120) ? new Zo(h && S) : r;
          }
          S = e[0];
          var x = -1, N = m[0];
          e:
            for (; ++x < l && M.length < A; ) {
              var C = S[x], P = n ? n(C) : C;
              if (C = i || C !== 0 ? C : 0, !(N ? wn(N, P) : s(M, P, i))) {
                for (h = d; --h; ) {
                  var U = m[h];
                  if (!(U ? wn(U, P) : s(e[h], P, i)))
                    continue e;
                }
                N && N.push(P), M.push(C);
              }
            }
          return M;
        }
        function wp(e, n, i, s) {
          return ro(e, function(l, d, h) {
            n(s, i(l), d, h);
          }), s;
        }
        function Rn(e, n, i) {
          n = wo(n, e), e = Os(e, n);
          var s = e == null ? e : e[Xe(qe(n))];
          return s == null ? r : ke(s, e, i);
        }
        function Xa(e) {
          return se(e) && Te(e) == Yo;
        }
        function Cp(e) {
          return se(e) && Te(e) == Fn;
        }
        function Ep(e) {
          return se(e) && Te(e) == In;
        }
        function On(e, n, i, s, l) {
          return e === n ? !0 : e == null || n == null || !se(e) && !se(n) ? e !== e && n !== n : Bp(e, n, i, s, On, l);
        }
        function Bp(e, n, i, s, l, d) {
          var h = G(e), m = G(n), A = h ? Xn : ye(e), M = m ? Xn : ye(n);
          A = A == Yo ? co : A, M = M == Yo ? co : M;
          var S = A == co, x = M == co, N = A == M;
          if (N && Eo(e)) {
            if (!Eo(n))
              return !1;
            h = !0, S = !1;
          }
          if (N && !S)
            return d || (d = new Ye()), h || pn(e) ? Es(e, n, i, s, l, d) : af(e, n, A, i, s, l, d);
          if (!(i & ee)) {
            var C = S && V.call(e, "__wrapped__"), P = x && V.call(n, "__wrapped__");
            if (C || P) {
              var U = C ? e.value() : e, D = P ? n.value() : n;
              return d || (d = new Ye()), l(U, D, i, s, d);
            }
          }
          return N ? (d || (d = new Ye()), sf(e, n, i, s, l, d)) : !1;
        }
        function kp(e) {
          return se(e) && ye(e) == Ve;
        }
        function Gr(e, n, i, s) {
          var l = i.length, d = l, h = !s;
          if (e == null)
            return !d;
          for (e = Y(e); l--; ) {
            var m = i[l];
            if (h && m[2] ? m[1] !== e[m[0]] : !(m[0] in e))
              return !1;
          }
          for (; ++l < d; ) {
            m = i[l];
            var A = m[0], M = e[A], S = m[1];
            if (h && m[2]) {
              if (M === r && !(A in e))
                return !1;
            } else {
              var x = new Ye();
              if (s)
                var N = s(M, S, A, e, n, x);
              if (!(N === r ? On(S, M, ee | uo, s, x) : N))
                return !1;
            }
          }
          return !0;
        }
        function Qa(e) {
          if (!re(e) || _f(e))
            return !1;
          var n = bo(e) ? kd : Ic;
          return n.test(qo(e));
        }
        function Dp(e) {
          return se(e) && Te(e) == xn;
        }
        function Lp(e) {
          return se(e) && ye(e) == Je;
        }
        function Pp(e) {
          return se(e) && Zt(e.length) && !!Q[Te(e)];
        }
        function es(e) {
          return typeof e == "function" ? e : e == null ? we : typeof e == "object" ? G(e) ? ts(e[0], e[1]) : ns(e) : Iu(e);
        }
        function Zr(e) {
          if (!Zn(e))
            return zd(e);
          var n = [];
          for (var i in Y(e))
            V.call(e, i) && i != "constructor" && n.push(i);
          return n;
        }
        function Rp(e) {
          if (!re(e))
            return yf(e);
          var n = Zn(e), i = [];
          for (var s in e)
            s == "constructor" && (n || !V.call(e, s)) || i.push(s);
          return i;
        }
        function Ur(e, n) {
          return e < n;
        }
        function os(e, n) {
          var i = -1, s = Ne(e) ? g(e.length) : [];
          return No(e, function(l, d, h) {
            s[++i] = n(l, d, h);
          }), s;
        }
        function ns(e) {
          var n = ti(e);
          return n.length == 1 && n[0][2] ? Ps(n[0][0], n[0][1]) : function(i) {
            return i === e || Gr(i, e, n);
          };
        }
        function ts(e, n) {
          return ii(e) && Ls(n) ? Ps(Xe(e), n) : function(i) {
            var s = _i(i, e);
            return s === r && s === n ? bi(i, e) : On(n, s, ee | uo);
          };
        }
        function xt(e, n, i, s, l) {
          e !== n && Pr(n, function(d, h) {
            if (l || (l = new Ye()), re(d))
              Op(e, n, h, i, xt, s, l);
            else {
              var m = s ? s(si(e, h), d, h + "", e, n, l) : r;
              m === r && (m = d), Dr(e, h, m);
            }
          }, Fe);
        }
        function Op(e, n, i, s, l, d, h) {
          var m = si(e, i), A = si(n, i), M = h.get(A);
          if (M) {
            Dr(e, i, M);
            return;
          }
          var S = d ? d(m, A, i + "", e, n, h) : r, x = S === r;
          if (x) {
            var N = G(A), C = !N && Eo(A), P = !N && !C && pn(A);
            S = A, N || C || P ? G(m) ? S = m : ue(m) ? S = ve(m) : C ? (x = !1, S = ms(A, !0)) : P ? (x = !1, S = _s(A, !0)) : S = [] : $n(A) || Ho(A) ? (S = m, Ho(m) ? S = pu(m) : (!re(m) || bo(m)) && (S = Ds(A))) : x = !1;
          }
          x && (h.set(A, S), l(S, A, s, d, h), h.delete(A)), Dr(e, i, S);
        }
        function rs(e, n) {
          var i = e.length;
          if (i)
            return n += n < 0 ? i : 0, _o(n, i) ? e[n] : r;
        }
        function is(e, n, i) {
          n.length ? n = ne(n, function(d) {
            return G(d) ? function(h) {
              return $o(h, d.length === 1 ? d[0] : d);
            } : d;
          }) : n = [we];
          var s = -1;
          n = ne(n, Le(L()));
          var l = os(e, function(d, h, m) {
            var A = ne(n, function(M) {
              return M(d);
            });
            return { criteria: A, index: ++s, value: d };
          });
          return dd(l, function(d, h) {
            return Yp(d, h, i);
          });
        }
        function zp(e, n) {
          return as(e, n, function(i, s) {
            return bi(e, s);
          });
        }
        function as(e, n, i) {
          for (var s = -1, l = n.length, d = {}; ++s < l; ) {
            var h = n[s], m = $o(e, h);
            i(m, h) && zn(d, wo(h, e), m);
          }
          return d;
        }
        function Gp(e) {
          return function(n) {
            return $o(n, e);
          };
        }
        function $r(e, n, i, s) {
          var l = s ? cd : en, d = -1, h = n.length, m = e;
          for (e === n && (n = ve(n)), i && (m = ne(e, Le(i))); ++d < h; )
            for (var A = 0, M = n[d], S = i ? i(M) : M; (A = l(m, S, A, s)) > -1; )
              m !== e && mt.call(m, A, 1), mt.call(e, A, 1);
          return e;
        }
        function ss(e, n) {
          for (var i = e ? n.length : 0, s = i - 1; i--; ) {
            var l = n[i];
            if (i == s || l !== d) {
              var d = l;
              _o(l) ? mt.call(e, l, 1) : Wr(e, l);
            }
          }
          return e;
        }
        function Kr(e, n) {
          return e + At(Za() * (n - e + 1));
        }
        function Zp(e, n, i, s) {
          for (var l = -1, d = fe(bt((n - e) / (i || 1)), 0), h = g(d); d--; )
            h[s ? d : ++l] = e, e += i;
          return h;
        }
        function qr(e, n) {
          var i = "";
          if (!e || n < 1 || n > Mo)
            return i;
          do
            n % 2 && (i += e), n = At(n / 2), n && (e += e);
          while (n);
          return i;
        }
        function $(e, n) {
          return ui(Rs(e, n, we), e + "");
        }
        function Up(e) {
          return Ka(fn(e));
        }
        function $p(e, n) {
          var i = fn(e);
          return Lt(i, Uo(n, 0, i.length));
        }
        function zn(e, n, i, s) {
          if (!re(e))
            return e;
          n = wo(n, e);
          for (var l = -1, d = n.length, h = d - 1, m = e; m != null && ++l < d; ) {
            var A = Xe(n[l]), M = i;
            if (A === "__proto__" || A === "constructor" || A === "prototype")
              return e;
            if (l != h) {
              var S = m[A];
              M = s ? s(S, A, m) : r, M === r && (M = re(S) ? S : _o(n[l + 1]) ? [] : {});
            }
            Ln(m, A, M), m = m[A];
          }
          return e;
        }
        var us = gt ? function(e, n) {
          return gt.set(e, n), e;
        } : we, Kp = _t ? function(e, n) {
          return _t(e, "toString", {
            configurable: !0,
            enumerable: !1,
            value: gi(n),
            writable: !0
          });
        } : we;
        function qp(e) {
          return Lt(fn(e));
        }
        function Ke(e, n, i) {
          var s = -1, l = e.length;
          n < 0 && (n = -n > l ? 0 : l + n), i = i > l ? l : i, i < 0 && (i += l), l = n > i ? 0 : i - n >>> 0, n >>>= 0;
          for (var d = g(l); ++s < l; )
            d[s] = e[s + n];
          return d;
        }
        function Hp(e, n) {
          var i;
          return No(e, function(s, l, d) {
            return i = n(s, l, d), !i;
          }), !!i;
        }
        function vt(e, n, i) {
          var s = 0, l = e == null ? s : e.length;
          if (typeof n == "number" && n === n && l <= Jl) {
            for (; s < l; ) {
              var d = s + l >>> 1, h = e[d];
              h !== null && !Re(h) && (i ? h <= n : h < n) ? s = d + 1 : l = d;
            }
            return l;
          }
          return Hr(e, n, we, i);
        }
        function Hr(e, n, i, s) {
          var l = 0, d = e == null ? 0 : e.length;
          if (d === 0)
            return 0;
          n = i(n);
          for (var h = n !== n, m = n === null, A = Re(n), M = n === r; l < d; ) {
            var S = At((l + d) / 2), x = i(e[S]), N = x !== r, C = x === null, P = x === x, U = Re(x);
            if (h)
              var D = s || P;
            else M ? D = P && (s || N) : m ? D = P && N && (s || !C) : A ? D = P && N && !C && (s || !U) : C || U ? D = !1 : D = s ? x <= n : x < n;
            D ? l = S + 1 : d = S;
          }
          return ge(d, Vl);
        }
        function ls(e, n) {
          for (var i = -1, s = e.length, l = 0, d = []; ++i < s; ) {
            var h = e[i], m = n ? n(h) : h;
            if (!i || !Qe(m, A)) {
              var A = m;
              d[l++] = h === 0 ? 0 : h;
            }
          }
          return d;
        }
        function cs(e) {
          return typeof e == "number" ? e : Re(e) ? Yn : +e;
        }
        function Pe(e) {
          if (typeof e == "string")
            return e;
          if (G(e))
            return ne(e, Pe) + "";
          if (Re(e))
            return Ua ? Ua.call(e) : "";
          var n = e + "";
          return n == "0" && 1 / e == -Ro ? "-0" : n;
        }
        function Fo(e, n, i) {
          var s = -1, l = it, d = e.length, h = !0, m = [], A = m;
          if (i)
            h = !1, l = Tr;
          else if (d >= u) {
            var M = n ? null : tf(e);
            if (M)
              return st(M);
            h = !1, l = wn, A = new Zo();
          } else
            A = n ? [] : m;
          e:
            for (; ++s < d; ) {
              var S = e[s], x = n ? n(S) : S;
              if (S = i || S !== 0 ? S : 0, h && x === x) {
                for (var N = A.length; N--; )
                  if (A[N] === x)
                    continue e;
                n && A.push(x), m.push(S);
              } else l(A, x, i) || (A !== m && A.push(x), m.push(S));
            }
          return m;
        }
        function Wr(e, n) {
          n = wo(n, e);
          var i = -1, s = n.length;
          if (!s)
            return !0;
          for (; ++i < s; ) {
            var l = Xe(n[i]);
            if (l === "__proto__" && !V.call(e, "__proto__") || (l === "constructor" || l === "prototype") && i < s - 1)
              return !1;
          }
          var d = Os(e, n);
          return d == null || delete d[Xe(qe(n))];
        }
        function ds(e, n, i, s) {
          return zn(e, n, i($o(e, n)), s);
        }
        function Nt(e, n, i, s) {
          for (var l = e.length, d = s ? l : -1; (s ? d-- : ++d < l) && n(e[d], d, e); )
            ;
          return i ? Ke(e, s ? 0 : d, s ? d + 1 : l) : Ke(e, s ? d + 1 : 0, s ? l : d);
        }
        function ps(e, n) {
          var i = e;
          return i instanceof q && (i = i.value()), Mr(n, function(s, l) {
            return l.func.apply(l.thisArg, So([s], l.args));
          }, i);
        }
        function Vr(e, n, i) {
          var s = e.length;
          if (s < 2)
            return s ? Fo(e[0]) : [];
          for (var l = -1, d = g(s); ++l < s; )
            for (var h = e[l], m = -1; ++m < s; )
              m != l && (d[l] = Pn(d[l] || h, e[m], n, i));
          return Fo(be(d, 1), n, i);
        }
        function fs(e, n, i) {
          for (var s = -1, l = e.length, d = n.length, h = {}; ++s < l; ) {
            var m = s < d ? n[s] : r;
            i(h, e[s], m);
          }
          return h;
        }
        function Jr(e) {
          return ue(e) ? e : [];
        }
        function jr(e) {
          return typeof e == "function" ? e : we;
        }
        function wo(e, n) {
          return G(e) ? e : ii(e, n) ? [e] : Us(J(e));
        }
        var Wp = $;
        function Co(e, n, i) {
          var s = e.length;
          return i = i === r ? s : i, !n && i >= s ? e : Ke(e, n, i);
        }
        var hs = Dd || function(e) {
          return _e.clearTimeout(e);
        };
        function ms(e, n) {
          if (n)
            return e.slice();
          var i = e.length, s = Pa ? Pa(i) : new e.constructor(i);
          return e.copy(s), s;
        }
        function Yr(e) {
          var n = new e.constructor(e.byteLength);
          return new ft(n).set(new ft(e)), n;
        }
        function Vp(e, n) {
          var i = n ? Yr(e.buffer) : e.buffer;
          return new e.constructor(i, e.byteOffset, e.byteLength);
        }
        function Jp(e) {
          var n = new e.constructor(e.source, Xi.exec(e));
          return n.lastIndex = e.lastIndex, n;
        }
        function jp(e) {
          return Dn ? Y(Dn.call(e)) : {};
        }
        function _s(e, n) {
          var i = n ? Yr(e.buffer) : e.buffer;
          return new e.constructor(i, e.byteOffset, e.length);
        }
        function bs(e, n) {
          if (e !== n) {
            var i = e !== r, s = e === null, l = e === e, d = Re(e), h = n !== r, m = n === null, A = n === n, M = Re(n);
            if (!m && !M && !d && e > n || d && h && A && !m && !M || s && h && A || !i && A || !l)
              return 1;
            if (!s && !d && !M && e < n || M && i && l && !s && !d || m && i && l || !h && l || !A)
              return -1;
          }
          return 0;
        }
        function Yp(e, n, i) {
          for (var s = -1, l = e.criteria, d = n.criteria, h = l.length, m = i.length; ++s < h; ) {
            var A = bs(l[s], d[s]);
            if (A) {
              if (s >= m)
                return A;
              var M = i[s];
              return A * (M == "desc" ? -1 : 1);
            }
          }
          return e.index - n.index;
        }
        function As(e, n, i, s) {
          for (var l = -1, d = e.length, h = i.length, m = -1, A = n.length, M = fe(d - h, 0), S = g(A + M), x = !s; ++m < A; )
            S[m] = n[m];
          for (; ++l < h; )
            (x || l < d) && (S[i[l]] = e[l]);
          for (; M--; )
            S[m++] = e[l++];
          return S;
        }
        function gs(e, n, i, s) {
          for (var l = -1, d = e.length, h = -1, m = i.length, A = -1, M = n.length, S = fe(d - m, 0), x = g(S + M), N = !s; ++l < S; )
            x[l] = e[l];
          for (var C = l; ++A < M; )
            x[C + A] = n[A];
          for (; ++h < m; )
            (N || l < d) && (x[C + i[h]] = e[l++]);
          return x;
        }
        function ve(e, n) {
          var i = -1, s = e.length;
          for (n || (n = g(s)); ++i < s; )
            n[i] = e[i];
          return n;
        }
        function io(e, n, i, s) {
          var l = !i;
          i || (i = {});
          for (var d = -1, h = n.length; ++d < h; ) {
            var m = n[d], A = s ? s(i[m], e[m], m, i, e) : r;
            A === r && (A = e[m]), l ? to(i, m, A) : Ln(i, m, A);
          }
          return i;
        }
        function Xp(e, n) {
          return io(e, ri(e), n);
        }
        function Qp(e, n) {
          return io(e, Bs(e), n);
        }
        function Ft(e, n) {
          return function(i, s) {
            var l = G(i) ? rd : Tp, d = n ? n() : {};
            return l(i, e, L(s, 2), d);
          };
        }
        function ln(e) {
          return $(function(n, i) {
            var s = -1, l = i.length, d = l > 1 ? i[l - 1] : r, h = l > 2 ? i[2] : r;
            for (d = e.length > 3 && typeof d == "function" ? (l--, d) : r, h && Me(i[0], i[1], h) && (d = l < 3 ? r : d, l = 1), n = Y(n); ++s < l; ) {
              var m = i[s];
              m && e(n, m, s, d);
            }
            return n;
          });
        }
        function ys(e, n) {
          return function(i, s) {
            if (i == null)
              return i;
            if (!Ne(i))
              return e(i, s);
            for (var l = i.length, d = n ? l : -1, h = Y(i); (n ? d-- : ++d < l) && s(h[d], d, h) !== !1; )
              ;
            return i;
          };
        }
        function Ts(e) {
          return function(n, i, s) {
            for (var l = -1, d = Y(n), h = s(n), m = h.length; m--; ) {
              var A = h[e ? m : ++l];
              if (i(d[A], A, d) === !1)
                break;
            }
            return n;
          };
        }
        function ef(e, n, i) {
          var s = n & Ee, l = Gn(e);
          function d() {
            var h = this && this !== _e && this instanceof d ? l : e;
            return h.apply(s ? i : this, arguments);
          }
          return d;
        }
        function Ms(e) {
          return function(n) {
            n = J(n);
            var i = on(n) ? je(n) : r, s = i ? i[0] : n.charAt(0), l = i ? Co(i, 1).join("") : n.slice(1);
            return s[e]() + l;
          };
        }
        function cn(e) {
          return function(n) {
            return Mr(Tu(yu(n).replace(Kc, "")), e, "");
          };
        }
        function Gn(e) {
          return function() {
            var n = arguments;
            switch (n.length) {
              case 0:
                return new e();
              case 1:
                return new e(n[0]);
              case 2:
                return new e(n[0], n[1]);
              case 3:
                return new e(n[0], n[1], n[2]);
              case 4:
                return new e(n[0], n[1], n[2], n[3]);
              case 5:
                return new e(n[0], n[1], n[2], n[3], n[4]);
              case 6:
                return new e(n[0], n[1], n[2], n[3], n[4], n[5]);
              case 7:
                return new e(n[0], n[1], n[2], n[3], n[4], n[5], n[6]);
            }
            var i = un(e.prototype), s = e.apply(i, n);
            return re(s) ? s : i;
          };
        }
        function of(e, n, i) {
          var s = Gn(e);
          function l() {
            for (var d = arguments.length, h = g(d), m = d, A = dn(l); m--; )
              h[m] = arguments[m];
            var M = d < 3 && h[0] !== A && h[d - 1] !== A ? [] : xo(h, A);
            if (d -= M.length, d < i)
              return Ns(
                e,
                n,
                wt,
                l.placeholder,
                r,
                h,
                M,
                r,
                r,
                i - d
              );
            var S = this && this !== _e && this instanceof l ? s : e;
            return ke(S, this, h);
          }
          return l;
        }
        function Is(e) {
          return function(n, i, s) {
            var l = Y(n);
            if (!Ne(n)) {
              var d = L(i, 3);
              n = he(n), i = function(m) {
                return d(l[m], m, l);
              };
            }
            var h = e(n, i, s);
            return h > -1 ? l[d ? n[h] : h] : r;
          };
        }
        function Ss(e) {
          return mo(function(n) {
            var i = n.length, s = i, l = Ue.prototype.thru;
            for (e && n.reverse(); s--; ) {
              var d = n[s];
              if (typeof d != "function")
                throw new Ze(p);
              if (l && !h && kt(d) == "wrapper")
                var h = new Ue([], !0);
            }
            for (s = h ? s : i; ++s < i; ) {
              d = n[s];
              var m = kt(d), A = m == "wrapper" ? ni(d) : r;
              A && ai(A[0]) && A[1] == (lo | oe | oo | Tn) && !A[4].length && A[9] == 1 ? h = h[kt(A[0])].apply(h, A[3]) : h = d.length == 1 && ai(d) ? h[m]() : h.thru(d);
            }
            return function() {
              var M = arguments, S = M[0];
              if (h && M.length == 1 && G(S))
                return h.plant(S).value();
              for (var x = 0, N = i ? n[x].apply(this, M) : S; ++x < i; )
                N = n[x].call(this, N);
              return N;
            };
          });
        }
        function wt(e, n, i, s, l, d, h, m, A, M) {
          var S = n & lo, x = n & Ee, N = n & To, C = n & (oe | me), P = n & nr, U = N ? r : Gn(e);
          function D() {
            for (var K = arguments.length, H = g(K), Oe = K; Oe--; )
              H[Oe] = arguments[Oe];
            if (C)
              var Ie = dn(D), ze = fd(H, Ie);
            if (s && (H = As(H, s, l, C)), d && (H = gs(H, d, h, C)), K -= ze, C && K < M) {
              var le = xo(H, Ie);
              return Ns(
                e,
                n,
                wt,
                D.placeholder,
                i,
                H,
                le,
                m,
                A,
                M - K
              );
            }
            var eo = x ? i : this, go = N ? eo[e] : e;
            return K = H.length, m ? H = Mf(H, m) : P && K > 1 && H.reverse(), S && A < K && (H.length = A), this && this !== _e && this instanceof D && (go = U || Gn(go)), go.apply(eo, H);
          }
          return D;
        }
        function xs(e, n) {
          return function(i, s) {
            return wp(i, e, n(s), {});
          };
        }
        function Ct(e, n) {
          return function(i, s) {
            var l;
            if (i === r && s === r)
              return n;
            if (i !== r && (l = i), s !== r) {
              if (l === r)
                return s;
              typeof i == "string" || typeof s == "string" ? (i = Pe(i), s = Pe(s)) : (i = cs(i), s = cs(s)), l = e(i, s);
            }
            return l;
          };
        }
        function Xr(e) {
          return mo(function(n) {
            return n = ne(n, Le(L())), $(function(i) {
              var s = this;
              return e(n, function(l) {
                return ke(l, s, i);
              });
            });
          });
        }
        function Et(e, n) {
          n = n === r ? " " : Pe(n);
          var i = n.length;
          if (i < 2)
            return i ? qr(n, e) : n;
          var s = qr(n, bt(e / nn(n)));
          return on(n) ? Co(je(s), 0, e).join("") : s.slice(0, e);
        }
        function nf(e, n, i, s) {
          var l = n & Ee, d = Gn(e);
          function h() {
            for (var m = -1, A = arguments.length, M = -1, S = s.length, x = g(S + A), N = this && this !== _e && this instanceof h ? d : e; ++M < S; )
              x[M] = s[M];
            for (; A--; )
              x[M++] = arguments[++m];
            return ke(N, l ? i : this, x);
          }
          return h;
        }
        function vs(e) {
          return function(n, i, s) {
            return s && typeof s != "number" && Me(n, i, s) && (i = s = r), n = Ao(n), i === r ? (i = n, n = 0) : i = Ao(i), s = s === r ? n < i ? 1 : -1 : Ao(s), Zp(n, i, s, e);
          };
        }
        function Bt(e) {
          return function(n, i) {
            return typeof n == "string" && typeof i == "string" || (n = He(n), i = He(i)), e(n, i);
          };
        }
        function Ns(e, n, i, s, l, d, h, m, A, M) {
          var S = n & oe, x = S ? h : r, N = S ? r : h, C = S ? d : r, P = S ? r : d;
          n |= S ? oo : Po, n &= ~(S ? Po : oo), n & Be || (n &= -4);
          var U = [
            e,
            n,
            l,
            C,
            x,
            P,
            N,
            m,
            A,
            M
          ], D = i.apply(r, U);
          return ai(e) && zs(D, U), D.placeholder = s, Gs(D, e, n);
        }
        function Qr(e) {
          var n = pe[e];
          return function(i, s) {
            if (i = He(i), s = s == null ? 0 : ge(Z(s), 292), s && Ga(i)) {
              var l = (J(i) + "e").split("e"), d = n(l[0] + "e" + (+l[1] + s));
              return l = (J(d) + "e").split("e"), +(l[0] + "e" + (+l[1] - s));
            }
            return n(i);
          };
        }
        var tf = an && 1 / st(new an([, -0]))[1] == Ro ? function(e) {
          return new an(e);
        } : Mi;
        function Fs(e) {
          return function(n) {
            var i = ye(n);
            return i == Ve ? wr(n) : i == Je ? yd(n) : pd(n, e(n));
          };
        }
        function ho(e, n, i, s, l, d, h, m) {
          var A = n & To;
          if (!A && typeof e != "function")
            throw new Ze(p);
          var M = s ? s.length : 0;
          if (M || (n &= -97, s = l = r), h = h === r ? h : fe(Z(h), 0), m = m === r ? m : Z(m), M -= l ? l.length : 0, n & Po) {
            var S = s, x = l;
            s = l = r;
          }
          var N = A ? r : ni(e), C = [
            e,
            n,
            i,
            s,
            l,
            S,
            x,
            d,
            h,
            m
          ];
          if (N && gf(C, N), e = C[0], n = C[1], i = C[2], s = C[3], l = C[4], m = C[9] = C[9] === r ? A ? 0 : e.length : fe(C[9] - M, 0), !m && n & (oe | me) && (n &= -25), !n || n == Ee)
            var P = ef(e, n, i);
          else n == oe || n == me ? P = of(e, n, m) : (n == oo || n == (Ee | oo)) && !l.length ? P = nf(e, n, i, s) : P = wt.apply(r, C);
          var U = N ? us : zs;
          return Gs(U(P, C), e, n);
        }
        function ws(e, n, i, s) {
          return e === r || Qe(e, rn[i]) && !V.call(s, i) ? n : e;
        }
        function Cs(e, n, i, s, l, d) {
          return re(e) && re(n) && (d.set(n, e), xt(e, n, r, Cs, d), d.delete(n)), e;
        }
        function rf(e) {
          return $n(e) ? r : e;
        }
        function Es(e, n, i, s, l, d) {
          var h = i & ee, m = e.length, A = n.length;
          if (m != A && !(h && A > m))
            return !1;
          var M = d.get(e), S = d.get(n);
          if (M && S)
            return M == n && S == e;
          var x = -1, N = !0, C = i & uo ? new Zo() : r;
          for (d.set(e, n), d.set(n, e); ++x < m; ) {
            var P = e[x], U = n[x];
            if (s)
              var D = h ? s(U, P, x, n, e, d) : s(P, U, x, e, n, d);
            if (D !== r) {
              if (D)
                continue;
              N = !1;
              break;
            }
            if (C) {
              if (!Ir(n, function(K, H) {
                if (!wn(C, H) && (P === K || l(P, K, i, s, d)))
                  return C.push(H);
              })) {
                N = !1;
                break;
              }
            } else if (!(P === U || l(P, U, i, s, d))) {
              N = !1;
              break;
            }
          }
          return d.delete(e), d.delete(n), N;
        }
        function af(e, n, i, s, l, d, h) {
          switch (i) {
            case Xo:
              if (e.byteLength != n.byteLength || e.byteOffset != n.byteOffset)
                return !1;
              e = e.buffer, n = n.buffer;
            case Fn:
              return !(e.byteLength != n.byteLength || !d(new ft(e), new ft(n)));
            case Mn:
            case In:
            case Sn:
              return Qe(+e, +n);
            case Qn:
              return e.name == n.name && e.message == n.message;
            case xn:
            case vn:
              return e == n + "";
            case Ve:
              var m = wr;
            case Je:
              var A = s & ee;
              if (m || (m = st), e.size != n.size && !A)
                return !1;
              var M = h.get(e);
              if (M)
                return M == n;
              s |= uo, h.set(e, n);
              var S = Es(m(e), m(n), s, l, d, h);
              return h.delete(e), S;
            case ot:
              if (Dn)
                return Dn.call(e) == Dn.call(n);
          }
          return !1;
        }
        function sf(e, n, i, s, l, d) {
          var h = i & ee, m = ei(e), A = m.length, M = ei(n), S = M.length;
          if (A != S && !h)
            return !1;
          for (var x = A; x--; ) {
            var N = m[x];
            if (!(h ? N in n : V.call(n, N)))
              return !1;
          }
          var C = d.get(e), P = d.get(n);
          if (C && P)
            return C == n && P == e;
          var U = !0;
          d.set(e, n), d.set(n, e);
          for (var D = h; ++x < A; ) {
            N = m[x];
            var K = e[N], H = n[N];
            if (s)
              var Oe = h ? s(H, K, N, n, e, d) : s(K, H, N, e, n, d);
            if (!(Oe === r ? K === H || l(K, H, i, s, d) : Oe)) {
              U = !1;
              break;
            }
            D || (D = N == "constructor");
          }
          if (U && !D) {
            var Ie = e.constructor, ze = n.constructor;
            Ie != ze && "constructor" in e && "constructor" in n && !(typeof Ie == "function" && Ie instanceof Ie && typeof ze == "function" && ze instanceof ze) && (U = !1);
          }
          return d.delete(e), d.delete(n), U;
        }
        function mo(e) {
          return ui(Rs(e, r, Hs), e + "");
        }
        function ei(e) {
          return Ya(e, he, ri);
        }
        function oi(e) {
          return Ya(e, Fe, Bs);
        }
        var ni = gt ? function(e) {
          return gt.get(e);
        } : Mi;
        function kt(e) {
          for (var n = e.name + "", i = sn[n], s = V.call(sn, n) ? i.length : 0; s--; ) {
            var l = i[s], d = l.func;
            if (d == null || d == e)
              return l.name;
          }
          return n;
        }
        function dn(e) {
          var n = V.call(c, "placeholder") ? c : e;
          return n.placeholder;
        }
        function L() {
          var e = c.iteratee || yi;
          return e = e === yi ? es : e, arguments.length ? e(arguments[0], arguments[1]) : e;
        }
        function Dt(e, n) {
          var i = e.__data__;
          return mf(n) ? i[typeof n == "string" ? "string" : "hash"] : i.map;
        }
        function ti(e) {
          for (var n = he(e), i = n.length; i--; ) {
            var s = n[i], l = e[s];
            n[i] = [s, l, Ls(l)];
          }
          return n;
        }
        function Ko(e, n) {
          var i = bd(e, n);
          return Qa(i) ? i : r;
        }
        function uf(e) {
          var n = V.call(e, zo), i = e[zo];
          try {
            e[zo] = r;
            var s = !0;
          } catch {
          }
          var l = dt.call(e);
          return s && (n ? e[zo] = i : delete e[zo]), l;
        }
        var ri = Er ? function(e) {
          return e == null ? [] : (e = Y(e), Io(Er(e), function(n) {
            return Oa.call(e, n);
          }));
        } : Ii, Bs = Er ? function(e) {
          for (var n = []; e; )
            So(n, ri(e)), e = ht(e);
          return n;
        } : Ii, ye = Te;
        (Br && ye(new Br(new ArrayBuffer(1))) != Xo || En && ye(new En()) != Ve || kr && ye(kr.resolve()) != Wi || an && ye(new an()) != Je || Bn && ye(new Bn()) != Nn) && (ye = function(e) {
          var n = Te(e), i = n == co ? e.constructor : r, s = i ? qo(i) : "";
          if (s)
            switch (s) {
              case $d:
                return Xo;
              case Kd:
                return Ve;
              case qd:
                return Wi;
              case Hd:
                return Je;
              case Wd:
                return Nn;
            }
          return n;
        });
        function lf(e, n, i) {
          for (var s = -1, l = i.length; ++s < l; ) {
            var d = i[s], h = d.size;
            switch (d.type) {
              case "drop":
                e += h;
                break;
              case "dropRight":
                n -= h;
                break;
              case "take":
                n = ge(n, e + h);
                break;
              case "takeRight":
                e = fe(e, n - h);
                break;
            }
          }
          return { start: e, end: n };
        }
        function cf(e) {
          var n = e.match(_c);
          return n ? n[1].split(bc) : [];
        }
        function ks(e, n, i) {
          n = wo(n, e);
          for (var s = -1, l = n.length, d = !1; ++s < l; ) {
            var h = Xe(n[s]);
            if (!(d = e != null && i(e, h)))
              break;
            e = e[h];
          }
          return d || ++s != l ? d : (l = e == null ? 0 : e.length, !!l && Zt(l) && _o(h, l) && (G(e) || Ho(e)));
        }
        function df(e) {
          var n = e.length, i = new e.constructor(n);
          return n && typeof e[0] == "string" && V.call(e, "index") && (i.index = e.index, i.input = e.input), i;
        }
        function Ds(e) {
          return typeof e.constructor == "function" && !Zn(e) ? un(ht(e)) : {};
        }
        function pf(e, n, i) {
          var s = e.constructor;
          switch (n) {
            case Fn:
              return Yr(e);
            case Mn:
            case In:
              return new s(+e);
            case Xo:
              return Vp(e, i);
            case tr:
            case rr:
            case ir:
            case ar:
            case sr:
            case ur:
            case lr:
            case cr:
            case dr:
              return _s(e, i);
            case Ve:
              return new s();
            case Sn:
            case vn:
              return new s(e);
            case xn:
              return Jp(e);
            case Je:
              return new s();
            case ot:
              return jp(e);
          }
        }
        function ff(e, n) {
          var i = n.length;
          if (!i)
            return e;
          var s = i - 1;
          return n[s] = (i > 1 ? "& " : "") + n[s], n = n.join(i > 2 ? ", " : " "), e.replace(mc, `{
/* [wrapped with ` + n + `] */
`);
        }
        function hf(e) {
          return G(e) || Ho(e) || !!(za && e && e[za]);
        }
        function _o(e, n) {
          var i = typeof e;
          return n = n ?? Mo, !!n && (i == "number" || i != "symbol" && xc.test(e)) && e > -1 && e % 1 == 0 && e < n;
        }
        function Me(e, n, i) {
          if (!re(i))
            return !1;
          var s = typeof n;
          return (s == "number" ? Ne(i) && _o(n, i.length) : s == "string" && n in i) ? Qe(i[n], e) : !1;
        }
        function ii(e, n) {
          if (G(e))
            return !1;
          var i = typeof e;
          return i == "number" || i == "symbol" || i == "boolean" || e == null || Re(e) ? !0 : dc.test(e) || !cc.test(e) || n != null && e in Y(n);
        }
        function mf(e) {
          var n = typeof e;
          return n == "string" || n == "number" || n == "symbol" || n == "boolean" ? e !== "__proto__" : e === null;
        }
        function ai(e) {
          var n = kt(e), i = c[n];
          if (typeof i != "function" || !(n in q.prototype))
            return !1;
          if (e === i)
            return !0;
          var s = ni(i);
          return !!s && e === s[0];
        }
        function _f(e) {
          return !!La && La in e;
        }
        var bf = lt ? bo : Si;
        function Zn(e) {
          var n = e && e.constructor, i = typeof n == "function" && n.prototype || rn;
          return e === i;
        }
        function Ls(e) {
          return e === e && !re(e);
        }
        function Ps(e, n) {
          return function(i) {
            return i == null ? !1 : i[e] === n && (n !== r || e in Y(i));
          };
        }
        function Af(e) {
          var n = zt(e, function(s) {
            return i.size === w && i.clear(), s;
          }), i = n.cache;
          return n;
        }
        function gf(e, n) {
          var i = e[1], s = n[1], l = i | s, d = l < (Ee | To | lo), h = s == lo && i == oe || s == lo && i == Tn && e[7].length <= n[8] || s == (lo | Tn) && n[7].length <= n[8] && i == oe;
          if (!(d || h))
            return e;
          s & Ee && (e[2] = n[2], l |= i & Ee ? 0 : Be);
          var m = n[3];
          if (m) {
            var A = e[3];
            e[3] = A ? As(A, m, n[4]) : m, e[4] = A ? xo(e[3], z) : n[4];
          }
          return m = n[5], m && (A = e[5], e[5] = A ? gs(A, m, n[6]) : m, e[6] = A ? xo(e[5], z) : n[6]), m = n[7], m && (e[7] = m), s & lo && (e[8] = e[8] == null ? n[8] : ge(e[8], n[8])), e[9] == null && (e[9] = n[9]), e[0] = n[0], e[1] = l, e;
        }
        function yf(e) {
          var n = [];
          if (e != null)
            for (var i in Y(e))
              n.push(i);
          return n;
        }
        function Tf(e) {
          return dt.call(e);
        }
        function Rs(e, n, i) {
          return n = fe(n === r ? e.length - 1 : n, 0), function() {
            for (var s = arguments, l = -1, d = fe(s.length - n, 0), h = g(d); ++l < d; )
              h[l] = s[n + l];
            l = -1;
            for (var m = g(n + 1); ++l < n; )
              m[l] = s[l];
            return m[n] = i(h), ke(e, this, m);
          };
        }
        function Os(e, n) {
          return n.length < 2 ? e : $o(e, Ke(n, 0, -1));
        }
        function Mf(e, n) {
          for (var i = e.length, s = ge(n.length, i), l = ve(e); s--; ) {
            var d = n[s];
            e[s] = _o(d, i) ? l[d] : r;
          }
          return e;
        }
        function si(e, n) {
          if (!(n === "constructor" && typeof e[n] == "function") && n != "__proto__")
            return e[n];
        }
        var zs = Zs(us), Un = Pd || function(e, n) {
          return _e.setTimeout(e, n);
        }, ui = Zs(Kp);
        function Gs(e, n, i) {
          var s = n + "";
          return ui(e, ff(s, If(cf(s), i)));
        }
        function Zs(e) {
          var n = 0, i = 0;
          return function() {
            var s = Gd(), l = Kl - (s - i);
            if (i = s, l > 0) {
              if (++n >= $l)
                return arguments[0];
            } else
              n = 0;
            return e.apply(r, arguments);
          };
        }
        function Lt(e, n) {
          var i = -1, s = e.length, l = s - 1;
          for (n = n === r ? s : n; ++i < n; ) {
            var d = Kr(i, l), h = e[d];
            e[d] = e[i], e[i] = h;
          }
          return e.length = n, e;
        }
        var Us = Af(function(e) {
          var n = [];
          return e.charCodeAt(0) === 46 && n.push(""), e.replace(pc, function(i, s, l, d) {
            n.push(l ? d.replace(gc, "$1") : s || i);
          }), n;
        });
        function Xe(e) {
          if (typeof e == "string" || Re(e))
            return e;
          var n = e + "";
          return n == "0" && 1 / e == -Ro ? "-0" : n;
        }
        function qo(e) {
          if (e != null) {
            try {
              return ct.call(e);
            } catch {
            }
            try {
              return e + "";
            } catch {
            }
          }
          return "";
        }
        function If(e, n) {
          return De(jl, function(i) {
            var s = "_." + i[0];
            n & i[1] && !it(e, s) && e.push(s);
          }), e.sort();
        }
        function $s(e) {
          if (e instanceof q)
            return e.clone();
          var n = new Ue(e.__wrapped__, e.__chain__);
          return n.__actions__ = ve(e.__actions__), n.__index__ = e.__index__, n.__values__ = e.__values__, n;
        }
        function Sf(e, n, i) {
          (i ? Me(e, n, i) : n === r) ? n = 1 : n = fe(Z(n), 0);
          var s = e == null ? 0 : e.length;
          if (!s || n < 1)
            return [];
          for (var l = 0, d = 0, h = g(bt(s / n)); l < s; )
            h[d++] = Ke(e, l, l += n);
          return h;
        }
        function xf(e) {
          for (var n = -1, i = e == null ? 0 : e.length, s = 0, l = []; ++n < i; ) {
            var d = e[n];
            d && (l[s++] = d);
          }
          return l;
        }
        function vf() {
          var e = arguments.length;
          if (!e)
            return [];
          for (var n = g(e - 1), i = arguments[0], s = e; s--; )
            n[s - 1] = arguments[s];
          return So(G(i) ? ve(i) : [i], be(n, 1));
        }
        var Nf = $(function(e, n) {
          return ue(e) ? Pn(e, be(n, 1, ue, !0)) : [];
        }), Ff = $(function(e, n) {
          var i = qe(n);
          return ue(i) && (i = r), ue(e) ? Pn(e, be(n, 1, ue, !0), L(i, 2)) : [];
        }), wf = $(function(e, n) {
          var i = qe(n);
          return ue(i) && (i = r), ue(e) ? Pn(e, be(n, 1, ue, !0), r, i) : [];
        });
        function Cf(e, n, i) {
          var s = e == null ? 0 : e.length;
          return s ? (n = i || n === r ? 1 : Z(n), Ke(e, n < 0 ? 0 : n, s)) : [];
        }
        function Ef(e, n, i) {
          var s = e == null ? 0 : e.length;
          return s ? (n = i || n === r ? 1 : Z(n), n = s - n, Ke(e, 0, n < 0 ? 0 : n)) : [];
        }
        function Bf(e, n) {
          return e && e.length ? Nt(e, L(n, 3), !0, !0) : [];
        }
        function kf(e, n) {
          return e && e.length ? Nt(e, L(n, 3), !0) : [];
        }
        function Df(e, n, i, s) {
          var l = e == null ? 0 : e.length;
          return l ? (i && typeof i != "number" && Me(e, n, i) && (i = 0, s = l), xp(e, n, i, s)) : [];
        }
        function Ks(e, n, i) {
          var s = e == null ? 0 : e.length;
          if (!s)
            return -1;
          var l = i == null ? 0 : Z(i);
          return l < 0 && (l = fe(s + l, 0)), at(e, L(n, 3), l);
        }
        function qs(e, n, i) {
          var s = e == null ? 0 : e.length;
          if (!s)
            return -1;
          var l = s - 1;
          return i !== r && (l = Z(i), l = i < 0 ? fe(s + l, 0) : ge(l, s - 1)), at(e, L(n, 3), l, !0);
        }
        function Hs(e) {
          var n = e == null ? 0 : e.length;
          return n ? be(e, 1) : [];
        }
        function Lf(e) {
          var n = e == null ? 0 : e.length;
          return n ? be(e, Ro) : [];
        }
        function Pf(e, n) {
          var i = e == null ? 0 : e.length;
          return i ? (n = n === r ? 1 : Z(n), be(e, n)) : [];
        }
        function Rf(e) {
          for (var n = -1, i = e == null ? 0 : e.length, s = {}; ++n < i; ) {
            var l = e[n];
            to(s, l[0], l[1]);
          }
          return s;
        }
        function Ws(e) {
          return e && e.length ? e[0] : r;
        }
        function Of(e, n, i) {
          var s = e == null ? 0 : e.length;
          if (!s)
            return -1;
          var l = i == null ? 0 : Z(i);
          return l < 0 && (l = fe(s + l, 0)), en(e, n, l);
        }
        function zf(e) {
          var n = e == null ? 0 : e.length;
          return n ? Ke(e, 0, -1) : [];
        }
        var Gf = $(function(e) {
          var n = ne(e, Jr);
          return n.length && n[0] === e[0] ? zr(n) : [];
        }), Zf = $(function(e) {
          var n = qe(e), i = ne(e, Jr);
          return n === qe(i) ? n = r : i.pop(), i.length && i[0] === e[0] ? zr(i, L(n, 2)) : [];
        }), Uf = $(function(e) {
          var n = qe(e), i = ne(e, Jr);
          return n = typeof n == "function" ? n : r, n && i.pop(), i.length && i[0] === e[0] ? zr(i, r, n) : [];
        });
        function $f(e, n) {
          return e == null ? "" : Od.call(e, n);
        }
        function qe(e) {
          var n = e == null ? 0 : e.length;
          return n ? e[n - 1] : r;
        }
        function Kf(e, n, i) {
          var s = e == null ? 0 : e.length;
          if (!s)
            return -1;
          var l = s;
          return i !== r && (l = Z(i), l = l < 0 ? fe(s + l, 0) : ge(l, s - 1)), n === n ? Md(e, n, l) : at(e, Na, l, !0);
        }
        function qf(e, n) {
          return e && e.length ? rs(e, Z(n)) : r;
        }
        var Hf = $(Vs);
        function Vs(e, n) {
          return e && e.length && n && n.length ? $r(e, n) : e;
        }
        function Wf(e, n, i) {
          return e && e.length && n && n.length ? $r(e, n, L(i, 2)) : e;
        }
        function Vf(e, n, i) {
          return e && e.length && n && n.length ? $r(e, n, r, i) : e;
        }
        var Jf = mo(function(e, n) {
          var i = e == null ? 0 : e.length, s = Lr(e, n);
          return ss(e, ne(n, function(l) {
            return _o(l, i) ? +l : l;
          }).sort(bs)), s;
        });
        function jf(e, n) {
          var i = [];
          if (!(e && e.length))
            return i;
          var s = -1, l = [], d = e.length;
          for (n = L(n, 3); ++s < d; ) {
            var h = e[s];
            n(h, s, e) && (i.push(h), l.push(s));
          }
          return ss(e, l), i;
        }
        function li(e) {
          return e == null ? e : Ud.call(e);
        }
        function Yf(e, n, i) {
          var s = e == null ? 0 : e.length;
          return s ? (i && typeof i != "number" && Me(e, n, i) ? (n = 0, i = s) : (n = n == null ? 0 : Z(n), i = i === r ? s : Z(i)), Ke(e, n, i)) : [];
        }
        function Xf(e, n) {
          return vt(e, n);
        }
        function Qf(e, n, i) {
          return Hr(e, n, L(i, 2));
        }
        function eh(e, n) {
          var i = e == null ? 0 : e.length;
          if (i) {
            var s = vt(e, n);
            if (s < i && Qe(e[s], n))
              return s;
          }
          return -1;
        }
        function oh(e, n) {
          return vt(e, n, !0);
        }
        function nh(e, n, i) {
          return Hr(e, n, L(i, 2), !0);
        }
        function th(e, n) {
          var i = e == null ? 0 : e.length;
          if (i) {
            var s = vt(e, n, !0) - 1;
            if (Qe(e[s], n))
              return s;
          }
          return -1;
        }
        function rh(e) {
          return e && e.length ? ls(e) : [];
        }
        function ih(e, n) {
          return e && e.length ? ls(e, L(n, 2)) : [];
        }
        function ah(e) {
          var n = e == null ? 0 : e.length;
          return n ? Ke(e, 1, n) : [];
        }
        function sh(e, n, i) {
          return e && e.length ? (n = i || n === r ? 1 : Z(n), Ke(e, 0, n < 0 ? 0 : n)) : [];
        }
        function uh(e, n, i) {
          var s = e == null ? 0 : e.length;
          return s ? (n = i || n === r ? 1 : Z(n), n = s - n, Ke(e, n < 0 ? 0 : n, s)) : [];
        }
        function lh(e, n) {
          return e && e.length ? Nt(e, L(n, 3), !1, !0) : [];
        }
        function ch(e, n) {
          return e && e.length ? Nt(e, L(n, 3)) : [];
        }
        var dh = $(function(e) {
          return Fo(be(e, 1, ue, !0));
        }), ph = $(function(e) {
          var n = qe(e);
          return ue(n) && (n = r), Fo(be(e, 1, ue, !0), L(n, 2));
        }), fh = $(function(e) {
          var n = qe(e);
          return n = typeof n == "function" ? n : r, Fo(be(e, 1, ue, !0), r, n);
        });
        function hh(e) {
          return e && e.length ? Fo(e) : [];
        }
        function mh(e, n) {
          return e && e.length ? Fo(e, L(n, 2)) : [];
        }
        function _h(e, n) {
          return n = typeof n == "function" ? n : r, e && e.length ? Fo(e, r, n) : [];
        }
        function ci(e) {
          if (!(e && e.length))
            return [];
          var n = 0;
          return e = Io(e, function(i) {
            if (ue(i))
              return n = fe(i.length, n), !0;
          }), Nr(n, function(i) {
            return ne(e, Sr(i));
          });
        }
        function Js(e, n) {
          if (!(e && e.length))
            return [];
          var i = ci(e);
          return n == null ? i : ne(i, function(s) {
            return ke(n, r, s);
          });
        }
        var bh = $(function(e, n) {
          return ue(e) ? Pn(e, n) : [];
        }), Ah = $(function(e) {
          return Vr(Io(e, ue));
        }), gh = $(function(e) {
          var n = qe(e);
          return ue(n) && (n = r), Vr(Io(e, ue), L(n, 2));
        }), yh = $(function(e) {
          var n = qe(e);
          return n = typeof n == "function" ? n : r, Vr(Io(e, ue), r, n);
        }), Th = $(ci);
        function Mh(e, n) {
          return fs(e || [], n || [], Ln);
        }
        function Ih(e, n) {
          return fs(e || [], n || [], zn);
        }
        var Sh = $(function(e) {
          var n = e.length, i = n > 1 ? e[n - 1] : r;
          return i = typeof i == "function" ? (e.pop(), i) : r, Js(e, i);
        });
        function js(e) {
          var n = c(e);
          return n.__chain__ = !0, n;
        }
        function xh(e, n) {
          return n(e), e;
        }
        function Pt(e, n) {
          return n(e);
        }
        var vh = mo(function(e) {
          var n = e.length, i = n ? e[0] : 0, s = this.__wrapped__, l = function(d) {
            return Lr(d, e);
          };
          return n > 1 || this.__actions__.length || !(s instanceof q) || !_o(i) ? this.thru(l) : (s = s.slice(i, +i + (n ? 1 : 0)), s.__actions__.push({
            func: Pt,
            args: [l],
            thisArg: r
          }), new Ue(s, this.__chain__).thru(function(d) {
            return n && !d.length && d.push(r), d;
          }));
        });
        function Nh() {
          return js(this);
        }
        function Fh() {
          return new Ue(this.value(), this.__chain__);
        }
        function wh() {
          this.__values__ === r && (this.__values__ = cu(this.value()));
          var e = this.__index__ >= this.__values__.length, n = e ? r : this.__values__[this.__index__++];
          return { done: e, value: n };
        }
        function Ch() {
          return this;
        }
        function Eh(e) {
          for (var n, i = this; i instanceof Tt; ) {
            var s = $s(i);
            s.__index__ = 0, s.__values__ = r, n ? l.__wrapped__ = s : n = s;
            var l = s;
            i = i.__wrapped__;
          }
          return l.__wrapped__ = e, n;
        }
        function Bh() {
          var e = this.__wrapped__;
          if (e instanceof q) {
            var n = e;
            return this.__actions__.length && (n = new q(this)), n = n.reverse(), n.__actions__.push({
              func: Pt,
              args: [li],
              thisArg: r
            }), new Ue(n, this.__chain__);
          }
          return this.thru(li);
        }
        function kh() {
          return ps(this.__wrapped__, this.__actions__);
        }
        var Dh = Ft(function(e, n, i) {
          V.call(e, i) ? ++e[i] : to(e, i, 1);
        });
        function Lh(e, n, i) {
          var s = G(e) ? xa : Sp;
          return i && Me(e, n, i) && (n = r), s(e, L(n, 3));
        }
        function Ph(e, n) {
          var i = G(e) ? Io : Ja;
          return i(e, L(n, 3));
        }
        var Rh = Is(Ks), Oh = Is(qs);
        function zh(e, n) {
          return be(Rt(e, n), 1);
        }
        function Gh(e, n) {
          return be(Rt(e, n), Ro);
        }
        function Zh(e, n, i) {
          return i = i === r ? 1 : Z(i), be(Rt(e, n), i);
        }
        function Ys(e, n) {
          var i = G(e) ? De : No;
          return i(e, L(n, 3));
        }
        function Xs(e, n) {
          var i = G(e) ? id : Va;
          return i(e, L(n, 3));
        }
        var Uh = Ft(function(e, n, i) {
          V.call(e, i) ? e[i].push(n) : to(e, i, [n]);
        });
        function $h(e, n, i, s) {
          e = Ne(e) ? e : fn(e), i = i && !s ? Z(i) : 0;
          var l = e.length;
          return i < 0 && (i = fe(l + i, 0)), Ut(e) ? i <= l && e.indexOf(n, i) > -1 : !!l && en(e, n, i) > -1;
        }
        var Kh = $(function(e, n, i) {
          var s = -1, l = typeof n == "function", d = Ne(e) ? g(e.length) : [];
          return No(e, function(h) {
            d[++s] = l ? ke(n, h, i) : Rn(h, n, i);
          }), d;
        }), qh = Ft(function(e, n, i) {
          to(e, i, n);
        });
        function Rt(e, n) {
          var i = G(e) ? ne : os;
          return i(e, L(n, 3));
        }
        function Hh(e, n, i, s) {
          return e == null ? [] : (G(n) || (n = n == null ? [] : [n]), i = s ? r : i, G(i) || (i = i == null ? [] : [i]), is(e, n, i));
        }
        var Wh = Ft(function(e, n, i) {
          e[i ? 0 : 1].push(n);
        }, function() {
          return [[], []];
        });
        function Vh(e, n, i) {
          var s = G(e) ? Mr : wa, l = arguments.length < 3;
          return s(e, L(n, 4), i, l, No);
        }
        function Jh(e, n, i) {
          var s = G(e) ? ad : wa, l = arguments.length < 3;
          return s(e, L(n, 4), i, l, Va);
        }
        function jh(e, n) {
          var i = G(e) ? Io : Ja;
          return i(e, Gt(L(n, 3)));
        }
        function Yh(e) {
          var n = G(e) ? Ka : Up;
          return n(e);
        }
        function Xh(e, n, i) {
          (i ? Me(e, n, i) : n === r) ? n = 1 : n = Z(n);
          var s = G(e) ? gp : $p;
          return s(e, n);
        }
        function Qh(e) {
          var n = G(e) ? yp : qp;
          return n(e);
        }
        function em(e) {
          if (e == null)
            return 0;
          if (Ne(e))
            return Ut(e) ? nn(e) : e.length;
          var n = ye(e);
          return n == Ve || n == Je ? e.size : Zr(e).length;
        }
        function om(e, n, i) {
          var s = G(e) ? Ir : Hp;
          return i && Me(e, n, i) && (n = r), s(e, L(n, 3));
        }
        var nm = $(function(e, n) {
          if (e == null)
            return [];
          var i = n.length;
          return i > 1 && Me(e, n[0], n[1]) ? n = [] : i > 2 && Me(n[0], n[1], n[2]) && (n = [n[0]]), is(e, be(n, 1), []);
        }), Ot = Ld || function() {
          return _e.Date.now();
        };
        function tm(e, n) {
          if (typeof n != "function")
            throw new Ze(p);
          return e = Z(e), function() {
            if (--e < 1)
              return n.apply(this, arguments);
          };
        }
        function Qs(e, n, i) {
          return n = i ? r : n, n = e && n == null ? e.length : n, ho(e, lo, r, r, r, r, n);
        }
        function eu(e, n) {
          var i;
          if (typeof n != "function")
            throw new Ze(p);
          return e = Z(e), function() {
            return --e > 0 && (i = n.apply(this, arguments)), e <= 1 && (n = r), i;
          };
        }
        var di = $(function(e, n, i) {
          var s = Ee;
          if (i.length) {
            var l = xo(i, dn(di));
            s |= oo;
          }
          return ho(e, s, n, i, l);
        }), ou = $(function(e, n, i) {
          var s = Ee | To;
          if (i.length) {
            var l = xo(i, dn(ou));
            s |= oo;
          }
          return ho(n, s, e, i, l);
        });
        function nu(e, n, i) {
          n = i ? r : n;
          var s = ho(e, oe, r, r, r, r, r, n);
          return s.placeholder = nu.placeholder, s;
        }
        function tu(e, n, i) {
          n = i ? r : n;
          var s = ho(e, me, r, r, r, r, r, n);
          return s.placeholder = tu.placeholder, s;
        }
        function ru(e, n, i) {
          var s, l, d, h, m, A, M = 0, S = !1, x = !1, N = !0;
          if (typeof e != "function")
            throw new Ze(p);
          n = He(n) || 0, re(i) && (S = !!i.leading, x = "maxWait" in i, d = x ? fe(He(i.maxWait) || 0, n) : d, N = "trailing" in i ? !!i.trailing : N);
          function C(le) {
            var eo = s, go = l;
            return s = l = r, M = le, h = e.apply(go, eo), h;
          }
          function P(le) {
            return M = le, m = Un(K, n), S ? C(le) : h;
          }
          function U(le) {
            var eo = le - A, go = le - M, Su = n - eo;
            return x ? ge(Su, d - go) : Su;
          }
          function D(le) {
            var eo = le - A, go = le - M;
            return A === r || eo >= n || eo < 0 || x && go >= d;
          }
          function K() {
            var le = Ot();
            if (D(le))
              return H(le);
            m = Un(K, U(le));
          }
          function H(le) {
            return m = r, N && s ? C(le) : (s = l = r, h);
          }
          function Oe() {
            m !== r && hs(m), M = 0, s = A = l = m = r;
          }
          function Ie() {
            return m === r ? h : H(Ot());
          }
          function ze() {
            var le = Ot(), eo = D(le);
            if (s = arguments, l = this, A = le, eo) {
              if (m === r)
                return P(A);
              if (x)
                return hs(m), m = Un(K, n), C(A);
            }
            return m === r && (m = Un(K, n)), h;
          }
          return ze.cancel = Oe, ze.flush = Ie, ze;
        }
        var rm = $(function(e, n) {
          return Wa(e, 1, n);
        }), im = $(function(e, n, i) {
          return Wa(e, He(n) || 0, i);
        });
        function am(e) {
          return ho(e, nr);
        }
        function zt(e, n) {
          if (typeof e != "function" || n != null && typeof n != "function")
            throw new Ze(p);
          var i = function() {
            var s = arguments, l = n ? n.apply(this, s) : s[0], d = i.cache;
            if (d.has(l))
              return d.get(l);
            var h = e.apply(this, s);
            return i.cache = d.set(l, h) || d, h;
          };
          return i.cache = new (zt.Cache || fo)(), i;
        }
        zt.Cache = fo;
        function Gt(e) {
          if (typeof e != "function")
            throw new Ze(p);
          return function() {
            var n = arguments;
            switch (n.length) {
              case 0:
                return !e.call(this);
              case 1:
                return !e.call(this, n[0]);
              case 2:
                return !e.call(this, n[0], n[1]);
              case 3:
                return !e.call(this, n[0], n[1], n[2]);
            }
            return !e.apply(this, n);
          };
        }
        function sm(e) {
          return eu(2, e);
        }
        var um = Wp(function(e, n) {
          n = n.length == 1 && G(n[0]) ? ne(n[0], Le(L())) : ne(be(n, 1), Le(L()));
          var i = n.length;
          return $(function(s) {
            for (var l = -1, d = ge(s.length, i); ++l < d; )
              s[l] = n[l].call(this, s[l]);
            return ke(e, this, s);
          });
        }), pi = $(function(e, n) {
          var i = xo(n, dn(pi));
          return ho(e, oo, r, n, i);
        }), iu = $(function(e, n) {
          var i = xo(n, dn(iu));
          return ho(e, Po, r, n, i);
        }), lm = mo(function(e, n) {
          return ho(e, Tn, r, r, r, n);
        });
        function cm(e, n) {
          if (typeof e != "function")
            throw new Ze(p);
          return n = n === r ? n : Z(n), $(e, n);
        }
        function dm(e, n) {
          if (typeof e != "function")
            throw new Ze(p);
          return n = n == null ? 0 : fe(Z(n), 0), $(function(i) {
            var s = i[n], l = Co(i, 0, n);
            return s && So(l, s), ke(e, this, l);
          });
        }
        function pm(e, n, i) {
          var s = !0, l = !0;
          if (typeof e != "function")
            throw new Ze(p);
          return re(i) && (s = "leading" in i ? !!i.leading : s, l = "trailing" in i ? !!i.trailing : l), ru(e, n, {
            leading: s,
            maxWait: n,
            trailing: l
          });
        }
        function fm(e) {
          return Qs(e, 1);
        }
        function hm(e, n) {
          return pi(jr(n), e);
        }
        function mm() {
          if (!arguments.length)
            return [];
          var e = arguments[0];
          return G(e) ? e : [e];
        }
        function _m(e) {
          return $e(e, ae);
        }
        function bm(e, n) {
          return n = typeof n == "function" ? n : r, $e(e, ae, n);
        }
        function Am(e) {
          return $e(e, B | ae);
        }
        function gm(e, n) {
          return n = typeof n == "function" ? n : r, $e(e, B | ae, n);
        }
        function ym(e, n) {
          return n == null || Ha(e, n, he(n));
        }
        function Qe(e, n) {
          return e === n || e !== e && n !== n;
        }
        var Tm = Bt(Or), Mm = Bt(function(e, n) {
          return e >= n;
        }), Ho = Xa(/* @__PURE__ */ (function() {
          return arguments;
        })()) ? Xa : function(e) {
          return se(e) && V.call(e, "callee") && !Oa.call(e, "callee");
        }, G = g.isArray, Im = ga ? Le(ga) : Cp;
        function Ne(e) {
          return e != null && Zt(e.length) && !bo(e);
        }
        function ue(e) {
          return se(e) && Ne(e);
        }
        function Sm(e) {
          return e === !0 || e === !1 || se(e) && Te(e) == Mn;
        }
        var Eo = Rd || Si, xm = ya ? Le(ya) : Ep;
        function vm(e) {
          return se(e) && e.nodeType === 1 && !$n(e);
        }
        function Nm(e) {
          if (e == null)
            return !0;
          if (Ne(e) && (G(e) || typeof e == "string" || typeof e.splice == "function" || Eo(e) || pn(e) || Ho(e)))
            return !e.length;
          var n = ye(e);
          if (n == Ve || n == Je)
            return !e.size;
          if (Zn(e))
            return !Zr(e).length;
          for (var i in e)
            if (V.call(e, i))
              return !1;
          return !0;
        }
        function Fm(e, n) {
          return On(e, n);
        }
        function wm(e, n, i) {
          i = typeof i == "function" ? i : r;
          var s = i ? i(e, n) : r;
          return s === r ? On(e, n, r, i) : !!s;
        }
        function fi(e) {
          if (!se(e))
            return !1;
          var n = Te(e);
          return n == Qn || n == Xl || typeof e.message == "string" && typeof e.name == "string" && !$n(e);
        }
        function Cm(e) {
          return typeof e == "number" && Ga(e);
        }
        function bo(e) {
          if (!re(e))
            return !1;
          var n = Te(e);
          return n == et || n == Hi || n == Yl || n == ec;
        }
        function au(e) {
          return typeof e == "number" && e == Z(e);
        }
        function Zt(e) {
          return typeof e == "number" && e > -1 && e % 1 == 0 && e <= Mo;
        }
        function re(e) {
          var n = typeof e;
          return e != null && (n == "object" || n == "function");
        }
        function se(e) {
          return e != null && typeof e == "object";
        }
        var su = Ta ? Le(Ta) : kp;
        function Em(e, n) {
          return e === n || Gr(e, n, ti(n));
        }
        function Bm(e, n, i) {
          return i = typeof i == "function" ? i : r, Gr(e, n, ti(n), i);
        }
        function km(e) {
          return uu(e) && e != +e;
        }
        function Dm(e) {
          if (bf(e))
            throw new O(f);
          return Qa(e);
        }
        function Lm(e) {
          return e === null;
        }
        function Pm(e) {
          return e == null;
        }
        function uu(e) {
          return typeof e == "number" || se(e) && Te(e) == Sn;
        }
        function $n(e) {
          if (!se(e) || Te(e) != co)
            return !1;
          var n = ht(e);
          if (n === null)
            return !0;
          var i = V.call(n, "constructor") && n.constructor;
          return typeof i == "function" && i instanceof i && ct.call(i) == Ed;
        }
        var hi = Ma ? Le(Ma) : Dp;
        function Rm(e) {
          return au(e) && e >= -Mo && e <= Mo;
        }
        var lu = Ia ? Le(Ia) : Lp;
        function Ut(e) {
          return typeof e == "string" || !G(e) && se(e) && Te(e) == vn;
        }
        function Re(e) {
          return typeof e == "symbol" || se(e) && Te(e) == ot;
        }
        var pn = Sa ? Le(Sa) : Pp;
        function Om(e) {
          return e === r;
        }
        function zm(e) {
          return se(e) && ye(e) == Nn;
        }
        function Gm(e) {
          return se(e) && Te(e) == nc;
        }
        var Zm = Bt(Ur), Um = Bt(function(e, n) {
          return e <= n;
        });
        function cu(e) {
          if (!e)
            return [];
          if (Ne(e))
            return Ut(e) ? je(e) : ve(e);
          if (Cn && e[Cn])
            return gd(e[Cn]());
          var n = ye(e), i = n == Ve ? wr : n == Je ? st : fn;
          return i(e);
        }
        function Ao(e) {
          if (!e)
            return e === 0 ? e : 0;
          if (e = He(e), e === Ro || e === -Ro) {
            var n = e < 0 ? -1 : 1;
            return n * Wl;
          }
          return e === e ? e : 0;
        }
        function Z(e) {
          var n = Ao(e), i = n % 1;
          return n === n ? i ? n - i : n : 0;
        }
        function du(e) {
          return e ? Uo(Z(e), 0, no) : 0;
        }
        function He(e) {
          if (typeof e == "number")
            return e;
          if (Re(e))
            return Yn;
          if (re(e)) {
            var n = typeof e.valueOf == "function" ? e.valueOf() : e;
            e = re(n) ? n + "" : n;
          }
          if (typeof e != "string")
            return e === 0 ? e : +e;
          e = Ca(e);
          var i = Mc.test(e);
          return i || Sc.test(e) ? nd(e.slice(2), i ? 2 : 8) : Tc.test(e) ? Yn : +e;
        }
        function pu(e) {
          return io(e, Fe(e));
        }
        function $m(e) {
          return e ? Uo(Z(e), -Mo, Mo) : e === 0 ? e : 0;
        }
        function J(e) {
          return e == null ? "" : Pe(e);
        }
        var Km = ln(function(e, n) {
          if (Zn(n) || Ne(n)) {
            io(n, he(n), e);
            return;
          }
          for (var i in n)
            V.call(n, i) && Ln(e, i, n[i]);
        }), fu = ln(function(e, n) {
          io(n, Fe(n), e);
        }), hu = ln(function(e, n, i, s) {
          io(n, Fe(n), e, s);
        }), mi = ln(function(e, n, i, s) {
          io(n, he(n), e, s);
        }), qm = mo(Lr);
        function Hm(e, n) {
          var i = un(e);
          return n == null ? i : qa(i, n);
        }
        var Wm = $(function(e, n) {
          e = Y(e);
          var i = -1, s = n.length, l = s > 2 ? n[2] : r;
          for (l && Me(n[0], n[1], l) && (s = 1); ++i < s; )
            for (var d = n[i], h = Fe(d), m = -1, A = h.length; ++m < A; ) {
              var M = h[m], S = e[M];
              (S === r || Qe(S, rn[M]) && !V.call(e, M)) && (e[M] = d[M]);
            }
          return e;
        }), Vm = $(function(e) {
          return e.push(r, Cs), ke(mu, r, e);
        });
        function Jm(e, n) {
          return va(e, L(n, 3), ro);
        }
        function jm(e, n) {
          return va(e, L(n, 3), Rr);
        }
        function Ym(e, n) {
          return e == null ? e : Pr(e, L(n, 3), Fe);
        }
        function Xm(e, n) {
          return e == null ? e : ja(e, L(n, 3), Fe);
        }
        function Qm(e, n) {
          return e && ro(e, L(n, 3));
        }
        function e_(e, n) {
          return e && Rr(e, L(n, 3));
        }
        function o_(e) {
          return e == null ? [] : St(e, he(e));
        }
        function n_(e) {
          return e == null ? [] : St(e, Fe(e));
        }
        function _i(e, n, i) {
          var s = e == null ? r : $o(e, n);
          return s === r ? i : s;
        }
        function t_(e, n) {
          return e != null && ks(e, n, vp);
        }
        function bi(e, n) {
          return e != null && ks(e, n, Np);
        }
        var r_ = xs(function(e, n, i) {
          n != null && typeof n.toString != "function" && (n = dt.call(n)), e[n] = i;
        }, gi(we)), i_ = xs(function(e, n, i) {
          n != null && typeof n.toString != "function" && (n = dt.call(n)), V.call(e, n) ? e[n].push(i) : e[n] = [i];
        }, L), a_ = $(Rn);
        function he(e) {
          return Ne(e) ? $a(e) : Zr(e);
        }
        function Fe(e) {
          return Ne(e) ? $a(e, !0) : Rp(e);
        }
        function s_(e, n) {
          var i = {};
          return n = L(n, 3), ro(e, function(s, l, d) {
            to(i, n(s, l, d), s);
          }), i;
        }
        function u_(e, n) {
          var i = {};
          return n = L(n, 3), ro(e, function(s, l, d) {
            to(i, l, n(s, l, d));
          }), i;
        }
        var l_ = ln(function(e, n, i) {
          xt(e, n, i);
        }), mu = ln(function(e, n, i, s) {
          xt(e, n, i, s);
        }), c_ = mo(function(e, n) {
          var i = {};
          if (e == null)
            return i;
          var s = !1;
          n = ne(n, function(d) {
            return d = wo(d, e), s || (s = d.length > 1), d;
          }), io(e, oi(e), i), s && (i = $e(i, B | R | ae, rf));
          for (var l = n.length; l--; )
            Wr(i, n[l]);
          return i;
        });
        function d_(e, n) {
          return _u(e, Gt(L(n)));
        }
        var p_ = mo(function(e, n) {
          return e == null ? {} : zp(e, n);
        });
        function _u(e, n) {
          if (e == null)
            return {};
          var i = ne(oi(e), function(s) {
            return [s];
          });
          return n = L(n), as(e, i, function(s, l) {
            return n(s, l[0]);
          });
        }
        function f_(e, n, i) {
          n = wo(n, e);
          var s = -1, l = n.length;
          for (l || (l = 1, e = r); ++s < l; ) {
            var d = e == null ? r : e[Xe(n[s])];
            d === r && (s = l, d = i), e = bo(d) ? d.call(e) : d;
          }
          return e;
        }
        function h_(e, n, i) {
          return e == null ? e : zn(e, n, i);
        }
        function m_(e, n, i, s) {
          return s = typeof s == "function" ? s : r, e == null ? e : zn(e, n, i, s);
        }
        var bu = Fs(he), Au = Fs(Fe);
        function __(e, n, i) {
          var s = G(e), l = s || Eo(e) || pn(e);
          if (n = L(n, 4), i == null) {
            var d = e && e.constructor;
            l ? i = s ? new d() : [] : re(e) ? i = bo(d) ? un(ht(e)) : {} : i = {};
          }
          return (l ? De : ro)(e, function(h, m, A) {
            return n(i, h, m, A);
          }), i;
        }
        function b_(e, n) {
          return e == null ? !0 : Wr(e, n);
        }
        function A_(e, n, i) {
          return e == null ? e : ds(e, n, jr(i));
        }
        function g_(e, n, i, s) {
          return s = typeof s == "function" ? s : r, e == null ? e : ds(e, n, jr(i), s);
        }
        function fn(e) {
          return e == null ? [] : Fr(e, he(e));
        }
        function y_(e) {
          return e == null ? [] : Fr(e, Fe(e));
        }
        function T_(e, n, i) {
          return i === r && (i = n, n = r), i !== r && (i = He(i), i = i === i ? i : 0), n !== r && (n = He(n), n = n === n ? n : 0), Uo(He(e), n, i);
        }
        function M_(e, n, i) {
          return n = Ao(n), i === r ? (i = n, n = 0) : i = Ao(i), e = He(e), Fp(e, n, i);
        }
        function I_(e, n, i) {
          if (i && typeof i != "boolean" && Me(e, n, i) && (n = i = r), i === r && (typeof n == "boolean" ? (i = n, n = r) : typeof e == "boolean" && (i = e, e = r)), e === r && n === r ? (e = 0, n = 1) : (e = Ao(e), n === r ? (n = e, e = 0) : n = Ao(n)), e > n) {
            var s = e;
            e = n, n = s;
          }
          if (i || e % 1 || n % 1) {
            var l = Za();
            return ge(e + l * (n - e + od("1e-" + ((l + "").length - 1))), n);
          }
          return Kr(e, n);
        }
        var S_ = cn(function(e, n, i) {
          return n = n.toLowerCase(), e + (i ? gu(n) : n);
        });
        function gu(e) {
          return Ai(J(e).toLowerCase());
        }
        function yu(e) {
          return e = J(e), e && e.replace(vc, hd).replace(qc, "");
        }
        function x_(e, n, i) {
          e = J(e), n = Pe(n);
          var s = e.length;
          i = i === r ? s : Uo(Z(i), 0, s);
          var l = i;
          return i -= n.length, i >= 0 && e.slice(i, l) == n;
        }
        function v_(e) {
          return e = J(e), e && sc.test(e) ? e.replace(Ji, md) : e;
        }
        function N_(e) {
          return e = J(e), e && fc.test(e) ? e.replace(pr, "\\$&") : e;
        }
        var F_ = cn(function(e, n, i) {
          return e + (i ? "-" : "") + n.toLowerCase();
        }), w_ = cn(function(e, n, i) {
          return e + (i ? " " : "") + n.toLowerCase();
        }), C_ = Ms("toLowerCase");
        function E_(e, n, i) {
          e = J(e), n = Z(n);
          var s = n ? nn(e) : 0;
          if (!n || s >= n)
            return e;
          var l = (n - s) / 2;
          return Et(At(l), i) + e + Et(bt(l), i);
        }
        function B_(e, n, i) {
          e = J(e), n = Z(n);
          var s = n ? nn(e) : 0;
          return n && s < n ? e + Et(n - s, i) : e;
        }
        function k_(e, n, i) {
          e = J(e), n = Z(n);
          var s = n ? nn(e) : 0;
          return n && s < n ? Et(n - s, i) + e : e;
        }
        function D_(e, n, i) {
          return i || n == null ? n = 0 : n && (n = +n), Zd(J(e).replace(fr, ""), n || 0);
        }
        function L_(e, n, i) {
          return (i ? Me(e, n, i) : n === r) ? n = 1 : n = Z(n), qr(J(e), n);
        }
        function P_() {
          var e = arguments, n = J(e[0]);
          return e.length < 3 ? n : n.replace(e[1], e[2]);
        }
        var R_ = cn(function(e, n, i) {
          return e + (i ? "_" : "") + n.toLowerCase();
        });
        function O_(e, n, i) {
          return i && typeof i != "number" && Me(e, n, i) && (n = i = r), i = i === r ? no : i >>> 0, i ? (e = J(e), e && (typeof n == "string" || n != null && !hi(n)) && (n = Pe(n), !n && on(e)) ? Co(je(e), 0, i) : e.split(n, i)) : [];
        }
        var z_ = cn(function(e, n, i) {
          return e + (i ? " " : "") + Ai(n);
        });
        function G_(e, n, i) {
          return e = J(e), i = i == null ? 0 : Uo(Z(i), 0, e.length), n = Pe(n), e.slice(i, i + n.length) == n;
        }
        function Z_(e, n, i) {
          var s = c.templateSettings;
          i && Me(e, n, i) && (n = r), e = J(e), n = mi({}, n, s, ws);
          var l = mi({}, n.imports, s.imports, ws), d = he(l), h = Fr(l, d);
          De(d, function(D) {
            if (Yi.test(D))
              throw new O(T);
          });
          var m, A, M = 0, S = n.interpolate || nt, x = "__p += '", N = Cr(
            (n.escape || nt).source + "|" + S.source + "|" + (S === ji ? yc : nt).source + "|" + (n.evaluate || nt).source + "|$",
            "g"
          ), C = "//# sourceURL=" + (V.call(n, "sourceURL") ? (n.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++jc + "]") + `
`;
          e.replace(N, function(D, K, H, Oe, Ie, ze) {
            return H || (H = Oe), x += e.slice(M, ze).replace(Nc, _d), K && (m = !0, x += `' +
__e(` + K + `) +
'`), Ie && (A = !0, x += `';
` + Ie + `;
__p += '`), H && (x += `' +
((__t = (` + H + `)) == null ? '' : __t) +
'`), M = ze + D.length, D;
          }), x += `';
`;
          var P = V.call(n, "variable") && n.variable;
          if (!P)
            x = `with (obj) {
` + x + `
}
`;
          else if (Yi.test(P))
            throw new O(b);
          x = (A ? x.replace(tc, "") : x).replace(rc, "$1").replace(ic, "$1;"), x = "function(" + (P || "obj") + `) {
` + (P ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (m ? ", __e = _.escape" : "") + (A ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + x + `return __p
}`;
          var U = Mu(function() {
            return W(d, C + "return " + x).apply(r, h);
          });
          if (U.source = x, fi(U))
            throw U;
          return U;
        }
        function U_(e) {
          return J(e).toLowerCase();
        }
        function $_(e) {
          return J(e).toUpperCase();
        }
        function K_(e, n, i) {
          if (e = J(e), e && (i || n === r))
            return Ca(e);
          if (!e || !(n = Pe(n)))
            return e;
          var s = je(e), l = je(n), d = Ea(s, l), h = Ba(s, l) + 1;
          return Co(s, d, h).join("");
        }
        function q_(e, n, i) {
          if (e = J(e), e && (i || n === r))
            return e.slice(0, Da(e) + 1);
          if (!e || !(n = Pe(n)))
            return e;
          var s = je(e), l = Ba(s, je(n)) + 1;
          return Co(s, 0, l).join("");
        }
        function H_(e, n, i) {
          if (e = J(e), e && (i || n === r))
            return e.replace(fr, "");
          if (!e || !(n = Pe(n)))
            return e;
          var s = je(e), l = Ea(s, je(n));
          return Co(s, l).join("");
        }
        function W_(e, n) {
          var i = Zl, s = Ul;
          if (re(n)) {
            var l = "separator" in n ? n.separator : l;
            i = "length" in n ? Z(n.length) : i, s = "omission" in n ? Pe(n.omission) : s;
          }
          e = J(e);
          var d = e.length;
          if (on(e)) {
            var h = je(e);
            d = h.length;
          }
          if (i >= d)
            return e;
          var m = i - nn(s);
          if (m < 1)
            return s;
          var A = h ? Co(h, 0, m).join("") : e.slice(0, m);
          if (l === r)
            return A + s;
          if (h && (m += A.length - m), hi(l)) {
            if (e.slice(m).search(l)) {
              var M, S = A;
              for (l.global || (l = Cr(l.source, J(Xi.exec(l)) + "g")), l.lastIndex = 0; M = l.exec(S); )
                var x = M.index;
              A = A.slice(0, x === r ? m : x);
            }
          } else if (e.indexOf(Pe(l), m) != m) {
            var N = A.lastIndexOf(l);
            N > -1 && (A = A.slice(0, N));
          }
          return A + s;
        }
        function V_(e) {
          return e = J(e), e && ac.test(e) ? e.replace(Vi, Id) : e;
        }
        var J_ = cn(function(e, n, i) {
          return e + (i ? " " : "") + n.toUpperCase();
        }), Ai = Ms("toUpperCase");
        function Tu(e, n, i) {
          return e = J(e), n = i ? r : n, n === r ? Ad(e) ? vd(e) : ld(e) : e.match(n) || [];
        }
        var Mu = $(function(e, n) {
          try {
            return ke(e, r, n);
          } catch (i) {
            return fi(i) ? i : new O(i);
          }
        }), j_ = mo(function(e, n) {
          return De(n, function(i) {
            i = Xe(i), to(e, i, di(e[i], e));
          }), e;
        });
        function Y_(e) {
          var n = e == null ? 0 : e.length, i = L();
          return e = n ? ne(e, function(s) {
            if (typeof s[1] != "function")
              throw new Ze(p);
            return [i(s[0]), s[1]];
          }) : [], $(function(s) {
            for (var l = -1; ++l < n; ) {
              var d = e[l];
              if (ke(d[0], this, s))
                return ke(d[1], this, s);
            }
          });
        }
        function X_(e) {
          return Ip($e(e, B));
        }
        function gi(e) {
          return function() {
            return e;
          };
        }
        function Q_(e, n) {
          return e == null || e !== e ? n : e;
        }
        var e0 = Ss(), o0 = Ss(!0);
        function we(e) {
          return e;
        }
        function yi(e) {
          return es(typeof e == "function" ? e : $e(e, B));
        }
        function n0(e) {
          return ns($e(e, B));
        }
        function t0(e, n) {
          return ts(e, $e(n, B));
        }
        var r0 = $(function(e, n) {
          return function(i) {
            return Rn(i, e, n);
          };
        }), i0 = $(function(e, n) {
          return function(i) {
            return Rn(e, i, n);
          };
        });
        function Ti(e, n, i) {
          var s = he(n), l = St(n, s);
          i == null && !(re(n) && (l.length || !s.length)) && (i = n, n = e, e = this, l = St(n, he(n)));
          var d = !(re(i) && "chain" in i) || !!i.chain, h = bo(e);
          return De(l, function(m) {
            var A = n[m];
            e[m] = A, h && (e.prototype[m] = function() {
              var M = this.__chain__;
              if (d || M) {
                var S = e(this.__wrapped__), x = S.__actions__ = ve(this.__actions__);
                return x.push({ func: A, args: arguments, thisArg: e }), S.__chain__ = M, S;
              }
              return A.apply(e, So([this.value()], arguments));
            });
          }), e;
        }
        function a0() {
          return _e._ === this && (_e._ = Bd), this;
        }
        function Mi() {
        }
        function s0(e) {
          return e = Z(e), $(function(n) {
            return rs(n, e);
          });
        }
        var u0 = Xr(ne), l0 = Xr(xa), c0 = Xr(Ir);
        function Iu(e) {
          return ii(e) ? Sr(Xe(e)) : Gp(e);
        }
        function d0(e) {
          return function(n) {
            return e == null ? r : $o(e, n);
          };
        }
        var p0 = vs(), f0 = vs(!0);
        function Ii() {
          return [];
        }
        function Si() {
          return !1;
        }
        function h0() {
          return {};
        }
        function m0() {
          return "";
        }
        function _0() {
          return !0;
        }
        function b0(e, n) {
          if (e = Z(e), e < 1 || e > Mo)
            return [];
          var i = no, s = ge(e, no);
          n = L(n), e -= no;
          for (var l = Nr(s, n); ++i < e; )
            n(i);
          return l;
        }
        function A0(e) {
          return G(e) ? ne(e, Xe) : Re(e) ? [e] : ve(Us(J(e)));
        }
        function g0(e) {
          var n = ++Cd;
          return J(e) + n;
        }
        var y0 = Ct(function(e, n) {
          return e + n;
        }, 0), T0 = Qr("ceil"), M0 = Ct(function(e, n) {
          return e / n;
        }, 1), I0 = Qr("floor");
        function S0(e) {
          return e && e.length ? It(e, we, Or) : r;
        }
        function x0(e, n) {
          return e && e.length ? It(e, L(n, 2), Or) : r;
        }
        function v0(e) {
          return Fa(e, we);
        }
        function N0(e, n) {
          return Fa(e, L(n, 2));
        }
        function F0(e) {
          return e && e.length ? It(e, we, Ur) : r;
        }
        function w0(e, n) {
          return e && e.length ? It(e, L(n, 2), Ur) : r;
        }
        var C0 = Ct(function(e, n) {
          return e * n;
        }, 1), E0 = Qr("round"), B0 = Ct(function(e, n) {
          return e - n;
        }, 0);
        function k0(e) {
          return e && e.length ? vr(e, we) : 0;
        }
        function D0(e, n) {
          return e && e.length ? vr(e, L(n, 2)) : 0;
        }
        return c.after = tm, c.ary = Qs, c.assign = Km, c.assignIn = fu, c.assignInWith = hu, c.assignWith = mi, c.at = qm, c.before = eu, c.bind = di, c.bindAll = j_, c.bindKey = ou, c.castArray = mm, c.chain = js, c.chunk = Sf, c.compact = xf, c.concat = vf, c.cond = Y_, c.conforms = X_, c.constant = gi, c.countBy = Dh, c.create = Hm, c.curry = nu, c.curryRight = tu, c.debounce = ru, c.defaults = Wm, c.defaultsDeep = Vm, c.defer = rm, c.delay = im, c.difference = Nf, c.differenceBy = Ff, c.differenceWith = wf, c.drop = Cf, c.dropRight = Ef, c.dropRightWhile = Bf, c.dropWhile = kf, c.fill = Df, c.filter = Ph, c.flatMap = zh, c.flatMapDeep = Gh, c.flatMapDepth = Zh, c.flatten = Hs, c.flattenDeep = Lf, c.flattenDepth = Pf, c.flip = am, c.flow = e0, c.flowRight = o0, c.fromPairs = Rf, c.functions = o_, c.functionsIn = n_, c.groupBy = Uh, c.initial = zf, c.intersection = Gf, c.intersectionBy = Zf, c.intersectionWith = Uf, c.invert = r_, c.invertBy = i_, c.invokeMap = Kh, c.iteratee = yi, c.keyBy = qh, c.keys = he, c.keysIn = Fe, c.map = Rt, c.mapKeys = s_, c.mapValues = u_, c.matches = n0, c.matchesProperty = t0, c.memoize = zt, c.merge = l_, c.mergeWith = mu, c.method = r0, c.methodOf = i0, c.mixin = Ti, c.negate = Gt, c.nthArg = s0, c.omit = c_, c.omitBy = d_, c.once = sm, c.orderBy = Hh, c.over = u0, c.overArgs = um, c.overEvery = l0, c.overSome = c0, c.partial = pi, c.partialRight = iu, c.partition = Wh, c.pick = p_, c.pickBy = _u, c.property = Iu, c.propertyOf = d0, c.pull = Hf, c.pullAll = Vs, c.pullAllBy = Wf, c.pullAllWith = Vf, c.pullAt = Jf, c.range = p0, c.rangeRight = f0, c.rearg = lm, c.reject = jh, c.remove = jf, c.rest = cm, c.reverse = li, c.sampleSize = Xh, c.set = h_, c.setWith = m_, c.shuffle = Qh, c.slice = Yf, c.sortBy = nm, c.sortedUniq = rh, c.sortedUniqBy = ih, c.split = O_, c.spread = dm, c.tail = ah, c.take = sh, c.takeRight = uh, c.takeRightWhile = lh, c.takeWhile = ch, c.tap = xh, c.throttle = pm, c.thru = Pt, c.toArray = cu, c.toPairs = bu, c.toPairsIn = Au, c.toPath = A0, c.toPlainObject = pu, c.transform = __, c.unary = fm, c.union = dh, c.unionBy = ph, c.unionWith = fh, c.uniq = hh, c.uniqBy = mh, c.uniqWith = _h, c.unset = b_, c.unzip = ci, c.unzipWith = Js, c.update = A_, c.updateWith = g_, c.values = fn, c.valuesIn = y_, c.without = bh, c.words = Tu, c.wrap = hm, c.xor = Ah, c.xorBy = gh, c.xorWith = yh, c.zip = Th, c.zipObject = Mh, c.zipObjectDeep = Ih, c.zipWith = Sh, c.entries = bu, c.entriesIn = Au, c.extend = fu, c.extendWith = hu, Ti(c, c), c.add = y0, c.attempt = Mu, c.camelCase = S_, c.capitalize = gu, c.ceil = T0, c.clamp = T_, c.clone = _m, c.cloneDeep = Am, c.cloneDeepWith = gm, c.cloneWith = bm, c.conformsTo = ym, c.deburr = yu, c.defaultTo = Q_, c.divide = M0, c.endsWith = x_, c.eq = Qe, c.escape = v_, c.escapeRegExp = N_, c.every = Lh, c.find = Rh, c.findIndex = Ks, c.findKey = Jm, c.findLast = Oh, c.findLastIndex = qs, c.findLastKey = jm, c.floor = I0, c.forEach = Ys, c.forEachRight = Xs, c.forIn = Ym, c.forInRight = Xm, c.forOwn = Qm, c.forOwnRight = e_, c.get = _i, c.gt = Tm, c.gte = Mm, c.has = t_, c.hasIn = bi, c.head = Ws, c.identity = we, c.includes = $h, c.indexOf = Of, c.inRange = M_, c.invoke = a_, c.isArguments = Ho, c.isArray = G, c.isArrayBuffer = Im, c.isArrayLike = Ne, c.isArrayLikeObject = ue, c.isBoolean = Sm, c.isBuffer = Eo, c.isDate = xm, c.isElement = vm, c.isEmpty = Nm, c.isEqual = Fm, c.isEqualWith = wm, c.isError = fi, c.isFinite = Cm, c.isFunction = bo, c.isInteger = au, c.isLength = Zt, c.isMap = su, c.isMatch = Em, c.isMatchWith = Bm, c.isNaN = km, c.isNative = Dm, c.isNil = Pm, c.isNull = Lm, c.isNumber = uu, c.isObject = re, c.isObjectLike = se, c.isPlainObject = $n, c.isRegExp = hi, c.isSafeInteger = Rm, c.isSet = lu, c.isString = Ut, c.isSymbol = Re, c.isTypedArray = pn, c.isUndefined = Om, c.isWeakMap = zm, c.isWeakSet = Gm, c.join = $f, c.kebabCase = F_, c.last = qe, c.lastIndexOf = Kf, c.lowerCase = w_, c.lowerFirst = C_, c.lt = Zm, c.lte = Um, c.max = S0, c.maxBy = x0, c.mean = v0, c.meanBy = N0, c.min = F0, c.minBy = w0, c.stubArray = Ii, c.stubFalse = Si, c.stubObject = h0, c.stubString = m0, c.stubTrue = _0, c.multiply = C0, c.nth = qf, c.noConflict = a0, c.noop = Mi, c.now = Ot, c.pad = E_, c.padEnd = B_, c.padStart = k_, c.parseInt = D_, c.random = I_, c.reduce = Vh, c.reduceRight = Jh, c.repeat = L_, c.replace = P_, c.result = f_, c.round = E0, c.runInContext = _, c.sample = Yh, c.size = em, c.snakeCase = R_, c.some = om, c.sortedIndex = Xf, c.sortedIndexBy = Qf, c.sortedIndexOf = eh, c.sortedLastIndex = oh, c.sortedLastIndexBy = nh, c.sortedLastIndexOf = th, c.startCase = z_, c.startsWith = G_, c.subtract = B0, c.sum = k0, c.sumBy = D0, c.template = Z_, c.times = b0, c.toFinite = Ao, c.toInteger = Z, c.toLength = du, c.toLower = U_, c.toNumber = He, c.toSafeInteger = $m, c.toString = J, c.toUpper = $_, c.trim = K_, c.trimEnd = q_, c.trimStart = H_, c.truncate = W_, c.unescape = V_, c.uniqueId = g0, c.upperCase = J_, c.upperFirst = Ai, c.each = Ys, c.eachRight = Xs, c.first = Ws, Ti(c, (function() {
          var e = {};
          return ro(c, function(n, i) {
            V.call(c.prototype, i) || (e[i] = n);
          }), e;
        })(), { chain: !1 }), c.VERSION = a, De(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(e) {
          c[e].placeholder = c;
        }), De(["drop", "take"], function(e, n) {
          q.prototype[e] = function(i) {
            i = i === r ? 1 : fe(Z(i), 0);
            var s = this.__filtered__ && !n ? new q(this) : this.clone();
            return s.__filtered__ ? s.__takeCount__ = ge(i, s.__takeCount__) : s.__views__.push({
              size: ge(i, no),
              type: e + (s.__dir__ < 0 ? "Right" : "")
            }), s;
          }, q.prototype[e + "Right"] = function(i) {
            return this.reverse()[e](i).reverse();
          };
        }), De(["filter", "map", "takeWhile"], function(e, n) {
          var i = n + 1, s = i == qi || i == Hl;
          q.prototype[e] = function(l) {
            var d = this.clone();
            return d.__iteratees__.push({
              iteratee: L(l, 3),
              type: i
            }), d.__filtered__ = d.__filtered__ || s, d;
          };
        }), De(["head", "last"], function(e, n) {
          var i = "take" + (n ? "Right" : "");
          q.prototype[e] = function() {
            return this[i](1).value()[0];
          };
        }), De(["initial", "tail"], function(e, n) {
          var i = "drop" + (n ? "" : "Right");
          q.prototype[e] = function() {
            return this.__filtered__ ? new q(this) : this[i](1);
          };
        }), q.prototype.compact = function() {
          return this.filter(we);
        }, q.prototype.find = function(e) {
          return this.filter(e).head();
        }, q.prototype.findLast = function(e) {
          return this.reverse().find(e);
        }, q.prototype.invokeMap = $(function(e, n) {
          return typeof e == "function" ? new q(this) : this.map(function(i) {
            return Rn(i, e, n);
          });
        }), q.prototype.reject = function(e) {
          return this.filter(Gt(L(e)));
        }, q.prototype.slice = function(e, n) {
          e = Z(e);
          var i = this;
          return i.__filtered__ && (e > 0 || n < 0) ? new q(i) : (e < 0 ? i = i.takeRight(-e) : e && (i = i.drop(e)), n !== r && (n = Z(n), i = n < 0 ? i.dropRight(-n) : i.take(n - e)), i);
        }, q.prototype.takeRightWhile = function(e) {
          return this.reverse().takeWhile(e).reverse();
        }, q.prototype.toArray = function() {
          return this.take(no);
        }, ro(q.prototype, function(e, n) {
          var i = /^(?:filter|find|map|reject)|While$/.test(n), s = /^(?:head|last)$/.test(n), l = c[s ? "take" + (n == "last" ? "Right" : "") : n], d = s || /^find/.test(n);
          l && (c.prototype[n] = function() {
            var h = this.__wrapped__, m = s ? [1] : arguments, A = h instanceof q, M = m[0], S = A || G(h), x = function(K) {
              var H = l.apply(c, So([K], m));
              return s && N ? H[0] : H;
            };
            S && i && typeof M == "function" && M.length != 1 && (A = S = !1);
            var N = this.__chain__, C = !!this.__actions__.length, P = d && !N, U = A && !C;
            if (!d && S) {
              h = U ? h : new q(this);
              var D = e.apply(h, m);
              return D.__actions__.push({ func: Pt, args: [x], thisArg: r }), new Ue(D, N);
            }
            return P && U ? e.apply(this, m) : (D = this.thru(x), P ? s ? D.value()[0] : D.value() : D);
          });
        }), De(["pop", "push", "shift", "sort", "splice", "unshift"], function(e) {
          var n = ut[e], i = /^(?:push|sort|unshift)$/.test(e) ? "tap" : "thru", s = /^(?:pop|shift)$/.test(e);
          c.prototype[e] = function() {
            var l = arguments;
            if (s && !this.__chain__) {
              var d = this.value();
              return n.apply(G(d) ? d : [], l);
            }
            return this[i](function(h) {
              return n.apply(G(h) ? h : [], l);
            });
          };
        }), ro(q.prototype, function(e, n) {
          var i = c[n];
          if (i) {
            var s = i.name + "";
            V.call(sn, s) || (sn[s] = []), sn[s].push({ name: n, func: i });
          }
        }), sn[wt(r, To).name] = [{
          name: "wrapper",
          func: r
        }], q.prototype.clone = Vd, q.prototype.reverse = Jd, q.prototype.value = jd, c.prototype.at = vh, c.prototype.chain = Nh, c.prototype.commit = Fh, c.prototype.next = wh, c.prototype.plant = Eh, c.prototype.reverse = Bh, c.prototype.toJSON = c.prototype.valueOf = c.prototype.value = kh, c.prototype.first = c.prototype.head, Cn && (c.prototype[Cn] = Ch), c;
      }), tn = Nd();
      Oo ? ((Oo.exports = tn)._ = tn, gr._ = tn) : _e._ = tn;
    }).call(By);
  })(Hn, Hn.exports)), Hn.exports;
}
var Wn = ky();
const PT = (o, t) => {
  const r = Wn.mapValues(o, (u) => u === "" || u === void 0 ? null : u);
  return Wn.omit(r, t);
}, RT = (o, t, r) => {
  const a = r ? Wn.omitBy(r, (u) => u === null) : {};
  Wn.assign(o, t, Wn.pick(a, Object.keys(o)));
}, OT = (o) => {
  const { properties: t } = o, { context: r } = t;
  return {
    addressNumber: r.address?.address_number,
    alternate: r.region?.alternate?.name,
    country: r.country?.name,
    countryCode: r.country?.country_code,
    fullAddress: t.full_address,
    latitude: t.coordinates.latitude,
    longitude: t.coordinates.longitude,
    mapboxId: t.mapbox_id,
    place: r.place?.name,
    postcode: r.postcode?.name,
    region: r.region?.name,
    regionCode: r.region?.region_code_full,
    streetName: r.street?.name
  };
}, zT = (o, t) => {
  if (t == null)
    return null;
  const r = t.trim();
  if (r.length === 0)
    return null;
  const a = My[o] ?? [];
  if (a.length === 0)
    return r.toUpperCase();
  const u = r.toLowerCase(), f = a.find((p) => p.code.toLowerCase() === u || p.name.toLowerCase() === u);
  return f ? f.code.toUpperCase() : null;
}, GT = (o) => {
  if (typeof o != "string") return !1;
  const t = o.replace(/-\d{1,2}$/, ""), r = /^\d+$/.test(t), a = /^[a-zA-Z0-9]+$/.test(t), u = t.length;
  return r && u >= 8 && u <= 10 || a && u === 17;
}, ZT = (o, t) => {
  if (typeof o != "number" || !Number.isInteger(o)) return !1;
  const r = -(2 ** (t - 1)), a = 2 ** (t - 1) - 1;
  return o >= r && o <= a;
}, Dy = [
  { threshold: 0, step: 1 },
  { threshold: 10, step: 5 },
  { threshold: 50, step: 10 },
  { threshold: 100, step: 50 },
  { threshold: 1e3, step: 100 },
  { threshold: 5e3, step: 200 },
  { threshold: 1e4, step: 500 },
  { threshold: 5e4, step: 1e3 }
];
class Pl {
  constructor(t) {
    if (!t[0])
      throw new Error("SaleSteppedPrice requires at least one tier");
    this.tiers = [...t].sort((a, u) => a.threshold - u.threshold);
    const r = this.tiers[0];
    if (!r)
      throw new Error("SaleSteppedPrice requires at least one tier");
    this.firstTier = r;
  }
  /** Creates an instance with the default MVP1 tiers (see DEFAULT_SALE_STEP_TIERS). */
  static createDefault() {
    return new Pl(Dy);
  }
  /**
   * Checks whether an amount falls on the stepped price grid.
   *
   * @example validateAmount(1200) // true  (tier 1000-4999, step 100: (1200-1000) % 100 === 0)
   * @example validateAmount(1250) // false (tier 1000-4999, step 100: (1250-1000) % 100 !== 0)
   */
  validateAmount(t) {
    if (t < 0)
      return !1;
    const r = this.getTierForAmount(t, "up");
    return (t - r.threshold) % r.step === 0;
  }
  /**
   * Rounds an amount down (floor) to the nearest valid step value.
   *
   * @example getStepRoundedAmount(5300) // 5200 (tier 5000-9999, step 200)
   */
  getStepRoundedAmount(t) {
    return this.getStepRoundedValue(t, Math.floor);
  }
  /**
   * Rounds a reserve price up (ceil) to the nearest valid step value.
   *
   * @example getStepRoundedReservePrice(5100) // 5200 (tier 5000-9999, step 200)
   */
  getStepRoundedReservePrice(t) {
    return this.getStepRoundedValue(t, Math.ceil);
  }
  /**
   * From a valid base amount, computes the amount N steps away.
   * Positive deltaSteps moves up, negative moves down. Correctly
   * switches step size when crossing tier boundaries.
   * Throws if baseAmount is not on the grid.
   *
   * @example getDeltaStepsAmount(4900, 2)  // 5200 (4900+100=5000, then 5000+200=5200)
   * @example getDeltaStepsAmount(5000, -1) // 4900 (at boundary, uses lower tier step 100)
   */
  getDeltaStepsAmount(t, r) {
    if (!this.validateAmount(t))
      throw new Error("Error in SaleSteppedPrice.getDeltaStepsAmount, base is not a valid amount");
    return this.computeDeltaStepsAmount(t, r);
  }
  /**
   * Computes a default starting price for an auction given its reserve price.
   * Uses an exponential decay formula (BSD-3693) so the gap between starting
   * and reserve grows fast for cheap items and plateaus at ~25.000 for expensive ones.
   *
   * @example getAuctionStartingPriceDefaultValue(10000)  // 4600
   * @example getAuctionStartingPriceDefaultValue(100000) // 76500
   */
  getAuctionStartingPriceDefaultValue(t) {
    const a = t - 25e3 * (1 - Math.exp(-25e-6 * t));
    return this.getStepRoundedAmount(a);
  }
  /**
   * Returns the minimum negotiation offer for a direct sale: 30% of the price,
   * rounded down to the nearest valid step.
   *
   * @example getDirectSaleMinNegotiationOfferDefaultValue(10000) // 3000
   */
  getDirectSaleMinNegotiationOfferDefaultValue(t) {
    return this.getStepRoundedAmount(t * 0.3);
  }
  /**
   * Computes the suggested (discounted) price for a direct sale.
   * Uses a sigmoid that yields ~76% for low prices, trending toward
   * 100% for very high prices. Result is rounded down to the nearest valid step.
   *
   * @example getDirectSaleSuggestedPriceDefaultValue(5000)   // 4050  (~81%)
   * @example getDirectSaleSuggestedPriceDefaultValue(100000) // 88000 (~89%)
   */
  getDirectSaleSuggestedPriceDefaultValue(t) {
    const u = 0.98 - 0.16999999999999993 * Math.exp(-6e-6 * t);
    return this.getStepRoundedAmount(t * u);
  }
  /**
   * Finds the applicable tier for a given amount.
   * - direction 'up': returns the tier whose threshold is <= amount (used for validation/rounding)
   * - direction 'down': returns the tier whose threshold is < amount (at a boundary, picks the lower tier)
   */
  getTierForAmount(t, r) {
    const a = r === "up" ? (u) => u <= t : (u) => u < t;
    for (let u = this.tiers.length - 1; u >= 0; u--) {
      const f = this.tiers[u];
      if (f && a(f.threshold))
        return f;
    }
    return this.firstTier;
  }
  /** Rounds a value to the nearest valid step using the given rounding function (floor or ceil). */
  getStepRoundedValue(t, r) {
    const a = this.getTierForAmount(t, "up"), u = t - a.threshold;
    return r(u / a.step) * a.step + a.threshold;
  }
  /** Recursive implementation of getDeltaStepsAmount. Moves one step per call, recalculating the tier each time. */
  computeDeltaStepsAmount(t, r) {
    if (r === 0)
      return t;
    const a = r / Math.abs(r), u = r > 0 ? "up" : "down", f = this.getTierForAmount(t, u);
    return this.computeDeltaStepsAmount(t + f.step * a, r - a);
  }
}
const UT = ({
  reservePrice: o,
  isToBeScraped: t,
  isOneEuro: r
}) => {
  const a = t || o < 5e3 ? 50 : o < 1e4 ? 100 : o < 5e4 ? 500 : 1e3, u = t ? 50 : o < 5e3 ? 100 : o < 1e4 ? 500 : (o < 5e4, 1e3), f = t ? 1e3 : o < 5e3 ? 5e3 : o < 1e4 ? 1e4 : 5e4, p = t || r ? 250 : o <= 5e4 ? 500 : 1e3;
  return {
    minStepDefaultValue: a,
    maxStepDefaultValue: u,
    thresholdDefaultValue: f,
    bailDefaultValue: p
  };
};
function An(o) {
  const t = Object.prototype.toString.call(o);
  return o instanceof Date || typeof o == "object" && t === "[object Date]" ? new o.constructor(+o) : typeof o == "number" || t === "[object Number]" || typeof o == "string" || t === "[object String]" ? new Date(o) : /* @__PURE__ */ new Date(NaN);
}
function Ly(o, t) {
  const r = An(o), a = An(t);
  return r.getTime() > a.getTime();
}
function Py(o, t) {
  const r = An(o), a = An(t);
  return +r < +a;
}
function Ju(o, t) {
  const r = An(o), a = An(t);
  return +r == +a;
}
function $i(o) {
  throw new Error("Should not have reached this line");
}
var ao = /* @__PURE__ */ ((o) => (o.Seller = "Seller", o.Buyer = "Buyer", o))(ao || {}), so = /* @__PURE__ */ ((o) => (o.FixedPercentage = "FixedPercentage", o.FixedAmount = "FixedAmount", o.Standard = "Standard", o))(so || {});
const Ry = /* @__PURE__ */ new Date("2025-11-24"), Oy = /* @__PURE__ */ new Date("2025-11-28"), mn = 250, Ci = 0.0875, Rl = 0.0375, Ol = 5250, Ei = 1e5, zl = 2500, zy = (o, [t, r]) => (Ju(o, t) || Ly(o, t)) && (Py(o, r) || Ju(o, r)), Gl = ({
  feeTarget: o,
  baseAmount: t,
  assetsCount: r,
  feeConfiguration: a
}) => {
  const u = {
    [ao.Seller]: 1,
    [ao.Buyer]: -1
  }[o], f = t / r;
  return (() => {
    if (!a || a.type === so.Standard) {
      const p = zl - mn * u;
      return (() => {
        if (f <= p) return f + mn * u;
        const T = Ei - mn * u - Ci * Ei * u;
        return f <= T ? (f + mn * u) / (1 - Ci * u) : (f + Ol * u) / (1 - Rl * u);
      })() * r;
    }
    if (a.type === so.FixedPercentage)
      return t / (1 - a.feeOverrideValue * u);
    if (a.type === so.FixedAmount)
      return t + a.feeOverrideValue * u;
    $i(a.type);
  })();
}, $T = ({
  feeTarget: o,
  baseAmount: t,
  assetsCount: r,
  referenceDate: a,
  feeConfiguration: u
}) => {
  const f = t / r, p = (() => {
    if (!u || u.type === so.Standard)
      return f <= zl ? mn * r : f <= Ei ? (mn + Ci * f) * r : (Ol + Rl * f) * r;
    if (u.type === so.FixedPercentage)
      return t * u.feeOverrideValue;
    if (u.type === so.FixedAmount)
      return u.feeOverrideValue;
    $i(u.type);
  })(), T = o === ao.Buyer && a && zy(a, [Ry, Oy]) ? p * 0.5 : p;
  return {
    grossTotal: Math.ceil(o === ao.Buyer ? t + p : t),
    grossNet: Math.ceil(o === ao.Buyer ? t : t - p),
    grossFees: Math.ceil(p),
    total: Math.ceil(o === ao.Buyer ? t + T : t),
    net: Math.ceil(o === ao.Buyer ? t : t - T),
    fees: Math.ceil(T)
  };
}, KT = ({
  sellerReservePrice: o,
  assetsCount: t,
  feeConfiguration: r
}) => {
  const a = Math.ceil(
    Gl({
      feeTarget: ao.Seller,
      baseAmount: o,
      assetsCount: t,
      feeConfiguration: r
    })
  );
  return {
    sellerReservePrice: o,
    fees: a - o,
    reservePrice: a
  };
}, qT = ({
  buyerBudget: o,
  assetsCount: t,
  feeConfiguration: r
}) => {
  const a = Math.ceil(
    Gl({
      feeTarget: ao.Buyer,
      baseAmount: o,
      assetsCount: t,
      feeConfiguration: r
    })
  );
  return {
    buyerBudget: o,
    fees: o - a,
    buyerMaxOffer: a
  };
}, HT = ({
  sellerReservePrice: o,
  feeConfiguration: t
}) => {
  const r = (() => {
    if (!t || t.type === so.Standard)
      return o <= 2250 ? 250 : o <= 91e3 ? (o + 250) / 0.9125 : (o + 5250) / 0.9625;
    if (t.type === so.FixedPercentage)
      return o / (1 - t.feeOverrideValue);
    if (t.type === so.FixedAmount)
      return o + t.feeOverrideValue;
    $i(t.type);
  })();
  return Math.ceil(r);
}, WT = ({
  isSeller: o,
  isCustomerService: t,
  isAssignedSalesRep: r
}) => o || t || r, Gy = [
  "MinibusCityIntercity",
  "MinibusTouristic",
  "AutobusNormalFloor2Axle",
  "AutobusNormalFloor3Axle",
  "AutobusLowFloorLowEntry8_12Mt",
  "Autobus18Mt",
  "DoubleDecker"
];
function VT(o) {
  return typeof o == "string" && Gy.includes(o);
}
const Zy = hy, Uy = my, Yt = 10, $y = Yt - 1, jn = [
  ...Object.values(Zy).map(
    (o) => ({
      name: o.name,
      kind: "image",
      isInternal: !1,
      label: o.label,
      group: o.group,
      positionByType: o.positionByType,
      positionAdminByType: o.positionAdminByType
    })
  ),
  ...Object.values(Uy).map(
    (o) => ({
      name: o.name,
      kind: "video",
      isInternal: o.isInternal,
      label: o.label,
      group: o.group,
      positionByType: o.positionByType,
      positionAdminByType: o.positionAdminByType
    })
  )
], Ki = new Map(jn.map((o) => [o.name, o]));
function JT(o) {
  return Ki.get(o)?.isInternal ?? !1;
}
function jT(o) {
  return o === "DoubleDecker";
}
function YT(o) {
  const t = Ki.get(o);
  return t ? t.kind === "image" ? "IMAGES_BASE" : o === "video_engine_working" ? "VIDEOS_ENGINE" : o === "video_warranty" ? "VIDEOS_WARRANTY" : "VIDEOS_OTHER" : null;
}
function XT(o) {
  return jn.filter((t) => t.positionAdminByType?.[o] !== void 0).sort((t, r) => (t.positionAdminByType?.[o] ?? 0) - (r.positionAdminByType?.[o] ?? 0)).map((t) => ({
    name: t.name,
    kind: t.kind,
    isInternal: t.isInternal,
    label: t.label,
    group: t.group,
    positionInspection: t.positionAdminByType?.[o] ?? 0,
    positionFleequid: t.positionByType?.[o] ?? null
  }));
}
function Ky(o) {
  return Number.isInteger(o) && o > 0 && o % Yt !== 0;
}
function qy(o) {
  return Math.floor(o / Yt) * Yt;
}
function QT(o, t) {
  const r = new Set(t);
  for (let a = 1; a <= $y; a++) {
    const u = o + a;
    if (!r.has(u))
      return u;
  }
  return null;
}
function eM(o, t) {
  if (!Ky(t))
    return null;
  const r = qy(t), a = jn.find((f) => f.positionAdminByType?.[o] === r);
  if (!a || a.isInternal)
    return null;
  const u = a.positionByType?.[o];
  return u === void 0 ? null : u + (t - r);
}
function oM(o) {
  return jn.filter((t) => !t.isInternal && t.positionByType?.[o] !== void 0).sort((t, r) => (t.positionByType?.[o] ?? 0) - (r.positionByType?.[o] ?? 0)).map((t) => t.name);
}
function nM(o, t) {
  const r = Ki.get(t);
  return !r || r.isInternal ? null : r.positionByType?.[o] ?? null;
}
function tM(o) {
  return jn.filter((t) => t.positionAdminByType?.[o] !== void 0).map((t) => t.name);
}
var Hy = /* @__PURE__ */ ((o) => (o.VEHICLE_TOO_OLD = "VEHICLE_TOO_OLD", o.ELECTRIC_OR_HYBRID = "ELECTRIC_OR_HYBRID", o.MILEAGE_OR_MAINTENANCE_EXCEEDED = "MILEAGE_OR_MAINTENANCE_EXCEEDED", o.NOT_SUPPORTED_VEHICLE_CLASS = "NOT_SUPPORTED_VEHICLE_CLASS", o.MISSING_REQUIRED_DATA = "MISSING_REQUIRED_DATA", o))(Hy || {});
const rM = {
  FleequidCare: {
    coverageCap: 1e4,
    warrantyDurationMonths: 3,
    creditPercentageGuidelines: [
      { maxAmount: 3e3, minCreditPercentage: 50 },
      { maxAmount: 5e3, minCreditPercentage: 45 },
      { maxAmount: 7e3, minCreditPercentage: 40 },
      { maxAmount: 9e3, minCreditPercentage: 35 },
      { maxAmount: 1e4, minCreditPercentage: 30 }
    ]
  },
  PowertrainWarranty: {
    coverageCap: 25e3,
    mileageLimits: [
      { durationMonths: 3, maxKm: 15e3 },
      { durationMonths: 6, maxKm: 3e4 },
      { durationMonths: 9, maxKm: 45e3 },
      { durationMonths: 12, maxKm: 6e4 }
    ],
    creditPercentageGuidelines: [
      { maxAmount: 1e4, minCreditPercentage: 30 },
      { maxAmount: 15e3, minCreditPercentage: 25 },
      { maxAmount: 2e4, minCreditPercentage: 20 },
      { maxAmount: 25e3, minCreditPercentage: 10 }
    ]
  }
};
export {
  Fy as ADMIN_USER_PASSWORD_RESET_TOKEN_PAYLOAD_TYPE,
  NT as AdminUserPasswordResetTokenPayloadSchema,
  tT as BANK_TRANSFER_BAIL_AUTHORIZATION_ID_PREFIX,
  hy as BUS_ASSET_BASE_IMAGES,
  rT as BUS_ASSET_COVER_IMAGES,
  my as BUS_ASSET_VIDEOS,
  eT as CalcomBookingMetadataSchema,
  Dy as DEFAULT_SALE_STEP_TIERS,
  dT as FILE_UPLOAD_EXTENSIONS,
  cT as FILE_UPLOAD_PDF_MAX_SIZE,
  ao as FeeTarget,
  so as FeeType,
  by as ITALIAN_REGIONS,
  Sy as LanguageISO6391Schema,
  yT as MAPBOX_API_CONFIG,
  $y as MAX_DISCRETIONARY_PHOTOS_PER_GAP,
  nT as ONE_EURO_STARTING_PRICE,
  Hy as PowertrainWarrantyIneligibilityReason,
  ST as SEARCH_SUGGEST_MAX_QUERY_LENGTH,
  IT as SEARCH_SUGGEST_MIN_QUERY_LENGTH,
  oT as STEP_LOWEST_COMMON_DENOMINATOR,
  Pl as SaleSteppedPrice,
  rM as VAS_CLAIM_CONFIGURATION,
  PT as adaptFormDataToDto,
  OT as adaptMapboxFeatureToAddressBody,
  xT as addressFormFieldSchema,
  qy as anchorOfPosition,
  Wy as busDossierDocumentKeys,
  qT as computeBuyerMaxOfferAndFees,
  $T as computeFees,
  WT as computeIsSellerPov,
  HT as computeReservePrice,
  UT as computeSaleDefaultValues,
  KT as computeSellerReservePriceAndFees,
  kT as convertKwToHp,
  Zi as countriesConfig,
  Cl as countryIso2List,
  AT as customerServiceEmail,
  gT as customerServicePhone,
  LT as fetchFormatQuery,
  vT as getAddressFormFieldSchema,
  sT as getAsCountryISO2,
  uT as getAsCountryISO3,
  pT as getAsLanguageISO6391,
  hT as getAsTaxCodeOrigin,
  Cy as getAsTin,
  Qy as getBusDossierDocumentResponsibility,
  Jy as getBusDossierFieldResponsibility,
  jy as getBusDossierRequiredVaryingFields,
  aT as getCountryCodesByContinent,
  lT as getCountryISO3FromISO2,
  iT as getCountryNameInEnglish,
  oM as getFleequidOrder,
  bT as getHubspotFlagUrl,
  mT as getHubspotSalesRepImageUrl,
  XT as getInspectionSequence,
  TT as getLanguage6391FromCountryIso2,
  YT as getMediaTypeForName,
  tM as getRequiredMedia,
  _T as hubspotDefaultSalesRepImageUrl,
  Ui as hubspotPublicFilesBaseUrl,
  RT as initFormData,
  DT as insertIf,
  Ky as isAnchoredPosition,
  Yy as isBusDossierDocumentHidden,
  Xy as isBusDossierDocumentRequired,
  Vy as isBusDossierFieldHidden,
  P0 as isBusDossierFieldRequired,
  yy as isCountryISO2,
  Ty as isCountryISO3,
  ZT as isDbIntegerValidator,
  jT as isDoubleDecker,
  JT as isInternalMedia,
  vy as isTaxCodeOrigin,
  ET as isTin,
  VT as isTrustReportType,
  fT as languageNames,
  MT as languageToRepresentativeCountryMap,
  BT as parseAsTin,
  FT as phoneValidator,
  kl as phoneValidatorE164,
  My as provinces,
  nM as resolveFleequidPosition,
  eM as resolveInterlacedFleequidPosition,
  QT as resolveNextAnchoredPosition,
  zT as resolveProvinceCode,
  xy as taxCodeOriginList,
  Gy as trustReportTypes,
  GT as vinValidator,
  wT as zodPhoneE164,
  CT as zodPhoneE164Optional
};
//# sourceMappingURL=shared.mjs.map
